// 马来

export default {
  loading: "Memuat",
  quantity: "Kuantiti",
  name: "Nama",
  all: "Semua",
  yes: "Ya",
  no: "Tidak",
  or: "Atau",
  and: "Dan",
  in_all: "Jumlah",
  Query: "Carian",
  creation: "Buat",
  Batchquery: "Carian Berkumpulan",
  delete: "Padam",
  checkAll: "Pilih Semua",
  Save_export_condition: "Simpan Syarat Eksport",
  Total_print: "Cetak Jumlah",
  successfully_delete: "Padaman Berjaya!",
  error_Message: "Mesej Pengecualian",
  edit: "Sunting",
  editUser: "Sunting Pengguna",
  confirm: "Sahkan",
  print: "Cetak",
  today: "Hari Ini",
  yesterday: "Semalam",
  enterprise: "Korporat",
  personage: "Individu",
  Before_yesterday: "Hari Sebelum Semalam",
  printLog: "Cetak Log",
  check: "Lihat",
  Button: "Butang",
  notice: "Nota",
  revocation: "Batal",
  Query_content: "Kandungan Carian",
  Scanning_successful: "Imbasan Berjaya",
  successful_operation: "Operasi Berjaya!",
  Please_select_orders_to_operate: "Sila pilih pesanan yang hendak diproses",
  Please_select_same_platform_orders: "Sila pilih pesanan dari platform yang sama untuk diproses",
  The_query_is_successful: "Permintaan berjaya",
  Delete_success: "Pembuangan berjaya!",
  operation_failed: "Operasi gagal!",
  more: "Lagi",
  click_to_download: "Klik untuk muat turun",
  More_operations: "Lagi operasi",
  More_Conditions: "Lagi syarat",
  Displaystatus: "Tunjukkan status",
  According: "Tunjukkan",
  Total_declared_value: "Jumlah nilai yang diisytiharkan",
  NoAccording: "Jangan tunjukkan",
  Download_via_QR_code: "Muat turun melalui kod QR",
  Please_select_display_status: "Sila pilih status paparan",
  Path_is_None_Check_whether_the_address_is_correct: "Alamat kosong, sila semak sama ada input alamat adalah betul!",
  Is_this_a_piece_of_content_sure_to_delete: "Adakah kandungan ini disahkan untuk dipadam?",
  phone_number: "Nombor Telefon Bimbit",
  Payment_order_number: "Nombor Pesanan Pembayaran",
  Please_enter_a_phone_number: "Sila masukkan nombor telefon bimbit",
  SystemSettings: "Tetapan Sistem",
  please_enter: "Sila masukkan",
  old_password: "Kata Laluan Lama",
  Please_enter_your_old_password: "Sila masukkan kata laluan lama",
  new_password: "Kata Laluan Baru",
  Please_enter_basket_length_width_and_height: "Sila masukkan Panjang/Lebar/Tinggi Bakul",
  Please_enter_the_order_number: "Sila masukkan Nombor Pesanan",
  Please_enter_the_search_criteria: "Sila masukkan kriteria pertanyaan",
  uploading: "Muat naik",
  next_step: "Langkah Seterusnya",
  last_step: "Langkah Sebelumnya",
  change_password: "Ubah Kata Laluan",
  Mission_center: "Pusat Tugas",
  TaskCenter: "Pusat Tugas",
  TaskCenterRegulates: "Pengurusan Pusat Tugas",
  TaskCenterList: "Pusat Tugas",
  Drag_and_drop_upload: "Muat naik Seret & Lepas",
  Successfully_copied_to_clipboard: "Salin ke papan klip dengan jayanya",
  Unable_to_copy_to_clipboard: "Tidak dapat menyalin ke papan klip",
  The_form_verification_fails_Please_modify_and_try_again: "Pengesahan borang gagal. Sila semak semula dan cuba lagi",
  The_selected_data_is_empty: "Data yang dipilih kosong",
  The_added_data_is_empty: "Data yang ditambah kosong",
  systematic_notification: "Pemberitahuan sistem",
  open_in_new_window: "Buka dalam tetingkap baru",
  successfully_upload: "Muat naik berjaya",
  Specify_export_order: "Tentukan pesanan eksport",
  Specified_export_goods: "Tentukan item eksport",
  Export_task_Id: "ID tugas eksport",
  Derived_exception: "Pengecualian eksport",
  View_Personal_details: "Lihat butiran peribadi",
  not_modified: "Tiada perubahan dibuat",
  save_as_PDF: "Simpan sebagai PDF",
  Download_sheet: "Muat turun label penghantaran",
  ToolDownload: "Muat turun alat",
  toolName: "Nama alat",
  remote_control_software: "Perisian kawalan jauh",
  Print_plug_in: "Pemalam cetakan",
  PDABrowser: "Pelayar PDA",
  It_can_be_downloaded_by_clicking_the_button_and_scanning_the_QR_code_by_touching_the_button: "Muat turun dengan mengklik atau menyentuh butang untuk mengimbas kod QR",
  The_user_does_not_have_any_permission_Please_assign_the_permission_to_the_superior_of_the_user: "Pengguna ini tidak mempunyai kebenaran. Sila minta ketua mereka menetapkan kebenaran yang sesuai",
  To_use_system_printing_you_need_to_download_a_print_plugin: "Cetak sistem memerlukan pemuatan pemalam cetak",
  The_current_user_has_no_permission_Please_set_the_permission_and_log_in_again: "Pengguna semasa tidak mempunyai kebenaran. Sila konfigurasi kebenaran sebelum log masuk semula",
  Using_the_specified_export_order_data_will_overwrite_the_list_of_selected_order_data: "Menggunakan data pesanan eksport yang ditetapkan akan menimpa data pesanan yang dipilih dalam senarai",
  This_order_has_not_been_shipped_out_of_the_warehouse_and_cannot_be_reprinted: "Pesanan ini belum dihantar; mencetak semula label penghantaran tidak dapat dilakukan.",
  Interface_communication_failed_Please_refresh_the_page_or_log_in_again_If_the_problem_persists_contact_the_administrator: "Komunikasi antara muka gagal. Sila semak semula halaman atau log masuk semula. Jika masalah berterusan, hubungi pentadbir.",
  Enter_the_client: "Akses Klien",
  query_condition: "Kriteria Carian",
  Home: "Home",
  return: "Balik",
  Please_upload: "Sila muat naik",
  The_upload_format_is: "Format muat naik ialah",
  The_file_format_was_wrong_last_time: "Format fail yang dimuat naik tidak betul",
  The_uploaded_file_exceeds_the_specified_size_Procedure: "Fail yang dimuat naik melebihi had saiz; muat naik gagal",
  Shop_status: "Status Kedai",
  normal: "Normal",
  Authorization_expired: "Kebenaran telah tamat tempoh",
  One_click_out_of_storage: "Penghantaran Satu Klik",
  can_only_choose_one: "Hanya satu pilihan boleh dipilih",
  Go_to_the_service_platform: "Arahkan semula ke Platform Perkhidmatan",
  api_Order: "Pesanan API",
  Notification_form: "Pesanan Push",
  Please_clear_template_format: "Sila nyahpilih format templat",
  announcementsList: "Senarai Pengumuman",
  successful_operation_exist: "Konfigurasi gudang ini sudah wujud",
  new: "Baharu",
  no_blank_remains: "Tiada pemisah baris kosong",
  mass_export: "Eksport Berjumlah",
  Print_controls: "Kawalan Cetakan",
  test: "Uji",
  The_store_backend_address_must_be_exactly_the_same_as_the_shipping_warehouse_address: "Alamat backend kedai mesti sepadan tepat dengan alamat gudang penghantaran",
  Password: "Kata Laluan",
  Authentication_Code: "Kod Pengesahan",
  Can_Exchange: "Tak jelas? Klik untuk segar semula",
  Remember_Password: "Ingat Kata Laluan",
  Login: "Log Masuk",
  Register_Account: "Daftar Akaun",
  Confirm_PassWord: "Sahkan Kata Laluan",
  Account_Manager_ID: "ID Pengurus Akaun",
  identity_card: "Kad Pengenalan",
  business_license: "Lesen Perniagaan",
  Please_Input_Password: "Sila masukkan kata laluan",
  The_Passwords_Entered_Do_Not_Match: "Kata laluan yang dimasukkan tidak sepadan",
  Please_Input_Phone_Number: "Sila masukkan nombor telefon bimbit",
  Please_Input_Verification_Code: "Sila masukkan kod pengesahan",
  Too_Many_Requests_Please_Try_Again_Later: "Pendaftaran kerap dikesan. Sila cuba lagi kemudian!",
  The_SMS_Verification_Code_Has_Been_Sent_Procedure: "Kod pengesahan SMS telah dihantar",
  Obtain_SMS_Verification_Code: "Dapatkan kod pengesahan SMS",
  Sending_The_Verification_Code: "Hantar kod pengesahan",
  Email: "E-mel",
  Phone_Number: "Nombor Telefon Mudah Alih",
  Message_Authentication_Code: "Kod Pengesahan SMS",
  Please_Enter_A_Valid_Email: "Sila masukkan alamat e-mel yang sah",
  The_Current_User_Has_Not_Been_Granted_Permissions_Please_Set_The_Permissions_And_Then_Try_Logging_In_Again: "Pengguna semasa tidak mempunyai kebenaran. Sila konfigurasi kebenaran sebelum mencuba log masuk semula",
  Too_Many_Errors_Please_Enter_The_Verification_Code_And_Try_Again: "Bilangan percubaan ralat telah melebihi. Sila masukkan semula kod pengesahan dan cuba lagi",
  Automatic_login_failed_Please_enter_your_account_and_password_manually: "Log masuk automatik gagal. Sila masukkan butiran log masuk secara manual",
  Logging_In_Automatically: "Log masuk automatik",
  Chinese: "Cina",
  English: "Inggeris",
  OMS_System: "Klien Sistem OMS",
  OMS_System_Admin: "Pentadbir Sistem OMS",
  UserAccount: "ID Pengguna",
  password: "Kata Laluan",
  RememberPassword: "Ingat Kata Laluan",
  ForgotPassword: "Lupa Kata Laluan",
  RegisterAccount: "Daftar Akaun",
  Register: "Daftar",
  login: "Log Masuk",
  Please_enter_a_user_account: "Tiada ID Pengguna dimasukkan",
  Please_enter_the_user_password: "Tiada Kata Laluan dimasukkan",
  Obtain_SMS_verification_code: "Dapatkan Kod Pengesahan SMS",
  SignIn: "Log Masuk",
  LoginSuccessful: "Log Masuk Berjaya",
  language: "Bahasa",
  LogOut: "Log Keluar",
  Skip_logistics_system: "Arah ke Sistem Logistik",
  No_need_to_export_content: "Tiada kandungan untuk dieksport",
  waiting_in_line: "Dalam barisan",
  No_data_yet: "Tiada data tersedia",
  Account_manager_ID: "ID Pengurus Akaun",
  message_authentication_code: "Kod Pengesahan SMS",
  The_SMS_verification_code_has_been_sent_Procedure: "Kod pengesahan SMS telah dihantar",
  authentication_code: "Kod Pengesahan",
  Sending_the_verification_code: "Menghantar kod pengesahan",
  Can_exchange: "Tidak jelas? Klik untuk kod baru",
  Export_successfully: "Pengeksportan berjaya!",
  Export_task: "Tugas Pengeksportan",
  print_out_task: "Tugas Cetakan",
  Derivation_time: "Masa Pengeksportan",
  Derived_state: "Status Pengeksportan",
  exporting: "Mengeksport",
  Recalculation_successful: "Pengiraan semula berjaya",
  It_is_being_saved_as_a_PDF: "Menyimpan sebagai PDF",
  The_PDF_export_was_successful_The_automatic_download_has_started_If_it_does_not_start_automatically_please_refresh_and_try_again: "Pengeksportan PDF berjaya, muat turun automatik akan bermula. Jika tidak automatik, segar semula dan cuba lagi",
  Export_task_name: "Nama Tugas",
  download: "Muat Turun",
  download_successfully: "Muat turun berjaya",
  Too_many_errors_Please_enter_the_verification_code_and_try_again: "Terlalu banyak ralat. Sila masukkan semula kod pengesahan dan cuba lagi.",
  fopltal: "Operasi kerap dikesan. Sila cuba lagi kemudian!",
  Frequent_operation_please_try_again_later: "Operasi kerap dikesan. Sila cuba lagi kemudian!",
  Business_license: "Lesen Perniagaan",
  Business_license_File: "Dokumen Lesen Perniagaan",
  Identity_card: "Kad Pengenalan",
  ID_card_document: "Dokumen Kad Pengenalan",
  Identity_card_code: "Nombor Kad Pengenalan",
  ID_card_number_of_legal_person: "Nombor Kad Pengenalan Wakil Sah",
  Please_enter_the_ID_card_number_of_the_legal_person: "Sila masukkan nombor kad pengenalan wakil sah",
  Please_enter_the_ID_number: "Sila masukkan nombor kad pengenalan",
  Default_customer: "Pelanggan Lalai",
  Do_you_want_to_confirm_the_cancellation: "Sahkan pembatalan?",
  express_sheet: "Waybill",
  Confirm_activation: "Sahkan pengaktifan?",
  Please_upload_PDF_file: "Sila muat naik fail PDF",
  delivered: "Sudah dihantar",
  One_click_export_across_warehouses_is_not_allowed: "Penghantaran satu klik merentas gudang tidak dibenarkan!",
  Please_select_the_recipient_country_first_the_receipt_will_be_saved_to_the_server_in_the_corresponding_region: "Sila pilih negara penerima terlebih dahulu; label penghantaran akan disimpan pada pelayan serantau yang sepadan",
  data_reorganizing: "Pemprosesan data sedang dijalankan",
  Please_upload_the_front_and_back_of_your_ID_card: "Sila muat naik kedua-dua belah kad pengenalan",
  Menu_authorization: "Kebenaran Menu",
  goodsOnline: "Produk Dalam Talian",
  adminGoodsOnline: "Produk Dalam Talian",
  menuID: "ID Menu",
  authorization: "Kebenaran",
  editRoleInfo: "Sunting Peranan",
  createRoleInfo: "Buat Peranan",
  Role_ordering: "Susun Peranan",
  UserCenter: "Pusat Peribadi",
  workbench: "Ruang Kerja",
  announceList: "Senarai Pengumuman",
  Processing_Center: "Pusat Pemprosesan",
  Outbound: "Penghantaran",
  Order: "Pesanan",
  pendingOrders: "Pesanan yang menunggu penghantaran",
  Basic_configuration: "Konfigurasi Asas",
  BasicConfiguration: "Konfigurasi Asas",
  basketList: "Senarai Bakul",
  fixedSkuFee: "Yuran Tetap SKU",
  consumables: "Jenis Barangan Habis",
  log: "Logsat",
  logType: "Jenis Logsat",
  Please_upload_the_national_emblem_and_portrait: "Sila muat naik sisi lambang negara dan sisi potret",
  oprateLog: "Logsat Operasi",
  oprateInfo: "Maklumat Operasi",
  Please_enter_a_keyword_to_search: "Sila masukkan kata kunci untuk mencari",
  MenuRemark: "Nota Menu",
  Please_select_whether_to_enable_it: "Sila pilih sama ada untuk mengaktifkan",
  Please_select_menu_type: "Sila pilih jenis menu",
  menu: "Menu",
  MenuManagement: "Pengurusan Menu",
  Please_enter_a_menu_name: "Sila masukkan nama menu",
  Menu_name: "Nama Menu",
  Please_add_the_menu: "Sila tambahkan menu terlebih dahulu",
  The_same_name_menu_is_not_allowed: "Nama menu yang sama tidak dibenarkan!",
  The_data_is_incorrect_adding_failed: "Ralat data, penambahan gagal",
  viewWarehouseEntry: "Lihat Nota Penerimaan",
  PDAStatus: "Status PDA",
  Task_generation_type: "Jenis Pengenerasian Tugas",
  Jump_to_old_system: "Alihkan ke Sistem Lama",
  This_operation_will_be_one_click_out_of_the_warehouse_and_can_not_be_undone_be_sure_to_confirm_that_the_order_is_complete_careful_operation: "Operasi ini akan melaksanakan penghantaran satu klik dan tidak boleh dibatalkan. Pastikan semua item pesanan lengkap sebelum meneruskan. Berhati-hati!",
  videoPhotoManagement: "Pengurusan Video & Foto",
  storageSpaceServersWarehouse: "Kapasiti Penyimpanan Pelayan Gudang",
  videoPhotographyManagementControl: "Kawalan Pengurusan Video & Foto",
  videoPhotoList: "Senarai Video & Foto",
  returnGoodsRegistrationShelving: "Pendaftaran Pulangan Ekspres, Pemeriksaan Kualiti & Rak",
  returnInventoryManagement: "Pengurusan Inventori Barang Dipulangkan",
  returnInventoryList: "Senarai Inventori Barang Dipulangkan",
  ShopeeProfitReport: "Laporan Keuntungan Shopee",
  warehouseLevelReport: "Laporan data pendapatan/perbelanjaan peringkat gudang",
  platformLevelReport: "Laporan data pendapatan/perbelanjaan peringkat platform",
  customerLevelReport: "Laporan data pendapatan/perbelanjaan peringkat pelanggan",
  storeLevelReport: "Laporan data pendapatan/perbelanjaan peringkat kedai",
  orderLevelReport: "Laporan data pendapatan/perbelanjaan peringkat pesanan",
  shopeeOrderProfitReport: "Laporan keuntungan pesanan Shopee",
  shopeeStoreReport: "Laporan keuntungan kedai Shopee",
  currencyExchangeRate: "Kadar pertukaran mata wang",
  currencyExchangeRateList: "Senarai kadar pertukaran mata wang",
  returnWarehouseFlowList: "Senarai log transaksi masuk/keluar bayaran balik",
  costRecalculation: "Pengiraan semula yuran",
  chargeGiveSpecial: "Kelulusan khas yuran",
  ShopeeReport: "Laporan Shopee",
  TikTokOrderProfitReport: "Laporan keuntungan pesanan TikTok",
  logisticsHandover: "Penyerahan Logistik",
  logisticsHandoverTaskList: "Senarai Tugas Penyerahan Logistik",
  taskScanningFlowList: "Log Transaksi Imbasan Tugas",
  handoverTaskList: "Tugas Penyerahan",
  tikTokStoreProfitReport: "Laporan Keuntungan TikTok Shop",
  lazadaProfitReport: "Laporan Keuntungan Lazada",
  lazadaOrderProfitReport: "Laporan Keuntungan Pesanan Lazada",
  lazadaStoreProfitReport: "Laporan Keuntungan Kedai Lazada",
  generateInventoryPlan: "Jana Pelan Penyediaan Stok",
  inventoryPlanManagement: "Pengurusan Pesanan Penyediaan Stok",
  TikTokProfitReport: "Laporan Keuntungan TikTok",
  viewInventoryPlanManagement: "Lihat Pengurusan Pesanan Penyediaan Stok",
  taskFlow: "Log Operasi Tugas",
  systemDeductionControl: "Kawalan Potongan Yuran Sistem",
  contractAuthorization: "Kebenaran Kontrak",
  contractListCheck: "Lihat Kontrak",
  logisticsHandoverScanningLog: "Log Imbasan Penyerahan Logistik",
  itemTypeRuleSettings: "Tetapan Peraturan Jenis Pakej",
  addLogisticsChannel: "Buat Saluran Logistik",
  editLogisticsChannel: "Sunting Saluran Logistik",
  listOfChannelsToBeConfirmed: "Senarai Saluran Tertunggak Pengesahan",
  newlyDevelopedCustomerSetting: "Pemasangan Klien Baru",
  parent_directory: "Direktori Ibu",
  Dictionary_management: "Pengurusan Kamus",
  explain: "Keterangan",
  Please_enter_explain: "Sila masukkan keterangan",
  warning: "Amaran",
  cancel_authorization: "Batal Kebenaran",
  Definitive_de_authorization: "Pastikan Pembatalan?",
  apiPushMotificationList: "Senarai Transaksi Push",
  platform: "Platform",
  shop: "Kedai",
  Please_select_CustomerId: "Sila pilih ID klien",
  Please_select_shop: "Sila pilih kedai",
  Only_a_single_store_can_be_selected: "Pilihan satu kedai sahaja",
  The_transaction_number_and_order_time_cannot_be_empty_at_the_same_time: "ID Transaksi dan Tarikh Pesanan Tidak Boleh Kosong Kedua-duanya",
  warehouse: "Gudang",
  Warehouse_name: "Nama Gudang",
  Warehouse_code: "Kod Gudang",
  storage_location: "Lokasi Stok",
  order_number: "Nombor Pesanan",
  transaction_number: "ID Transaksi",
  waybill_number: "Nombor Waybill",
  logistics_channel: "Saluran Logistik",
  Logistics_track: "Penjejak Logistik",
  Only_orders_entered_into_the_system_at_the_current_time_15_days_are_processed: "Proses Hanya Pesanan yang Dimasukkan dalam Tempoh 15 Hari Terakhir",
  search: "Cari",
  type: "Jenis",
  state: "Status",
  time: "Tarikh",
  country: "Negara",
  Please_enter_country: "Sila Masukkan Negara",
  oprate: "Tindakan",
  operation_log: "Log Tindakan",
  thumbnail: "Imej Mini",
  Bar_code_of_goods: "Barang Kod Bar",
  Commodity_bar_code_and_two_dimensional_code: "Kod QR Barang Kod Bar",
  stock_position: "Lokasi Penyimpanan",
  Orders_in_the_fulfillment: "Pesanan dalam Pemilihan",
  Pending_sorting_tasks: "Tugas Penyusunan Tertunda",
  Sorting_tasks: "Tugas Penyusunan Berlangsung",
  Pending_shipment: "Penghantaran Tertunda",
  In_transit: "Penghantaran Berlangsung",
  Irregularity_in_delivery: "Anomali Pemilihan",
  Abnormal_quantity_of_distribution: "Kuantiti dengan Anomali Pemilihan",
  The_sorting_task_is_abnormal: "Anomali Tugas Penyusunan",
  Shipment_exception: "Anomali Penghantaran",
  Abnormal_shipment_quantity: "Kuantiti dengan Anomali Penghantaran",
  log_list: "Senarai Log",
  Document_ID: "ID Dokumen",
  task_order_number: "Nombor Pesanan Tugas",
  order_id: "ID Pesanan",
  Operation_type: "Jenis Operasi",
  Operation_Description: "Keterangan Operasi",
  Operator: "Pengendali",
  creation_time: "Masa Penciptaan",
  No_delivery_basket: "Tiada Petak Pemilihan Tersedia",
  No_sorting_basket: "Tiada Bakul Penyortiran Tersedia",
  time_left: "Baki",
  overdue: "Lepasan Masa",
  days: "Hari",
  hours: "Jam",
  minutes: "Minit",
  copy: "Salin",
  copu_successful: "Salinan Berjaya",
  verify_the_time: "Masa Pengesahan",
  Transfer_to_oms_time: "Masa Pemindahan ke OMS",
  sorting_time: "Masa Penyortiran",
  Please_tick_the_content_first: "Sila pilih kandungan terlebih dahulu",
  start_date: "Tarikh Mula",
  end_date: "Tarikh Tamat",
  to: "Ke",
  Whether_used: "Sudah Digunakan",
  Last_three_days: "Tiga Hari Terakhir",
  Last_week: "Minggu Lalu",
  Last_month: "Bulan Lalu",
  Assign_a_distributor: "Nyatakan Kakitangan Picking",
  Please_appoint_a_distributor: "Sila pilih kakitangan picking yang ditetapkan",
  positionTransfer: "Pindahkan Stok",
  shiftingParkingData: "Pindahkan Gudang",
  Old_storage_location: "Lokasi Lama",
  New_storage_location: "Lokasi Baru",
  Transfer_quantity: "Kuantiti Pemindahan",
  Add_transfer_library: "Tambah Pemindahan",
  The_number_of_removable_warehouses: "Kuantiti Boleh Dipindahkan",
  Cannot_scan_the_same_database_location: "Tidak boleh imbas lokasi yang sama",
  This_product_does_not_exist_in_this_repository_Please_scan_other_repositories: "Tiada stok wujud untuk produk ini di lokasi ini. Sila imbas lokasi lain",
  Go_to_OMS1_0: "Lompat ke OMS 1.0",
  The_bar_code_cannot_exceed_100_characters: "Barcode tidak boleh melebihi 100 aksara",
  The_SKU_cannot_exceed_100_characters: "SKU tidak boleh melebihi 100 aksara",
  The_name_of_a_Chinese_product_cannot_exceed_300_characters: "Nama produk Cina tidak boleh melebihi 300 aksara",
  The_name_of_an_English_product_cannot_exceed_300_characters: "Nama produk Inggeris tidak boleh melebihi 300 aksara",
  Single_product_distribution: "Pemilihan satu item",
  singleProductDistribution: "Pemilihan satu item",
  tips: "Perhatian",
  Task_mode: "Kaedah tugasan",
  Get_task: "Dapatkan tugasan",
  Warehouse_partition: "Zon gudang",
  Distribution_box_scanning_box: "Medan imbasan bakul pemilihan",
  Distribution_basket_code: "Kod bakul pemilihan",
  Barcode_scanning_box_of_goods: "Medan imbasan kod bar produk",
  picture: "Imej",
  Allocated_goods: "Telah dipilih",
  To_be_distributed: "Tungguh pemilihan",
  stock: "Stokin",
  view_details: "Lihat butiran",
  details: "Butiran",
  Logistics_channel: "Saluran Logistik",
  Please_enter_customer_ID: "Sila masukkan ID Pelanggan",
  conveyor: "Pita Konveyor",
  please_scan_the_distribution_basket: "Sila imbas bakul pemungutan",
  The_basket_does_not_exist: "Bakul ini tidak wujud",
  Quantity_of_goods_allocated: "Kuantiti Dipungut",
  When_you_do_not_need_to_pick_and_ship_you_do_not_need_to_carry_the_basket_number_please_scan_the_distribution_basket_code_directly: "Apabila tiada pengasingan diperlukan untuk penghantaran, tiada keperluan untuk memasukkan nombor bakul. Sila imbas kod bakul pemungutan terus!",
  When_scanning_the_sorting_basket_the_basket_number_is_missing_please_rescan: "Imbas bakul penyortiran: nombor bakul tiada. Sila imbas semula",
  Quantity_sorted: "Kuantiti disortir",
  Quantity_of_goods_to_be_allocated: "Kuantiti menunggu peruntukan",
  distributor: "Pengendali peruntukan",
  Distribution_time: "Masa peruntukan",
  Total_quantity_to_be_allocated: "Jumlah kuantiti menunggu peruntukan",
  abnormal_quantity: "Kuantiti luar biasa",
  Distribution_start_time: "Masa mula peruntukan",
  Distribution_end_time: "Masa tamat peruntukan",
  Bulk_allocation: "Peruntukan kelompok",
  Sorting_query: "Permintaan penyortiran",
  Separate_sorting_and_shipping: "Penghantaran penyortiran individu",
  Total_sorting_quantity: "Jumlah kuantiti disortir",
  Sorting_stage: "Tahap penyortiran",
  Sorting_end_time: "Masa tamat penyortiran",
  sorter: "Pengutip",
  reauthorize: "Benarkan semula",
  Prepare_a_single_item_distribution_basket_in_the_current_warehouse: "Sediakan bakul kutipan satu item untuk gudang semasa",
  Scan_the_distribution_basket: "Imbas bakul kutipan",
  Scanning_product_bar_code: "Imbas kod bar produk",
  Click_the_quantity_of_allocated_goods_to_batch_allocate_goods: "Klik 'Kuantiti Dikutip' untuk melakukan kutipan pukal",
  Scan_the_corresponding_warehouse_location_for_distribution: "Imbas lokasi penyimpanan yang sepadan untuk kutipan",
  Take_the_goods_that_have_been_allocated_and_scan_the_goods_directly_to_be_shipped: "Bawa barangan yang dipilih dan imbas terus untuk penghantaran",
  Click_the_shipped_quantity_to_ship_in_bulk: "Klik kuantiti yang dihantar untuk penghantaran secara pukal",
  Click_on_the_selected_quantity_to_pick_in_bulk: "Klik kuantiti yang dipilih untuk pemilihan secara pukal",
  Scan_the_sorting_basket_head: "Imas baris atas tong penyortiran",
  Scan_all_distribution_baskets: "Imas semua tong pemungutan",
  Place_in_the_corresponding_sorting_basket: "Letakkan barangan ke dalam tong penyortiran yang sepadan",
  Scan_the_sorting_basket: "Imas tong penyortiran",
  Scan_all_products: "Imas semua barangan",
  priority_in_delivery: "Penghantaran keutamaan",
  Confirmation_marked_as_priority_shipment: "Tandakan sebagai penghantaran keutamaan",
  Click_on_the_shipped_quantity_to_scan_in_bulk: "Klik kuantiti yang dihantar untuk imbasan secara pukal",
  Carry_out_the_corresponding_weighing_photo_operation_to_deliver_the_goods: "Laksana operasi menimbang dan mengambil gambar yang berkaitan untuk penghantaran",
  multiProductDistribution: "Pemilihan berbilang item",
  singleItemDelivery: "Penghantaran satu item",
  Packaging_material: "Bahan pembungkusan",
  Order_information: "Butiran pesanan",
  orderInfo: "Butiran pesanan",
  total: "Jumlah",
  Shipper: "Pembilang",
  package_photo: "Gambar bungkusan",
  Package_material_information: "Maklumat pembungkusan",
  Waybill_number: "Nombor waybill",
  Has_been_inspected: "Disemak",
  pending_inspection: "Menunggu pemeriksaan",
  abnormal_delivery: "Anomali penghantaran",
  Photograph: "Gambar",
  Enter_key_to_take_a_photo: "Tekan Enter untuk ambil gambar",
  Please_weigh_the_order: "Sila timbang pesanan",
  Please_photos_the_order: "Sila ambil gambar pesanan",
  Out_of_stock_successfully: "Penghantaran keluar berjaya",
  The_order_number_cannot_be_empty: "Nombor pesanan tidak boleh dibiarkan kosong!",
  submit: "Hantar",
  send_back: "Batal",
  Flag_exception: "Tandakan sebagai anomali",
  sensitized: "Aktifkan",
  weigh: "Timbang",
  Remaining_shipment_quantity: "Baki kuantiti untuk dihantar",
  Quantity_shipped: "Kuantiti telah dihantar",
  Quantity_of_goods_to_be_shipped: "Kuantiti menunggu penghantaran",
  The_barcode_does_not_exist: "Bar kod untuk item ini tidak wujud",
  Follow_these_steps_to_fill_in_the_standard_template_and_import_the_data: "Sila lengkapkan templat standard dan import data seperti berikut:",
  Header_Entry_order_information_In_the_template_fill_in_the_data_of_the_table_header_from_order_type_to_remarks_Each_row_represents_an_entry_orderentry_order: "1. Maklumat Dokumen Masuk/Penghantaran: Dalam templat, lengkapkan lajur tajuk dari Jenis Pesanan hingga Komen. Setiap baris mewakili satu dokumen masuk/penghantaran.",
  Box_product_information_In_the_template_fill_in_the_table_head_data_from_the_box_number_to_the_weight_KG_box_Each_row_represents_a_box_of_products: "2. Maklumat Produk Kotak: Dalam templat, lengkapkan lajur tajuk dari Nombor Kotak hingga Berat (kg/kotak). Setiap baris mewakili satu kotak produk.",
  Please_ensure_that_each_item_is_filled_in_accurately_and_follow_the_example_after_downloading_the_standard_template: "Pastikan semua data diisi dengan tepat. Muat turun templat piawai dan ikuti format contoh.",
  The_weight_must_not_be_less_than_or_equal_to_0: "Berat tidak boleh kurang atau sama dengan 0",
  Exceeds_the_maximum_weight_please_re_enter: "Jika melebihi berat maksimum, sila masukkan semula",
  Unable_to_access_the_camera: "Tidak dapat mengakses kamera",
  Error_uploading_files_to_Alibaba_Cloud_Please_contact_the_administrator: "Pemunggahan fail ke Alibaba Cloud gagal. Hubungi pentadbir",
  The_number_of_anomalies_entered_is_incorrect: "Jumlah tidak sah dimasukkan",
  advanceLoadingSingleItemDelivery: "Penghantaran satu item (muatan awal)",
  advanceLoadingMultiProductDelivery: "Penghantaran berbilang item (muatan awal)",
  advanceLoadingExplosiveDelivery: "Penghantaran produk terlaris (muatan awal)",
  Only_xlsx_format_files_are_supported_for_import_and_the_size_cannot_exceed_15_MB_A_maximum_of_ten_thousand_rows_of_data_can_be_imported: "Hanya fail format xlsx disokong, dengan saiz maksimum 15MB dan sehingga 10,000 baris.",
  multiProductSorting: "Pengasingan berbilang item",
  The_sorting_basket_does_not_exist_or_is_already_occupied_Please_refresh_and_try_again: "Ruang pengasingan ini tidak wujud atau sedang digunakan. Sila segar semula dan cuba lagi.",
  Basket_state: "Status ruang",
  Please_Select_Basket_state: "Sila pilih status ruang",
  The_distribution_basket_does_not_exist: "Ruang peruntukan ini tidak wujud",
  Sort_the_basket_head: "Header ruang pengasingan",
  Task_details: "Butiran tugasan",
  Distribution_basket_not_scanned: "Bakul pemungutan belum diimbas",
  Remaining_sorting_orders: "Pesanan penyusunan yang tinggal",
  Quantity_of_remaining_sorting: "Jumlah penyusunan yang tinggal",
  Sorting_abnormal_quantity: "Bilangan anomali penyusunan",
  Sorting_start_time: "Masa mula penyusunan",
  The_list_has_been_picked: "Senarai pemungutan",
  Pick_details: "Butiran pemungutan",
  Sorting_number: "ID Penyusunan",
  Quantity_picked: "Jumlah dipungut",
  Quantity_to_be_picked: "Jumlah menunggu pemungutan",
  Bulk_pick_quantity: "Jumlah pemungutan kelompok",
  Allotment_quantity: "Jumlah diperuntukkan",
  number_of_pages: "Nombor halaman",
  Select_the_SKU_that_you_want_to_replace: "Pilih SKU yang memerlukan penggantian",
  When_entering_transaction_numbers_in_batches_separate_them_with_line_breaks_or: "Apabila memasukkan nombor transaksi secara pukal, pisahkan dengan pemisah baris atau koma",
  Multi_product_delivery: "Penghantaran Pelbagai Barangan",
  multiProductDelivery: "Penghantaran Pelbagai Barangan",
  newMultiProductDelivery: "Penghantaran Pelbagai Barangan Baru",
  IF_Need_to_take_pictures: "Perlukan Fotografi?",
  IF_Need_to_be_weighed: "Perlukan Penimbangan?",
  Priority_Shipping_Orders: "Pesanan Penghantaran Keutamaan",
  Scanning_sorting_blue_head: "Imbas Header Bakul Penyortiran",
  Number_of_current_product_types: "Kategori & Kuantiti Barangan Semasa",
  kind: "Kategori",
  indivual: "Barangan",
  dispatcher: "Pemeriksa",
  Shipping_Basket: "Bakul Penyortiran",
  Preview_photo: "Praperhatian Foto",
  reshoot: "Rakam Semula",
  No_photos_yet: "Tiada Foto Tersedia",
  determine: "Sahkan",
  Sorting_error_No_basket_number: "Ralat penyusunan, tiada ID bakul",
  The_current_task_is_complete: "Tugas semasa telah selesai",
  Loading_a_sheet: "Memuatkan label penghantaran",
  Transaction_number_only: "ID Transaksi sahaja",
  Transaction_number_and_order_weight: "ID Transaksi dan berat pesanan",
  Waybill_No_only: "Nombor waybill sahaja",
  Shipment_number_and_order_weight_only: "Nombor waybill dan berat pesanan sahaja",
  Shipping_format: "Format penghantaran",
  Freight_mode: "Kaedah penghantaran",
  Scan_delivery_information: "Imbas butiran penghantaran",
  add_basket_head: "Tambah tajuk bakul",
  save: "Simpan",
  Cancel: "Batal",
  sequence: "Nombor susunan",
  Please_enter_basket_header: "Sila masukkan tajuk bakul",
  Add_basket: "Tambah bakul",
  Edit_basket: "Sunting Bakul",
  Basket_Type: "Jenis Bakul",
  basket_head: "Header Bakul",
  basket_name: "Nama Bakul",
  Batch_create_baskets: "Buat Bakul Secara Berkumpulan",
  Please_select_a_basket_type: "Sila pilih jenis bakul",
  Basket_description: "Keterangan Bakul",
  Please_enter_a_basket_description: "Sila masukkan keterangan bakul",
  sorting_basket: "Bakul Penyusunan",
  Allotment_basket: "Bakul Pemilihan",
  Please_select_a_distribution_basket: "Sila pilih bakul pemilihan",
  Sorting_basket_number: "Nombor Bakul Penyusunan",
  Allocation_phase: "Tahap Pemilihan",
  Allotment_basket_item: "Bakul Pemilihan (Satu Barangan)",
  quality_inspection_basket: "Bakul Pemeriksaan Kualiti",
  other_types: "Jenis Lain",
  Operation_time: "Masa Operasi",
  Can_only_contain_letters_and_numbers: "Hanya mengandungi huruf dan nombor",
  print_basket_number: "Cetak Nombor Bakul",
  starting_number: "Nombor Permulaan",
  Please_enter_the_starting_number: "Sila masukkan nombor permulaan",
  end_number: "Nombor Penamat",
  Please_enter_the_end_number: "Sila masukkan nombor penamat",
  The_label_specification: "Spesifikasi Label",
  The_starting_number_must_be_less_than_the_ending_number: "Nombor penamat mesti lebih besar daripada nombor permulaan",
  If_you_enter_the_start_number_2_end_number_5_and_basket_prefix_A_the_basket_will_be_generated_A2_A3_A4_A5: "Sebagai contoh: Memasukkan nombor permulaan 2, nombor penamat 5, dan tajuk bakul A akan menjana bakul: A-2, A-3, A-4, A-5",
  custom_specification: "Spesifikasi Label Tersuai",
  operational_context: "Butiran Operasi",
  Basket_number: "Nombor Bakul",
  Please_enter_the_basket_name: "Sila masukkan nombor bakul",
  Bulk_allocation_quantity: "Kuantiti peruntukan kelompok",
  available: "Tersedia",
  occupy: "Dikuasai",
  Allocation_task_for_additional_packing_material_delivery: "Bahan pembungkusan tambahan diperlukan untuk penghantaran!",
  The_basket_needs_to_be_placed_in_the_special_packing_area_of_the_item: "Bakul ini mesti diletakkan di kawasan pembungkusan khas untuk item individu",
  The_basket_needs_to_be_placed_in_the_special_packing_area_for_explosive_products: "Bakul ini mesti diletakkan di kawasan pembungkusan khas untuk barangan terlaris",
  Please_place_in_the_nearest_single_item_delivery_area: "Peruntukan selesai! Sila letakkan di zon penghantaran item individu yang terdekat",
  Distribution_completed_Please_place_it_in_the_nearest_delivery_area: "Pemilihan selesai! Sila letakkan di kawasan penghantaran barangan terlaris terdekat",
  If_the_inspection_fails_contact_the_administrator: "Pengesahan waybill gagal. Hubungi pentadbir untuk penyelesaian",
  Incorrect_ticket_address_Failed_to_read_the_ticket: "Alamat waybill tidak betul: gagal membaca waybill",
  Failed_to_parse_the_PDF_content: "Kandungan waybill rosak: gagal mentafsir kandungan PDF",
  Failed_to_convert_PDF_to_JPG: "Gagal menukar PDF kepada JPG",
  Failed_to_parse_the_JPG_content: "Gagal mentafsir kandungan JPG",
  The_surface_bill_does_not_match_the_waybill: "Waybill tidak sepadan dengan nota penghantaran",
  Enter_product_bar_codes_separated_by_SKU_line_breaks_for_batch_query: "Sila masukkan kod bar produk dan SKU yang dipisahkan dengan pemisah baris, kemudian klik butang pertanyaan pukal untuk melakukan carian pukal.",
  Getting_data: "Mencari data...",
  The_shipping_mark_is_being_rendered: "Memaparkan label...",
  Rendering_box_label: "Memaparkan penandaan kotak...",
  Print_function_saved_as_PDF: "Fungsi cetakan: Simpan sebagai PDF",
  Set_the_default_printer_to: "Tetapkan pencetak lalai kepada",
  Microsoft_Print_to_PDF: "Microsoft Print to PDF",
  Or_set_it_in_the_print_window_that_pops_up_after_you_click_Print: "Konfigurasikan tetapan dalam kotak dialog cetakan yang muncul selepas mengklik Cetak",
  After_setting_up_the_printer_click_Print_and_click_OK: "Selepas menetapkan pencetak, klik Cetak kemudian klik OK",
  Note_When_the_printer_does_not_have_suitable_paper_A4_paper_can_be_used_using_the_top_zoom_function_to_adjust: "Nota: Jika pencetak kekurangan kertas yang sesuai, gunakan kertas A4 dan laras melalui fungsi penskalaan atas.",
  If_the_number_of_export_boxes_exceeds_300_boxes_it_will_be_divided_into_multiple_files_If_you_do_not_want_to_be_divided_into_multiple_files_please_use_the_print_function: "Nota: Apabila menyimpan sebagai PDF, mengeksport lebih daripada 300 kotak akan membahagikan fail kepada beberapa bahagian. Untuk mengelakkan pembahagian, gunakan fungsi cetakan.",
  Charge_items: "Jenis Caj",
  Add_currency_information: "Tambah Maklumat Caj",
  Edit_currency_information: "Sunting Maklumat Caj",
  special_price: "Harga Istimewa",
  default_price: "Harga Lalai",
  discounted_price: "Harga Diskun",
  Listing_fee: "Yuran Penyenaraian",
  order_processing_fee: "Yuran Pemprosesan Pesanan",
  orderProcessingFee: "Yuran Pengendalian",
  Destruction_delisting_fee: "Yuran Pemusnahan/Penyingkiran",
  Return_reshelving_fee: "Yuran Penyenaraian Semula Barangan Dikembalikan",
  Return_listing_fee: "Yuran Penyenaraian Barangan Dikembalikan",
  currency: "Mata Wang",
  currency_Type: "Jenis Mata Wang",
  Please_select_currency_type: "Sila pilih jenis mata wang",
  Please_enter_SKU: "Sila masukkan SKU",
  Please_enter_Stock: "Sila masukkan gudang",
  Please_enter_a_range_fee: "Sila masukkan yuran julat",
  Please_enter_the_number_of_ranges: "Sila masukkan kuantiti julat",
  Please_select_Charge_items: "Sila pilih jenis caj",
  expense_breakdown: "Butiran Yuran",
  Order_Status: "Status Pesanan",
  Empty_product_details_exist_Please_check_and_try_again: "Butiran produk tidak sah dikesan. Sila semak dan cuba semula.",
  There_are_duplicate_product_details_Please_check_and_try_again: "Butiran produk duplikat wujud. Sila semak dan cuba semula.",
  Skus_and_bar_codes_can_only_contain_English_numbers_and_symbols_and_Spaces: "SKU dan kod bar produk mesti terdiri daripada huruf Inggeris, nombor, dan simbol (- , ., _, ruang) sahaja.",
  After_activation_all_receiving_and_quality_inspection_information_will_be_cleared_The_stage_of_the_inbound_order_will_be_changed_to_Tail_end_Receiving_in_Progress_Please_complete_the_receiving_and_quality_inspection_operations_again: "Pengaktifan akan memadam semua rekod resit dan pemeriksaan kualiti. Tahap masuk akan bertukar kepada 'Resit Penghantaran Akhir'. Sila lengkapkan semula prosedur resit dan pemeriksaan.",
  If_necessary_please_make_sure_to_save_the_relevant_delivery_and_quality_inspection_information_before_activation: "Jika perlu, sila simpan data penerimaan dan pemeriksaan kualiti yang berkaitan sebelum pengaktifan",
  SKU: "SKU",
  Modified_by: "Pemodifikat",
  founder: "Pencipta",
  Please_enter_founder: "Sila masukkan pencipta",
  Please_enter_Modified_by: "Sila masukkan pemodifikat",
  tip: "Prompt",
  Confirm_before_deleting: "Adakah anda pasti ingin memadam data ini? Pemadaman adalah muktamad!",
  other: "Lain-lain",
  ProductID: "Nombor Item",
  batch_number: "Nombor Batch",
  Load_rate: "Kadar Penyimpanan",
  Menu_list: "Senarai Menu",
  menuList: "Senarai Menu",
  add_Menu: "Tambah Menu",
  Batch_add_menu: "Tambah Menu Batch",
  Edit_Menu: "Sunting Menu",
  Menu_Name: "Nama Menu Cina",
  Menu_EnName: "Nama Menu Inggeris",
  Please_enter_the_Menu_Name: "Sila masukkan nama menu Cina",
  Please_enter_the_Menu_EnName: "Sila masukkan nama menu Inggeris",
  Please_enter_menu_sort: "Sila masukkan susunan penyusunan menu",
  Menu_function: "Fungsi Menu",
  Menu_Icon: "Ikon",
  catalogue: "Direktori",
  Menu_Path: "Alamat Menu",
  structure_configuration: "Konfigurasi Struktur",
  Please_enter_the_Menu_Path: "Sila masukkan alamat capaian",
  Menu_Sort: "Susunan Penyusunan Menu",
  Menu_Code: "Kod Menu",
  MenuPlease_enter_the_Menu_Code: "Sila masukkan kod menu",
  MenuPlease_enter_the_Menu_address: "Sila masukkan alamat menu",
  Please_enter_Menu_Sort: "Sila masukkan susunan penyusunan",
  Menu_Name_Not_Null: "Nama Menu Cina tidak boleh kosong",
  Menu_EnName_Not_Null: "Nama Menu Inggeris tidak boleh kosong",
  Menu_Code_Not_Null: "Kod Menu tidak boleh kosong",
  Paren_Menu: "Menu Induk",
  Son_Menu: "Menu Anak",
  Please_Select_Paren_Menu: "Sila pilih menu ibu bapa",
  Please_Select_Son_Menu: "Sila pilih menu anak",
  Menu_Level: "Tahap Menu",
  Menu_creator: "Pencipta Menu",
  Menu_modifier: "Pemodifikasi Menu",
  Menu_creation_time: "Tarikh Penciptaan Menu",
  Menu_change_time: "Tarikh Pengubahsuaian Menu",
  Menu_Type: "Jenis Menu",
  Menu_Stair: "Tahap 1",
  Menu_Second: "Tahap 2",
  Menu_Three: "Tahap 3",
  Visible: "Kelihatan",
  Remark: "Nota",
  RemarkInfo: "Maklumat Nota",
  Please_Input_Remark: "Sila masukkan nota",
  scanWaybillNumber: "Imbas Nombor Waybill",
  initialDistributionFlowLog: "Log Pengagihan Peringkat Awal",
  logisticsChannelManagement: "Pengurusan Saluran Logistik",
  logisticsChannelManagementList: "Senarai Pengurusan Saluran Logistik",
  roleInfo: "Maklumat Peranan",
  sysRole: "Senarai Peranan",
  roleList: "Senarai Peranan",
  Role_CnName: "Nama Peranan dalam Bahasa Cina",
  Role_EnName: "Nama Peranan dalam Bahasa Inggeris",
  Role_Code: "ID Unik Peranan",
  Role_IsStart: "Diaktifkan",
  Add_Role: "Tambah Peranan",
  Edit_Role: "Tambah Peranan",
  Role_Name: "Nama Peranan",
  Please_Input_Role_Name: "Sila masukkan nama peranan",
  Please_Input_Role_CnName: "Sila masukkan nama peranan dalam Bahasa Cina",
  Please_Input_Role_EnName: "Sila masukkan nama peranan dalam Bahasa Cina",
  Please_Input_Role_Code: "Sila masukkan ID unik peranan",
  Reset: "Seting Semula",
  ResetQuery: "Seting Semula Carian",
  reset_data: "Seting Semula Data",
  Role_Sort: "Susun",
  Role_CnName_Not_Null: "Nama Peranan dalam Bahasa Cina tidak boleh kosong",
  Role_EnName_Not_Null: "Nama Peranan dalam Bahasa Inggeris tidak boleh kosong",
  Role_Code_Not_Null: "ID Unik Peranan tidak boleh kosong",
  Accredit_Menu: "Menu Bertauliah",
  Accredit_Stock: "Repositori Kebenaran",
  More: "Lagi",
  Editing_role: "Sunting Peranan",
  Modifying_Role_Permissions: "Ubah Kebenaran Peranan",
  Role_describe: "Keterangan Peranan",
  blocked_balances: "Baki Beku",
  Amount_of_gift: "Jumlah Dibenarkan",
  Adjustment_type: "Jenis Pelarasan",
  Adjustment_blocked_balances: "Laras Baki Beku",
  Adjustment_Amount_of_gift: "Laras Jumlah Dibenarkan",
  role_state: "Status Peranan",
  usersList: "Senarai Pengguna",
  usersInfo: "Maklumat Pengguna",
  userManagement: "Pengurusan Pengguna",
  User_Code: "Akaun Pengguna",
  User_Name: "Nama Pengguna",
  User_CnName: "Nama Peranan dalam Bahasa Cina",
  Owning_warehouse: "Repositori",
  Role: "Peranan",
  RoleManagement: "Pengurusan Peranan",
  user_password: "Kata Laluan Pengguna",
  staff: "Pekerja",
  staffManagement: "Pengurusan Pekerja",
  dictionaries: "Kamus",
  region: "Wilayah",
  stateManagement: "Pengurusan Negara",
  User_Branch: "Jabatan",
  User_Phone: "Mudah Alih",
  User_Rank: "Jawatan",
  User_Email: "E-mel",
  User_EntryDate: "Tarikh Mula",
  User_Status: "Status Pengguna",
  commonUser: "Pengguna Standard",
  service: "Perkhidmatan Pelanggan",
  open: "Diaktifkan",
  finance: "Kewangan",
  salesman: "Wakil Jualan",
  salesmanager: "Pengurus Jualan",
  superuser: "Pengguna Super",
  overseasagency: "Ejen Luar Negara",
  Please_select_User_Status: "Sila pilih status pengguna",
  Please_select_User_Role: "Sila pilih peranan pengguna",
  Please_select_User_Type: "Sila pilih jenis pengguna",
  Please_select_User_Branch: "Sila pilih jabatan",
  Please_select_User_Sex: "Sila pilih jantina",
  Please_select_salesman: "Sila pilih wakil jualan",
  Please_select_service: "Sila pilih perkhidmatan pelanggan",
  User_Type: "Jenis Pengguna",
  User_Sex: "Jantina Pengguna",
  man: "Lelaki",
  woman: "Wanita",
  User_Emergency: "Nombor Kenalan Kecemasan",
  User_PassWord: "Kata Laluan",
  User_confirmPassWord: "Sahkan Kata Laluan",
  User_IDNumber: "Kad Pengenalan",
  User_Address: "Alamat Kediaman",
  User_Unit: "Organisasi",
  warehouseList: "Senarai Gudang",
  transshipmentdepot: "Gudang Penghantaran",
  Please_Input_User_Name: "Sila masukkan nama pengguna",
  Please_Input_transshipmentdepot: "Sila masukkan gudang penghantaran",
  Please_select_transshipmentdepot: "Sila pilih gudang penghantaran",
  Please_select_stock: "Sila pilih gudang",
  Please_Input_User_Code: "Sila masukkan kod pengguna",
  Please_Input_User_PassWord: "Sila masukkan kata laluan",
  Please_Input_User_confirmPassWord: "Sila sahkan kata laluan",
  Please_Input_User_Rank: "Sila masukkan jawatan",
  Please_Input_User_IDNumber: "Sila masukkan nombor ID",
  Please_Input_User_Emergency: "Sila masukkan nombor hubungan kecemasan",
  Please_Input_User_Phone: "Sila masukkan nombor telefon bimbit",
  Please_enter_the_correct_mobile_number: "Sila masukkan nombor telefon bimbit yang sah",
  Please_Input_User_Address: "Sila masukkan alamat kediaman",
  Please_Input_User_Email: "Sila masukkan alamat e-mel",
  Please_enter_the_correct_email_address: "Sila masukkan alamat e-mel yang sah",
  Please_Input_User_Unit: "Sila masukkan organisasi",
  Please_Input_User_Status: "Sila pilih status",
  Please_Input_User_Role: "Sila pilih peranan",
  Entered_passwords_differ: "Kod kata yang dimasukkan tidak sepadan",
  The_password_contains_less_than_characters: "Panjang kata laluan mesti sekurang-kurangnya 6 aksara",
  Tpntbco816dolnos: "Kata laluan mesti mengandungi 8-16 aksara yang terdiri daripada huruf, nombor dan simbol!",
  The_password_must_contain_8_to_16_characters: "Panjang kata laluan hendaklah 8-16 aksara",
  It_is_currently_being_exported: "Kini sedang mengeksport",
  When_there_are_many_PDFS_to_be_saved_it_is_recommended_to_export_them_in_batches: "Apabila menyimpan beberapa fail PDF, pengeluaran pukal disyorkan",
  It_is_recommended_when_there_are_a_large_number_of_PDFS_to_be_saved: "Apabila menyimpan beberapa fail PDF, adalah digalakkan untuk",
  Export_in_batches: "mengeksport secara pukal",
  The_left_navigation_allows_you_to_select_the_number_of_boxes_to_printSKU_and_quantity: "Navigasi kiri membolehkan pemilihan kiraan kotak cetakan, SKU, kuantiti",
  Add_User: "Tambah pengguna baharu",
  Please_Select: "Sila pilih",
  Please_select_the_print_size: "Sila pilih saiz cetakan",
  Please_select_a_single_customer: "Sila pilih pelanggan individu",
  Please_select_print_data: "Sila pilih data cetakan",
  Please_select_a_single_warehouse: "Sila pilih gudang individu",
  Please_select_the_same_order_type_order: "Sila pilih pesanan bagi jenis pesanan yang sama",
  Please_Select_Task_Name: "Sila pilih nama tugasan",
  Please_Select_Order: "Sila pilih pesanan",
  Please_select_the_business_condition: "Sila pilih senario perniagaan",
  Please_Select_Date: "Sila pilih masa",
  Please_select_billing_properties: "Sila pilih atribut pengebilan",
  Please_select_whether_it_can_be_edited: "Sila pilih sama ada boleh disunting",
  Enabled: "Aktifkan",
  Batch_enabled_goods: "Aktifkan produk secara pukal",
  Prohibited_goods_in_bulk: "Nyahaktifkan produk secara pukal",
  Close: "Nyahaktifkan",
  all_transshipmentdepot: "Semua Gudang Penghantaran",
  all_warehouse: "Semua Gudang",
  Please_select_a_type: "Sila pilih jenis",
  Please_select_content: "Sila pilih kandungan",
  Cost_information: "Maklumat Yuran",
  Please_select_a_contact: "Sila pilih orang yang boleh dihubungi",
  The_same_rule_already_exists: "Peraturan identik sudah wujud",
  Please_select_the_goods_for_which_the_storage_location_needs_to_be_changed: "Sila pilih produk yang memerlukan perubahan lokasi penyimpanan",
  all_partition: "Semua Zon",
  enabled_product: "Aktifkan Produk",
  prohibited_product: "Nyahaktifkan Produk",
  set_inventory_warning: "Tetap Tanda Amaran Stok",
  When_a_single_warehouse_is_selected_either_the_priority_picking_floor_or_the_priority_picking_zone_must_be_filled_in_one_of_the_two: "Apabila memilih satu gudang, Lantai Pemilihan Keutamaan dan Zon Pemilihan Keutamaan adalah medan wajib (pilih satu)",
  department: "Jabatan",
  Investment_promotion_department: "Pembangunan Perniagaan",
  accounting_department: "Kewangan",
  customer_service_department: "Perkhidmatan Pelanggan",
  management_department: "Pentadbiran",
  oversea_location: "Gudang Luar Negara",
  distribution: "Pengedaran",
  IT: "IT",
  Logistics_Department: "Logistik",
  staffList: "Senarai Pekerja",
  personal_details: "Maklumat Peribadi",
  contact_Information: "Maklumat Kenalan",
  Owning_Information: "Maklumat Afiliasi",
  account_Information: "Maklumat Akaun",
  upload_photo_as_avatar: "Muat naik Gambar Profil",
  staffInfo: "Maklumat Pekerja",
  staff_name: "Nama Pekerja",
  staff_Code: "Akaun Pekerja",
  staff_Status: "Status Pekerja",
  staff_Role: "Peranan Pekerja",
  staff_gender: "Jantina Pekerja",
  staffType: "Jenis Pekerja",
  staff_password: "Kata Laluan Pekerja",
  Laborial_Staff: "Pekerja Kerap",
  Administrator: "Pentadbir",
  Please_enter_the_employee_name: "Sila masukkan nama pekerja",
  Please_enter_your_employee_ID: "Sila masukkan akaun pekerja",
  Please_select_member_type: "Sila pilih jenis pekerja",
  createStaff: "Buat Pekerja",
  editStaff: "Sunting Pekerja",
  Please_select_member: "Sila pilih pekerja",
  Please_select_an_employee_role: "Sila pilih peranan pekerja",
  batch_edit_staff_type: "Sunting pukal jenis pekerja",
  create_staff: "Buat Pekerja",
  batch_create_staff: "Buat pekerja secara pukal",
  batchCreateStaff: "Buat pekerja secara pukal",
  batch_modify: "Sunting pukal",
  Import_employees: "Import pekerja",
  Enter_employee_account: "Akses akaun pekerja",
  Prioritize_stock_allocation: "Peruntukan keutamaan",
  Module_Permissions: "Kebenaran modul",
  All_Modules: "Semua modul",
  After_selecting_a_module_you_can_view_the_data_of_restricted_modules: "Selepas memilih modul, data daripada modul terhad akan dapat dilihat",
  provided_that_the_corresponding_warehouse_or_transit_permissions_are_set: "Dengan syarat kebenaran gudang/gudang transit yang sepadan telah dikonfigurasikan",
  Add_consumables_type: "Tambah Jenis Bahan Penggunaan Baru",
  Edit_consumables_type: "Sunting Jenis Bahan Penggunaan",
  Consumable_name: "Nama Bahan Penggunaan",
  Description_of_consumables: "Keterangan Bahan Penggunaan",
  Please_enter_the_consumable_name: "Sila masukkan nama bahan penggunaan",
  Please_enter_a_description_of_the_consumable: "Sila masukkan keterangan bahan penggunaan",
  type_name: "Nama Jenis",
  Type_description: "Keterangan Jenis",
  Change_the_time: "Masa Pengubahsuaian",
  Add_consumables: "Tambah Bahan Penggunaan Baru",
  Add_consumable_information: "Tambah Maklumat Bahan Penggunaan Baru",
  Editing_Supplies_Information: "Sunting Maklumat Bahan Penggunaan",
  Consumables_Code: "Kod Bahan Penggunaan",
  Consumable_size: "Dimensi Bahan Penggunaan",
  Number_of_consumables: "Kuantiti Bahan Penggunaan",
  single_standard_price: "Harga Standard Unit",
  long: "Panjang",
  long_cm: "Panjang (cm)",
  outer_box_long_cm_one: "Panjang Kotak Luaran (cm/item)",
  Receiving_outer_box_long_cm_one: "Panjang Kotak Luaran Diterima (cm/unit)",
  please_enter_Receiving_outer_box_long_cm_one: "Sila masukkan panjang kotak luaran diterima (cm/unit)",
  width: "Lebar",
  width_cm: "Lebar (cm)",
  outer_box_width_cm_one: "Lebar Kotak Luaran (cm/unit)",
  Receiving_outer_box_width_cm_one: "Lebar Kotak Luaran Diterima (cm/unit)",
  please_enter_Receiving_outer_box_width_cm_one: "Sila masukkan lebar kotak luaran diterima (cm/unit)",
  Received_weight_KG_one: "Berat Diterima (kg/unit)",
  Received_weight_KG: "Berat Diterima",
  please_enter_Received_weight_KG_one: "Sila masukkan berat diterima (kg/unit)",
  height: "Tinggi",
  height_cm: "Tinggi (cm)",
  outer_box_height_cm_one: "Tinggi Kotak Luaran (cm/item)",
  Receiving_outer_box_height_cm_one: "Tinggi Kotak Luaran Penerimaan (cm/item)",
  please_enter_Receiving_outer_box_height_cm_one: "Sila masukkan tinggi kotak luaran penerimaan (cm/item)",
  Please_enter_the_consumable_code: "Sila masukkan kod barang habis guna",
  Please_enter_length_width_and_height: "Sila masukkan dimensi panjang, lebar, dan tinggi",
  Please_enter_the_quantity_of_consumables: "Sila masukkan kuantiti barang habis guna",
  Please_enter_a_single_standard_price: "Sila masukkan harga standard unit",
  Please_select_a_warehouse: "Sila pilih gudang",
  Please_enter_warehouse: "Sila masukkan gudang",
  Please_select_a_consumable_type: "Sila pilih jenis barang habis guna",
  Consumable_Type: "Jenis Barang Habis Guna",
  Billing_way: "Kaedah Pengebilan",
  The_priority_billing_method_shall_prevail: "Kaedah pengebilan keutamaan terpakai",
  Excluding_the_amount: "Jumlah dikecualikan",
  Automatically_calculate_the_estimated_inventory_formula: "Mengira secara automatik formula stok amaran",
  All_billing_methods_will_be_calculated_and_the_highest_fee_will_be_taken_as_the_standard: "Semua kaedah pengebilan akan dikira; kaedah dengan kos tertinggi akan digunakan",
  Billing_attribute: "Atribut Pengebilan",
  Stores_operation_accounting_attributes: "Atribut Pengebilan Operasi Gudang",
  Precedence_Billing_way: "Kaedah Pengebilan Utama",
  Please_select_Precedence_Billing_way: "Sila pilih kaedah pengebilan utama",
  The_number_of_the_first_charge: "Kuantiti Pengebilan Barangan Pertama",
  The_number_of_the_first_billing_item_must_not_be_less_than_1: "Kuantiti pengebilan barangan pertama tidak boleh kurang daripada 1",
  please_enter_The_number_of_the_first_charge: "Sila masukkan kuantiti pengebilan barangan pertama",
  Please_enter_the_number_of_items_for_which_the_charge_will_be_calculated: "Sila masukkan kuantiti pengebilan barangan seterusnya",
  The_continuation_charge_amount_cannot_be_less_than_1: "Jumlah Barangan Seterusnya tidak boleh kurang daripada 1",
  Please_select_Billing_way: "Sila pilih kaedah pengebilan",
  Volume_weight_value: "Nilai Berat Isipadu",
  Please_enter_volume_weight_value: "Sila masukkan nilai berat isipadu",
  Please_enter_the_case_number: "Sila masukkan nombor kontena",
  The_case_number_does_not_exist: "Nombor kontena tidak wujud!",
  The_sku_does_not_exist: "SKU tidak wujud",
  Save_receipt: "Simpan Resit",
  Save_receipt_succeed: "Resit berjaya disimpan",
  Please_stock_the_goods_at_the_specified_distribution_warehouse: "Sila ambil dari ruang peruntukan yang ditetapkan",
  putaway: "Penyimpanan",
  Inventory_batch_number: "Nombor Batch Inventori",
  unfinished: "Belum selesai",
  completed: "Selesai",
  Export_the_pairing_data: "Eksport Data Padanan",
  Currently_no_floor_is_added_to_the_warehouse_Please_perform_this_operation_after_adding_a_floor: "Tiada tingkat telah ditambah pada gudang semasa. Sila tambah tingkat sebelum meneruskan operasi ini.",
  If_the_selected_data_exists_the_selected_data_is_processed_preferentially_for_batch_processing: "Jika data yang dipilih wujud, keutamakan pemprosesan data yang dipilih untuk pemprosesan secara pukal.",
  If_the_selected_data_is_not_selected_manually_fill_in_the_box_number_range_for_batch_processing: "Apabila tiada data dipilih, masukkan secara manual julat nombor kotak untuk pemprosesan secara pukal.",
  If_the_field_value_is_empty_the_field_data_is_not_modified: "Apabila nilai medan kosong atau 0.00, data medan tersebut tidak akan diubah.",
  Momentumfee: "Tetapan Yuran Penghantaran Barangan Tunggal",
  export: "Eksport",
  Export_the_header_order: "Eksport Pesanan Keluar",
  Export_the_header_list: "Eksport Senarai Keluar",
  Export_the_First_bill: "Eksport Invois Keluar",
  Export_the_import_and_export_details: "Eksport Butiran Masuk/Keluar",
  Three_sides_before_weight: "Dimensi Dahulu, Berat Kedua",
  First_weight_then_three_sides: "Berat Dahulu, Dimensi Kedua",
  First_cubic_then_weight: "Meter Padu Dahulu, Berat Kedua",
  First_weight_then_cube: "Berat Dahulu, Meter Padu Kedua",
  First_cube_and_then_three_sides: "Meter Padu Dahulu, Dimensi Kedua",
  Three_sides_before_the_cube: "Dimensi Dahulu, Meter Padu Kedua",
  entryAndExitDetails: "Butiran Masuk/Keluar",
  add: "Tambah",
  Batch_add: "Tambah Berkumpulan",
  Batch_delete: "Padam Berkumpulan",
  date: "Tarikh",
  The_longest_edge: "Sisi Panjang Paling",
  Long_side: "Dimensi Kedua Panjang",
  The_shortest_edge: "Dimensi Pendek",
  weight: "Berat",
  Start_weight: "Berat Mula",
  End_weight: "Berat Akhir",
  weight_KG: "Berat (KG)",
  number: "Bilangan Barang",
  Add_interval: "Tambah Julat",
  SumThreeSides: "Jumlah Tiga Dimensi",
  SumThreeSides_CM: "Jumlah Tiga Dimensi (CM)",
  The_sum_of_the_three_sides_cannot_be_negative: "Jumlah Tiga Dimensi Tidak Boleh Negatif",
  First_packing_material_cost: "Yuran Bahan Pembungkusan Awal",
  Three_sides_length: "Jumlah Tiga Dimensi",
  Three_sides: "Tiga Dimensi",
  Start_hree_sides_length: "Tiga Dimensi Mula",
  End_hree_sides_length: "Tiga Dimensi Akhir",
  Three_sides_length_CM: "Jumlah Tiga Dimensi (CM)",
  actual_SumThreeSides: "Jumlah Sebenar Tiga Dimensi",
  actual_SumThreeSides_CM: "Jumlah Sebenar Tiga Dimensi (cm)",
  Continued_SKU_packaging_costs: "Yuran Pembungkusan SKU Tambahan",
  The_number_of_continuations_is_charged: "Barangan Tambahan Dikenakan",
  Please_enter_the_number_of_continuation_charges: "Sila masukkan barangan tambahan yang dikenakan",
  cost_a: "Yuran/barangan",
  Cost_attribute: "Atribut Yuran",
  cost_one_day_cube: "Yuran (hari/meter padu)",
  cube: "Meter Padu",
  Start_cube: "Meter Padu Permulaan",
  End_cube: "Meter Padu Akhir",
  Extra_charge: "Yuran Pengendalian SKU Tambahan",
  One_charge: "Yuran Pengendalian SKU Permulaan",
  One_Packaging_material: "Yuran Pembungkusan SKU Permulaan",
  Extra_Packaging_material: "Yuran Pembungkusan SKU Tambahan",
  Currency_type: "Mata Wang",
  Original_Currency_type: "Mata Wang Asal",
  Packaging_material_cost: "Yuran Pembungkusan",
  packagingMaterialManagement: "Pengurusan Pembungkusan",
  Please_enter_Currency_type: "Sila masukkan mata wang",
  Please_select_Currency_type: "Sila pilih mata wang",
  Please_enter_The_longest_edge: "Sila masukkan sisi terpanjang",
  Please_enter_Long_side: "Sila masukkan sisi kedua terpanjang",
  Please_enter_The_shortest_edge: "Sila masukkan sisi terpendek",
  Please_enter_weight: "Sila masukkan berat",
  Please_enter_quantity: "Sila masukkan kuantiti",
  Please_enter_SumThreeSides: "Sila masukkan jumlah panjang tiga sisi",
  Please_enter_cost_a: "Sila masukkan jumlah panjang tiga sisi",
  Please_enter_cost: "Sila masukkan yuran",
  Please_enter_Extra_charge: "Sila masukkan yuran pengendalian SKU tambahan",
  Please_enter_One_charge: "Sila masukkan yuran pengendalian SKU awal",
  Please_enter_number: "Sila masukkan bilangan item",
  Please_enter_One_Packaging_material: "Sila masukkan yuran pembungkusan SKU awal",
  Please_enter_Extra_Packaging_material: "Sila masukkan yuran pembungkusan SKU tambahan",
  Cancel_the_editor: "Batal suntingan",
  Cancel_the_add: "Batal tambah",
  Failed_to_start_the_camera_Please_check_whether_the_camera_is_available_Or_turn_on_the_camera_head: "Pengaktifan kamera gagal. Sila semak fungsi kamera! Sebagai alternatif, aktifkan akses kamera",
  This_operation_cannot_be_undone_Do_you_want_to_continue: "Tindakan ini tidak boleh dibatalkan. Teruskan?",
  size: "Dimensi",
  Please_select_size: "Sila pilih dimensi",
  Please_enter_size: "Sila masukkan dimensi",
  Three_high: "Panjang x Lebar x Tinggi",
  packaging: "Kaedah pembungkusan",
  The_whole_pack: "Pembungkusan keseluruhan pesanan",
  Pack_by_sku: "Pembungkusan berdasarkan SKU",
  Packing_according_to_the_entire_order_will_pack_all_the_items_in_the_entire_order_together: "Pengisian mengikut keseluruhan pesanan akan membundel semua barangan dalam pesanan tersebut bersama-sama",
  Package_according_to_SKU_and_pack_together_with_SKU: "Pengisian mengikut SKU akan membundel barangan dengan SKU yang sama bersama-sama",
  All_items_will_be_packaged_separately: "Semua barangan akan diisi secara berasingan",
  Create_a_warehouse_entry: "Buat Nota Penerimaan",
  Separate_product_packaging: "Pengisian Barangan Individu",
  editCost: "Sunting Yuran",
  outbound_pictures: "Gambar Hantar Keluar",
  photo_list: "Senarai Gambar",
  scan_pictures: "Imbas & Ambil Gambar",
  scanning_waybill_number: "Imbas Nombor Waybill",
  The_operation_fails_Check_whether_the_input_of_the_waybill_number_is_correct: "Operasi gagal. Sila semak semula nombor waybill yang dimasukkan.",
  Review_images: "Lihat Imej",
  Operation_of: "Pengendali",
  start_time: "Masa Mulai",
  End_days: "Tempoh (Hari)",
  Please_enter_the_start_time: "Sila masukkan masa mula",
  Please_enter_the_end_time: "Sila masukkan masa tamat",
  The_input_start_time_cannot_be_negative: "Masa mula yang dimasukkan tidak boleh negatif",
  The_end_time_cannot_be_negative: "Masa tamat yang dimasukkan tidak boleh negatif",
  The_start_time_cannot_be_later_than_the_end_time: "Masa mula tidak boleh lewat daripada masa tamat",
  The_end_time_cannot_be_later_than_the_start_time: "Masa tamat tidak boleh lebih awal daripada masa mula",
  end_time: "Masa tamat",
  Batch_set_roles: "Penugasan peranan kumpulan",
  Bulletin: "Pengumuman",
  BulletinManagement: "Pengurusan pengumuman",
  Bulletin_Type: "Jenis pengumuman",
  Bulletin_Name: "Tajuk pengumuman",
  This_window_asks_if_you_want_to_leave: "Tetingkap ini bertanya jika anda ingin keluar",
  The_information_you_enter_may_not_be_saved: "Masukan anda mungkin tidak disimpan",
  New_announcement: "Tambah pengumuman",
  announcementState: "Status pengumuman",
  workOrder: "Pengurusan pesanan kerja",
  workOrderList: "Senarai pesanan kerja",
  work_order_ID: "ID Tiket",
  problem_description: "Keterangan Isu",
  problem_types: "Jenis Isu",
  processed_time: "Masa Pemprosesan",
  processor: "Diproses Oleh",
  discuss: "Komen",
  ranking: "Tahap Penilaian",
  turn_off_time: "Masa Tutup",
  New_work_order: "Tambah Tiket Baru",
  result_of_handling: "Keputusan Pemprosesan",
  Please_enter_the_work_order_ID: "Sila masukkan ID Tiket",
  Please_provide_the_description_of_the_problem: "Sila masukkan Keterangan Isu",
  Please_provide_the_result_of_handling: "Sila masukkan Keputusan Pemprosesan",
  Work_order_information: "Maklumat Tiket",
  Should_this_work_order_be_invalidated: "Adakah tiket ini tidak sah?",
  to_deal_with: "Proses",
  Work_order_processing: "Pemprosesan Tiket",
  reply: "Balas",
  Please_select_the_type_of_question: "Sila pilih Jenis Isu",
  Please_select_the_rating_level: "Sila pilih Tahap Penilaian",
  Please_enter_your_evaluation: "Sila masukkan Penilaian",
  initiator: "Pengemukakan",
  Adding_dictionary_Categories: "Tambah Kategori Kamus",
  DictionaryList: "Senarai Kamus",
  dictionaryList: "Senarai Kamus",
  EditDictionary: "Sunting Kamus",
  Please_enter_the_dictionary_name: "Sila masukkan nama kamus",
  Name_of_dictionary: "Nama Kamus",
  Chinese_name: "Nama Cina",
  English_name: "Nama Inggeris",
  Goods_Chinese_name: "Nama Cina Produk",
  Goods_English_name: "Nama Inggeris Produk",
  setpoint: "Nilai Tetapan",
  Please_enter_Chinese_name: "Sila masukkan nama Cina",
  Please_enter_English_name: "Sila masukkan nama Inggeris",
  Please_enter_setpoint: "Sila masukkan nilai tetapan",
  Add_dictionary: "Tambah Kamus",
  Batch_Add_dictionary: "Tambah Kamus Secara Berkumpulan",
  value: "Nilai",
  Please_add_the_dictionary_first: "Sila tambah kamus terlebih dahulu",
  Chinese_name_English_name_does_not_allow_null_value: "Nama Cina/Nama Inggeris tidak boleh kosong",
  The_value_cannot_be_modified_after_it_is_set_Please_confirm_and_add_it_after_completion: "Setelah ditetapkan, nilai tidak boleh diubah. Sila pastikan ia lengkap sebelum meneruskan penambahan!",
  Batch_Add_Parent_Directory: "Tambah Direktori Induk Berjawatan",
  recently: "Baru-baru Ini",
  day: "Hari",
  Warehouse_capacity: "Kapasiti Gudang",
  Warehouse_capacity_data: "Data Kapasiti Gudang",
  Service_storage_capacity: "Kapasiti Terpakai",
  Storage_capacity_in_transit: "Kapasiti dalam Penghantaran",
  Residual_storage_capacity: "Kapasiti Baki",
  Use_of_space: "Dek Penyimpanan Terpakai",
  Available_space: "Dek Penyimpanan Tersedia",
  financial_data: "Data Kewangan",
  all_costs: "Semua Yuran",
  storage_charges: "Sewa Gudang",
  Removal_fee: "Yuran Penyingkiran Senarai",
  Returnable_shelving_fee: "Yuran Penyenaraian Semula Barangan Dikembalikan",
  other_expenses: "Yuran Lain",
  Order_data: "Data Pesanan",
  Orderto_be_supplied: "Pesanan Menunggu Pengisian",
  Order_In_transit: "Pesanan dalam Penghantaran",
  Orderto_shipped: "Pesanan Dihantar",
  Nearly_a_day: "24 Jam Terakhir",
  Last_seven_days: "7 Hari Terakhir",
  The_last_thirty_days: "30 Hari Terakhir",
  Nearly_ninety_days: "90 Hari Terakhir",
  Customer_details: "Butiran Pelanggan",
  TC_data: "Data Pengangkutan Masuk",
  TC_wait_for_receiving: "Tunai Pengangkutan Masuk Menunggu Penerimaan",
  Transfer_Warehouse_Receipt: "Tunai Gudang Transit",
  Transit_warehouse_receiving_time: "Masa Tunai Gudang Transit",
  in_transit: "Dalam Penghantaran",
  The_Last_Leg_Received: "Pengangkutan Keluar Diterima",
  finish: "Siap",
  Warehouse_entry_data: "Data Tunai Masuk",
  Transit_warehouse_to_receive_goods: "Tunai Gudang Transit Menunggu Penerimaan",
  The_last_leg_to_be_received: "Pengangkutan Keluar Menunggu Penerimaan",
  To_be_inspected: "Menunggu Pemeriksaan Kualiti",
  To_be_put_on_the_shelf: "Menunggu Penyusunan",
  Return_data: "Data Barang Dipulangkan",
  Customer_ID: "ID Pelanggan",
  ClientManagement: "Pengurusan Pelanggan",
  Customer: "Pelanggan",
  spread: "Kembangkan",
  pack_up: "Kecilkan",
  Put_away_the_menu: "Menu Kecilkan",
  Customer_List: "Senarai Pelanggan",
  clientList: "Senarai Pelanggan",
  advanced_query: "Carian Lanjutan",
  Customer_account_number: "Akaun Pelanggan",
  Please_enter_account_number: "Sila masukkan akaun pelanggan",
  Customer_account_name: "Nama Pelanggan",
  Please_enter_account_name: "Sila masukkan nama pelanggan",
  Customer_account_state: "Status Pelanggan",
  Please_enter_account_state: "Sila masukkan status pelanggan",
  unverified: "Belum disahkan",
  approve: "Lulus Kelulusan",
  Approval_failure: "Gagal Kelulusan",
  Api_Order: "Pesanan API",
  Notification_Form: "Pesanan Diteruskan",
  handbill: "Pesanan Manual",
  forbidden: "Dilumpuhkan",
  audit: "Dalam Semakan",
  Contract_to_be_signed: "Kontrak Tertunggak",
  cell_phone_number: "Nombor Telefon Bimbit",
  Please_enter_cell_phone_number: "Sila masukkan nombor telefon bimbit",
  Please_select_cell_phone_number: "Sila pilih status pelanggan",
  Please_select_Customer: "Sila pilih pelanggan",
  company_name: "Syarikat",
  corporate_company: "Syarikat Entiti Undang-Undang",
  Please_enter_company_name: "Sila masukkan nama syarikat",
  registration_time: "Tarikh Pendaftaran",
  clearing_form: "Kaedah Penyetelan",
  Please_select_clearing_form: "Sila pilih kaedah penyetelan",
  Please_select_whether_to_renew: "Sila pilih sama ada untuk memperbaharui",
  Starting_amount: "Jumlah Permulaan",
  Closing_amount: "Jumlah Akhir",
  prejunction: "Penyetelan Awal",
  monthly_balance: "Penyetelan Bulanan",
  balance_outstanding: "Baki",
  Please_enter_balance_outstanding: "Sila masukkan baki",
  Please_enter_contact_information: "Sila masukkan butiran hubungan",
  Please_select_balance_outstanding: "Sila pilih baki",
  Please_select_the_shipping_to_transit_bin_method: "Sila pilih kaedah pengangkutan ke gudang transit",
  have: "Ya",
  without: "Tidak",
  Add_customer: "Tambah Pelanggan",
  Batch_upload: "Muat Naik Berkumpulan",
  reset_passwords: "Setingkan Semula Kata Laluan",
  Limit_adjustment: "Laraskan Had Kredit",
  allot_salesman: "Tugaskan Wakil Jualan",
  allot_service: "Tugaskan Perkhidmatan Pelanggan",
  Customer_Name: "Nama Klien",
  subordinate_companies: "Syarikat Bersekutu",
  contact_information: "Maklumat Perhubungan",
  account_frozen: "Jumlah Beku",
  line_of_credit: "Had Kredit",
  No_currency_available: "Tiada Mata Wang Buat Masa Ini",
  Set_currency: "Tetapkan Mata Wang",
  account_type: "Jenis Akaun",
  account_state: "Status Akaun",
  Merchant_name: "Nama Penjual",
  Merchant_Number: "ID Penjual",
  Corporate_name: "Nama Wakil Undang-Undang",
  Corporate_Identity_Card: "ID Wakil Undang-Undang",
  Corporate_phone_number: "Nombor Telefon Bimbit Wakil Undang-Undang",
  Business_license_registration_address: "Alamat Berdaftar Lesen Perniagaan",
  business_address: "Alamat Pejabat",
  Unified_social_credit_code: "Kod Kredit Sosial Bersatu",
  Please_enter_unified_social_credit_code: "Sila masukkan Kod Kredit Sosial Bersatu",
  user_role: "Peranan Pengguna",
  service_team: "Pasukan Perkhidmatan",
  Distribution_service_team: "Tugaskan Pasukan Perkhidmatan",
  Please_select_a_customer: "Sila pilih klien",
  available_balance: "Baki Tersedia",
  Audit_customer: "Kaji Semula Klien",
  Confirm_to_audit_the_customer: "Kuatkuasakan Kajian Semula",
  Please_enter_the_customer_mobile_number: "Sila masukkan nombor telefon bimbit pelanggan",
  New_account_login_will_overwrite_the_data_of_the_original_account_whether_to_continue: "Log masuk dengan akaun baru akan menimpa data akaun sedia ada. Teruskan?",
  Set_up_warehouse: "Tetapkan gudang",
  Set_up_a_transit_warehouse: "Tetapkan gudang transit",
  Full_warehouse_or_not: "Adakah ini gudang utama?",
  Whether_all_transfer_warehouse: "Adakah ini gudang transit?",
  Total_balance: "Baki keseluruhan",
  client_info: "Maklumat Pelanggan",
  clientInfo: "Maklumat Pelanggan",
  createClient: "Buat Pelanggan",
  editClient: "Sunting Pelanggan",
  basic_information: "Maklumat Asas",
  address_message: "Maklumat Alamat",
  QQ_WeChat: "QQ/WeChat",
  QQ_WeChat_ID_Not_Nickname: "ID QQ/WeChat (bukan nama panggilan)",
  oblast_province: "Negeri/Wilayah",
  province: "Wilayah",
  district: "Daerah",
  Please_enter_oblast: "Sila masukkan Negeri",
  city: "Kota",
  Please_enter_city: "Sila masukkan Kota",
  location: "Alamat",
  shipping_address: "Alamat Penghantaran",
  Alternate_delivery_address: "Alamat Penghantaran Alternatif",
  Please_enter_location: "Sila masukkan Alamat",
  financial_information: "Maklumat Kewangan",
  customer_code: "Kod Pelanggan",
  Customer_mailbox: "E-mel Pelanggan",
  Customer_mobile_phone_number: "Nombor Telefon Bimbit Pelanggan",
  customer_company: "Syarikat Pelanggan",
  Superior_account: "Akaun Induk",
  service_conditions: "Status Perniagaan",
  underway: "Dalam Proses",
  Terminated: "Tamat",
  delivery_method: "Kaedah Penghantaran",
  assigner: "Ditugaskan Kepada",
  operating_log: "Log Operasi",
  auditor: "Penilai",
  audit_time: "Masa Semakan",
  Identifying_people: "Disahkan Oleh",
  acknowledging_time: "Masa Pengesahan",
  Whether_to_send_back_ERP: "Sama Ada Untuk Di-upload ke ERP",
  Return_time: "Masa Upload",
  Return_result: "Keputusan Upload",
  Account_top_up_details: "Butiran Isi Semula Akaun",
  accountTopUpDetails: "Butiran Isi Semula Akaun",
  Recharge_method: "Kaedah Isi Semula",
  Storage_query: "Semakan Inventori",
  storageQuery: "Semakan Inventori",
  account_recharge: "Isi Semula Akaun",
  accountRecharge: "Isi Semula Akaun",
  online_trading: "Transaksi Dalam Talian",
  Online_payment: "Bayaran Dalam Talian",
  money: "Jumlah",
  Please_enter_the_money: "Sila masukkan jumlah",
  Recharge_type: "Jenis Isi Semula",
  The_page_you_visited_does_not_exist_Please_check_whether_the_network_connection_is_normal_or_check_whether_the_address_input_is_correct: "Halaman yang anda cuba akses tidak wujud. Sila semak sambungan rangkaian anda atau pastikan alamat dimasukkan dengan betul!",
  The_orders_that_have_been_shipped_and_failed_to_be_shipped_can_be_scanned_and_reprinted_here_Orders_that_have_been_shipped_can_be_reprinted_here_Note_The_order_must_be_the_order_placed_in_your_task_list: "Untuk pesanan di mana imbasan penghantaran telah selesai tetapi penghantaran gagal, anda boleh mencetak semula nota penghantaran di sini. Untuk pesanan yang telah dihantar, anda boleh mencetak semula label penghantaran di sini. (Nota: Pesanan mesti berada di bawah senarai tugasan anda.)",
  Confirm_the_mark_is_abnormal: "Pastikan Penandaan sebagai Anomali?",
  operation_procedure: "Prosedur Operasi",
  Operating_Instructions: "Arahan Operasi",
  general: "Am",
  system_wide: "Secara Sistem",
  clientSide: "Klien",
  Management: "Pentadbir",
  Announcement_title: "Tajuk Pengumuman",
  Announcement_content: "Kandungan Pengumuman",
  Announcement_Number: "ID Pengumuman",
  Please_enter_Announcement_title: "Sila masukkan tajuk pengumuman",
  Please_enter_Announcement_Number: "Sila masukkan ID pengumuman",
  Please_enter_Announcement_content: "Sila masukkan kandungan pengumuman",
  Please_select_Bulletin_Type: "Sila pilih jenis pengumuman",
  title: "Tajuk",
  method: "Kaedah Permintaan",
  requestMethod: "Mod Permintaan",
  operUrl: "URL Operasi",
  operIp: "Alamat IP Operasi",
  operLocation: "Lokasi Operasi",
  operParam: "Parameter Operasi",
  status: "Status",
  errorMsg: "Mesej Ralat",
  operTime: "Masa Operasi",
  Success: "Jaya",
  Failure: "Gagal",
  Inventory_order_list: "Senarai Pesanan Gudang",
  inventoryOrderList: "Senarai Pesanan Gudang",
  inventoryAllOrderList: "Semua Pesanan",
  abnormalTransportationList: "Anomali Penghantaran",
  warehouse_order_management: "Pengurusan Pesanan Gudang",
  logistics: "Logistik",
  logistics_status: "Status Logistik",
  Please_select_Logistics_channel: "Sila pilih saluran logistik",
  Platform_state: "Status Platform",
  Please_select_Platform_state: "Sila pilih status platform",
  Please_enter_order_number: "Sila masukkan nombor pesanan",
  Please_enter_waybill_number: "Sila masukkan nombor waybill",
  Please_enter_transaction_number: "Sila masukkan nombor transaksi",
  Priority_delivery: "Penghantaran Keutamaan",
  Priority_delivery_order: "Pesanan Penghantaran Keutamaan",
  Non_priority_delivery_orders: "Pesanan Penghantaran Bukan Keutamaan",
  Platform_setting_priority_delivery: "Tetapan Penghantaran Keutamaan Platform",
  Manually_set_priority_delivery: "Tetapan Penghantaran Keutamaan Manual",
  Please_select_Priority_delivery: "Sila pilih status penghantaran keutamaan",
  shipping_method: "Kaedah Penghantaran",
  Please_select_shipping_method: "Sila pilih kaedah penghantaran",
  Please_select_logistics_status: "Sila pilih status logistik",
  Please_select_platform: "Sila pilih platform",
  time_of_payment: "Masa Pembayaran",
  Please_select_time_of_payment: "Sila pilih masa pembayaran",
  Please_select_Recharge_method: "Sila pilih kaedah tambah nilai",
  To_be_reviewed: "Tungguh Kelulusan",
  drop_shipping: "Tungguh Penghantaran",
  Being_distributed: "Penunaian Pesanan",
  shipped: "Penghantaran Siap",
  have_been_voided: "Pesanan Dibatalkan",
  have_been_reject: "Pesanan Ditolak",
  Get_the_tracking_number: "Dapatkan Nombor Waybill",
  Set_up_order_package_materials: "Konfigurasikan Pembungkusan Pesanan",
  Forward_delivery: "Alihkan ke Tungguh Penghantaran",
  cancellation: "Dibatalkan",
  Cancelled_order: "Pesanan Dibatalkan",
  activate: "Aktifkan",
  Get_order: "Dapatkan Pesanan",
  Get_order_time: "Masa Mendapatkan Pesanan",
  Upload_sheet: "Muat naik Label Penghantaran",
  processing_batch: "Pemprosesan Berkumpulan",
  Return_for_review: "Kembali ke Tungguh Kelulusan",
  Print_sheet: "Cetak Label Penghantaran",
  Preview_the_waybill: "Prviu Waybill",
  Printing_sheet: "Mencetak Waybill...",
  Preview_failed_orders: "Prviu Pesanan Gagal",
  create_order: "Buat Pesanan",
  createOrder: "Buat Pesanan",
  Batch_create_order: "Buat Pesanan Secara Berkumpulan",
  stores_expired: "Kebenaran Kedai Habis Tempoh",
  Push_or_not: "Notifikasi Terorong",
  Please_select_whether_to_push: "Sila pilih sama ada untuk terorong",
  Please_select_order_status: "Sila pilih status pesanan",
  Platform_logistics_channel: "Platform Saluran Logistik",
  master_bill_number: "Nombor Waybill Induk",
  WMS_status: "Status WMS",
  destination_country: "Negara Destinasi",
  Platform_remarks: "Nota Platform",
  Warehouse_presence_remarks: "Nota Gudang Ada",
  No_warehouse_remarks_exist: "Nota Gudang Tiada",
  Warehouse_note: "Nota Gudang",
  Delivery_of_abnormal_information: "Maklumat Anomali Pengangkutan",
  Remaining_delivery_time: "Masa Penghantaran Baki",
  order_amount: "Jumlah Pesanan",
  primitive_money: "Mata Wang Asal",
  Order_profit: "Untung Pesanan",
  profit_margin: "Margin Keuntungan",
  delivery_time: "Masa Keluar",
  Deduct_time: "Masa Potongan",
  Save_the_current_search_conditions: "Simpan Syarat Carian Semasa",
  No_data_is_selected: "Tiada data dipilih!",
  No_customer_has_been_selected: "Tiada pelanggan dipilih!",
  The_order_was_cancelled_successfully: "Pesanan dibatalkan dengan jayanya!",
  Order_activation_success: "Pesanan diaktifkan dengan jayanya!",
  Orders_have_been_prioritized_for_delivery: "Pesanan ditetapkan untuk penghantaran keutamaan!",
  OrderInfo: "Butiran Pesanan",
  Modify_remarks: "Sunting Nota",
  Quick_query_condition: "Syarat Carian Pantas",
  Marked_delivery: "Tandakan sebagai Dihantar",
  Please_select_a_piece_of_data: "Sila pilih satu rekod",
  Marked_delivery_Succeed: "Tandakan sebagai Dihantar Berjaya",
  Marked_delivery_lose: "Tandakan sebagai Dihantar Gagal",
  Systematic_item_list: "Butiran Produk Sistem",
  not_available: "Tiada tersedia",
  multiattribute: "Multi-atribut",
  multiattributeID: "ID berbilang atribut",
  Please_select_an_order_from_the_same_warehouse: "Sila pilih pesanan dari gudang yang sama",
  Batch_replacement_of_SKUs: "Gantikan SKU secara pukal",
  replace_SKU: "Gantikan SKU",
  delete_SKU: "Padam SKU",
  add_sku: "Tambah SKU",
  Only_one_SKU_can_be_replaced: "Hanya menyokong penggantian satu SKU",
  Select_the_sku_that_you_want_to_replace: "Pilih SKU untuk digantikan",
  Select_the_new_SKU: "Pilih SKU baru",
  Whether_the_product_has_a_barcode: "Adakah produk mempunyai label bar kod?",
  Duplicate_SKUs_appear: "SKU dwi salinan dikesan",
  Printing: "Cetakan sedang dijalankan...",
  Please_select_a_type_of_basket: "Sila pilih jenis bakul",
  printPreview: "Prviu cetakan",
  designPrinting: "Reka cetakan",
  Delete_an_order: "Padam pesanan",
  Pairing_or_not: "Adakah ia dipadankan?",
  type_of_merchandize: "Kategori produk",
  Print_type: "Jenis cetakan",
  The_uploaded_file_format_is_incorrect: "Ralat format fail dimuat naik",
  Currently_only_single_order_upload_is_supported: "Pada masa ini hanya menyokong muat naik satu pesanan",
  Save_as_PDF: "Simpan sebagai PDF",
  downloading: "Muat turun",
  Direct_printing: "Cetak terus",
  Confirm_submission: "Sahkan penghantaran?",
  quantity_of_order: "Kuantiti pesanan",
  hour: "Masa",
  The_task_can_be_obtained_directly: "Tugas boleh diperoleh secara langsung",
  You_need_to_scan_the_distribution_basket_to_get_the_task: "Perlukan imbasan bakul pemungutan untuk mendapatkan tugas",
  When_the_task_type_is_multi_product_you_can_choose_whether_to_allocate_goods_by_floor: "Pilihan pemungutan berasaskan lantai hanya tersedia apabila memilih jenis tugas 'Pelbagai-barang'",
  Whether_to_scan_the_warehouse_location_when_distributing_goods: "Perlukan imbasan lokasi penyimpanan semasa proses pemilihan?",
  When_the_task_type_is_multi_product_the_matching_and_sending_function_cannot_be_enabled: "Apabila memilih jenis tugas berbilang item, pemilihan dan penghantaran serentak tidak dapat diaktifkan",
  presell: "Pra-jualan",
  stockoutOrder: "Pesanan kehabisan stok",
  No_out_of_stock_orders: "Pesanan tidak kehabisan stok",
  Online_product_Pictures: "Imej produk dalam talian",
  After_the_warehouse_is_selected_the_corresponding_inventory_will_be_returned: "Selepas memilih gudang untuk penghantaran keluar, stok yang sepadan akan dipaparkan",
  Transfer_the_tracking_number_to_obtain: "Dipindahkan ke pemerolehan nombor waybill",
  Transfer_the_tracking_number_to_obtain_or_pending_shipment: "Dipindahkan ke pemerolehan nombor waybill / Menunggu penghantaran",
  Orders_with_a_tracking_number_will_automatically_be_moved_to_awaiting_shipment_while_orders_without_a_tracking_number_will_enter_tracking_number_retrieval: "Pesanan dengan nombor penjejakan secara automatik bertukar kepada 'Menunggu Penghantaran'; manakala yang tiada akan memasuki 'Pendaftaran Nombor Penjejakan'.",
  The_tracking_number_exists: "Nombor penjejakan wujud",
  No_waybill_number_exists: "Nombor penjejakan tidak wujud",
  has_waybill_number: "Nombor penjejakan ada",
  no_waybill_number: "Nombor penjejakan tiada",
  Whether_out_of_stock: "Status kehabisan stok",
  stockout: "Kehabisan stok",
  stockout_short: "Kehabisan stok",
  Platform_and_Shop: "Platform/Kedai",
  Whether_the_waybill_number_exists: "Status nombor penjejakan",
  Presence_platform_remarks: "Nota platform ada",
  No_platform_remarks: "Nota platform tiada",
  has_platform_remark: "Nota platform disertakan",
  no_platform_remark: "Nota platform dikecualikan",
  Presence_remark: "Nota ada",
  No_remarks_exist: "Nota tiada",
  has_remark: "Komen wujud",
  no_remark: "Tiada komen",
  Split_order: "Pesanan berpecah",
  Unsplit_order: "Pesanan tidak berpecah",
  Advance_order: "Pesanan pra-jualan",
  Non_advance_order: "Pesanan bukan pra-jualan",
  Matching_order: "Pesanan padanan",
  Already_paired_Order: "Pesanan padanan selesai",
  unpaired_Order: "Pesanan padanan menunggu",
  Traffic_anomaly: "Anomali penghantaran",
  A_traffic_exception_exists_Procedure: "Anomali penghantaran wujud",
  No_traffic_exception_exists: "Tiada anomali penghantaran",
  has_transportation_abnormal: "Anomali penghantaran wujud",
  no_transportation_abnormal: "Tiada anomali penghantaran",
  allTask: "Semua tugasan",
  todayTask: "Tugasan hari ini",
  todayTask17: "Tugasan hari ini 17",
  todayTask14: "Tugasan hari ini 14",
  yesterdayTask: "Tugasan semalam",
  New_quick_query: "Carian pantas baru",
  Order_status_inquiry: "Permintaan status pesanan",
  The_tracking_number_is_being_obtained: "Perolehan nombor penjejakan sedang dijalankan...",
  Submit_the_order_task: "Tugas Pesanan yang Dihantar",
  Mixed_shipment_or_not: "Pilihan Penghantaran Campuran",
  Order_task_submitted_today_00_00_00_18_00_00: "Tugas Pesanan yang Dihantar Hari Ini 00:00:00-18:00:00",
  Order_task_submitted_yesterday_00_00_00_23_59_59: "Tugas Pesanan yang Dihantar Semalam 00:00:00-23:59:59",
  This_operation_will_permanently_delete_the_query_condition_Do_you_want_to_continue: "Tindakan ini akan memadamkan syarat pertanyaan ini secara kekal. Teruskan?",
  After_obtaining_the_tracking_number_it_will_be_automatically_transferred_to_the_agent_for_delivery: "Sebaik sahaja nombor waybill berjaya diperoleh, ia akan secara automatik dipindahkan ke Tertunggak Penghantaran",
  The_input_format_is_incorrect_English_is_not_allowed_only_three_decimal_places: "Format input tidak betul. Huruf Inggeris tidak dibenarkan; hanya tiga tempat perpuluhan dibenarkan",
  Once_the_QR_code_scanning_is_initiated_it_will_be_invalid_Repeated_scanning_will_fail_the_verification_and_the_transaction_needs_to_be_re_initiated: "Setelah diimbas, kod QR top-up dalam talian akan tamat tempoh. Imbasan berulang akan gagal pengesahan; transaksi mesti dimulakan semula",
  Confirm_the_transfer_pending: "Sahkan Pemindahan ke Tertunggak Pemprosesan",
  transfer_pending: "Pindahkan ke Tertunggak Pemprosesan",
  When_the_task_type_is_multi_product_if_delivery_inspection_is_disabled_there_is_no_need_to_scan_all_SKUs_of_the_corresponding_order_scanning_one_SKU_will_allow_the_corresponding_order_to_be_shipped_If_enabled_all_SKUs_of_the_order_need_to_be_scanned: "Apabila jenis tugasan adalah berbilang-item, jika pengesahan penghantaran dilumpuhkan, mengimbas mana-mana satu SKU akan melepaskan pesanan yang sepadan untuk dihantar. Jika diaktifkan, semua SKU mesti diimbas.",
  When_the_task_type_is_single_product_and_the_match_and_send_function_is_enabled_There_is_no_need_to_wait_for_the_allocation_task_to_be_completely_finished_Once_some_SKUs_are_allocated_you_can_operate_the_orders_of_the_corresponding_allocated_SKUs_for_shipping: "Apabila jenis tugasan adalah satu-item dan Hantar secara berperingkat diaktifkan, pesanan untuk SKU yang dipenuhi sebahagiannya boleh dihantar tanpa menunggu pesanan lengkap sepenuhnya.",
  Enable_this_function_and_single_product_orders_can_be_obtained_in_multi_product_allocation: "Mengaktifkan ciri ini membolehkan pengambilan pesanan satu-barang semasa pemenuhan berbilang-barang.",
  Expired_stores: "Kedai Luput",
  The_transportation_of_goods_in_the_past_seven_days_has_been_abnormal: "Anomali Penghantaran dalam Tujuh Hari Terakhir",
  Whether_to_exclude_submission_rules: "Peraturan Penghantaran Tidak Disertakan",
  Not_excluded_submission_rules: "Peraturan Penghantaran Disertakan",
  Excluded_submission_rules: "Peraturan Penghantaran Tidak Disertakan",
  Whether_to_exclude_automatic_packaging_rules: "Peraturan Pembungkusan Automatik Tidak Disertakan",
  Not_excluded_automatic_packaging_rules: "Peraturan Pembungkusan Automatik Disertakan",
  Excluded_automatic_packaging_rules: "Peraturan Pembungkusan Automatik Tidak Disertakan",
  Cancel_excluded_submission_rules: "Batal Pengecualian Peraturan Penghantaran",
  Cancel_excluded_automatic_packaging_rules: "Batal Pengecualian Peraturan Pembungkusan Automatik",
  Excluded_all_rules: "Kecualikan Semua Peraturan",
  Cancel_excluded_all_rules: "Batal Pengecualian Semua Peraturan",
  Refresh_platform_status: "Segarkan Status Platform",
  Only_supports_operations_for_API_orders_with_a_delivery_deadline_within_12_hours_and_push_orders_created_later_than_12_hours: "Hanya menyokong pesanan API dalam tempoh 12 jam sebelum tarikh akhir penghantaran dan pesanan push yang dibuat lebih 12 jam lalu",
  shipping_label: "Waybill",
  shipping_label_exists: "Waybill wujud",
  no_shipping_label_exists: "Waybill tidak wujud",
  has_label: "Waybill ada",
  no_label: "Waybill tiada",
  out_of_stock_orders: "Pesanan kehabisan stok",
  No_waybill_number: "Tiada nombor waybill",
  // has_platform_remark:"Nota platform ada",
  has_warehouse_remark: "Nota gudang ada",
  no_warehouse_remark: "Nota gudang tiada",
  is_split_orders: "Pesanan berpecah",
  is_presell_orders: "Pesanan pra-jualan",
  Unpaired: "Tidak sepadan",
  Get_the_logistics_track: "Dapatkan penjejakan logistik",
  Latest_updates: "Kemas kini terkini",
  Logistics_information_is_being_pulled: "Maklumat logistik sedang diperoleh",
  package_information: "Butiran bahan pembungkusan",
  Chinese_product_name: "Nama produk dalam bahasa Cina",
  English_product_name: "Nama produk dalam bahasa Inggeris",
  Obtaining_tracking_number: "Nombor penjejakan sedang diperoleh",
  No_abnormalities: "Tiada anomali",
  Submission_rules_are_not_excluded: "Peraturan penghantaran tidak dikecualikan",
  The_submission_rule_is_excluded: "Peraturan penghantaran dikecualikan",
  Automatic_packaging_material_rules_not_excluded: "Peraturan pembungkusan automatik tidak dikecualikan",
  The_automatic_packaging_rules_have_been_excluded: "Peraturan pembungkusan automatik dikecualikan",
  The_number_of_selected_orders_cannot_exceed_100: "Jumlah pesanan yang dipilih tidak boleh melebihi 100",
  Reship: "Hantar semula penghantaran",
  Transfer_cancellation_exception: "Alihkan ke pengecualian pembatalan",
  Returned_without_generation: "Dipulangkan tanpa penjanaan",
  The_currently_selected_order_has_no_delivery_exceptions_and_requires_no_action: "Tiada anomali penghantaran untuk pesanan yang dipilih semasa; tiada tindakan diperlukan",
  If_you_need_to_check_the_inventory_information_of_the_products_please_select_the_option_on_the_right: "Untuk melihat butiran inventori produk, pilih butang di sebelah kanan",
  Add_Warehouse_Product_Inventory_Details: "Tambah butiran inventori produk gudang",
  editOrder: "Sunting pesanan",
  bulk_edit: "Sunting pukal",
  empty: "Kosongkan",
  consigner: "Pengirim",
  shipper: "Penghantar",
  Order_deduction: "Caj pesanan",
  Select_sender: "Pilih pengirim",
  Please_enter_consigner: "Sila masukkan butiran pengirim",
  Sender_information: "Maklumat pengirim",
  consigner_address: "Alamat pengirim",
  Please_enter_consigner_address: "Sila masukkan alamat pengirim",
  consignee_information: "Maklumat penerima",
  recipients: "Penerima",
  recipientsList: "Senarai penerima",
  Save_as_a_regular_recipient: "Simpan sebagai Penerima Kegemaran",
  Select_recipients: "Pilih Penerima",
  Please_enter_recipients: "Sila masukkan penerima",
  Only_one_recipient_can_be_selected: "Hanya satu penerima boleh dipilih",
  Please_enter_the_recipient_name_for_query: "Sila masukkan nama penerima untuk carian",
  postcode: "Poskod",
  Please_enter_postcode: "Sila masukkan poskod",
  recipients_country: "Negara Penerima",
  Please_enter_recipients_country: "Sila masukkan negara penerima",
  Please_select_recipients_country: "Sila pilih negara penerima",
  Please_select_recipients: "Sila pilih penerima",
  type_of_shipping: "Kaedah Penghantaran",
  Please_enter_type_of_shipping: "Sila masukkan kaedah penghantaran",
  Please_select_type_of_shipping: "Sila pilih kaedah penghantaran",
  Alternate_recipient_address: "Alamat Penerima Alternatif",
  Please_enter_Alternate_recipient_address: "Sila masukkan alamat penerima alternatif",
  commodity_information: "Maklumat Produk",
  Select_product: "Pilih Produk",
  Save_until_reviewed: "Simpan ke Tinjauan Tertunda",
  Submit_to_consignment: "Hantar ke Penghantaran Tertunda",
  Batch_set_package_materials: "Batch Set Bahan Pembungkusan",
  Please_add_packing_material: "Sila Tambah Bahan Pembungkusan",
  under: "Di Bawah",
  Please_enter_the_tracking_number_information: "Sila Masukkan Nombor Penjejakan/Maklumat Huola",
  Please_select_the_estimated_time_of_arrival: "Sila Pilih Anggaran Masa Ketibaan di Gudang",
  Only_a_single_recipient_can_be_selected: "Hanya Satu Penerima Boleh Dipilih",
  Please_enter_a_combination_SKU: "Sila Masukkan SKU Gabungan",
  The_number_of_empty_combination_SKUs_exists_Check_and_try_again: "Kuantiti SKU Gabungan Tidak Sah, Sila Semak dan Cuba Semula",
  Please_enter_the_combination_SKU_name: "Sila Masukkan Nama SKU Gabungan",
  Click_to_select_the_row_data_doubleclick_to_select_the_row_data_and_confirm_the_current_selection_data: "Klik untuk memilih data baris, klik dua kali untuk memilih data baris dan mengesahkan pilihan semasa!",
  tagged: "Berketiket",
  No_mark: "Tiada Ketiketan",
  Import_recipients: "Import Penerima",
  agree: "Setuju",
  reject: "Tolak",
  cancellationOrder: "Batalkan Pesanan",
  reason_for_refusal: "Sebab Tolakan",
  Please_enter_reason_for_refusal: "Sila pilih sebab tolak",
  Application_for_cancellation_of_time: "Masa Permohonan Pembatalan",
  expiration_time: "Masa Luput",
  reason_of_cancellation: "Sebab Pembatalan",
  Please_Select_Warehouse_First: "Sila pilih gudang terlebih dahulu",
  Please_Select_Packaging_Method_First: "Sila pilih kaedah pembungkusan terlebih dahulu",
  Number_Of_Loops: "Bilangan Lapisan",
  Please_Select_Packaging_Material: "Sila pilih bahan pembungkusan",
  Please_Select_Packaging_Method: "Sila pilih kaedah pembungkusan",
  Please_Enter_Number_Of_Loops: "Sila masukkan bilangan lapisan",
  Order_Packaging: "Pembungkusan Pesanan",
  Packaging_Method: "Kaedah Pembungkusan",
  Packaging_Material_Type: "Jenis Bahan Pembungkusan",
  Whole_Order_Packaging: "Pembungkusan Pesanan Keseluruhan",
  Packaging_By_SKU: "Pembungkusan Berdasarkan SKU",
  Individual_Product_Packaging: "Pembungkusan Barangan Individu",
  Volume: "Isipadu",
  Unit_Price: "Harga Satu Unit",
  Please_Enter_Quantity: "Sila Masukkan Jumlah",
  Packaging_Material_Type_And_Packaging_Method_Must_Be_Filled_In_Simultaneously: "Jenis Bahan Pembungkusan dan Kaedah Pembungkusan Kedua-duanya Mesti Diisi",
  first_leg: "Peringkat Pertama",
  Head_process_management: "Pengurusan Peringkat Pertama",
  FirstLegOrderManagement: "Pengurusan Pesanan Peringkat Pertama",
  firstLegOrderList: "Senarai Pesanan Peringkat Pertama",
  firstBillingList: "Senarai Invois Peringkat Pertama",
  First_billing_list: "Senarai Invois Peringkat Pertama",
  FirstLegOrderStatus: "Status Pesanan Peringkat Pertama",
  FirstLegOrderNumber: "Nombor Pesanan Peringkat Pertama",
  Headway_tracking_number_Order_number_Grabway_information: "Nombor Penjejakan Peringkat Awal/Nombor Penjejakan/Maklumat Huwa",
  First_order_stage: "Peringkat Pesanan Peringkat Awal",
  Please_enter_FirstLegOrderNumber: "Sila masukkan nombor penjejakan peringkat awal",
  warehouse_entry_number: "Nombor Pesanan Masuk",
  Please_enter_warehouse_entry_number: "Sila masukkan nombor pesanan masuk",
  createoriginReceivingInboundOrder: "Buat Pesanan Masuk Peringkat Awal",
  editOriginReceivingInboundOrder: "Sunting Pesanan Masuk Peringkat Awal",
  editHeaderList: "Sunting Pesanan Peringkat Awal",
  firstLegOrderId: "ID Peringkat Awal",
  draft: "Draf",
  audited: "Diluluskan",
  abnormal: "Tidak Normal",
  Self_delivery_warehouse: "Hantar sendiri ke Gudang",
  The_customer_sends_it_to_the_transit_warehouse: "Pelanggan menghantar ke gudang transit",
  Door_to_door_collection: "Pengambilan di Ambang Pintu",
  Transfer_warehouse_contact_logistics_to_customer_designated_address_collection: "Gudang Transit Menghubungi Logistik untuk Pengambilan di Alamat yang Disyorkan Pelanggan",
  Warehouse_entry_stage: "Tahap Pesanan Masuk",
  Warehouse_entry_description: "Keterangan Pesanan Masuk",
  Batch_number_issued_by_three_warehouses: "Nombor Batch Gudang Pihak Ketiga",
  Three_party_warehouse_PO_number: "Nombor PO Gudang Pihak Ketiga",
  Storage_single_status: "Status Pesanan Masuk",
  destination: "Destinasi",
  Other_destinations: "Destinasi Lain",
  Other_address: "Alamat Lain",
  Other_address_contacts: "Kenalan Alamat Lain",
  Other_address_Contact_number: "Nombor Kenalan Alamat Lain",
  Estimated_time_of_arrival: "Anggaran Masa Tiba di Gudang",
  Channel_type: "Jenis Saluran",
  Please_select_a_destination: "Sila Pilih Destinasi",
  Please_select_Channel_type: "Sila Pilih Jenis Saluran",
  Self_delivered: "Hantar Sendiri",
  Take_in: "Pengambilan",
  total_quantity: "Jumlah Kuantiti",
  odd: "Nombor Pesanan",
  push: "Tolak",
  Do_not_push: "Jangan Hantar",
  Edit_cabinet_number: "Sunting Nombor Kontena",
  Cargo_pull_information: "Maklumat Huolala",
  odd_Cargo_pull_information: "Nombor Penjejakan/Butiran Huolala",
  First_billing_stage: "Tahap Invois Peringkat Awal",
  First_pass_single_stage: "Peringkat Awal",
  Delivery_to_transit_warehouse: "Kaedah Penghantaran ke Gudang Transit",
  Reserved_gross_weight: "Jumlah Berat Dijadualkan",
  Total_number_of_reservations: "Jumlah Isipadu Dijadualkan",
  Total_number_of_quantity: "Jumlah Kuantiti Dijadualkan",
  Total_number_of_packages_arrived: "Jumlah Sejumlah Pesa",
  Actual_gross_weight: "Jumlah Sejumlah Berat",
  Actual_total_number_of_squares: "Jumlah Sejumlah Isipadu",
  Total_number_of_appointments: "Jumlah Sejumlah Pesa Dijadualkan",
  Total_number_of_boxes_booked: "Jumlah Sejumlah Kotak Dijadualkan",
  Cost_per_cubic_meter_KG: "Kos per Meter Padu/Kilogram",
  expense_per_cubic_meter_KG: "Kos per Meter Padu/Kilogram",
  Total_number_of_billed_squares: "Jumlah Meter Padu Dikenakan Bayaran",
  Gross_chargeable_weight: "Jumlah Berat Dikenakan Bayaran",
  Additional_charge_per_cubic_meter_KG: "Caj Tambahan Per Meter Padu/KG",
  Surcharge_cost_per_cubic_meter_KG: "Kos Caj Tambahan Per Meter Padu/KG",
  container_number: "Nombor Kontena",
  Please_enter_container_number: "Sila Masukkan Nombor Kontena",
  Please_select_a_stuffing_time: "Sila Masukkan Masa Pemuatan Kontena",
  Customer_remarks: "Nota Pelanggan",
  Customer_service_remarks: "Nota Perkhidmatan Pelanggan",
  Financial_remarks: "Nota Kewangan",
  Abnormal_remarks: "Nota Tidak Normal",
  please_enter_Abnormal_remarks: "Sila Masukkan Nota Tidak Normal",
  receiving_time: "Masa Resit",
  consignee: "Penerima",
  Delivery_time: "Masa Resit Pengangkutan",
  Estimated_time_to_transit_warehouse: "Anggaran Masa Ketibaan di Gudang Transit",
  Destination_arrival_time: "Masa Ketibaan Destinasi",
  submission_time: "Masa Penghantaran",
  Create_a_Customer_ID: "Buat ID Pelanggan",
  The_operation_failed_because_an_empty_box_exists_Please_modify_the_box_and_try_again: "Operasi gagal. Kontena kosong dikesan. Sila betulkan dan cuba semula!",
  The_operation_failed_because_there_is_an_empty_amount_of_incoming_storage_Please_modify_it_and_try_again: "Operasi gagal. Jumlah masuk kosong dikesan. Sila betulkan dan cuba semula!",
  viewOriginReceivingInboundOrder: "Lihat Butiran Pesanan Masuk",
  firstReceiptGoods: "Resit Masuk",
  goods_receiving_information: "Maklumat Resit",
  consignment_sheet: "Senarai Resit",
  firstBillingDetails: "Butiran Invois Masuk",
  billing_details: "Butiran Invois",
  billingDetails: "Butiran Invois",
  Inventory_SKU_List: "Senarai SKU Inventori",
  inventorySKUIist: "Senarai SKU Inventori",
  First_order_number: "Nombor Pesanan Masuk",
  Entry_number: "Nombor Waybill Masuk",
  Financial_verification_time: "Masa Pengesahan Kewangan",
  Verify_collection_time: "Masa Resit Disahkan",
  Total_freight: "Jumlah Amaun Kargo",
  freight_amount: "Amaun Kargo",
  Total_freight_cost: "Jumlah Kos Kargo",
  gross_profit: "Jumlah Keuntungan",
  Gross_surcharge: "Jumlah Caj Tambahan",
  Basic_query: "Carian Asas",
  Logistics_inquiry: "Carian Logistik",
  logisticsInquiry: "Carian Logistik",
  Logistics_batch: "Batch Logistik",
  Number_of_scans: "Jumlah Dimasukkan",
  Successful_quantity: "Jumlah Berjaya",
  Number_of_failures: "Jumlah Gagal",
  Remark_query: "Carian Keterangan",
  Time_query: "Carian Masa",
  Amount_inquiry: "Carian Amaun",
  settlement_date: "Masa Penyataan",
  Statement_number: "Nombor Dokumen Penyataan",
  Supplier_settlement: "Penyelesaian Pembekal",
  viewFirstBillingDetails: "Lihat Butiran Invois Masuk",
  stuffing_time: "Masa Pemuatan Kontena",
  Changing_Customer_ID: "Ubah ID Pelanggan",
  Submit_initial_billing: "Serahkan Invois Masuk",
  Return_the_initial_bill: "Invois Peringkat Pertama",
  freight_inquiry: "Permintaan Barang",
  Starting_weight: "Berat Awal",
  Initial_number: "Isipadu Awal (Meter Padu)",
  End_square: "Isipadu Akhir (Meter Padu)",
  Starting_number_of_packages: "Kepingan Awal",
  End_number_of_packages: "Kepingan Akhir",
  Initial_quantity: "Kuantiti Awal",
  End_quantity: "Kuantiti Akhir",
  Actual_quantity_arrived: "Kuantiti Sebenar Ketibaan",
  Reservation_quantity: "Kuantiti Jadual",
  The_number_of_received_boxes_is_inconsistent_with_the_number_of_reserved_boxes_whether_to_continue_to_submit: "Perbezaan Bilangan Kotak Terima dengan Bilangan Jadual - Teruskan Penghantaran?",
  First_leg_deduction_fee: "Potongan Peringkat Pertama",
  Advance_payment: "Pembayaran Peringkat Pertama",
  Transfer_warehouse_to_collect: "Pengambilan Gudang Transit",
  Shipping_to_overseas_warehouse: "Penghantaran ke Gudang Luar Negara",
  Overseas_warehouse_delivery: "Penghantaran Gudang Luar Negara",
  There_are_mandatory_fields_in_the_received_information: "Butiran penghantaran mengandungi medan wajib yang tidak diisi",
  There_are_mandatory_fields_in_the_channel_information: "Butiran pengangkutan mengandungi medan wajib yang tidak diisi",
  There_are_no_required_fields_in_the_delivery_information: "Butiran ketibaan gudang mengandungi medan wajib yang tidak diisi",
  Please_select_a_delivery_type: "Sila pilih jenis penghantaran",
  warehousing: "Penerimaan gudang",
  pick_up_in_a_store: "Pengambilan sendiri",
  delivery: "Penghantaran",
  delivery_address: "Alamat penghantaran",
  Store_goods_directly_in_overseas_warehouses: "Penyimpanan terus barangan di gudang luar negara",
  The_customer_will_receive_the_goods_from_the_overseas_warehouse_by_himself: "Pelanggan mengambil barangan terus dari gudang luar negara",
  By_overseas_warehouse_contact_logistics_delivery_to_the_customer_designated_location: "Gudang luar negara mengatur penghantaran ke lokasi yang ditetapkan oleh pelanggan",
  Upload_credentials: "Muat naik Bukti Pembayaran",
  credentials: "Bukti Pembayaran",
  Please_select_the_same_channel_type: "Sila pilih jenis saluran yang sama",
  replacement_expense: "Reset Caj",
  Set_the_replacement_charge_according_to_the_head_charge: "Reset caj berdasarkan tetapan yuran peringkat awal",
  Reset_the_current_order_cost_by_the_actual_number_of_square_feet: "Reset caj pesanan semasa berdasarkan meter padu sebenar",
  Reset_the_current_order_charge_according_to_the_actual_order: "Reset yuran pesanan semasa berdasarkan dimensi penghantaran sebenar",
  Order_different_goods_attributes_warehouse_transit_warehouse_billing_method_currency_customer_will_use_the_current_cost_Settings_to_calculate_the_cost: "Atribut barangan, gudang, gudang transit, kaedah pengebilan, mata wang, dan pelanggan yang berbeza dalam pesanan akan dikira menggunakan tetapan yuran semasa.",
  Freight_cost_surcharge_cost_default_value_is_set_for_the_current_order_cost_corresponding_to_the_maximum_amount_cubic_KG: "Kos kargo, kos surcaj, nilai lalai sepadan dengan jumlah maksimum (meter padu/kg) yang ditetapkan untuk yuran pesanan semasa.",
  Freight_cubic_meter_KG: "Kargo (meter padu/kg)",
  Additional_charge_cubic_meter_KG: "Surchaj (meter padu/kg)",
  freight_cost_cubic_meter_KG: "Kos Kargo (meter padu/kg)",
  Surcharge_cost_cubic_meter_KG: "Kos Caj Tambahan (meter padu/kg)",
  The_content_is_not_filled_in: "Terdapat medan yang belum diisi",
  Please_scan_the_head_track_number: "Sila imbas nombor penjejakan penghantaran awal",
  Please_scan_a_valid_header_tracking_number: "Sila imbas nombor penjejakan penghantaran awal yang sah",
  Attributes_of_goods_received: "Atribut Barangan Diterima",
  Commodity_property: "Atribut Barangan Produk",
  Import_order: "Import Pesanan",
  Click_Upload: "Klik untuk muat naik",
  Click_here_to_download_the_template: "Klik di sini untuk muat turun templat",
  Download_template: "Muat turun templat",
  DeliveryTime: "Masa Pengangkutan",
  Start_time_of_inspection: "Masa Mula Pemeriksaan Kualiti",
  End_time_of_inspection: "Masa Akhir Pemeriksaan Kualiti",
  Shelf_start_time: "Masa Mula Penyimpanan",
  End_shelf_time: "Masa Akhir Penyimpanan",
  Billing_information: "Maklumat Pengebilan",
  evidence_of_payment: "Bukti Pembayaran",
  Be_generating: "Dihasilkan...",
  Entering_a_custom_size_will_override_the_selected_print_size: "Memasukkan dimensi tersuai akan menimpa dimensi cetakan yang dipilih",
  import_first_receipt_goods: "Kemasukkan resit penghantaran awal",
  View_the_inbound_and_outbound_flows: "Lihat log transaksi masuk/keluar gudang",
  tracking_number: "Nombor penjejakan logistik",
  edit_tracking_number: "Sunting nombor penjejakan logistik",
  transit_time: "Masa pengangkutan",
  loading_time: "Masa pemuatan",
  preset_Exception_Remark: "Catatan anomali pratetap",
  Batch_Modify_Product_Billing_Attributes: "Sunting pukal atribut pengebilan produk",
  Please_Select_Product_Billing_Attributes: "Sila pilih atribut pengebilan produk",
  Product_Billing_Attributes: "Atribut pengebilan produk",
  stockManagement: "Pengurusan Gudang",
  Warehouse_entry_list: "Senarai resit gudang",
  warehouseEntryList: "Senarai resit gudang",
  warehouseReceiptList: "Senarai resit barangan resit gudang",
  over_time: "Masa tamat",
  Hit_shelves_on_time: "Perapian Tepat Masa",
  Number_of_SKUs: "Jumlah SKU",
  SKU_total_quantity: "Jumlah Keseluruhan SKU",
  qualified_quantity: "Jumlah Kelayakan",
  Quantity_of_reserved_storage: "Jumlah Masukan Jadual",
  Number_of_reserved_storage_parties: "Meter Padu Masukan Jadual",
  time_efficiency: "Masa Pimpinan",
  On_shelf_rate: "Kadar Perapian Tepat Masa",
  Whether_it_is_forced_into_transit: "Paksa ke Status 'Dalam Penghantaran'",
  Store_entry_details: "Butiran Pesanan Masukan",
  Damaged_quantity: "Jumlah Rosak",
  Miss_delivery: "Barangan Hilang",
  Miss_delivery_quantity: "Jumlah Kekurangan",
  wrongly_send: "Barangan Salah",
  wrongly_send_quantity: "Jumlah Salah",
  Warehousing_to_receive_goods: "Penerimaan Masukan",
  warehousingReceiveGoods: "Penerimaan Masukan",
  inventoryEntryListChecked: "Senarai Tunggu Pemeriksaan Barangan Masuk",
  inventoryEntryList: "Senarai Tunggu Rak Barangan Masuk",
  Inbound_inspection: "Pemeriksaan Barangan Masuk",
  inboundInspection: "Pemeriksaan Barangan Masuk",
  Quality_inspection_quantity: "Kuantiti Pemeriksaan Kualiti",
  quality_testing: "Pemeriksaan Kualiti",
  Batch_quality_inspection: "Pemeriksaan Kualiti Batch",
  Obtaining_quality_Inspection_Task: "Dapatkan Tugas Pemeriksaan Kualiti",
  Generate_a_quality_check_task: "Tugaskan Tugas Pemeriksaan Kualiti",
  Setting_priority_inspection: "Tetapkan Keutamaan Pemeriksaan Kualiti",
  The_inspection_quantity_cannot_be_empty: "Kuantiti pemeriksaan kualiti tidak boleh kosong",
  Disabled_Excess_Check_quantity_cannot_be_greater_than_the_scheduled_check_quantity: "Apabila pemeriksaan berlebihan tidak diaktifkan, kuantiti tidak boleh melebihi kuantiti yang dijadualkan",
  Abnormal_quality_inspection_quantity: "Anomali kuantiti pemeriksaan kualiti",
  enter_the_qualified_quantity: "Sila masukkan kuantiti item yang menepati piawaian",
  enter_the_breakage_quantity: "Sila masukkan kuantiti item yang rosak",
  enter_the_lack_send_quantity: "Sila masukkan kuantiti item yang hilang",
  enter_the_wrongly_send_quantity: "Sila masukkan kuantiti item yang dihantar salah",
  enter_the_actual_weight: "Sila masukkan berat sebenar",
  enter_the_actual_length: "Sila masukkan panjang sebenar",
  enter_the_actual_width: "Sila masukkan lebar sebenar",
  enter_the_actual_height: "Sila masukkan ketinggian sebenar",
  length_CM: "Panjang (CM)",
  width_CM: "Lebar (CM)",
  height_CM: "Tinggi (CM)",
  widht_MM: "Lebar (MM)",
  height_MM: "Tinggi (MM)",
  There_may_be_print_incompatibilities_when_using_custom_printing: "Kandungan cetakan mungkin tidak serasi apabila menggunakan cetakan tersuai",
  This_parameter_is_valid_only_when_the_width_and_height_are_greater_than_0: "Hanya berkesan apabila kedua-dua dimensi lebar dan tinggi melebihi 0",
  Create_mis_sent_SKUs: "Buat SKU salah hantar",
  The_number_of_missent_SKUs_cannot_be_0: "Kuantiti SKU salah hantar tidak boleh 0",
  Only_a_single_item_can_be_selected: "Hanya satu item boleh dipilih",
  Number_of_SKUs_sent_incorrectly: "Kuantiti SKU salah hantar",
  The_inspection_of_the_sku_has_been_completed_Scan_other_SKUs: "SKU ini telah selesai pemeriksaan kualiti. Sila imbas SKU lain.",
  The_inspection_Label_quantity_cannot_be_empty: "Sila masukkan bilangan label yang dilekatkan.",
  The_inspection_Label_quantity_cannot_be_greater_than_the_qualified_quantity: "Bilangan label pemeriksaan tidak boleh melebihi bilangan item yang layak.",
  Please_scan_the_receipt_number: "Sila imbas nombor resit gudang.",
  Quality_inspector: "Inspektor",
  Quality_inspection_information: "Butiran pemeriksaan",
  Product_real_information: "Maklumat sebenar produk",
  printBoxLabel: "Cetak label kotak",
  Print_head_entry_slip: "Cetak resit gudang peringkat pertama",
  Print_shipping_mark_and_case_label: "Cetak label penghantaran",
  Print_storage_box_label: "Cetak label resit gudang",
  Quantity_labeled: "Bilangan label yang dilekatkan",
  Quantity_inspected: "Bilangan yang diperiksa",
  Printing_product_bar_code: "Cetak kod bar produk",
  unpackingInspection: "Pemeriksaan membuka bungkusan",
  fastQualityInspectionAndShelf: "Pemeriksaan pantas dan penyusunan rak",
  qualityInspectionTaskList: "Senarai Tugas Pemeriksaan Kualiti",
  shelvesTaskList: "Senarai Tugas Penyimpanan",
  Ordinary_quality_inspection: "Pemeriksaan Standard",
  Rapid_quality_inspection: "Pemeriksaan Ekspres",
  Please_enter_SKU_or_product_barcode: "Sila masukkan SKU/Barang Kod Produk",
  batch_input: "Pemasukan Satu Klik",
  Please_enter_the_number_of_boxes: "Sila masukkan bilangan kotak",
  Order_types: "Jenis Pesanan",
  entering_the_warehouse: "Masukan",
  FirstLegOrder: "Waybill Peringkat Pertama",
  InventoryOrder: "Waybill Masukan",
  FirstLegOrder_AND_InventoryOrder: "Waybill Peringkat Pertama + Waybill Masukan",
  InventoryOrderType: "Jenis Waybill Masukan",
  InventoryOrderID: "ID Waybill Masukan",
  ThirdPartyInventoryOrder: "Waybill Masukan Gudang Pihak Ketiga",
  Receive_information: "Maklumat Pengambilan",
  Receiving_address: "Alamat Pengambilan",
  transport_information: "Maklumat Pengangkutan",
  Arrival_information: "Maklumat Ketibaan di Gudang",
  delivery_type: "Kaedah Penghantaran",
  Push_order: "Pesanan Terus",
  Push_order_Type: "Status Pesanan Terus",
  Please_select_delivery_type: "Sila Pilih Kaedah Penghantaran",
  Please_select_Order_types: "Sila Pilih Jenis Pesanan",
  Please_select_a_task_type: "Sila Pilih Jenis Tugas",
  detailed_address: "Alamat Perincian",
  Please_enter_detailed_address: "Sila Masukkan Alamat Perincian",
  Please_enter_phone: "Sila Masukkan Nombor Kenalan",
  Select_a_contact: "Pilih Nama Kenalan",
  phone: "Nombor Kenalan",
  warehouse_address: "Alamat Gudang",
  Warehouse_information: "Maklumat Gudang",
  freight_information: "Maklumat Kargo",
  Please_enter_mode_of_transportation: "Sila Masukkan Kaedah Pengangkutan",
  Please_enter_warehouse_address: "Sila Masukkan Alamat Gudang",
  Please_select_Estimated_time_to_transit_warehouse: "Sila Pilih Anggaran Masa Ketibaan di Gudang Perantaraan",
  Please_select_an_estimated_time_to_warehouse: "Sila pilih anggaran masa ketibaan di gudang",
  Shipping_to_transit_warehouse_method: "Kaedah penghantaran ke gudang transit",
  Pure_warehouse_receipt_does_not_support_door_to_door_collection: "Slip masuk sahaja tidak menyokong pengambilan di muka pintu",
  General_container_number: "Jumlah nombor kotak",
  cargo_list: "Senarai barangan",
  cargoInfo: "Maklumat barangan",
  personalized_setting: "Tetapan pengubahsuaian",
  Navigation_bar_style: "Gaya bar navigasi",
  window: "Tetingkap",
  windowAddress: "Alamat tetingkap",
  printContent: "Cetak kandungan",
  printingQuantity: "Cetak kuantiti",
  isShowCnName: "Paparkan nama Cina",
  isShowMadeInChina: "Paparkan 'Made in China'",
  isShowTime: "Paparkan masa",
  The_cargo_list_is_empty: "Senarai barangan kosong",
  add_cargo_list: "Tambah senarai barangan",
  batch_add_cargo_list: "Tambah senarai barangan secara pukal",
  total_value: "Jumlah nilai",
  outer_box_length: "Panjang kotak luaran",
  Please_enter_outer_box_length: "Sila masukkan panjang kotak luaran",
  outer_box_width: "Lebar kotak luaran",
  Please_enter_outer_box_width: "Sila masukkan lebar kotak luaran",
  outer_box_height: "Tinggi kotak luaran",
  Please_enter_outer_box_height: "Sila masukkan tinggi kotak luaran",
  Receiving_container_length: "Panjang kotak luaran yang diterima",
  Receiving_container_width: "Lebar kotak luaran yang diterima",
  Receiving_container_height: "Tinggi kotak luaran yang diterima",
  Received_weight: "Berat yang diterima",
  carton_size: "Dimensi kotak luaran",
  Please_select_whether_there_is_a_label: "Sila pilih sama ada dilabel",
  Please_enter_the_customer_name: "Sila masukkan nama pelanggan",
  box: "Kotak",
  boxNumber: "Nombor kotak",
  product_details: "Butiran produk",
  add_product_details: "Tambah butiran produk",
  remove: "Keluarkan",
  product_image: "Imej produk",
  Eng_Cn_Name: "Nama produk dalam bahasa Cina",
  Please_enter_Eng_Cn_Name: "Sila masukkan nama produk dalam bahasa Cina",
  Eng_En_Name: "Nama produk dalam bahasa Inggeris",
  Please_enter_Eng_En_Name: "Sila masukkan nama produk Bahasa Inggeris",
  unit_price: "Harga unit",
  Please_enter_unit_price: "Sila masukkan harga unit",
  Is_there_a_mark: "Label ada",
  goodsCode: "Barcode produk",
  model: "Model",
  Please_enter_model: "Sila masukkan model",
  material: "Bahan",
  stage: "Tahap",
  product_code: "Kod produk",
  Please_enter_material: "Sila masukkan bahan",
  customs_code: "Kod kastam",
  Please_enter_customs_code: "Sila masukkan kod kastam",
  brand: "Jenama",
  Please_enter_brand: "Sila masukkan jenama",
  List_of_goods_not_selected_for_addition: "Senarai barangan tidak dipilih untuk ditambah",
  There_is_an_empty_container_number_Please_fill_in_the_container_number_and_try_again: "Nombor kotak tidak sah dikesan. Sila masukkan nombor kotak yang sah dan cuba semula!",
  Property_of_goods: "Atribut barangan",
  Please_select_goods_attributes: "Sila pilih atribut barangan",
  CollectInfo: "Maklumat pengambilan",
  Repeated_SKUs_appear: "SKU dwi-salinan dikesan",
  Save_to_draft: "Simpan ke draf",
  batch_processing: "Pemprosesan pukal",
  Quantity_in_storage: "Kuantiti masuk",
  Dimensional_synchronization: "Sinkronisasi dimensi",
  The_batch_list_is_not_selected: "Senarai barangan yang tidak dipilih untuk pemprosesan pukal",
  Total_storage_quantity: "Jumlah kuantiti masuk",
  Gross_cargo_weight: "Jumlah berat barangan",
  Shipping_Information: "Maklumat penghantaran",
  Delivery_type: "Jenis penghantaran",
  box_quantity: "Bilangan kotak",
  Size_of_the_outer_box_received: "Dimensi kotak luaran yang diterima",
  not_receive_the_goods: "Tidak diterima",
  received: "Diterima",
  Take_pictures_of_receiving_goods: "Imej resit",
  Receive_goods_in_one_box: "Resit satu kotak",
  Double_receipt: "Resit dwi-salinan",
  Write_back_time: "Masa tulis balik",
  Write_back_result: "Keputusan tulis balik",
  Single_box_Only_one_box_can_be_selected: "Resit satu kotak hanya membenarkan pemilihan satu kotak",
  The_receiving_list_has_empty_value_and_cannot_be_saved: "Senarai resit mengandungi nilai kosong, penyimpanan gagal",
  No_box_was_selected_to_save_the_receipt: "Tiada kotak dipilih untuk penyimpanan resit",
  Duplicate_receipt_is_detected_whether_to_duplicate_receipt: "Resit dwi dikesan. Pengesahan resit dwi?",
  Whether_excess_inspection: "Melebihi kuota pemeriksaan kualiti?",
  Priority_inspection: "Keutamaan pemeriksaan kualiti?",
  Only_a_single_entry_ticket_can_be_selected: "Hanya pesanan resit tunggal dibenarkan",
  The_box_number_already_exists: "Nombor kotak tidak betul, sila masukkan semula",
  Please_enter_the_box_number: "Sila masukkan nombor kotak",
  The_inspection_of_all_the_current_container_numbers_has_been_completed: "Semua pemeriksaan kualiti telah selesai untuk nombor kotak semasa",
  There_is_no_quality_inspection_data_for_the_current_container_number: "Tiada data pemeriksaan tersedia untuk nombor kotak semasa. Sila imbas semula!",
  The_SKU_does_not_exist_in_the_current_container_number: "SKU tidak wujud untuk nombor kotak semasa",
  inspected: "Diperiksa",
  Not_inspected: "Belum diperiksa",
  Successful_receipt: "Resit berjaya",
  Submit_and_print: "Hantar dan cetak",
  Print_head_list: "Cetak waybill",
  Header_list: "Senarai waybill",
  printHeaderList: "Cetak senarai waybill",
  printSubMitHeaderList: "Cetak senarai waybill yang dihantar",
  First_shipping_mark: "Label waybill",
  printFirsShippingMark: "Cetak label waybill",
  printSubMitFirsShippingMark: "Cetak label waybill yang dihantar",
  First_single_box_label: "Label kotak waybill",
  Warehouse_single_box_label: "Label kotak pesanan masuk",
  printFirstSingleBoxLabelAndWarehouseSingleBoxLabel: "Cetak label kotak waybill + label kotak resit gudang",
  printSubMitFirstSingleBoxLabelAndWarehouseSingleBoxLabel: "Cetak dan hantar label kotak waybill + label kotak resit gudang",
  Select_individual_order: "Sila pilih satu pesanan",
  total_number_packages: "Jumlah item",
  total_weight_KG: "Jumlah berat (kg)",
  Gross_cube_CBM: "Jumlah meter padu (CBM)",
  Gross_cube: "Jumlah meter padu",
  Export_data_priority: "Keutamaan eksport data",
  Specified_exported_data: "Nyatakan data eksport",
  List_selection_data: "Pilih data daripada senarai",
  List_filtering_data: "Tapis data daripada senarai",
  distributionManagement: "Pengurusan pemenuhan pesanan",
  printInventoryEntryList: "Cetak senarai resit gudang",
  The_form_verification_failed_Please_check_and_try_again: "Pengesahan borang gagal. Sila semak dan cuba semula.",
  The_product_bar_code_does_not_exist_in_the_current_task_list_or_has_been_put_on_the_shelf: "Barang kod produk ini tidak wujud dalam pesanan tugas semasa atau telah disisihkan sepenuhnya. Sila imbas semula!",
  Inventory_entry_list: "Senarai Penerimaan",
  Print_the_inventory_entry_list: "Cetak Senarai Penerimaan",
  One_click_out_and_print_the_pick_list: "Keluaran Satu Klik & Cetak Slip Picking",
  One_click_out_the_warehouse_and_print_the_invoice: "Keluaran Satu Klik & Cetak Slip Penghantaran",
  Only_confirmation_time_is_supported: "Hanya masa pengesahan disokong",
  Please_select_confirmation_time: "Sila pilih masa pengesahan",
  Only_save_the_hour_minute_and_second_of_the_confirmation_time: "Hanya menyimpan jam, minit, dan saat masa pengesahan; secara lalai menggunakan tarikh hari ini untuk pertanyaan pantas",
  The_current_operation_cannot_be_undone_Do_you_want_to_continue: "Operasi semasa tidak boleh dibatalkan. Teruskan?",
  Quantities_that_have_not_passed_quality_inspection_will_be_considered_entirely_unqualified: "Kuantiti yang tidak diperiksa akan dianggap sepenuhnya tidak mematuhi",
  Edit_warehouse_remark: "Sunting nota gudang",
  Submit_to_listed: "Serahkan ke status disisihkan",
  Has_the_quality_inspection_been_completed: "Adakah pemeriksaan kualiti telah selesai?",
  Forecast_error_message: "Ralat ramalan",
  Take_pictures_out_of_the_warehouse: "Foto penghantaran keluar",
  Online_product_details: "Butiran produk dalam talian",
  Product_preview: "Imej pratonton produk",
  declared_value: "Nilai yang dinyatakan",
  Weight_KG_piece: "Berat (kg/unit)",
  Weight_KG_box: "Berat (kg/kotak)",
  Declared_value_USD_piece: "Nilai yang dinyatakan (USD/unit)",
  Please_enter_Declared_value_USD_piece: "Sila masukkan nilai yang dinyatakan (USD/unit)",
  Please_enter_Weight_KG_piece: "Sila masukkan berat (kg/unit)",
  CommodityManagement: "Pengurusan Produk",
  commodity: "Produk",
  commodityName: "Nama produk",
  Online_product_name: "Nama produk dalam talian",
  SKUManagement: "Pengurusan SKU",
  inventorySKUManagement: "Pengurusan SKU Inventori",
  inventorySKU: "SKU Inventori",
  EditInventorySKU: "SKU Inventori",
  inventorySKUName: "Nama SKU Inventori",
  inventorySKUList: "Senarai SKU Inventori",
  inventorySKUImage: "Imej SKU Inventori",
  Click_to_upload_stock_SKU_picture: "Klik untuk Memuat naik Imej SKU Inventori",
  Click_to_upload_combined_SKU_images: "Klik untuk Memuat naik Imej SKU Kombinasi",
  Import_goods: "Import Produk",
  Batch_create_goods: "Buat Produk Berkumpulan",
  Edit_the_combined_SKU: "Sunting SKU Kombinasi",
  bar_code: "Barang Kod",
  Commodity_billing_attribute: "Atribut Pengebilan Produk",
  Editable_or_not: "Boleh Disunting",
  Combination_quantity: "Kuantiti Kombinasi",
  Add_stock_SKUs: "Tambah SKU Inventori",
  Please_enter_inventorySKU: "Sila Masukkan SKU Inventori",
  Please_enter_bar_code: "Sila Masukkan Barang Kod",
  product_Cn_name: "Nama Produk dalam Bahasa Cina",
  Please_enter_product_Cn_name: "Sila Masukkan Nama Produk dalam Bahasa Cina",
  product_En_name: "Nama Produk dalam Bahasa Inggeris",
  Please_enter_product_En_name: "Sila Masukkan Nama Produk dalam Bahasa Inggeris",
  initiate_mode: "Aktifkan Status",
  Please_select_initiate_mode: "Sila Pilih Status untuk Diaktifkan",
  inventory_status: "Status Inventori",
  Please_select_inventory_status: "Sila pilih status inventori",
  Alarm_threshold_status: "Status Ambang Amaran",
  Please_select_Alarm_threshold_status: "Sila pilih status ambang amaran",
  Last_two_weeks: "Dua Minggu Terakhir",
  Last_two_month: "Dua Bulan Terakhir",
  Last_three_month: "Tiga Bulan Terakhir",
  actual_weight_KG: "Berat Sebenar (KG)",
  Actual_Trilateral_sum_CM: "Jumlah Sebenar Tiga Dimensi (CM)",
  Actual_size_CM: "Dimensi Sebenar (CM)",
  physical_length: "Panjang Sebenar",
  physical_width: "Lebar Sebenar",
  physical_height: "Tinggi Sebenar",
  size_CM: "Dimensi (CM)",
  Actual_size: "Dimensi Sebenar",
  print_size: "Dimensi Cetakan",
  Custom_size: "Dimensi Tersuai",
  Custom_size_print: "Dimensi Tersuai untuk Cetakan",
  Please_enter_actual_weight: "Sila masukkan berat sebenar",
  Please_enter_actual_Trilateral_sum_CM: "Sila masukkan jumlah sebenar tiga dimensi (CM)",
  Please_enter_actual_weight_KG: "Sila masukkan berat sebenar (kg)",
  Please_enter_actual_size: "Sila masukkan dimensi sebenar",
  inventory_quantity: "Jumlah inventori",
  Total_occupied_inventory: "Inventori terisi",
  Total_cubic_number_of_inventory: "Jumlah isipadu inventori (meter padu)",
  Total_unshipped_quantity: "Jumlah inventori belum dihantar",
  Total_available_inventory: "Jumlah inventori tersedia",
  Available_Stock: "Inventori tersedia",
  Total_number_of_cubes_in_transit: "Jumlah isipadu dalam perjalanan (meter padu)",
  Total_number_in_transit: "Jumlah inventori dalam perjalanan",
  Total_unavailable_inventory_quantity: "Jumlah inventori tidak tersedia",
  In_transit_inventory: "Inventori dalam perjalanan",
  Sales_Volume_7_14_30_60_90: "Isipadu jualan (7/14/30 hari)",
  Sales_Volume_60_90: "Isipadu jualan (60/90 hari)",
  Sales_Volume_45_60_90: "Isipadu jualan (45/60/90 hari)",
  Forecast_30_day_average_daily_sales: "Anggaran jualan harian purata 30 hari",
  Number_of_warnings: "Kuantiti amaran",
  Alert_stock: "Stokin amaran",
  Whether_to_calculate_alert_inventory_automatically: "Kira stok amaran secara automatik?",
  Please_select_Whether_to_calculate_alert_inventory_automatically: "Pilih sama ada untuk mengira stok amaran secara automatik",
  Automatic_calculation_mode: "Kaedah pengiraan automatik",
  purchase_price: "Harga pembelian",
  Please_select_SKU: "Pilih SKU",
  portfolioSKUManagement: "Pengurusan SKU gabungan",
  portfolioSKUList: "Senarai SKU gabungan",
  product_barcode: "Barcode produk",
  Please_enter_the_product_barcode: "Masukkan barcode produk",
  Select_all_boxes: "Pilih semua kotak",
  Reset_option: "Reset pilihan",
  Modify_the_print_quantity_of_the_selected_item: "Ubah suai kuantiti cetakan produk yang dipilih",
  Please_enter_the_product_barcode_for_screening: "Masukkan barcode produk untuk menapis",
  Inventory_warning_does_not_allow_duplicate_warehouses: "Amaran inventori tidak boleh menggandakan gudang",
  isReceiveWarningNotice: "Terima notifikasi amaran",
  Last_release_date: "Tarikh penyenaraian terkini",
  Add_early_warning: "Tambah stok amaran",
  Days_of_existing_warning: "Hari sejak amaran",
  Please_enter_the_number_of_alerts: "Masukkan stok amaran",
  Please_enter_the_expected_number_of_days: "Masukkan tempoh amaran",
  Please_select_automatic_calculation_mode: "Pilih kaedah pengiraan automatik",
  Please_select_whether_to_receive_an_alert_notification: "Sila pilih sama ada untuk menerima pemberitahuan amaran",
  Average_daily_sales_for_the_last_7_days: "Jualan Harian Purata sepanjang 7 Hari Terakhir",
  Average_daily_sales_for_the_last_15_days: "Jualan Harian Purata sepanjang 15 Hari Terakhir",
  Average_daily_sales_for_the_last_30_days: "Jualan Harian Purata sepanjang 30 Hari Terakhir",
  Average_weekly_sales: "Jualan Mingguan Purata",
  Sales_time_meets_12_months_week: "Tempoh Jualan Mencapai 12 (Bulan/Minggu)",
  Total_sales_in_the_last_12_weeks_month_divided_by_12: "Jumlah Jualan sepanjang 12 (Minggu/Bulan) Terakhir ÷ 12",
  Average_monthly_sales: "Jualan Bulanan Purata",
  The_data_was_updated_in_the_early_hours_of_the_next_day: "Data dikemas kini pada tengah malam hari berikutnya",
  The_sales_time_does_not_meet_12_months_week: "Tempoh Jualan Tidak Mencapai 12 (Bulan/Minggu)",
  Total_sales_in_months_weeks_sold_divided_by_the_number_of_months_weeks_sold: "Jumlah jualan (bulan/minggu) ÷ Jualan (bulan/minggu)",
  Set_inventory_warning_in_batches: "Tetapkan amaran inventori kumpulan",
  combination_SKU_Chinese_name: "Nama Cina SKU gabungan",
  combination_SKU_English_name: "Nama Inggeris SKU gabungan",
  Add_the_combined_SKU: "Tambah SKU gabungan",
  Combine_SKU_images: "Imej SKU gabungan",
  combined_SKU: "SKU gabungan",
  Portfolio_inventory: "Inventori gabungan",
  goodsImage: "Imej produk",
  viewPortfolioSKU: "Lihat SKU gabungan",
  Historical_operation_record: "Rekod operasi sejarah",
  Edit_inventory_SKU_list: "Sunting senarai SKU inventori",
  editInventorySkuList: "Sunting senarai SKU inventori",
  viewInventorySkuList: "Lihat senarai SKU inventori",
  createInventorySkuList: "Buat senarai SKU inventori",
  Only_common_products_can_be_selected: "Hanya produk standard menyokong pelbagai pilihan",
  inventory_management: "Pengurusan inventori",
  inventoryManagement: "Pengurusan inventori",
  Unavailable_inventory: "Status ketersediaan",
  inventoryList: "Senarai inventori",
  product_material: "Bahan produk",
  Please_select_product_material: "Sila pilih bahan produk",
  Product_bar_code: "Barcode produk",
  Reference_number: "Nombor rujukan",
  update_specified_goods: "Kemas kini produk yang ditetapkan",
  pull_specified_goods: "Dapatkan produk yang ditetapkan",
  please_select_data: "Sila pilih data",
  Select_a_single_SKU_for_operation: "Sila pilih SKU individu untuk tindakan",
  update_successfully: "Kemas kini berjaya",
  pull_successfully: "Pemerolehan berjaya",
  please_enter_link_id: "Sila masukkan ID pautan",
  subordinate_Account: "Akaun anak",
  Authorized_subaccount: "Benarkan akaun anak",
  Assign_subaccount: "Tugaskan akaun anak",
  Please_select_the_subaccount_that_you_want_to_authorize: "Sila pilih sub-akaun yang memerlukan kebenaran",
  Please_select_a_sub_account: "Sila pilih sub-akaun",
  modifyProductInformationList: "Senyawa senarai transaksi maklumat produk",
  batchCreateCombinedsku: "Bina SKU gabungan secara pukal",
  batch_create_combined_sku: "Bina SKU gabungan secara pukal",
  Please_check_the_data_first: "Sila pilih data terlebih dahulu",
  Import_the_combined_SKU: "Import SKU gabungan",
  batchCreateSubAccount: "Bina sub-akaun secara pukal",
  batch_Create_SubAccounts: "Bina sub-akaun secara pukal",
  Import_subAccounts: "Import sub-akaun",
  Import_to_modify_the_product_barcode: "Import Ubah suai kod bar produk",
  modify_the_product_barcode: "Ubah suai kod bar produk",
  Set_the_default_allocation_of_the_first_trip_fee: "Tetap bayaran penghantaran awal kongsi lalai",
  Default_allocation_of_first_trip_fee: "Bayaran penghantaran awal kongsi lalai",
  Default_first_leg_fee: "Bayaran penghantaran awal lalai",
  Default_allocation_of_first_trip_fee_only_used_for_order_profit_report_calculation_statistics: "Caj kargo awal kongsi lalai adalah semata-mata untuk pengiraan laporan keuntungan pesanan",
  Includes_the_quantity_to_be_reviewed_and_reviewed_received_in_the_transit_warehouse_and_in_transit_and_in_the_last_leg_and_received_in_the_last_leg_and_in_the_quality_inspection_and_inspected_but_not_yet_listed: "Termasuk kuantiti yang menunggu semakan, telah disemak, diterima di gudang transit, dalam perjalanan, menerima penghantaran akhir, penghantaran akhir diterima, sedang menjalani pemeriksaan kualiti, telah diperiksa tetapi belum disusun di rak",
  This_operation_will_permanently_delete_sku: "Tindakan ini akan memadam SKU secara kekal",
  Batch_modification_of_purchase_prices: "Sunting pukal harga pembelian",
  Batch_modification_of_default_allocation_of_headhaul_fees: "Sunting secara pukal caj penghantaran awal kongsi lalai",
  Original_purchase_price: "Harga pembelian asal",
  New_purchase_price: "Harga pembelian baru",
  The_original_default_allocation_of_the_origin_leg_cost: "Caj penghantaran awal kongsi lalai asal",
  New_default_allocation_of_origin_charges: "Caj penghantaran awal kongsi lalai baru",
  Modify_the_purchase_price: "Sunting harga pembelian",
  Form_modification_of_purchase_price: "Penyuntingan harga pembelian berasaskan borang",
  Modify_the_default_allocation_of_origin_charges: "Sunting caj penghantaran awal kongsi lalai",
  Modify_the_default_allocation_of_the_initial_transportation_cost_in_the_form: "Penyuntingan caj penghantaran awal kongsi lalai lalai berasaskan borang",
  Import_and_modify_the_purchase_price_and_the_default_headway_cost_allocation: "Import untuk menyunting harga pembelian dan caj penghantaran awal kongsi lalai",
  Greater_than_0_001_and_less_than_9999999: "Lebih besar daripada 0.001 dan kurang daripada 9999999",
  Unusable_inventory_quantity: "Kuantiti stok tidak tersedia",
  createGoods: "Buat produk",
  product_information: "Maklumat produk",
  Please_enter_product_information: "Sila masukkan maklumat produk",
  product_specification: "Spesifikasi produk",
  Product_declaration: "Deklarasi produk",
  procurement_price: "Harga pembelian",
  Please_enter_cost_price: "Sila masukkan harga kos",
  Please_enter_procurement_price: "Sila masukkan harga pembelian",
  volume_cm: "Isipadu (cm³)",
  actual_volume: "Isipadu sebenar",
  actual_volume_cm: "Isipadu sebenar (cm³)",
  commercial_specification: "Spesifikasi produk",
  Please_enter_commercial_specification: "Sila masukkan spesifikasi produk",
  Product_name_Chinese: "Nama produk yang dinyatakan (Bahasa Cina)",
  Please_enter_Product_name: "Sila masukkan nama produk yang dinyatakan",
  Product_name_English: "Nama Produk yang Disatakan (Inggeris)",
  country_of_origin: "Negara Asal",
  Please_enter_country_of_origin: "Sila masukkan negara asal",
  Days_of_purchase: "Hari Perolehan",
  Please_enter_Days_of_purchase: "Sila masukkan hari perolehan",
  product_attribute: "Atribut Produk",
  Special_commodity_attribute: "Atribut Produk Khas",
  Please_select_product_properties: "Sila pilih atribut produk",
  inventory_warning: "Amaran Stok",
  Early_warning_inventory: "Tahap Stok Amaran",
  Days_of_warning: "Hari Amaran",
  Please_enter_Early_warning_inventory: "Sila masukkan tahap stok amaran",
  Please_enter_Days_of_warning: "Sila masukkan hari amaran",
  Calculating_early_warning_inventory: "Kaedah Pengiraan Stok Amaran",
  Automatic_calculation_of_early_warning_inventory: "Mengira stok amaran secara automatik",
  Alert_inventory_is_equal_to_alert_days_multiplied_by_daily_sales: "Stok Amaran = Hari Amaran × Jumlah Jualan Harian",
  Click_to_upload: "Klik untuk memuat naik",
  Only_jpg_or_png_files_with_a_maximum_size_of_2048kb_can_be_uploaded: "Hanya fail jpg atau png boleh dimuat naik, tidak melebihi 2048kb",
  Please_upload_product_pictures: "Sila muat naik imej produk",
  Please_enter_dimensions_of_length_width_and_height_greater_than_zero: "Sila masukkan dimensi panjang, lebar dan tinggi, semuanya melebihi sifar",
  The_operation_failed__Please_check_the_content_and_submit_again: "Operasi gagal. Sila semak semula kemasukan anda dan hantar semula",
  editorialGoods: "Sunting produk",
  viewGoods: "Lihat produk",
  Enter_SKU_and_bar_code_separated_by_commas_comma: "Sila masukkan SKU dan kod bar, dipisahkan dengan koma",
  Please_enter_sku: "Sila masukkan SKU",
  delete_in_batches_sku: "Padam Berkas SKU",
  Select_the_sku_that_you_want_to_delete: "Pilih SKU untuk dipadam",
  Select_the_SKUs_that_you_want_to_add: "Pilih SKU untuk ditambah",
  And_enter_the_number_of_SKUs_you_want_to_add: "Masukkan kuantiti untuk ditambah",
  Select_the_SKU_that_you_want_to_modify: "Pilih SKU untuk diubah",
  Enter_the_number_of_SKUs_that_you_want_to_modify: "Masukkan kuantiti untuk diubah",
  Select_the_SKU_for_which_you_want_to_modify_the_repository: "Pilih SKU untuk tukar gudang",
  And_select_a_new_warehouse: "Pilih gudang baru",
  Adding_SKUs_in_bulk: "Tambah Berkas SKU",
  Edit_note: "Sunting Nota",
  select_sku: "Pilih SKU",
  Type_query: "Tulis Carian",
  Export_goods: "Eksport Produk",
  Export_incoming_and_outgoing_records: "Eksport Rekod Masuk/Keluark",
  product_list: "Senarai Produk",
  product_list_sub_warehouse: "Senarai Produk (Mengikut Gudang)",
  serial_Number: "Nombor",
  Create_distribution_control: "Tubuhkan Kawalan Peruntukan",
  Number_of_generated_tasks: "Jana Kuantiti Tugas",
  create_task: "Jana Tugas",
  Delivery_process_2_cannot_use_border_variation: "Proses Penghantaran 2 tidak dapat menggunakan penukaran peruntukan-ke-peruntukan",
  If_a_check_order_exists_during_task_generation_the_check_order_task_is_preferentially_generated: "Semasa menjana tugas, jika terdapat pesanan bertanda, tugas untuk pesanan bertanda akan diutamakan",
  warehouse_management: "Pengurusan Gudang",
  warehouseOperation: "Operasi Gudang",
  warehouse_Number: "Nombor Gudang",
  Please_enter_warehouse_Number: "Sila masukkan nombor gudang",
  Please_enter_warehouse_partition: "Sila masukkan bahagian gudang",
  goods_shelf: "Rak",
  goods_shelf_info: "Maklumat Rak",
  Shelf_type: "Jenis Rak",
  Please_enter_Shelf_type: "Sila masukkan jenis rak",
  Shelf_layer: "Tahap Rak",
  Please_enter_Shelf_layer: "Sila masukkan tahap rak",
  Storage_rack: "Lajur Rak",
  Please_enter_Storage_rack: "Sila masukkan lajur rak",
  Shelf_size_length_width_and_height: "Dimensi Rak (P*L*T)",
  Shelf_cube: "Isipadu Rak (m³)",
  Please_enter_Shelf_cube: "Sila masukkan isipadu rak",
  Library_location_information: "Maklumat Lokasi Penyimpanan",
  Storage_location_type: "Jenis Lokasi Penyimpanan",
  Please_enter_Storage_location_type: "Sila masukkan jenis lokasi penyimpanan",
  SKU_storage_type: "Jenis Penyimpanan SKU",
  Please_enter_goods_shelf: "Sila masukkan rak",
  Please_enter_Residual_storage_capacity: "Sila masukkan baki kapasiti penyimpanan",
  Please_enter_Storage_capacity_in_transit: "Sila masukkan kapasiti penyimpanan dalam perjalanan",
  Please_enter_Service_storage_capacity: "Sila masukkan kapasiti penyimpanan yang digunakan",
  Please_select_the_currency_of_charge: "Sila pilih mata wang pengebilan",
  Storage_location_SKU: "SKU Lokasi Penyimpanan",
  Please_enter_Storage_location_SKU: "Sila masukkan SKU lokasi penyimpanan",
  Initial_storage: "Kapasiti Penyimpanan Permulaan",
  End_storage: "Kapasiti Penyimpanan Akhir",
  Add_partition: "Tambah Zon",
  Edit_partition: "Sunting Zon",
  partition_number: "Nombor Zon",
  Please_enter_partition: "Sila masukkan zon",
  Please_enter_partition_number: "Sila masukkan nombor zon",
  Please_select_floor: "Sila pilih tingkat",
  partition: "Zon",
  floor: "Tingkat",
  Batch_pairing: "Padanan Batch",
  storey: "Tingkat",
  Single_SKU: "SKU Tunggal",
  Multiple_SKU: "Beberapa SKU",
  Add_warehouse: "Tambah Gudang",
  Edit_warehouse: "Sunting Gudang",
  Add_storage_location: "Tambah Lokasi Penyimpanan",
  contacts: "Orang Perhubungan",
  Please_enter_contacts: "Sila masukkan orang perhubungan",
  Warehouse_zip_code: "Poskod Gudang",
  Please_enter_Warehouse_zip_code: "Sila masukkan poskod gudang",
  Toll_currency: "Mata Wang Pengebilan",
  Please_enter_Toll_currency: "Sila masukkan mata wang pengebilan",
  Warehouse_recipient: "Penerima Gudang",
  Recipient_phone_number: "Telefons Penerima",
  Warehouse_capacity_m: "Kapasiti Gudang/m³",
  Service_storage_capacity_m: "Kapasiti Digunakan/m³",
  Storage_capacity_in_transit_m: "Kapasiti Dalam Perjalanan/m³",
  Residual_storage_capacity_m: "Kapasiti Baki/m³",
  Zoned_storage_m: "Kapasiti Zon/m³",
  Storage_location_Storage_capacity_m: "Kapasiti Bin/m³",
  Storage_capacity_SKU: "SKU Kapasiti",
  Bind_the_library_location_SKU: "SKU Bin Terikat",
  Pick_the_warehouse_location: "Bin Pemilihan",
  Shelf_coding: "Kod Rak",
  Please_enter_Shelf_coding: "Sila masukkan kod rak",
  Shelf_name: "Nama Rak",
  Please_enter_Shelf_name: "Sila masukkan nama rak",
  Shelf_length: "Panjang Rak",
  Please_enter_Shelf_length: "Sila masukkan panjang rak",
  Shelf_weight: "Lebar Rak",
  Please_enter_Shelf_weight: "Sila masukkan lebar rak",
  Shelf_height: "Tinggi Rak",
  Please_enter_Shelf_height: "Sila masukkan tinggi rak",
  single_face: "Sisi tunggal",
  two_sided: "Dua sisi",
  Warehouse_location_number: "Nombor Petak",
  Location_number: "ID Petak",
  Edit_library_location: "Sunting Petak",
  Only_one_table_can_be_imported_simultaneously: "Hanya satu jadual boleh diimport pada satu masa",
  Only_tables_can_be_imported: "Hanya jadual boleh diimport",
  Only_select_tables_are_allowed: "Hanya jadual boleh dipilih",
  Import_a_single_table_first: "Sila jalankan import jadual tunggal terlebih dahulu",
  Unselected_formula: "Tiada formula dipilih",
  Selection_result_table: "Pilih Jadual Hasil",
  Please_select_table: "Sila pilih satu jadual",
  Only_one_table_can_be_selected: "Hanya satu jadual boleh dipilih",
  Manually_insert_data: "Masukkan Data Secara Manual",
  The_current_table_is: "Jadual semasa ialah",
  Trigger_name: "Nama Pencetus",
  Please_enter_Trigger_name: "Sila masukkan nama pencetus",
  libraryLocationList: "Senarai Lokasi Penyimpanan",
  Back_libraryLocationList: "Kembali ke Senarai Lokasi Penyimpanan",
  have_been_used: "Digunakan",
  unused: "Tidak Digunakan",
  print_Library_location_number: "Cetak Nombor Lokasi Penyimpanan",
  quantity_in_stock: "Kuantiti Stok",
  Inventory_occupancy: "Kuantiti Stok Terisi",
  Inventory_warning_quantity: "Kuantiti Amaran Stok",
  deposit_type: "Jenis Penyimpanan",
  The_location_type: "Jenis Lokasi Penyimpanan",
  sectionList: "Senarai Zon",
  shelvesList: "Senarai Rak",
  Batch_delete_shelves: "Padam Beramai-ramai Rak",
  Modify_the_partition_number: "Ubah Nombor Zon",
  Modify_the_shelf_number: "Ubah Nombor Rak",
  Modify_the_storage_location_number: "Ubah Nombor Lokasi Penyimpanan",
  Please_enter_the_shelf_number: "Sila masukkan nombor rak",
  Import_modified_partition_codes: "Kemasukan untuk mengubah suai kod zon",
  Import_and_modify_the_shelf_number: "Kemasukan untuk mengubah suai nombor rak",
  Import_and_modify_the_storage_location_numbers: "Kemasukan untuk mengubah suai nombor lokasi penyimpanan",
  Please_select_the_shelves_you_want_to_delete: "Sila pilih rak untuk dipadam",
  Confirm_to_delete_the_shelfs: "Sahkan pemadaman rak",
  goods_shelf_number: "Nombor Rak",
  regional_management: "Pengurusan Wilayah",
  countriesList: "Senarai Negara",
  Added_country: "Tambah Negara",
  Bulk_add_countries: "Tambah Negara Secara Berkumpulan",
  Please_select_country: "Sila Pilih Negara",
  Please_select_Destination_warehouse: "Sila Pilih Gudang Destinasi",
  Destination_warehouse: "Gudang Destinasi",
  recipientManagement: "Pengurusan Penerima",
  Please_enter_the_recipient_name: "Sila Masukkan Nama Penerima",
  Please_enter_the_recipient_phone_number: "Sila Masukkan Telefon Penerima",
  Recipient_name: "Nama Penerima",
  Receiver_Address: "Alamat Penerima",
  Add_recipient: "Tambah Penerima",
  Edit_recipient: "Sunting Penerima",
  Recipient_email_address: "E-mel Penerima",
  Please_select_the_full_region: "Sila Pilih Wilayah Penuh",
  Please_select_a_region: "Sila Pilih Wilayah",
  financialManagement: "Pengurusan Kewangan",
  financialReports: "Laporan Kewangan",
  cost: "Perbelanjaan",
  costmanagement: "Pengurusan Perbelanjaan",
  costType: "Status Perbelanjaan",
  costSetting: "Tetapan Perbelanjaan",
  Client_editing: "Suntingan Pelanggan",
  AmazonBaiyiUS: "Amazon Baiyikexun USA",
  amazonBaiyiUS: "Amazon Baiyikexun USA",
  month: "Bulan",
  turnover: "Perolehan",
  The_amount_of_the_platform_should_be_lent: "Jumlah Platform yang Terhutang untuk Pengeluaran",
  The_wrong_amount_should_be_lent: "Jumlah yang Terhutang untuk Pengeluaran yang Silap",
  have_already_settled: "Telah Diselesaikan",
  consolidate_orders: "Pesanan Konsolidasi",
  refund: "Pembayaran Balik",
  rebates: "Pembayaran Balik Sebahagian",
  Refund_and_compensation: "Pampasan Pembayaran Balik",
  compensate: "Pampasan",
  Unlent_amount: "Jumlah Belum Dikeluarkan",
  deleteTable: "Padam Jadual",
  Confirm_deletion_table: "Kesahkan Pemadaman",
  Recharge_time: "Masa Isi Semula",
  Please_select_a_Recharge_time: "Sila pilih masa isi semula",
  Add_top_up: "Tambah Isi Semula",
  exchange_rate: "Kadar Pertukaran",
  Amount_actually_paid: "Jumlah Bayaran Sebenar",
  Please_enter_the_Amount_actually_paid: "Sila masukkan jumlah bayaran sebenar",
  Currency_of_payment: "Mata Wang Bayaran",
  Please_enter_the_Currency_of_payment: "Sila masukkan mata wang bayaran",
  The_currency_of_the_deposit: "Mata Wang Isi Semula",
  Please_enter_the_The_currency_of_the_deposit: "Sila masukkan mata wang isi semula",
  service_charge: "Caj Pengendalian",
  accounting_date: "Masa Ketibaan",
  Please_select_a_accounting_date: "Sila pilih masa ketibaan",
  note: "Keterangan",
  Top_up_number: "Nombor Isi Semula",
  recharge_amount: "Jumlah Isi Semula",
  Balance_before_recharge: "Baki Sebelum Isi Semula",
  Balance_after_recharge: "Baki Selepas Isi Semula",
  The_charge_shall_not_be_greater_than_the_amount_of_the_deposit: "Yuran transaksi tidak boleh melebihi jumlah top-up",
  Recharge_information: "Maklumat Top-up",
  Please_select_a_billing_time: "Sila pilih masa penyelesaian",
  Please_enter_the_statement_number: "Sila masukkan nombor invois penyelesaian",
  Please_select_a_recharge_type: "Sila pilih jenis top-up",
  About_to_jump_to_the_recharge_page: "Anda kini akan dialihkan ke halaman top-up",
  state_of_payment: "Status Pembayaran",
  Continue_to_pay: "Teruskan Pembayaran",
  during_the_payment: "Pembayaran Dalam Proses",
  payment_failure: "Pembayaran Gagal",
  have_expired: "Tamat Tempoh",
  canceled: "Dibatalkan",
  Completed_transaction: "Transaksi Siap",
  Uncompleted_transaction: "Transaksi Tertunggak",
  failure_of_transaction: "Transaksi Gagal",
  Only_a_single_task_can_be_selected: "Hanya satu tugasan boleh dipilih",
  Please_select_a_basket: "Sila pilih bakul",
  Sheet_address: "Alamat Waybill",
  Recommended_storage_location: "Lokasi Penyimpanan Disyorkan",
  The_product_is_finished: "Barang Ini Lengkap",
  initial_workpiece: "Barang Pertama",
  follow_up_workpiece: "Barang Seterusnya",
  aggregate_amount: "Jumlah Keseluruhan",
  Daily_order_volume: "Jumlah Isipadu Pesanan Harian",
  Total_order_processing_fee: "Jumlah Yuran Pemprosesan Pesanan",
  Average_unit_price_per_order: "Harga Unit Purata setiap Pesanan",
  Total_number_of_SKUs_for_shipment: "Jumlah Kuantiti SKU Penghantaran",
  Average_unit_price_per_SKU: "Harga Unit Purata setiap SKU",
  orderProcessingFeeSet: "Yuran Pemprosesan Pesanan",
  Additional_cost: "Tambah Yuran",
  Additional_Max_cost: "Tambah Yuran Maksimum",
  Add_order_processing_fee: "Tambah Yuran Pemprosesan Pesanan",
  Additional_charge: "Caj Tambahan",
  Rate_number: "Kod Yuran",
  type_of_cost: "Jenis Yuran",
  Please_select_type_of_cost: "Sila pilih jenis yuran",
  Please_enter_Additional_charge: "Sila masukkan jumlah surcaj",
  Please_enter_Rate_number: "Sila masukkan kod yuran",
  Out_of_range_first_SKU_operating_fee: "Yuran pengendalian SKU pertama untuk barangan bersaiz besar",
  Please_enter_Out_of_range_first_SKU_operating_fee: "Sila masukkan yuran pengendalian SKU pertama untuk barangan bersaiz besar",
  Continued_SKU_operating_fee_out_of_range: "Yuran pengendalian SKU tambahan untuk barangan bersaiz besar",
  Please_enter_Continued_SKU_operating_fee_out_of_range: "Sila masukkan yuran pengendalian SKU tambahan untuk barangan bersaiz besar",
  Cost_of_first_packing_material_out_of_range: "Yuran bahan pembungkusan pertama untuk barangan bersaiz besar",
  Please_enter_Cost_of_first_packing_material_out_of_range: "Sila masukkan yuran pembungkusan bersaiz besar pertama",
  SKU_packaging_costs_are_exceeded: "Yuran pembungkusan SKU bersaiz besar berikutnya",
  Please_enter_SKU_packaging_costs_are_exceeded: "Sila masukkan yuran pembungkusan SKU bersaiz besar berikutnya",
  The_number_of_out_of_range_continuums_is_charged: "Kuantiti bil item bersaiz besar berikutnya",
  Please_enter_The_number_of_out_of_range_continuums_is_charged: "Sila masukkan kuantiti bil item bersaiz besar berikutnya",
  The_input_add_fee_has_no_value_Please_check_and_try_again: "Input mengandungi nilai kosong untuk yuran tambahan, sila semak dan cuba semula",
  Please_add_the_charges: "Sila tambah yuran",
  The_charge_standard_number_cannot_be_repeated: "Kod yuran tidak boleh digandakan",
  Out_of_range_listing_fees: "Yuran penyenaraian bersaiz besar",
  Out_of_range_Destruction_delisting_fee: "Yuran pemusnahan/penyusutan bersaiz besar",
  Out_of_range_Return_listing_fee: "Yuran Penyusunan Semula Pengembalian di Luar Skop",
  Three_sides_are_preferred: "Dimensi Terpanjang Utama",
  Preferred_weight: "Berat Utama",
  packagingMaterialCost: "Yuran Pembungkusan",
  Package_material_coding: "Kod Pembungkusan",
  Please_enter_Package_material_coding: "Sila masukkan kod pembungkusan",
  Packing_material_name: "Nama Pembungkusan",
  Please_enter_Packing_material_name: "Sila masukkan nama pembungkusan",
  Packing_material_length: "Panjang Pembungkusan",
  Please_enter_Package_material_length: "Sila masukkan panjang pembungkusan",
  Packing_material_width: "Lebar Pembungkusan",
  Please_enter_Package_material_width: "Sila masukkan lebar pembungkusan",
  Packing_material_height: "Tinggi Pembungkusan",
  Packing_material_Weight: "Berat Pembungkusan",
  Please_enter_Packing_material_height: "Sila masukkan tinggi pembungkusan",
  Packing_material_quantity: "Jumlah Pembungkusan",
  Please_enter_Packing_material_quantity: "Sila masukkan jumlah pembungkusan",
  Packing_material_type: "Jenis Pembungkusan",
  Please_enter_Packing_material_type: "Sila masukkan jenis pembungkusan",
  add_Packing_material: "Tambah pembungkusan",
  edit_Packing_material: "Sunting pembungkusan",
  Batch_add_Packing_material: "Tambah pembungkusan secara pukal",
  quantity_of_commodity: "Jumlah produk",
  The_box_number_does_not_exist: "Nombor kotak ini tidak wujud",
  Packaging_material_picture: "Imej pembungkusan",
  createCost: "Yuran penciptaan",
  Please_upload_picture_of_package_material: "Sila muat naik imej pembungkusan",
  expenseDeduction: "Penyesuaian yuran",
  Add_a_premium_deduction: "Tambah penyesuaian yuran",
  Expense_reimbursement_type: "Jenis penyesuaian yuran",
  Please_select_the_type_of_reimbursement: "Sila pilih jenis penyesuaian yuran",
  Please_select_packing_material: "Sila pilih pembungkusan",
  Please_select_a_packaging_method: "Sila pilih kaedah pembungkusan",
  Set_the_packaging_mode_in_batches: "Tetap kaedah pembungkusan secara pukal",
  Please_enter_barcode_SKU_Chinese_product_name_English_product_name: "Sila masukkan SKU, bar kod produk, nama produk dalam bahasa Cina, nama produk dalam bahasa Inggeris, kemudian klik butang carian untuk mencari",
  Please_enter_barcode_SKU: "Sila masukkan SKU, bar kod produk, kemudian klik butang carian untuk mencari",
  Please_enter_the_order_number_separated_by_line_breaks_or_commas: "Sila masukkan nombor pesanan, dipisahkan dengan peralihan baris atau koma",
  Packing_material_billing_type: "Jenis pengebilan pembungkusan",
  Minimum_charge_amount: "Jumlah pengebilan minimum",
  Number_of_warnings_must_not_exceed_the_quantity_in_stock: "Amaran: kuantiti tidak boleh melebihi jumlah inventori",
  default_packaging_material: "Pembungkusan lalai",
  packingMaterialDetail: "Butiran pembungkusan",
  packing_material_info: "Maklumat bahan pembungkusan",
  import_order_processing_fee: "Yuran pemprosesan pesanan import",
  import_storage_charges: "Yuran sewaan gudang import",
  import_fixed_sku_fees: "Yuran SKU tetap import",
  import_first_pass_cost: "Yuran pengangkutan awal import",
  setFeesByTemplate: "Tetapkan yuran mengikut templat",
  The_amount_of_the_deduction: "Jumlah pelarasan yuran",
  viewFixedSKUFee: "Lihat yuran SKU tetap",
  SpecialAprovalNumber: "Nombor kelulusan khas",
  Special_Customer_ID: "ID pelanggan kelulusan khas",
  Addition_special_fees: "Buat kelulusan khas yuran",
  Special_approval_for_import_fees: "Import kelulusan khas yuran",
  The_current_approver: "Pembenar semasa",
  Whether_to_be_anonymous_or_not: "Status tanpa nama",
  Work_order_source: "Sumber pesanan kerja",
  Notes_should_not_exceed_1000_characters: "Nota tidak boleh melebihi 1000 aksara",
  Pending_approval_currently: "Pembenar semasa",
  Currently_awaiting_review: "Sedang menunggu semakan",
  firstPassCostSetting: "Konfigurasi Yuran Peringkat Awal",
  firstPassCost: "Yuran Peringkat Awal",
  freight_cost_cube_KG: "Kos Kargo (Meter Padu/Kilogram)",
  freight_cost: "Kos Kargo",
  fixed_cost: "Kos",
  profit: "Keuntungan",
  Please_enter_the_shipping_cost: "Sila Masukkan Kos Kargo",
  Surcharge_cost_cube_KG: "Kos Caj Tambahan (Meter Padu/Kilogram)",
  Surcharge_cost: "Kos Caj Tambahan",
  Please_enter_the_Surcharge_cost: "Sila Masukkan Kos Caj Tambahan",
  Out_of_range_freight_cube_KG: "Kargo Luar Julat (Meter Padu/Kilogram)",
  Out_of_range_freight: "Kargo Luar Julat",
  Please_enter_Out_of_range_freight: "Sila Masukkan Kargo Luar Julat",
  Overreach_surcharge_cube_KG: "Caj Tambahan Luar Julat (Meter Padu/Kilogram)",
  Overreach_surcharge: "Caj Tambahan Luar Julat",
  Please_enter_Overreach_surcharge_cube_KG: "Sila masukkan caj lebihan isipadu",
  Minimum_number_of_charging_parties: "Isipadu Minimum yang Boleh Ditagih",
  Please_enter_Minimum_number_of_charging_parties: "Sila masukkan isipadu minimum yang boleh ditagih",
  Start_greater_than: "Mula (>)",
  cutoff: "Akhir (<=)",
  additional_charge_cube_KG: "Caj lebihan (meter padu/kg)",
  additional_charge: "Caj lebihan",
  Minimum_chargeable_weight: "Berat Minimum yang Boleh Ditagih",
  Please_enter_Minimum_chargeable_weight: "Sila masukkan berat minimum yang boleh ditagih",
  The_added_fee_is_empty: "Caj tambahan kosong",
  The_added_cost_has_a_null_value_The_creation_failed_Please_modify_the_cost_and_try_again: "Caj tambahan mengandungi nilai kosong. Penciptaan gagal. Sila ubah suai dan cuba semula",
  The_start_of_the_added_fee_is_not_equal_to_the_end_Please_modify_it_and_try_again: "Permulaan yuran tambahan tidak sama dengan penghujung. Sila ubah suai dan cuba semula.",
  Volume_weight_calculation_method_cubic_divide_volume_weight_is_worth_the_result_compare_the_weight_which_big_which: "Kaedah pengiraan berat isipadu: Kira nilai berat isipadu, bandingkan berat, ambil yang mana lebih besar.",
  Length_cm_X_width_cm_X_height_cm_volume_weight_value: "Isipadu: (Panjang(cm) * Lebar(cm) * Tinggi(cm) / Nilai berat isipadu) / 1000000",
  There_are_no_packing_materials_for_the_warehouse: "Tiada bahan pembungkusan tersedia untuk gudang ini",
  Printing_control: "Nombor tugasan cetakan",
  Several_tasks: "sesuatu tugas",
  code: "Kod",
  await: "Menunggu",
  second: "saat",
  request_timeout: "Permintaan tamat masa",
  Stop_query: "Hentikan pertanyaan",
  Edit_the_entry_slip: "Sunting resit gudang",
  Deduction_amount: "Jumlah potongan tambahan",
  Deduction_personnel: "Orang bertanggungjawab untuk potongan",
  Deduction_time: "Masa potongan",
  fixedSkuFees: "Yuran SKU tetap",
  Added_fixed_SKU_fee: "Tambah yuran SKU tetap",
  edit_fixed_SKU_fee: "Sunting yuran SKU tetap",
  Select_Add_SKUs: "Pilih SKU untuk ditambah",
  storageCharges: "Yuran sewa gudang",
  List_of_warehouse_rental_charges: "Senarai yuran sewa gudang",
  listWarehouseRentalCharges: "Senarai yuran sewa gudang",
  Start_days: "Tarikh mula",
  time_Info: "Maklumat Masa",
  Warehousing_charge: "Yuran Penyewaan Gudang",
  Days_in_storage: "Hari dalam Gudang",
  warehousing_time: "Masa Masuk Gudang",
  edit_cost: "Sunting Yuran",
  please_enter_SKU: "Sila Masukkan SKU",
  Operator_query: "Permintaan Pengendali",
  Minimum_length_of_three_sides: "Panjang Minimum Tiga Sisi",
  Maximum_length_of_three_sides: "Panjang Maksimum Tiga Sisi",
  The_input_fee_cannot_be_negative: "Yuran tidak boleh negatif",
  Storage_rental_days_are_calculated_at_the_beginning_of_each_SKU_incoming_batch: "Hari penyewaan gudang dikira dari tarikh permulaan kumpulan masuk setiap SKU",
  labellingCharge: "Yuran Pelabelan",
  Label_quantity: "Bilangan Label yang Dilekatkan",
  Label_or_not: "Pelabelan Diperlukan",
  special_CostId: "ID Pengecualian",
  special_CustomerId: "ID Pelanggan yang Dikecualikan",
  finish_time: "Tarikh Tamat",
  additionSpecialFees: "Buat Pengecualian Yuran",
  additionSpecialFeesEdit: "Sunting Pengecualian Yuran",
  viewSpecialApprovalExpenses: "Lihat Pengecualian Yuran",
  comeupReview: "Serahkan untuk Kelulusan",
  Special_approval_information: "Butiran Pengecualian",
  Whether_to_invalidate_this_special_approval_for_expenses: "Sama ada untuk membatalkan pengecualian yuran ini",
  After_approval_the_original_fee_settings_will_be_overwritten_Please_carefully_check_if_the_settings_are_correct: "Kelulusan akan menimpa tetapan yuran asal. Sila semak ketepatan dengan teliti",
  Please_select_the_same_type_of_special_order: "Pilih pesanan pengecualian jenis yang sama",
  Financial_statement: "Penyata Kewangan",
  financialStatement: "Penyata Kewangan",
  tableConfigurationList: "Senarai Konfigurasi Jadual",
  Add_configuration_table: "Tambah Jadual Konfigurasi",
  table_name: "Nama Jadual",
  table_ID: "ID Jadual",
  table_name_data_type: "Jenis Data Nama Jadual",
  tier: "Hierarki",
  Required_or_not: "Medan Wajib",
  Enable_or_not: "Diaktifkan",
  Add_field: "Tambah Medan",
  field_name: "Nama Medan",
  field_ID: "ID Medan",
  Field_data_type: "Jenis Data Medan",
  to_lead: "Import",
  Multiple_table_import: "Import Pelbagai Jadual",
  Serial_number_multi_table_import: "Import Pelbagai Jadual Nombor Siri",
  inportSuccess: "Import Berjaya",
  Drag_the_file_here: "Seret fail ke sini",
  Only_xls_xlsx_csv__files_can_be_uploaded_and_the_size_does_not_exceed_100_MB: "Hanya fail xls/xlsx/csv boleh dimuat naik, tidak melebihi 100MB",
  formulaConfiguration: "Konfigurasi Formula",
  Add_a_single_table_formula: "Tambah Formula Satu Jadual",
  Edit_a_single_table_formula: "Sunting Formula Satu Jadual",
  Add_a_multi_table_formula: "Tambah Formula Pelbagai Jadual",
  Edit_table_formula: "Sunting Formula Jadual",
  List: "Jadual",
  data_processing_type: "Jenis Pemprosesan Data",
  operator_symbol: "Pengendali",
  summation: "Jumlah",
  Specified_data: "Data Tertentu",
  Marker_text: "Tandakan Teks",
  de_weight: "Buang Duplikat",
  equation: "Formula",
  equation_Name: "Nama Formula",
  Sign_Color: "Warna Tandakan",
  Result_field: "Medan Keputusan",
  Selection_formula: "Pilih Formula",
  Selection_result_List: "Pilih Jadual Keputusan",
  Please_select_the_result_table: "Sila pilih jadual keputusan",
  Only_one_result_table_can_be_selected: "Hanya satu jadual keputusan boleh dipilih",
  resultList: "Jadual Keputusan",
  serial_number: "Nombor Siri",
  Serial_number: "Nombor Transaksi",
  Please_enter_the_serial_number: "Sila masukkan nombor transaksi",
  Please_upload_the_certificate: "Sila muat naik baucar",
  include: "Sertakan",
  delete_batch: "Padam Batch",
  Specified_number_of_rows: "Tentukan Bilangan Baris",
  Batch_process_field_data_types: "Jenis Data Medan Pemprosesan Batch",
  Please_enter_the_serial_number_of_the_batch_you_want_to_delete: "Sila masukkan nombor siri batch yang hendak dipadam",
  editFinancialStatement: "Sunting Penyata Kewangan",
  Add_trigger: "Tambah Pemicu",
  Collection_management: "Pengurusan Hutang Kewajipan",
  Please_enter_the_tracking_number_separated_by_commas_or_newlines: "Sila masukkan nombor waybill, dipisahkan oleh koma atau perbezaan baris",
  Please_enter_the_transaction_number_separated_by_commas_or_line_breaks: "Sila masukkan nombor transaksi, dipisahkan oleh koma atau perbezaan baris",
  Please_enter_the_head_order_number_separated_by_a_comma_or_a_newline: "Sila masukkan nombor pesanan awal, dipisahkan oleh koma atau perentang baris",
  Please_enter_the_receipt_number_separated_by_a_comma_or_a_newline: "Sila masukkan nombor resit barangan, dipisahkan oleh koma atau perentang baris",
  registerReturnOrder: "Resit Pengembalian",
  returnOrderGrounding: "Pengisian Semula Pengembalian",
  Number_of_remaining_shelves: "Kuantiti Pengisian Semula Baki",
  please_enter_Number_of_shelves: "Sila masukkan kuantiti pengisian semula",
  Batch_registration_basket: "Rangkaian Bakul Registers",
  registration_basket: "Bakul Registers",
  Today_is_total_revenue: "Jumlah Pendapatan Hari Ini",
  Today_is_total_expenditure: "Jumlah Perbelanjaan Hari Ini",
  Today_is_balance: "Baki Hari Ini",
  Yesterday_is_balance: "Baki Semalam",
  ConsolidationOfSimilar: "Gabungkan Perbelanjaan Serupa",
  sales_return: "Pulang",
  return_management: "Pengurusan Pulangan",
  returnManagement: "Pengurusan Pulangan",
  returnList: "Senarai Pulangan",
  Claim_status: "Status Tuntutan",
  date_issued: "Tarikh Simpanan Semula",
  valid_time: "Tempoh Kesahihan",
  Create_a_return_form: "Buat Slip Pulangan",
  Edit_a_return_form: "Sunting Slip Pulangan",
  Receiving_warehouse: "Gudang Penerimaan",
  logistics_provider: "Pengangkut",
  Return_note: "Nota Pulangan",
  processing_scheme: "Proses Penyelesaian",
  Product_picture: "Imej Produk",
  Select_add_item: "Pilih & Tambah Barangan",
  Claim_time: "Masa Tuntutan",
  Temporary_storage_number: "Nombor Penyimpanan Sementara",
  viewReturnNote: "Lihat Slip Pulangan",
  Claimed: "Dituntut",
  unclaimed: "Tidak Dituntut",
  Parcel_information: "Maklumat Parcel",
  Package_picture: "Imej Parcel",
  Package_details: "Butiran Parcel",
  Number_of_shelves: "Jumlah Tersenarai",
  unqualified_quantity: "Jumlah Tidak Pematuhan",
  Quantity_of_abandonment: "Jumlah Dibuang",
  // Return_Basket:"Bakul Pengembalian',",
  Image: "Imej",
  Return_StockUnit: "Lokasi Tong Pengembalian",
  // Actual_Weight:"Berat Sebenar',",
  // Actual_Lenth:"Panjang Sebenar',",
  // Actual_Width:"Lebar Sebenar',",
  // Actual_Height:"Tinggi Sebenar',",
  Receiving_Warehouse: "Gudang Penerimaan",
  Claim_ReturnOrderMsagess: "Parcel semasa tidak didaftarkan. Teruskan mengisi butiran dan klik Simpan untuk mendaftarkan di Kawasan Tuntutan!",
  Please_enter_the_tracking_number: "Sila masukkan nombor waybill",
  Please_enter_the_warehouse: "Sila pilih gudang penerimaan",
  Please_enter_the_logistics_provider: "Sila masukkan pengangkut",
  Please_enter_the_temporary_number: "Sila masukkan nombor stor sementara",
  Please_enter_the_sku: "Sila pilih SKU",
  Package_picture_isNotNull: "Imej bungkusan tidak boleh kosong",
  ReturnOrder_ItemProduct_IsNotSkuQuantityNull: "Kuantiti SKU item dikembalikan tidak boleh kosong",
  ReturnOrder_ItemProduct_IsNotQuantityNull: "Kuantiti item dikembalikan tidak boleh kosong",
  Please_add_the_return_order_item: "Sila tambah item yang dikembalikan",
  Reject: "Tolak",
  Abandon: "Buang",
  Ground_Quantity: "Bilangan disusun di rak",
  Stay_Ground_Quantity: "Bilangan menunggu untuk disusun di rak",
  Please_select_the_basket: "Sila imbas bakul pulangan",
  Handle_Remark: "Nota pemprosesan",
  Please_add_the_commodity: "Sila tambah produk",
  Please_fill_in_the_required_information: "Sila masukkan dimensi sebenar untuk item terperinci",
  Please_enter_the_unqualified_quantity: "Sila masukkan kuantiti tidak mematuhi",
  The_unqualified_quantity_cannot_be_greater_than_the_product_quantity: "Jumlah tidak mematuhi tidak boleh melebihi jumlah keseluruhan",
  Generate_shelf_task: "Tugas penyenaraian",
  Please_enter_the_solution: "Sila masukkan penyelesaian pemprosesan",
  Please_upload_pictures: "Sila muat naik imej",
  //quality_testing:"quality_testing:'Pemeriksaan Kualiti',",
  Return_StockUnits: "Inventori dikembalikan",
  Actual_Weight: "Berat sebenar (kg/unit)",
  Actual_Lenth: "Panjang sebenar",
  Actual_Width: "Lebar sebenar",
  Actual_Height: "Tinggi sebenar",
  Actual_Lenth_unit: "Panjang sebenar (cm)",
  Actual_Width_unit: "Lebar sebenar (cm)",
  Actual_Height_unit: "Tinggi sebenar (cm)",
  Actual_Size: "Dimensi sebenar (cm)",
  Return_Basket: "Bakul pulangan",
  ThirdParty_Warehousing: "Gudang pihak ketiga",
  Determine_whether_to_reject: "Pastikan penolakan?",
  Determine_whether_to_abandon: "Konfirmasi pelupusan",
  returnOrderStayGrounding: "Senarai pulangan menunggu penyusunan",
  Please_select_a_product_that_belongs_to_this_customer: "Pilih produk pelanggan yang berkaitan",
  Viewing_Delivery_logs: "Lihat log penghantaran",
  Reprint_face_sheet: "Cetak semula label penghantaran",
  By_default_the_quantity_of_reserved_storage_is_regarded_as_the_qualified_quantity_during_batch_inspection: "Semasa pemeriksaan kualiti secara pukal, kuantiti masuk yang dijadualkan secara lalai menjadi kuantiti lulus. Produk secara lalai akan ditandakan sebagai telah diperiksa. Teruskan?",
  When_the_return_form_of_the_claim_area_is_unclaimed_for_more_than_30_days_it_will_automatically_enter_the_destruction_area: "Barangan di kawasan tuntutan yang tidak dituntut melebihi 30 hari akan secara automatik dimasukkan ke zon pemusnahan",
  Failure_to_claim_within_30_days_automatically_enters_the_destruction_zone: "Barangan yang tidak dituntut selepas 30 hari secara automatik akan memasuki zon pemusnahan",
  claim: "Tuntutan",
  Please_enter_separated_by_commas_or_newlines: "Sila masukkan, dipisahkan dengan koma atau peralihan baris",
  Import_returns: "Kembaran Import",
  attribution: "Penugas",
  unfinishedReturnTaskList: "Senarai Tugas Kembali Belum Selesai",
  finishedReturnTaskList: "Senarai Tugas Kembali Selesai",
  Viewing_print_logs: "Lihat Log Cetakan",
  batch_abandon: "Pemusnahan Berkumpulan",
  The_minimum_value_is: "Nilai minimum ialah",
  The_original_product_cannot_be_deleted_if_there_is_a_shortage_or_defective_product_please_fill_in_the_unqualified_quantity: "Produk asal tidak boleh dipadam. Untuk barangan kehabisan stok atau rosak, sila masukkan kuantiti tidak mematuhi",
  Confirm_return_pending_review: "Kuatkuasakan Kembali Menunggu Semakan",
  Confirm_abandon: "Kuatkuasakan Pemusnahan",
  Cofirm_modify_warehouse: "Sahkan Pengubahsuaian Gudang",
  Verify_tracking_number: "Semak Nombor Waybill",
  publish: "Penyenaraian",
  publishLazada: "Produk Lazada Live",
  publishShopee: "Produk Shopee Live",
  publishTikTok: "Produk TikTok Live",
  tiktokGoodsOnline: "Produk TikTok Live",
  lazadaGoodsOnline: "Produk Lazada Live",
  shopeeGoodsOnline: "Produk Shopee Live",
  lazadaTrusteeshipGoodsOnline: "Produk Lazada Terurus Live",
  Goods_to_be_released: "Produk Menunggu Pelepasan",
  CNSC_Goods_to_be_released: "Produk CNSC Menunggu Pelepasan",
  Global_commodity: "Produk Global",
  Site_goods: "Produk Laman",
  Link_ID: "ID Pautan",
  Link_Name: "Nama Pautan",
  Link_SKU: "SKU Pautan",
  Variant_ID: "ID Varian",
  master_map: "Imej Utama",
  onLineSKU: "SKU Dalam Talian",
  pair: "Padanan",
  Paired_inventory_SKUs: "Padanan",
  pairLog: "Log Padanan",
  unpair: "Tidak Dipadankan",
  Modified_pairing: "Ubah Padanan",
  PlatformAuthorization: "Kebenaran Platform",
  store_management: "Pengurusan Kedai",
  ShopAuthorization: "Kebenaran Kedai",
  shopAuthorization: "Kebenaran Kedai",
  Add_authorization: "Tambah Kebenaran",
  name_of_shop: "Nama Kedai",
  store_name: "Nama Kedai",
  korach: "Boleh Ditarik Semula",
  Being_drawn: "Sedang Ditarik",
  Please_enter_the_name_of_the_shop: "Sila Masukkan Nama Kedai",
  Platform_store_name: "Nama Kedai Platform",
  authorization_status: "Status Kebenaran",
  be_authorized: "Dibenarkan",
  Authorization_successful: "Kebenaran Berjaya",
  unauthorized: "Tidak Dibenarkan",
  privileged_time: "Masa Kebenaran",
  Expiration_time_of_authorization: "Masa Luput Kebenaran",
  Is_the_address_consistent: "Konsistensi Alamat",
  Manually_synchronize_the_repository: "Sinkronisasi Gudang Manual",
  After_authorization_automatically_pull_orders_within_half_a_month_automatically_pull_returns_within_half_a_month_and_online_product_information_within_half_a_year: "Selepas kebenaran, secara automatik mengambil pesanan dalam tempoh dua minggu terakhir, pemulangan dalam tempoh dua minggu terakhir, dan maklumat produk dalam talian dalam tempoh enam bulan terakhir",
  After_authorization_automatically_pull_online_products_that_have_been_updated_within_half_a_year: "Selepas kebenaran, secara automatik mengambil produk dalam talian dengan kemas kini dalam tempoh enam bulan terakhir",
  Platform_SKUs_have_changed_please_pay_attention_to_re_pairing_otherwise_the_original_platform_SKUs_and_stock_SKUs_are_still_paired: "SKU platform telah berubah; sila ambil perhatian untuk memadankan semula, jika tidak padanan SKU platform asal dan SKU inventori akan kekal",
  Replace_the_pairing_the_goods_information_of_the_previous_order_will_not_be_replaced_with_the_newly_paired_goods_please_go_to_the_order_list_to_modify_the_goods: "Apabila menukar padanan, maklumat produk pesanan sebelum ini tidak akan dikemas kini dengan item padanan baru. Sila ubah suai produk dalam senarai pesanan.",
  After_the_dissolution_of_the_relationship_the_product_information_of_the_previous_order_will_not_be_unpaired_After_the_manual_pairing_the_new_pairing_logic_will_not_be_executed_for_the_previously_paired_order_Please_go_to_the_order_list_to_modify_the_product: "Selepas penamatan hubungan, maklumat produk pesanan sebelum ini tidak akan dikemas kini dengan padanan baru. Selepas memadankan semula secara manual, pesanan yang telah dipadankan sebelum ini tidak akan mengikuti logik padanan baru. Sila ubah suai produk dalam senarai pesanan.",
  Pull_goods: "Tarik Produk",
  Recent_pull_time: "Masa Tarikan Terakhir",
  Store_pull_status: "Status Tarikan Kedai",
  Store_pull_exception: "Anomali Tarikan Kedai",
  Store_Pull_time: "Masa Tarikan Kedai",
  Last_7_days: "7 hari terakhir",
  Last_30_days: "30 hari terakhir",
  Last_90_days: "90 hari terakhir",
  Last_180_days: "180 hari terakhir",
  Stores_that_have_not_shipped_within_2_months_will_be_automatically_invalidated: "Kedai yang tiada penghantaran selama 2 bulan akan dilumpuhkan secara automatik",
  Latest_shipping_time: "Tarikh penghantaran terakhir",
  Last_3_months: "3 bulan terakhir",
  Beginning_to_pull_the_time: "Masa mula ambil balik",
  Ending_pull_time: "Masa tamat ambil balik",
  WMSmissionContro: "Kawalan Tugas WMS",
  Configuration_task_type: "Konfigurasikan jenis tugas",
  please_select_Configuration_task_type: "Sila pilih konfigurasi jenis tugas",
  Distribution_task_generation_control_type: "Kawalan penjanaan tugas ambil",
  please_select_Distribution_task_generation_control_type: "Sila pilih jenis kawalan penjanaan tugas pemungutan",
  Task_order_quantity: "Jumlah Pesanan Tugas",
  Please_enter_the_Task_order_quantity: "Sila masukkan jumlah pesanan tugas",
  Maximum_order_number: "Bilangan Pesanan Maksimum",
  Please_enter_the_Maximum_order_number: "Sila masukkan bilangan pesanan maksimum",
  Allocation_inquiry: "Carian Pemungutan",
  Whether_to_allocate_goods_by_floor: "Pemungutan Berdasarkan Lantai",
  please_select_Whether_to_allocate_goods_by_floor: "Sila pilih sama ada untuk melakukan pemungutan berdasarkan lantai",
  Whether_the_storage_space_can_be_allocated: "Sama Ada Petak Stok Tersedia untuk Pemungutan",
  please_select_Whether_the_storage_space_can_be_allocated: "Sila pilih sama ada petak stok tersedia untuk pemungutan",
  Order_allocation_timeout_time: "Had Masa Pemungutan Pesanan",
  Please_enter_the_Order_allocation_timeout_time: "Sila masukkan tempoh tamat masa pemilihan pesanan",
  Generate_timeout_order_tasks_first: "Keutamaan Penghasilan Tugas Pesanan Tamat Masa",
  please_select_Generate_timeout_order_tasks_first: "Sila pilih sama ada untuk memberi keutamaan kepada penghasilan tugas pesanan tamat masa",
  Match_and_send: "Pemilihan dan Penghantaran Serentak",
  please_select_Match_and_send: "Sila pilih pemilihan dan penghantaran serentak",
  Delivery_weighing: "Menimbang Barangan Semasa Penghantaran",
  please_select_Delivery_weighing: "Sila pilih sama ada untuk menimbang barangan semasa penghantaran",
  Do_you_want_to_take_photos: "Mengambil Gambar Penghantaran",
  Is_the_shipment_recorded: "Merakam Video Penghantaran",
  please_select_Do_you_want_to_take_photos: "Sila pilih sama ada untuk mengambil gambar penghantaran",
  Check_whether_the_goods_are_delivered: "Meneliti Barangan Semasa Penghantaran",
  please_select_Check_whether_the_goods_are_delivered: "Sila pilih sama ada untuk meneliti barangan semasa penghantaran",
  Whether_the_whole_sorting_task_is_shipped: "Menghantar Keseluruhan Tugas Penyusunan",
  please_select_Whether_the_whole_sorting_task_is_shipped: "Sila pilih sama ada untuk menghantar keseluruhan tugas penyusunan",
  Delivery_inquiry: "Permintaan penghantaran",
  New_task_control: "Kawal tugas baharu",
  Edit_task_control: "Sunting kawalan tugas",
  Allocation_information: "Maklumat pemilihan",
  shipping_information: "Maklumat penghantaran",
  Multi_floor_combination_distribution: "Pemilihan gabungan berbilang peringkat",
  Distribute_goods_while_shipping: "Pilih dan hantar serentak",
  Total_allocation_quantity: "Jumlah kuantiti pemilihan",
  Total_shipment_quantity: "Jumlah kuantiti penghantaran",
  Delivery_phase: "Fasa penghantaran",
  Delivery_start_time: "Masa mula penghantaran",
  Delivery_end_time: "Masa tamat penghantaran",
  Abnormal_query: "Permintaan pengecualian",
  need: "Diperlukan",
  do_without: "Tidak diperlukan",
  Please_enter_basket_remarks: "Sila masukkan nota bakul",
  Failed_to_print_sheet_please_rescan: "Cetak label gagal, sila imbas semula",
  Single_print_success: "Cetak label berjaya",
  batch_delivery: "Penghantaran berkuantiti",
  Bulk_shipment_quantity: "Jumlah penghantaran berkuantiti",
  Whether_to_scan_the_database: "Imej lokasi penyimpanan?",
  Please_confirm_that_the_goods_have_been_returned_to_the_original_warehouse: "Sila sahkan barangan telah dikembalikan ke lokasi penyimpanan asal",
  Return_the_order_to_ungenerated: "Kembalikan pesanan ke status 'Tidak dijana'",
  Return_the_order_to_a_draft: "Kembalikan pesanan ke status 'Draf'",
  Return_the_order_to_the_pending_review_status: "Kembalikan pesanan ke status 'Menunggu semakan'",
  Item_task_list: "Senarai tugasan satu barangan",
  itemTaskList: "Senarai tugasan satu barangan",
  Multi_task_list: "Senarai tugasan berbilang item",
  multiTaskList: "Senarai tugasan berbilang item",
  Packing_material_condition: "Status bahan pembungkusan",
  Basket_quantity: "Jumlah bakul",
  viewWarehouseEntryList: "Lihat senarai masuk",
  No_combo_SKU_images_uploaded: "Sila muat naik imej gabungan SKU",
  Whether_sorting_and_delivery_is_required: "Perlukan penyusunan untuk penghantaran?",
  delivery_process: "Proses penghantaran",
  delivery_process_one: "Proses penghantaran 1",
  delivery_process_two: "Proses penghantaran 2",
  Delivery_flow_2_does_not_allow_the_use_of_border_variations: "Proses 2 melarang pemungutan dan penyusunan serentak",
  Delivery_process_2_Multi_floor_distribution_is_not_allowed: "Proses 2 melarang pemungutan berbilang peringkat",
  Default_delivery_process_scanning_the_corresponding_basket_for_goods_sorting_and_delivery: "Proses Penghantaran Lalai: Imbas bakul yang sepadan untuk penyusunan dan penghantaran barangan",
  Goods_are_sorted_and_no_baskets_are_needed_for_delivery: "Barangan menjalani penyusunan; bakul tidak lagi diperlukan untuk penghantaran",
  Multiple_products_and_edge_matching_edge_division_unusable_volume: "Peruntukan berdasarkan isipadu dilarang untuk pemilihan/penyusunan berbilang item secara serentak",
  Use_the_delivery_flow_for_multi_product_tasks_2_The_border_variation_is_not_allowed: "Tugas berbilang item yang menggunakan Proses Penghantaran 2 tidak boleh menggunakan pemilihan/penyusunan serentak",
  surfTheInternet: "Status Dalam Talian",
  surfExternalOrder: "Kebenaran Pesanan Luaran",
  Please_choose_surfTheInternet: "Sila pilih status dalam talian",
  Please_choose_surfExternalOrder: "Sila pilih sama ada untuk membenarkan pesanan luaran",
  Whether_to_go_online_refers_to_whether_the_platform_api_interface_is_called_to_verify_whether_the_logistics_trajectory_has_been_collected: "Status dalam talian merujuk kepada sama ada antara muka API platform dipanggil untuk mengesahkan penjejakan logistik dan status pengambilan",
  Preview_sheet: "Rangka tinjau waybill",
  If_the_bill_is_abnormal_contact_the_administrator: "Anomali waybill: hubungi pentadbir untuk penyelesaian",
  Exit_Printing: "Tutup cetakan",
  single_product: "Satu item",
  paperTask: "Tugas kertas",
  multiProductPaperDistribution: "Pemungutan kertas berbilang item",
  singleProductPaperDistribution: "Pemungutan kertas satu item",
  obtainPaperDistributionOfSingleProduct: "Dapatkan pemungutan kertas satu item",
  completeThePaperDistributionOfTheSingleProduct: "Lengkapkan pemungutan kertas satu item",
  obtainMultiProductPaperDistribution: "Dapatkan pemilihan kertas berbilang item",
  completeMultiProductPaperDistribution: "Lengkapkan pemilihan kertas berbilang item",
  Paper_tracking_number: "Nombor waybill kertas",
  basket: "Bakul",
  basket_Info: "Butiran bakul",
  specified_Quantity: "Kuantiti yang ditetapkan",
  Individual_product_operation: "Operasi satu item",
  Multiple_product_operation: "Operasi berbilang item",
  multipleProductOperation: "Operasi berbilang item",
  multiple_products: "Beragam item",
  order_quantity: "Kuantiti pesanan",
  volume: "Isipadu",
  describe: "Keterangan",
  taskList: "Senarai tugasan",
  Extra_packing_material: "Bahan pembungkusan tambahan",
  Additional_packing_material_exists: "Bahan pembungkusan tambahan ada",
  listOrdersShipped: "Senarai pesanan penghantaran tertunda",
  listAbnormalShipment: "Senarai anomali penghantaran tertunda",
  Order_phase: "Tahap pesanan",
  order_source: "Sumber pesanan",
  Quantity_occupied: "Kuantiti diduduki",
  The_address_of_the_bill_is_empty_Contact_the_administrator: "Alamat waybill kosong. Sila hubungi pentadbir untuk bantuan.",
  The_address_of_the_bill_is_empty: "Alamat waybill kosong.",
  There_are_orders_with_empty_waybill_numbers_in_the_selected_orders_so_the_waybill_cannot_be_previewed: "Sesetengah pesanan terpilih mengandungi nombor waybill kosong. Waybill tidak boleh didahulupandang.",
  Please_scan: "Sila imbas.",
  Please_scan_the_barcode: "Sila imbas kod bar produk.",
  Modify_the_number_of_SKUs: "Ubah kuantiti SKU.",
  Modified_warehouse: "Ubah gudang.",
  Submitted_to_be_reviewed: "Serahkan kepada Tinjauan Tertunda.",
  Commit_back_not_generated: "Serahkan semula kepada Belum Dijana.",
  Back_to_not_generated: "Kembali ke Belum Dijana.",
  Back_to_draft: "Kembali ke Draf",
  Return_to_pending_review: "Kembali ke Tinjauan Tertunda",
  priority: "Keutamaan",
  secondary: "Sekunder",
  order_inquiry: "Permintaan Pesanan",
  info_query: "Permintaan Maklumat",
  Print_basket_number: "Cetak Nombor Bakul",
  Back_to_basket_list: "Kembali ke Senarai Bakul",
  Sorting_starts_numbering: "Nombor Permulaan Penyusunan",
  Sorting_end_number: "Nombor Penamatan Penyusunan",
  Tripartite_warehouse_information: "Maklumat Gudang Pihak Ketiga",
  Threeway_warehouse_OP_number: "Nombor OP Gudang Pihak Ketiga",
  Batch_sorting: "Penyusunan Batch",
  The_sorting_number_of_the_current_scan_is: "Nombor Penyusunan Imbasan Semasa ialah",
  Print_the_sorting_basket_head: "Cetak Header Bakul Penyusunan",
  List_of_shipped_orders: "Senarai Pesanan Dihantar",
  listShippedOrders: "Senarai Pesanan Dihantar",
  taskID: "ID Tugas",
  Please_enter_taskID: "Sila masukkan ID Tugas",
  There_are_no_tasks_in_the_basket: "Tiada tugas yang sedang ditetapkan untuk bakul ini",
  bulk_print: "Cetak Batch",
  to_do_list_ID: "ID Pesanan Tugas",
  task_type: "Jenis Tugas",
  List_of_tasks_in_allocation: "Senarai Tugas: Dalam Pemilihan",
  listTasksAllocation: "Senarai Tugas: Dalam Pemilihan",
  Sorting_task_list: "Senarai Tugas: Dalam Penyusunan",
  sortingTaskList: "Senarai Tugas: Dalam Penyusunan",
  List_of_tasks_being_shipped: "Senarai Tugas: Dalam Penghantaran",
  listTasksBeingShipped: "Senarai Tugas: Dalam Penghantaran",
  Printing_successfully_Stopped_printing: "Cetak Berjaya, Hentikan Cetakan",
  List_of_shipped_tasks: "Senarai Tugas: Dihantar",
  listShippedTasks: "Senarai Tugas: Dihantar",
  explosiveOperation: "Operasi Barangan Terlaris",
  explosiveDistribution: "Pemilihan Barangan Terlaris",
  explosiveDelivery: "Penghantaran Barangan Terlaris",
  explosiveList: "Senarai Barangan Terlaris",
  Order_origin_currency: "Mata Wang Asal Pesanan",
  Out_of_storage: "Dalam Proses",
  Print_failed_Please_check_and_try_again: "Cetak Gagal! Sila Semak dan Cuba Semula",
  One_click_out_completed: "Selesai Penghantaran Satu Klik",
  not_finished: "Belum Selesai",
  have_not_started: "Belum Dimulakan",
  If_the_printing_is_not_successful_for_more_than_5_seconds_the_printing_ends: "Cetak Masa Habis Selepas 5 Saat Tanpa Jangkaan, Cetakan Dihentikan",
  Whether_it_is_a_paper_task: "Adakah Ini Tugas Kertas?",
  Checking_the_sheet: "Semak Waybill",
  A_sheet_is_being_printed: "Cetak Waybill",
  System_deduction: "Potongan Sistem",
  Get_the_distribution_task: "Dapatkan Tugas Pemilihan",
  Reprint_the_distribution_sheet: "Cetak Semula Slip Pemilihan",
  invoice: "Invois",
  HOT: "Barangan Terlaris",
  print_TaskId: "ID Tugas Cetakan",
  Generating_task: "Jana Tugas",
  distributionControl: "Kawalan Peruntukan",
  Order_distribution_time_zone: "Zon Waktu Peruntukan Pesanan",
  Order_distribution_sorting_field: "Medan Penyusunan Peruntukan",
  automatic_printing: "Cetak Automatik",
  Non_automatic_printing: "Jangan Cetak Automatik",
  Automatic_printing_of_distribution_slips: "Cetak Automatik Slip Peruntukan",
  Automatically_prints_the_task_ID: "Cetak Automatik ID Tugas",
  The_time_zone_already_exists: "Zon waktu ini sudah wujud",
  Add_Time_zone: "Tambah Zon Waktu",
  example: "Contoh",
  Ungenerated_task: "Tugas tidak dijana",
  completed_distribution: "Peruntukan selesai",
  Order_submission_time: "Masa Penghantaran Pesanan",
  Please_select_automatic_printing: "Sila pilih cetak automatik",
  Please_select_order_distribution_sorting_field: "Sila pilih medan penyusunan peruntukan",
  The_entered_time_zone_must_be_longer_than_one_hour_from_the_existing_time_zone: "Zon waktu yang dimasukkan mesti berbeza sekurang-kurangnya satu jam daripada zon waktu semasa",
  The_time_zone_must_be_between_0100_and_2300: "Waktu yang dimasukkan mesti antara 01:00 dan 23:00",
  Support_input_time_zone_return_to_add_the_input_time_zone_needs_to_exist_in_the_selection_value: "Anda boleh memilih waktu secara langsung atau memasukkan zon waktu dan menekan Enter untuk menambahkannya. Nota: Zon waktu yang dimasukkan mesti wujud dalam senarai pilihan",
  Sort_by_order_submission_time_from_morning_to_night: "Susun mengikut waktu penghantaran pesanan dari yang terdahulu ke yang terkemudian",
  The_order_is_sorted_by_the_repository_number_and_the_next_repository_order_task_will_be_performed_only_after_processing_the_current_repository_order_task: "Susun mengikut nombor lokasi penyimpanan. Hanya selepas menamatkan pesanan untuk lokasi semasa, pesanan untuk lokasi seterusnya akan diproses.",
  Sort_by_sku_the_current_sku_is_completed_before_proceeding_to_the_next_sku: "Susun mengikut SKU. Hanya selepas menamatkan pesanan untuk SKU semasa, SKU seterusnya akan diproses.",
  Generate_earlier_time_zone_tasks_first: "Keutamakan penjanaan tugas untuk zon waktu yang lebih awal.",
  If_the_order_distribution_time_zone_is_not_set_it_will_not_be_divided_by_time_Only_the_order_distribution_sorting_field_will_be_sorted_to_generate_the_order: "Jika tiada zon waktu peruntukan pesanan ditetapkan, segmentasi berdasarkan masa tidak akan berlaku. Pesanan akan dijana semata-mata berdasarkan medan penyusunan peruntukan pesanan.",
  Pre_0_yesterday_orders_are_preferentially_generated: "Keutamakan penjanaan pesanan yang dibuat sebelum tengah malam (semalam)",
  Generate_orders_from_0000_to_1200: "Jana pesanan dalam jangka masa 00:00 hingga 12:00",
  Generate_orders_after_1200_to_before_2400: "Jana pesanan yang dibuat selepas 12:00 tetapi sebelum 24:00",
  Please_enter_the_number_of_tasks: "Sila masukkan kuantiti tugasan",
  Please_select_a_single_order_type: "Sila pilih satu jenis pesanan",
  Please_scan_task_ID: "Sila imbas ID tugasan",
  Whether_to_limit_the_sorting_and_delivery_to_the_same_person: "Hadkan penyusunan dan penghantaran kepada individu yang sama?",
  Mixed_shipments_are_possible_for_orders_of_different_task_types: "Pesanan bagi jenis tugasan yang berbeza boleh dihantar bersama",
  task_bound_person: "Peruntuk tugasan",
  remaining_products: "Jenis produk yang tinggal untuk disusun di rak",
  Please_perform_wms_task_control_first: "Sila jalankan kawalan tugasan WMS terlebih dahulu",
  The_current_warehouse_has_not_performed_wms_task_control: "Gudang semasa belum menjalankan kawalan tugasan WMS",
  whether_batch_ship: "Penghantaran secara pukal diaktifkan?",
  hot_item_whether_batch_ship: "Penghantaran secara pukal diaktifkan untuk produk terlaris?",
  manualEntryAndExitList: "Senarai pergerakan stok manual",
  Manual_Entry_and_exit_slip_number: "Nombor pesanan pergerakan stok manual",
  Manual_Entry_and_exit_slip_type: "Jenis pergerakan stok manual",
  Manual_Entry_and_exit_slip_status: "Status pergerakan stok manual",
  accomplish_Time: "Masa penyiapan",
  audits: "Lulus",
  Create_ManualEntryAndExit: "Buat pesanan pergerakan stok manual",
  Please_fill_in_the_audit_remarks: "Sila masukkan ulasan kelulusan",
  audit_remarks: "Ulasan kelulusan",
  pass_the_audit: "Kelulusan diberikan",
  The_inventory_will_be_changed_after_clicking: "Inventori akan dikemas kini selepas pengesahan",
  Clicking_OK_will_flag_the_exception: "Ditandakan sebagai tidak normal selepas pengesahan",
  Click_OK_and_it_will_be_rejected: "Ditolak selepas pengesahan",
  Number_of_shelvesd: "Jumlah rak",
  Type_of_outgoing_and_incoming_accounts: "Jenis perakaunan",
  If_a_recommended_repository_exists_the_recommended_repository_is_selected_by_default: "Apabila lokasi penyimpanan yang disyorkan wujud, ia akan dipilih secara lalai",
  If_a_recommended_repository_exists_the_recommended_repository_is_entered_by_default: "Apabila lokasi penyimpanan yang disyorkan wujud, ia akan dimasukkan secara lalai",
  Consolidation_of_similar_expenses: "Gabungkan Caj Serupa",
  Add_Consolidation_of_similar_expenses: "Tambah Gabungan Caj Serupa",
  Monthly_Expense_List: "Senarai Penggunaan Bulanan",
  Name_of_the_expense_item: "Nama Barangan Caj",
  Accounting_in: "Kemasukan Kredit",
  Accounting_out: "Kemasukan Debut",
  in_out_account: "Transaksi",
  Sku_and_quantity: "SKU Produk dan Kuantiti",
  Billing_weight: "Berat Dibil",
  Charge_quantity: "Penyetelan Yuran: Unit Dibil",
  Charge_weight: "Penyetelan Yuran: Berat",
  Cost_setting_Cube: "Penyetelan Yuran: Meter Padu",
  cost_setting_Three_sides_length_CM: "Penyetelan Yuran: Jumlah 3 Sisi",
  Cost_set_three_sides_long: "Penyetelan Yuran: Panjang 3 Sisi",
  goods_cobe: "Meter Padu Produk",
  goods_Three_sides_length_CM: "Panjang 3 Sisi Produk",
  goods_weight: "Berat Produk",
  type_of_fee: "Jenis Yuran",
  Item_code: "Kod Barang",
  Fill_in_the_positive_balance_of_recharge_and_fill_in_the_negative_balance_of_deduction: "Masukkan nilai positif untuk baki topup; masukkan nilai negatif untuk baki tolakan",
  stock_in_and_stock_out_record: "Rekod Stok Masuk/Keluar",
  storage_location_number: "Nombor Lokasi Stok",
  Entry_quantity: "Kuantiti Pergerakan Stok",
  total_inventory_quantity: "Jumlah Kuantiti Stok",
  Current_batch_inventory_quantity: "Kuantiti Stok Batch Semasa",
  Batch_stock_quantity: "Jumlah Kuantiti Stok Lokasi",
  Batch_occupied_inventory_quantity: "Kuantiti Stok Terduduki Batch",
  life: "Umur Stok",
  Has_stock: "Stok Tersedia",
  No_stock: "Stok Tidak Tersedia",
  Has_No_stock: "Status Ketersediaan Stok",
  stock_type: "Jenis Stok",
  Entry_time: "Tarikh Resit",
  Tripartite_storage: "Stok Gudang Pihak Ketiga",
  General_stock: "Stok Biasa",
  Unusable_inventory: "Stok Tidak Tersedia",
  Entry_and_exit_records: "Lihat Butiran Stok",
  grounding: "Penyenaraian",
  Shelf_in_bulk: "Penyenaraian Batch",
  Number_of_shelvesds: "Kuantiti Penyenaraian",
  Unshelved: "Tidak Disenaraikan",
  Already_listed: "Disenaraikan",
  Multiple_quantity: "Kuantiti Terlebih Terbitkan",
  Shelf_batch: "Batch Penyimpanan",
  Check_the_storage_details: "Lihat Butiran Pergerakan Stok",
  operate_successfully: "Operasi Berjaya",
  Print_the_default_size_paper_distribution: "Cetak Senarai Picking Kertas Saiz Lalai",
  Print_A4_size_distribution: "Cetak Senarai Picking Kertas Saiz A4",
  Print_100_150_size_distribution: "Cetak Senarai Picking Kertas Saiz 100*150",
  The_customer_password_will_be_reset_to_ESTP_mobile_number: "Kata laluan pelanggan akan diset semula kepada: ESTP+Nombor Telefon Bimbit",
  Get_a_shelf_task: "Dapatkan Semula Tugas Penyimpanan",
  Please_select_some_user: "Kakitangan Penyimpanan",
  Prioritize_shelving: "Tetapkan Keutamaan Penyimpanan",
  Please_select_the_type_of_manual_entry_ticket: "Sila pilih jenis slip stok masuk/keluar manual",
  Please_select_warehouse: "Sila pilih gudang",
  Please_select_the_warehouse_location: "Sila pilih lokasi penyimpanan",
  Please_scan_the_database_location: "Sila imbas lokasi penyimpanan",
  Select_date_time: "Pilih tarikh dan masa",
  please_select_stockId: "Sila pilih gudang",
  please_select_stockzone: "Sila pilih zon",
  please_select_shelf: "Sila pilih rak",
  Please_scan_sku: "Sila imbas SKU",
  please_select_auditUser: "Sila pilih pengesah",
  Storage_type: "Jenis stok masuk/keluar",
  Billing_quantity: "Kuantiti ditagih",
  Cost_type: "Jenis yuran",
  frozenBillingDetails: "Bekukan butiran pengebilan",
  storage_location_capacity: "Kapasiti lokasi penyimpanan",
  product_capacity: "Kapasiti penggunaan produk",
  recommendstorage_location_type: "Jenis lokasi penyimpanan yang disyorkan",
  Operational_query: "Permintaan operasi",
  Please_scan_the_basket: "Sila imbas kod bakul!",
  The_number_of_shelves_cannot_be_greater_than_the_qualified_number: "Kuantiti stok tidak boleh melebihi kuantiti yang diluluskan",
  Whether_batch_shelves: "Pengisian stok secara kelompok diaktifkan",
  Please_select_the_same_warehouse_entry_form_to_submit: "Sila pilih nota penerimaan dari gudang yang sama untuk dihantar!",
  The_database_bit_number_does_not_exist: "Nombor lokasi penyimpanan ini tidak wujud",
  replacement_cost: "Seting semula kos",
  Create_a_breakout_task: "Buat tugasan terlaris",
  Match_and_divide: "Agihkan dan edarkan serentak",
  matchAndDivide: "Agihkan dan edarkan serentak",
  Online_SKU_images: "Imej SKU dalam talian",
  Seller_SKU: "SKU Penjual",
  AbnormalRemarks: "Nota ketidakseragaman",
  Store_SKU: "SKU Kedai",
  Authorization_assignment: "Penugasan kebenaran",
  Please_enter_the_AccessToken: "Sila masukkan AccessToken",
  Please_enter_the_RefreshToken: "Sila masukkan RefreshToken",
  APITokenInformation: "Maklumat token API",
  authorization_management: "Pengurusan Kebenaran",
  authorization_message: "Maklumat Kebenaran",
  companyName: "Nama Syarikat",
  Print_a_paper_distribution: "Cetak Senarai Pemilihan Barangan",
  Select_case_number: "Pilih Nombor Kotak",
  Starting_box_number: "Nombor Kotak Mula",
  End_box_number: "Nombor Kotak Akhir",
  picker: "Pilih",
  Pick_date: "Tarikh Pemilihan",
  print_time: "Masa Cetak",
  sku_quantity: "Kuantiti SKU",
  Refill_slip_number: "Nombor Pesanan Potongan Pengembalian",
  Whether_to_cancel_supplementary_deduction: "Sahkan Pembatalan Potongan Pengembalian?",
  irredeemable: "Pembatalan tidak boleh diulang",
  This_item_is_out_of_stock: "Tiada stok untuk barangan ini",
  The_repository_does_not_exist: "Lokasi penyimpanan ini tidak wujud",
  flowingWaterInAndOutOfStorage: "Log Transaksi Masuk/Keluar",
  Generation_task_type: "Jana Jenis Tugas",
  View_the_default_log_of_the_initial_shipping_fee_for_modifying_the_purchase_price: "Lihat/Sunting Log Yuran Fasa Pertama Harga Pembelian Lalai",
  warehouseEntryControl: "Kawalan Resit/Pulang",
  Add_the_entry_ticket_control: "Tambah Kawalan Sistem",
  Edit_entry_slip_control: "Sunting Kawalan Sistem",
  Whether_to_open_excess_inspection: "Aktifkan Pemeriksaan Kualiti Berlebihan?",
  Control_the_number_of_boxes_generated_during_inspection_tasks: "Kawal Penghasilan Bilangan Kotak Tugas Pemeriksaan Kualiti",
  Control_the_number_of_SKUs_generated_by_the_mount_task: "Kawal Bilangan Penghasilan Varian SKU Tugas Rak",
  Create_entry_ticket_control: "Buat Kawalan Sistem",
  Enter_0_for_the_entire_build_task: "Masukkan 0 untuk Penghasilan Tugas Pesanan Penuh",
  Whether_To_return_the_package_to_take_photos: "Perlukan Fotografi Parcel Pulangan?",
  Control_The_number_of_boxes_generated_for_a_quality_inspection_task_indicates_the_number_of_boxes_generated_when_a_worker_obtains_a_quality_inspection_task_Set_0_to_the_entire_generation_task: "Kawal kuantiti penjanaan tugas pemeriksaan kualiti: Bilangan kotak yang dijana apabila pekerja mengambil tugas pemeriksaan kualiti. Masukkan 0 untuk menjana tugas bagi keseluruhan pesanan",
  Control_the_number_of_SKU_types_generated_for_the_shelf_task_to_the_number_of_SKU_types_generated_when_obtaining_the_shelf_task_Fill_in_0_for_the_entire_single_generation_task: "Kawal kepelbagaian penjanaan SKU tugas rak: Bilangan variasi SKU yang dijana apabila pekerja mengambil tugas rak. Masukkan 0 untuk menjana tugas bagi keseluruhan pesanan",
  Whether_to_take_a_picture_of_the_return_is_whether_to_take_a_picture_of_the_package_when_the_return_receipt_is_received: "Perlukan fotografi bungkusan pulangan: Sama ada untuk mengambil gambar bungkusan semasa menerima pesanan pulangan",
  There_are_mandatory_fields_that_are_not_filled_in_Please_fill_them_in_and_try_again: "Medan wajib tiada. Sila lengkapkan dan cuba semula.",
  inbound_and_return_control: "Kawalan Masukan/Pulang",
  Subaccount_management: "Pengurusan Akaun Anak",
  subaccountList: "Senarai Akaun Anak",
  Subaccount_number: "ID Akaun Anak",
  subaccount_name: "Nama Akaun Anak",
  Please_enter_a_subaccount_name: "Sila masukkan nama akaun anak",
  Add_a_subaccount: "Tambah Akaun Anak",
  subAccountRoleInfo: "Maklumat Akaun Anak",
  payment_type: "Kaedah Pembayaran",
  Whether_to_terminate_services: "Bubar Perniagaan",
  Subaccount_role: "Peranan Akaun Anak",
  Please_add_product: "Sila tambah produk",
  An_empty_container_number_exists_Please_check_and_try_again: "Nombor kotak tidak sah. Sila semak dan cuba semula.",
  An_empty_number_exists_Please_check_and_try_again: "Jumlah tidak sah dimasukkan. Sila semak dan cuba semula.",
  Submit_success: "Penyampaian berjaya!",
  cancellation_of_order: "Batal Pesanan",
  Cancel_a_task: "Batal Tugas",
  Confirm_cancellation_of_order: "Sahkan Pembatalan Pesanan",
  Confirm_cancel_task: "Sahkan Pembatalan Tugas",
  Order_operation: "Operasi Pesanan",
  Cancel_an_order: "Batal Pesanan",
  Undo_to_exception: "Batal ke Status Tidak Normal",
  Undo_to_ungenerated: "Batal ke Status Belum Diproses",
  cancelOrder: "Batal Pesanan",
  Please_enter_the_waybill_number_Only_100_waybills_are_supported_at_a_time_separated_by_line_breaks: "Sila masukkan nombor waybill. Hanya 100 waybill disokong setiap penyampaian, dipisahkan dengan pemisah baris.",
  Order_cancellation_Pick_stock_please_return_the_stock_to_the_original_shelf_order_cancellation_directly_to_the_confirmation: "Untuk pesanan di mana proses pengambilan telah bermula, batalkan inventori pengambilan. Pulangkan stok ke rak asal. Status pesanan akan kembali kepada 'Disahkan'.",
  automaticProcessingRule: "Peraturan Pemprosesan Automatik",
  Rule_name: "Nama Peraturan",
  Rule_type: "Jenis Peraturan",
  priority_level: "Keutamaan",
  Rule_description: "Keterangan Peraturan",
  Rule_subitem: "Sub-item Peraturan",
  Modification_time: "Masa Pengubahsuaian",
  Modified_successfully: "Pengubahsuaian Berjaya",
  content: "Kandungan",
  Please_add_at_least_one_rule: "Sila tambah sekurang-kurangnya satu peraturan",
  Please_select_the_rule_type_first: "Sila pilih jenis peraturan terlebih dahulu",
  Rule_detail: "Butiran Peraturan",
  sku_matching_mode: "Kaedah Padanan SKU",
  packing_type: "Jenis Pembungkusan",
  Please_select_at_least_one_rule: "Sila pilih sekurang-kurangnya satu peraturan",
  Only_process_the_orders_that_have_been_pending_review_for_15_days_from_the_current_system_time_and_the_inventory_sufficient: "Proses hanya pesanan menunggu semakan yang dimasukkan dalam tempoh 15 hari terakhir dari masa sistem semasa dan dengan stok yang mencukupi",
  Customer_inquiry_Please_enter_only_numbers: "Untuk pertanyaan pelanggan, sila masukkan nilai numerik sahaja",
  listWarehouseRentalChargesDetail: "Butiran Invois Sewa Gudang",
  warehouseRentalBillSKUDetails: "Butiran SKU Invois Sewa Gudang",
  list_warehouse_rental_charges_detail: "Butiran Invois Sewa Gudang",
  Inventory_batch: "Butiran Stok",
  Upload_file_error_Upload_acsv_XLS_XLSX_file: "Ralat fail dimuat naik! Sila muat naik fail dengan sambungan .CSV, .XLS, atau .XLSX",
  There_are_unfinished: "Tugas",
  task: "yang belum selesai",
  Whether_to_process: "Teruskan untuk tangani?",
  chart_type: "Jenis Carta",
  Excluding_today: "Kecualikan hari ini",
  rop_shipping_product_ranking_list: "Barangan teratas yang menunggu penghantaran",
  single_Product_Single_Order: "Satu barangan satu kuantiti",
  single_Product_Multi_Order: "Satu barangan berbilang kuantiti",
  singleProductMultiOrder: "Satu barangan berbilang kuantiti",
  multi_Product_Multi_Order: "Beberapa barangan berbilang kuantiti",
  multiProductMultiOrder: "Beberapa barangan berbilang kuantiti",
  single_product_single_order_drop_shipping_product_quantity_ranking_list: "Peringkat Kuantiti Hantaran Tertunda bagi Satu Barangan dan Satu Kuantiti",
  single_Product_Multi_Order_drop_shipping_product_quantity_ranking_list: "Peringkat Kuantiti Hantaran Tertunda bagi Satu Barangan dan Pelbagai Kuantiti",
  multi_product_Multi_order_drop_shipping_product_quantity_ranking_list: "Peringkat Kuantiti Hantaran Tertunda bagi Pelbagai Barangan dan Pelbagai Kuantiti",
  to_do_task: "Tugas Tertunda",
  value_added_services: "Perkhidmatan Tambahan Nilai",
  The_timeout_is_set_to_a_certain_time: "Tetapan Masa Tamat Ditetapkan kepada",
  Recent_announcements: "Pengumuman Terbaru",
  See_more: "Lihat Lebih Banyak",
  next: "Seterusnya",
  warehouseHolidayList: "Senarai Cuti Gudang",
  holidayDate: "Tarikh Cuti",
  overdueSetting: "Tetapan Lelewat",
  overdueTime: "Tempoh Lelewat",
  Import_warehouse_holidays: "Import Cuti Gudang",
  overdue_Duration: "Tempoh Lelewat",
  Warehouse_during_holidays: "Cuti Gudang",
  product_item_type: "Jenis Barangan Produk",
  Update_the_product_diversion_number: "Kemas Kini ID Penyusunan Produk",
  Do_you_need_to_update_the_product_diversion_number: "Kemas Kini ID Penyusunan Produk",
  Priority_calculation_method: "Kaedah Pengiraan Utama",
  formula_mode: "Kaedah Pengiraan",
  Add_range: "Tambah Julat",
  Add_the_maximum_range: "Tambah Julat Maksimum",
  The_input_range_for_addition_contains_null_values_Please_check_and_try_again: "Julat penambahan yang dimasukkan mengandungi nilai null. Sila semak dan cuba semula.",
  Imported_part_type_rule_setting: "Import Tetapan Peraturan Jenis Parcel",
  set_type: "Jenis Tetapan",
  calculation_type: "Jenis Pengiraan",
  calculate_the_time_type: "Jenis Masa Pengiraan",
  calculated_value: "Nilai Pengiraan",
  overseas_warehouse_fees: "Yuran Gudang Luar Negara",
  First_leg_fees: "Yuran Peringkat Awal",
  Days: "Hari",
  Month: "Bulan",
  Add_newly_developed_customers: "Tambah Pelanggan Pembangunan Baru",
  Delete_newly_developed_customers: "Padam Pelanggan Pembangunan Baru",
  Please_select_set_type: "Sila pilih jenis tetapan",
  Please_select_calculation_type: "Sila pilih jenis pengiraan",
  Please_select_calculate_the_time_type: "Sila pilih jenis masa pengiraan",
  Whether_to_use_the_strategy_of_new_order_volume_for_the_entire_month: "Gunakan Strategi Jumlah Isipadu Pesanan Baharu Sebulan Penuh",
  Please_enter_the_calculated_value: "Masukkan Nilai Pengiraan",
  The_calculated_value_must_be_greater_than_zero: "Nilai pengiraan mesti lebih besar daripada 0",
  When_the_time_type_is_month_the_value_cannot_exceed_twelve: "Apabila jenis masa pengiraan ialah bulan, nilai ini tidak boleh melebihi 12",
  The_month_corresponding_to_the_starting_time_obtained_from_the_calculation_type: "Untuk bulan yang sepadan dengan tarikh mula yang diperoleh daripada jenis pengiraan,",
  For_new_customers_this_will_no_longer_be_counted_after_this_month: "ia dikira sebagai pelanggan baharu yang dibangunkan; selepas bulan ini, ia tidak dikira lagi",
  The_time_type_is_month: "Jenis masa pengiraan ialah bulan:",
  Using_the_strategy_of_total_monthly_new_orders_If_the_data_generation_time_is_the_1st_day: "Menggunakan strategi volum pesanan baharu sebulan penuh: Jika data dijana pada 1 haribulan,",
  Even_if_the_entire_current_month_has_a_high_volume_of_new_customer_orders_if_this_is_the_case_for_any_other_days: "keseluruhan bulan semasa dikira sebagai volum pesanan pelanggan baharu. Bagi tarikh lain,",
  The_number_of_new_development_customer_orders_will_be_available_from_the_start_date_until_the_end_of_next_month: "tempoh dari tarikh mula hingga akhir bulan berikutnya dikira sebagai volum pesanan pelanggan baharu.",
  Unutilized_monthly_new_order_volume_strategy_For_the_month_for_which_the_starting_time_was_determined_based_on_the_calculation_type: "Tidak menggunakan strategi volum pesanan baharu sebulan penuh: Bagi bulan yang sepadan dengan masa mula yang diperoleh daripada jenis pengiraan,",
  For_the_volume_of_new_customer_orders: "ia dikira sebagai volum pesanan pelanggan baharu.",
  The_time_type_for_calculation_is_in_days: "Jenis masa pengiraan adalah hari:",
  The_start_and_end_times_are_calculated_by_adding_the_first_occurrence_time_of_the_corresponding_type_to_the_corresponding_calculated_value_in_days_months: "Masa mula dan tamat ditentukan dengan menambah nilai pengiraan yang sepadan (hari/bulan) kepada masa pertama kali berlaku bagi jenis yang berkaitan.",
  For_example_The_calculation_type_is: "Sebagai contoh: Jenis pengiraan sama dengan:",
  Enter_into_inventory_set_the_time_type_to_days_and_the_calculation_value_to_15: "Inbound, jenis masa pengiraan sama dengan: hari, nilai pengiraan sama dengan: 15",
  Assuming_the_initial_listing_date_is_2025_11_01_then_the_number_of_new_customer_orders_would_be_2025_11_01_to_2025_11_15: "Dengan andaian tarikh penyenaraian pertama ialah: 2025-11-01, tarikh mula dan tamat untuk volum pesanan pelanggan baharu ialah: 2025-11-01 hingga 2025-11-15.",
  During_this_period_the_orders_that_were_dispatched_are_all_counted_as_the_sales_volume_for_new_customers: "Semua pesanan keluar sepanjang tempoh ini dikira ke dalam volum pesanan pelanggan baharu.",
  count_method: "Kaedah Pengiraan",
  Whether_to_automatically_generate_count_tasks: "Jana tugas pengiraan inventori secara automatik?",
  Whether_to_freeze_inventory: "Bekukan inventori untuk dikira?",
  whether_Difference_count: "Semakan inventori berasaskan perbezaan",
  count_setting: "Tetapan semakan inventori",
  When_there_is_an_count_surplus_or_count_deficit_the_next_round_of_count_tasks_will_be_generated_after_the_end_of_the_count_until_the_final_count: "Sekiranya berlaku lebihan atau kekurangan, tugas semakan inventori seterusnya akan dijana selepas penyempurnaan, dan akan diteruskan sehingga semakan inventori terakhir.",
  Indicates_how_many_rounds_of_count_are_required_If_only_one_round_of_count_is_required_the_value_is_one_If_you_need_to_count_two_rounds_it_is_two_and_so_on: "Menunjukkan bilangan pusingan semakan inventori yang diperlukan. Untuk satu pusingan, masukkan 1; untuk dua pusingan, masukkan 2, dan seterusnya.",
  Count_round: "Pusingan semakan inventori",
  max_count_round: "Pusingan maksimum semakan inventori",
  The_types_of_count_tasks_are_divided_into_light_count_and_dark_count: "Jenis tugas inventori dikategorikan sebagai terbuka atau buta.",
  If_the_light_count_is_selected_the_specific_number_of_SKU_inventory_to_be_counted_will_be_displayed_If_dark_count_is_selected_the_specific_number_of_SKU_inventory_to_be_counted_is_not_displayed: "Memilih inventori terbuka memaparkan kuantiti khusus bagi setiap SKU yang perlu dikira; memilih inventori buta tidak memaparkan kuantiti khusus bagi setiap SKU yang perlu dikira.",
  Whether_multiple_rounds_of_count_can_be_the_same_person: "Sama ada individu yang sama boleh menjalankan beberapa pusingan inventori",
  If_the_automatic_generation_of_count_tasks_is_not_enabled_the_task_to_be_counted_is_not_automatically_generated: "Jika penjanaan automatik tugas inventori dilumpuhkan, tugas inventori yang tertunda tidak akan dijana secara automatik",
  If_you_need_to_restart_the_automatic_generation_of_the_count_task_the_time_of_the_automatic_generation_of_the_count_task_will_start_in_the_morning_of_the_next_day: "Sekiranya penjanaan tugas automatik diaktifkan semula, kira mundur untuk penjanaan tugas akan bermula pada tengah malam hari berikutnya.",
  count_methods_are_divided_into_SKU_count_and_count_by_warehouse_location: "Kaedah inventori merangkumi pengiraan berasaskan SKU dan pengiraan berasaskan lokasi.",
  According_to_the_SKU_count_all_the_storage_locations_that_have_this_SKU_stock_will_be_counted_and_only_the_time_of_the_last_SKU_count_will_be_updated: "Pengiraan berasaskan SKU melibatkan pemeriksaan semua lokasi yang menyimpan inventori untuk SKU tersebut, hanya mengemas kini masa kiraan terakhir SKU tersebut.",
  If_the_count_is_taken_by_warehouse_location_all_SKUs_with_inventory_in_the_warehouse_location_will_be_counted_and_only_the_last_count_time_of_the_warehouse_location_will_be_updated: "Semasa menjalankan inventori berasaskan lokasi, semua SKU yang mempunyai stok di lokasi tersebut akan dikira, dan hanya masa inventori terakhir lokasi itu akan dikemas kini.",
  Subtract_the_last_SKU_or_warehouse_count_time_according_to_the_current_days_find_the_qualified_data_and_generate_the_count_task: "Dengan tolak masa inventori terakhir SKU/lokasi daripada bilangan hari semasa, data yang memenuhi kriteria dikenal pasti untuk menjana tugasan inventori.",
  The_cycle_of_the_count_task_is_automatically_generated: "Kitaran tugas inventori yang dijana secara automatik",
  Indicates_how_many_count_details_exist_in_an_automatic_count_task: "Menunjukkan bilangan baris inventori dalam tugas inventori automatik.",
  For_example_if_the_task_method_is_SKUs_and_the_number_of_automatically_generated_tasks_for_library_locations_and_SKUs_is_ten_the_count_details_contain_10_different_SKUs: "Contoh: Apabila kaedah inventori ialah SKU dan kuantiti tugas yang dijana secara automatik (lokasi/SKU) ialah 10, butiran inventori akan mengandungi 10 SKU berbeza.",
  Automatic_generation_task: "Tugas yang dijana secara automatik",
  check_log: "Lihat log",
  Not_less_than_two: "Tidak boleh kurang daripada 2",
  Quantity_of_need_to_counted: "Kuantiti untuk dikira",
  Quantity_of_actually_count: "Jumlah Sebenar Dibilang",
  Quantity_of_wait_to_count: "Jumlah Tertunggak Bilangan",
  Quantity_of_count_loss: "Jumlah Kekurangan",
  Quantity_of_count_profit: "Jumlah Leebihan",
  task_number: "ID Tugas",
  finally: "Akhir",
  execution_time_of_count: "Masa Pelaksanaan Kiraan Inventori",
  executor_of_count: "Pengira Inventori",
  execute_count: "Laksana Kiraan Inventori",
  check_count_details: "Lihat Butiran Kiraan",
  The_total: "Jumlah",
  Need_to_count_rounds: "Jumlah Pusingan Pengiraan Diperlukan",
  current_count_rounds: "Pusingan Pengiraan Semasa",
  counter: "Pengira Inventori",
  quantity_of_occupy_stock: "Jumlah Inventori Terisi",
  quantity_of_disabled_stock: "Jumlah Inventori Tidak Tersedia",
  storage_location_final_count_time: "Masa Kiraan Terakhir untuk Lokasi",
  product_final_count_time: "Masa Kiraan Terakhir untuk Barangan",
  Manually_generate_count_task: "Jana Tugas Kiraan Inventori Secara Manual",
  Designated_counter: "Nyatakan Pengira Inventori",
  Data_from_different_warehouses_exists_Ensure_that_the_selected_data_belongs_to_the_same_warehouse: "Terdapat data daripada gudang yang berbeza. Sila sahkan data yang dipilih adalah milik gudang yang sama!",
  The_warehouse_is_not_set_for_count_please_set_for_count_first: "Tetapan inventori tidak dikonfigurasikan untuk gudang ini. Sila konfigurasi tetapan inventori terlebih dahulu.",
  please_add_data_first: "Sila tambah data terlebih dahulu!",
  count_task_number: "ID Tugas Inventori",
  stock_batch: "Batch Inventori",
  stock_batch_ID: "ID Batch Inventori",
  stock_batch_Num: "Kuantiti Batch Inventori",
  Number_of_quarantined_shelves: "Kuantiti Rak Terpisah",
  Original_batch_shelf_time: "Masa Rak Batch Asal",
  Isolated_storage_location: "Lokasi Terpisah",
  Whether_the_inventory_is_out_of_storage_location: "Inventori Bukan Lokasi",
  Isolation_shelf_time: "Masa Rak Terpisah",
  Quarantine_inventory_shelving_task_number: "ID Tugas Rak Inventori Terpisah",
  Mission_start_shelf_time: "Masa Permulaan Rak Simpanan Tugas",
  Mission_completed_shelf_time: "Masa Penyempurnaan Rak Simpanan Tugas",
  Task_remarks: "Nota Tugas",
  Original_storage_location: "Lokasi Asal",
  Isolation_shelf_space: "Lokasi Rak Simpanan Terpisah",
  Complete_the_task: "Sempurnakan Tugas",
  Fetch_task: "Dapatkan Tugas",
  Complete_this_round_of_tasks: "Sempurnakan Pusingan Semasa",
  Current_total_stock: "Jumlah Stok Semasa",
  Real_time: "Waktu Sebenar",
  Task_rotation: "Pusingan Tugas",
  Add_non_existing_stock_in_storage_location: "Tambah Stok Lokasi yang Tidak Wujud",
  count_loss_reason: "Sebab Kekurangan Stok",
  count_loss_remark: "Nota Kekurangan Stok",
  count_loss_type: "Jenis Kekurangan Stok",
  Defective_product: "Tidak Memenuhi Piawaian",
  lack: "Hilang",
  Current_stock: "Stok Semasa",
  Inventory_quantity_at_the_end_of_the_last_round: "Jumlah Stok pada Akhir Pusingan Sebelumnya",
  Quantity_of_actually_count_of_last_round_count: "Jumlah Kiraan Sebenar Pusingan Sebelumnya",
  Quantity_of_count_profit_of_last_round_count: "Jumlah Stok Lebih Pusingan Sebelumnya",
  Quantity_of_count_loss_of_last_round_count: "Jumlah Kekurangan Pusingan Sebelumnya",
  End_time_of_last_round_count: "Masa Tamat Inventori Pusingan Sebelumnya",
  count_checked_and_no_problem_stock: "Inventori Diverifikasi dan Disahkan",
  Missing_or_damaged_quantity: "Jumlah Kurang/Rosak",
  The_amount_that_exceeds_the_real_time_current_inventory: "Jumlah Melebihi Inventori Semasa (Masa Sebenar)",
  Whether_the_real_time_current_inventory_is_different_from_the_Inventory_quantity_at_the_end_of_the_last_round: "Adakah Inventori Semasa (Masa Sebenar) Berbeza Daripada Jumlah Inventori Akhir Pusingan Sebelumnya?",
  Please_complete_the_current_task_first: "Sila Lengkapkan Tugas Semasa Dahulu",
  The_storage_location_does_not_exist_or_has_been_completed: "Lokasi penyimpanan tidak wujud atau telah selesai",
  The_bar_code_does_not_exist_or_has_been_completed: "Barang kod produk tidak wujud atau telah selesai",
  Please_scan_the_storage_location_and_scan_the_product_bar_code_and_enter_the_quantity_of_actually_count: "Sila imbas lokasi penyimpanan dan barang kod produk terlebih dahulu, kemudian masukkan jumlah sebenar",
  Cancel_count_task: "Batalkan tugas inventori",
  count_details: "Butiran inventori",
  count_log: "Log inventori",
  Confirm_whether_to_cancel_the_count_task: "Kukuhkan pembatalan tugas inventori",
  countSetting: "Tetapan inventori",
  stockStorageLocationList: "Senarai lokasi penyimpanan inventori",
  countTaskList: "Senarai tugas inventori",
  countTask: "Tugas inventori",
  IsolatedStorageLocationList: "Senarai lokasi penyimpanan terasing",
  isolatedShelfTaskList: "Senarai tugas rak terasing",
  isolatedShelfTask: "Tugas rak terasing",
  pendingClaimList: "Tunggakan Pampasan",
  countDetails: "Butiran Inventori",
  Please_scan_the_storage_location: "Sila imbas lokasi penyimpanan terlebih dahulu",
  please_confirm_exist_storage_location_data_first: "Sila sahkan data lokasi penyimpanan wujud",
  Isolated_storage_location_listing_task_number: "ID Tugas Rak Lokasi Terpisah",
  task_start_time: "Masa Mula Tugas",
  task_end_time: "Masa Tamat Tugas",
  Whether_the_inventory_is_not_in_the_original_storage_location: "Adakah inventori ini dari lokasi bukan asal?",
  The_actual_number_of_products_on_shelves: "Kuantiti sebenar produk yang dirak",
  the_time_that_product_listing_to_the_isolated_storage_location: "Masa produk dirak ke lokasi terpisah",
  Please_scan_the_Original_storage_location: "Sila imbas lokasi asal terlebih dahulu",
  please_confirm_exist_Original_storage_location_data_first: "Sila sahkan terlebih dahulu bahawa data lokasi asal wujud",
  this_task_is_completed: "Tugas ini berada dalam status siap",
  the_storage_location_do_not_exist_or_is_not_isolated_storage_location: "Lokasi ini tidak wujud atau bukan lokasi pengasingan",
  Whether_to_force_the_task_to_complete: "Adakah penyempurnaan paksa tugas diperlukan?",
  The_inventory_has_been_counted_to_the_last_product_and_the_count_task_is_to_be_finished_Is_it_confirmed_that_it_is_completed: "Inventori untuk item terakhir telah selesai, tugas akan diakhiri. Sahkan penyempurnaan?",
  unoccupied_quantity: "Kuantiti tidak diperuntukkan",
  occupied_quantity: "Kuantiti diperuntukkan",
  return_order: "Nota pemulangan",
  manual_entry_and_exit: "Masuk/keluar manual",
  Shifting_storage_location: "Alihkan lokasi",
  Shifting_warehouse: "Alihkan gudang",
  can_no_be_zero: "Tidak boleh sifar",
  When_this_feature_is_enabled_customers_will_not_be_able_to_use_this_inventory_to_submit_orders_during_the_count: "Mengaktifkan fungsi ini menghalang pelanggan daripada menggunakan stok ini untuk membuat pesanan semasa inventori dijalankan.",
  Will_not_be_able_to_operate_this_inventory: "Stok ini tidak akan dapat diakses untuk operasi.",
  If_the_whether_Difference_count_is_equal_yes_the_count_rounds_default_is_two_and_it_cannot_be_less_than_two: "Jika kiraan ketidaksamaan sama dengan kiraan kitaran inventori, lalai akan menjadi 2 dan tidak boleh kurang daripada 2.",
  It_is_used_to_control_the_maximum_count_rounds_when_there_is_a_difference_in_count_quantity: "Digunakan untuk mengawal kiraan kitaran inventori maksimum apabila ketidaksamaan berlaku.",
  modifiable: "Boleh diubah suai.",
  When_there_is_no_difference_it_is_the_final_count_round: "Apabila tiada ketidaksuaian berlaku, ini menjadi kiraan kitaran inventori akhir.",
  whether_the_profit_is_isolated_from_the_warehouse_on_the_shelf: "Sama ada stok lebihan disusun di lokasi terpencil",
  uncounted: "Tidak dikira",
  Have_counted: "Dikira",
  whether_Difference: "Sama ada ketidaksuaian wujud",
  inventory_position_has_not_been_counted_in_recent_N_days: "Lokasi yang tidak dikira dalam N hari terakhir",
  goods_have_not_been_counted_in_recent_N_days: "Barangan yang tidak dikira dalam N hari terakhir",
  Total_quantity_of_goods_in_warehouse: "Jumlah bilangan barangan dalam gudang",
  goods_type_quantity: "Bilangan jenis barangan",
  Whether_the_inventory_loss_is_not_available_for_storage: "Sama ada stok kekurangan disusun di lokasi yang tidak tersedia",
  Unavailable_library_positions: "Lokasi yang tidak tersedia",
  When_the_unavailable_storage_location_is_selected_for_shelving_the_inventory_of_goods_that_are_in_short_supply_during_the_inventory_check_will_be_automatically_shelved_to_the_unavailable_storage_location: "Apabila memilih rak ke lokasi yang tidak tersedia, inventori yang tidak mencukupi akan secara automatik dirak ke lokasi yang tidak tersedia semasa pelaksanaan inventori.",
  When_the_inventory_counting_settings_select_this_item_as_yes_executing_the_final_inventory_counting_if_there_is_a_profit_will_generate_an_isolated_shelving_task_and_move_the_profit_goods_to_the_isolated_library_position: "Apabila pilihan ini ditetapkan kepada Ya dalam tetapan inventori, jika lebihan dikesan selepas pelaksanaan inventori akhir, satu tugas rak terasing akan dijana untuk memindahkan barangan lebihan ke lokasi terasing.",
  When_the_inventory_counting_settings_select_this_item_as_no_executing_the_final_inventory_counting_if_there_is_a_profit_will_directly_correct_the_real_time_inventory_and_move_the_profit_goods_to_the_normal_inventory: "Apabila tetapan ini dipilih sebagai Tidak, sebarang lebihan inventori yang dikenal pasti semasa kiraan stok akhir akan terus menyesuaikan inventori masa nyata, dengan barangan lebihan dipindahkan terus ke inventori biasa.",
  There_are_no_unavailable_locations_in_the_current_warehouse_so_if_you_need_to_set_them_go_to_Add_them_first: "Tiada lokasi penyimpanan yang tidak dapat diakses pada masa ini di gudang ini. Untuk mengkonfigurasikan, tambahkan terlebih dahulu.",
  isolated_storage_location_down: "Pembuangan Lokasi Pengasingan",
  isolated_storage_unit_no: "ID Lokasi Pengasingan",
  isolated_storage_unit_quantity: "Kuantiti Lokasi Pengasingan",
  no_such_storage_unit_in_warehouse: "ID lokasi ini tidak wujud di gudang ini",
  cannot_exceed_isolated_quantity: "Tidak boleh melebihi kuantiti lokasi pengasingan",
  Inventory_cannot_be_removed_from_the_shelves: "Pembuangan Stok yang Tidak Dapat Diakses",
  The_quantity_cannot_be_empty_and_must_be_a_number: "Kuantiti tidak boleh kosong dan mesti berangka",
  Can_only_be_a_positive_integer: "Mesti hanya integer positif",
  Confirm_recount: "Sahkan Pengiraan Semula",
  Take_stock_again: "Mengira Semula",
  At_the_end_of_the_final_inventory_round_the_quantity_of_stock_exceeded_expectations: "Kuantiti inventori melebihi unjuran pada penutup kitaran inventori terakhir",
  At_the_end_of_the_final_inventory_round_the_quantity_of_missing_or_defective_stock: "Kuantiti inventori hilang atau diklasifikasikan sebagai tidak standard pada penutup kitaran inventori terakhir",
  Actual_inventory_quantity_at_the_end_of_the_final_counting_round: "Kuantiti inventori sebenar pada penutup kitaran inventori terakhir",
  Round_Start_Time: "Masa mula kitaran",
  Round_End_Time: "Masa tamat kitaran",
  Whether_to_independently_choose_the_inventory_execution_method: "Adakah untuk memilih kaedah pelaksanaan pengambilan stok secara bebas",
  Select_inventory_execution_method: "Pilih kaedah pelaksanaan kiraan inventori",
  Directly_deduct_from_inventory: "Potongan terus daripada stok",
  Place_on_unavailable_storage_location: "Pengisian semula lokasi penyimpanan yang tidak tersedia",
  When_the_inventory_setting_is_selected_as_Yes_during_inventory_execution_if_there_is_a_loss_in_quantity_you_can_choose_whether_to_directly_deduct_from_inventory_or_shelve_in_unavailable_locations: "Apabila tetapan ini dipilih sebagai Ya, semasa pelaksanaan kiraan inventori, jika terdapat kekurangan, anda boleh memilih antara Kurangkan terus daripada inventori atau Isikan semula lokasi yang tiada stok.",
  viewOrderProcessingFee: "Lihat yuran pemprosesan pesanan",
  goods_ranking_list: "Peringkat produk",
  Bar_chart: "Graf bar",
  weeks: "Mingguan",
  hot: "Terlaris",
  unsalable: "Perlahan pergerakan",
  Line_chart: "Graf garisan",
  Total_account_balance: "Jumlah baki akaun",
  Account_balance: "Baki akaun",
  Number_of_authorized_stores: "Bilangan kedai yang dibenarkan",
  Number_of_authorized_expired_stores: "Bilangan kedai dengan kebenaran yang telah tamat tempoh",
  Time_period: "Tempoh masa",
  Sales_volume: "Jualan produk",
  Commodity_inventory: "Inventori produk",
  Commodity_inventory_storage_location: "Inventori produk (mengikut lokasi)",
  You_have_an_expired_license_store_to_deal_with: "Anda mempunyai kedai dengan kebenaran yang telah tamat tempoh yang menunggu pemprosesan",
  years: "Tahun",
  Historical_announcemen: "Pengumuman sejarah",
  This_year: "Tahun Ini",
  Number_of_squares: "Meter Padu",
  shipment: "Penghantaran",
  Release_time: "Tarikh Pelepasan",
  Frozen_balance: "Baki Beku",
  Frozen: "Beku",
  Store_shipment: "Penghantaran Kedai",
  is_total_orders_click_on_the_detailed_data_to_view_the_order_list: "Jumlah Isipadu Pesanan. Klik 'Data Perincian' untuk melihat senarai pesanan",
  Real_time_total_orders_of_the_day_click_on_the_detailed_data_to_view_the_storage_order_list: "Isipadu Pesanan Harian Masa Sebenar. Klik 'Data Perincian' untuk melihat senarai pesanan gudang",
  Created_nearly_seven_days_ago: "Dicipta dalam 7 hari terakhir",
  Warehouse_order: "Pesanan Gudang",
  Does_not_include_today_is_sales: "Tidak termasuk jualan hari ini",
  Pie_chart: "Graf Bar",
  This_week: "Minggu Ini",
  Current_month: "Bulan Ini",
  Unread_announcement: "Pengumuman Belum Dibaca",
  months: "Bulan",
  main_account: "Akaun Utama",
  head_entry: "Penghantaran Masuk",
  First_Leg_Order: "Pesanan Masuk",
  exception_First_Leg_Order: "Pesanan Masuk Tidak Normal",
  In_the_stock_shelves: "Proses Penghantaran & Rak Masuk",
  Hello_welcome_to_use_estp_oms: "Halo, selamat datang ke Yisufei OMS",
  Hello_welcome_to_use_Hyperdimensional_OMS: "Halo, selamat datang ke Chaowei IoT OMS",
  customer_number: "ID Pelanggan",
  Top_up_immediately: "Isikan Semula Sekarang",
  Sales_Volume: "Jumlah Jualan",
  Data_last_updated: "Data Dikemas Kini Terakhir",
  Beijing_time: "Waktu Beijing",
  obligation_first_leg_order: "Pesanan Masuk Pembayaran Tertunggak",
  Total_square_inventory: "Jumlah Keluasan Gudang",
  go: "Pergi Ke",
  Temporarily_unavailable_please_contact_the_administrator: "Sewaktu ini tidak tersedia, sila hubungi pentadbir",
  The_operation_succeeds_and_The_data_is_refreshed_successfully: "Operasi berjaya, data berjaya disegarkan",
  number_of_SKU: "Jumlah varieti SKU",
  Exclusive_Investment_Promotion: "Pembangunan perniagaan eksklusif",
  Exclusive_customer_service: "Perkhidmatan pelanggan khusus",
  inventory_all_quantity: "Jumlah kuantiti inventori",
  Total_number_inventory_in_transit: "Jumlah inventori dalam perjalanan",
  Order_out_today: "Jumlah pesanan hari ini",
  Order_out_today_yesterday: "Jumlah pesanan semalam",
  Timeout_failed_to_complete_the_task: "Tugas yang belum selesai melebihi masa",
  Overdue_order: "Pesanan lewat",
  Warehousing_order: "Pesanan masuk",
  Quantity_of_goods_in_stock_today: "Pesanan penyenaraian masuk hari ini",
  Number_of_SKUs_in_storage_today: "Jumlah SKU penyenaraian masuk hari ini",
  Return_order: "Pesanan pulangan",
  Order_quantity_of_return_today: "Pesanan Dikembalikan dan Disisihkan Hari Ini",
  Number_of_SKUs_returned_today: "Jumlah SKU Dikembalikan dan Disisihkan Hari Ini",
  First_billing: "Invois Penghantaran Awal",
  unaudited_customer_number: "Jumlah Pengesahan Pelanggan Tertunggak",
  toBePaidOrderList: "Pesanan Pembayaran Tertunggak",
  toBePaid: "Pembayaran Tertunggak",
  Whether_the_product_is_sold_or_not_will_be_calculated_every_day_if_not_the_number_of_unsalable_days_will_be_added_by_one_and_if_there_is_the_number_of_unsalable_days_will_be_reset_to_zero: "Pengiraan harian status jualan produk: jika tidak terjual, tambah satu hari kepada kiraan inventori pegun; jika terjual, set semula kiraan inventori pegun kepada sifar",
  The_sum_of_pending_shipment_distribution_and_shipment: "Jumlah Jumlah Penghantaran Tertunggak, Penyempurnaan Pesanan, dan Penghantaran Berlangsung",
  The_number_to_be_reviewed: "Jumlah Pengesahan Tertunggak",
  The_sum_of_the_delivery_exceptions_in_the_pending_review_and_waybill_number_acquisition: "Jumlah menunggu semakan, pemulihan nombor waybill, dan anomali penghantaran",
  You_do_not_have_permission_to_access_this_page: "Anda tidak mempunyai kebenaran untuk mengakses halaman ini",
  salesReportForSKU: "Laporan Jualan SKU",
  salesReportForWarehouse: "Laporan Jualan Gudang",
  salesReportForPlatform: "Laporan Jualan Platform",
  salesReportForCountry: "Laporan Jualan Negara",
  salesReportForStore: "Laporan Jualan Kedai",
  product_quantity_sold: "Kuantiti Jualan Produk",
  Average_daily_sales: "Jualan Harian Purata",
  Product_name_in_Chinese_and_English: "Nama Produk (Bahasa Cina & Inggeris)",
  unsalableGoodsReport: "Laporan Inventori Perlahan",
  unsalable_days: "Hari Inventori Perlahan",
  overdueList: "Senarai Terlambat",
  overdueDetailList: "Senarai Butiran Terlambat",
  customerDailyConsumptionFlow: "Log Transaksi Harian Pelanggan",
  customerMonthlyConsumptionFlow: "Log Transaksi Bulanan Pelanggan",
  commodityItemNumberReport: "Laporan Nombor Item Produk",
  financialOperations: "Laporan Operasi Kewangan",
  dailyBalance: "Baki Harian Pelanggan",
  shipmentReport: "Laporan Jumlah Penghantaran",
  warehouseShipmentReport: "Laporan Jumlah Penghantaran Gudang",
  platformShipmentReport: "Laporan Jumlah Penghantaran Platform",
  countryShipmentReport: "Laporan Jumlah Penghantaran Negara",
  storeShipmentReport: "Laporan Jumlah Penghantaran Kedai",
  Trend_chart: "Grafik Tren",
  system_setting_overdue_time: "Tempoh Terlambat yang Ditetapkan Sistem",
  overdue_order_number: "Bilangan Pesanan Terlambat",
  overdue_data: "Tarikh Terlambat",
  order_overdue_delivery_time: "Masa Penghantaran Pesanan Terlambat",
  order_delivery_time: "Masa Penghantaran Pesanan",
  Daily_cost_trend_chart: "Grafik Tren Perbelanjaan Harian",
  total_Daily_cost_trend_chart: "Graf Tren Jumlah Perbelanjaan Harian",
  Total_cost: "Jumlah Perbelanjaan",
  clientShipmentReport: "Laporan Jumlah Penghantaran Pelanggan",
  warehouseDailyReport: "Laporan Harian Gudang",
  dailyOrderAllocationReport: "Laporan Pemilihan Pesanan Harian",
  monthlyOrderAllocationReport: "Laporan Pemilihan Pesanan Bulanan",
  dailyOrderSortReport: "Laporan Penyusunan Pesanan Harian",
  monthlyOrderSortReport: "Laporan Penyusunan Pesanan Bulanan",
  dailyOrderDeliverReport: "Laporan Penghantaran Pesanan Harian",
  monthlyOrderDeliverReport: "Laporan Penghantaran Pesanan Bulanan",
  task_finish_number: "Bilangan Tugas Siap",
  order_product_number: "Kuantiti Barangan Pesanan",
  total_time_spent: "Jumlah Masa Dihabiskan",
  order_count: "Jumlah Pesanan",
  dailyLogisticsReturnReceiptReport: "Laporan Resit Kembali Logistik Harian",
  dailyCustomerLogisticsReturnReceiptReport: "Laporan Resit Kembali Logistik Pelanggan Harian",
  dailyCustomeReturnGoodsReceiptReport: "Laporan Resit Kembali Barang Pelanggan Harian",
  orderToBeReviewedOutOfStockReport: "Laporan Barang Habis Stok Pesanan Tertunggak yang Menunggu Kelulusan",
  monthlyCustomeReturnGoodsReceiptReport: "Laporan Resit Kembali Barang Pelanggan Bulanan",
  customerShippedQuantityByWarehouse: "Jumlah Isipadu Penghantaran Pelanggan (Gudang)",
  goodsSalesVolumeByTotalSku: "Jumlah Isipadu Jualan Barang (Jumlah SKU)",
  goodsSalesVolumeByWarehouse: "Jumlah Isipadu Jualan Barang (Gudang)",
  The_create_time_is_about_N_days: "Masa Penciptaan dalam N Hari",
  Quantity_out_of_stock: "Kuantiti Habis Stok",
  this_day: "Hari Semasa",
  goodsOutOfStockReport: "Laporan Barang Habis Stok",
  out_of_stock_days: "Tempoh Habis Stok",
  out_of_stock_date: "Tarikh Habis Stok",
  dailyConsumptionFlow: "Aliran Transaksi Harian",
  monthlyConsumptionFlow: "Aliran Transaksi Bulanan",
  warehouse_hourly_uncleared_orders: "Pesanan Belum Diproses Per Jawatankuasa Per Jam",
  responsible_person: "Orang Yang Bertanggungjawab",
  total_unshipped_quantity: "Jumlah Isipadu Belum Dihantar",
  total_shipped_quantity: "Jumlah Isipadu Dihantar",
  ratio: "Kadar",
  warehouse_hourly_shipping: "Penghantaran Per Jawatankuasa Per Jam",
  total_order_quantity: "Jumlah Isipadu Pesanan",
  outbound_count: "Jumlah Isipadu Keluar",
  orderTimelinessMonitoringTable: "Jadual Pemantauan Ketepatan Masa Pesanan",
  hourlyShippingReport: "Laporan Penghantaran Per Jam",
  Packing_timeliness_rate: "Kecekapan Pembungkusan",
  monthlyOrderVolumeInvestmentPromotionOfficerReport: "Laporan Isipadu Pesanan Bulanan untuk Pegawai Pembangunan Perniagaan",
  monthlyOrderVolumeInvestmentPromotionDepartmentReport: "Laporan Isipadu Pesanan Bulanan untuk Jabatan Pembangunan Perniagaan",
  monthlyOrderVolumeCustomerReport: "Laporan Isipadu Pesanan Bulanan untuk Pelanggan",
  monthlyOrderVolumeCountryReport: "Laporan Isipadu Pesanan Bulanan mengikut Negara",
  monthlyOrderVolumeWarehouseReport: "Laporan Jumlah Isipadu Pesanan Gudang Bulanan",
  monthlyOrderVolumePlatformrReport: "Laporan Jumlah Isipadu Pesanan Platform Bulanan",
  investment_Promotion_Officer: "Wakil Pembangunan Perniagaan",
  investment_Promotion_Department: "Jabatan Pembangunan Perniagaan",
  average_daily_order_volume: "Purata Isipadu Pesanan Harian",
  average_daily_proportion: "Purata Peratusan Harian",
  total_order_volume: "Jumlah Isipadu Pesanan",
  total_order_volume_proportion: "Jumlah Peratusan Isipadu Pesanan",
  number_of_newly_developed_customers: "Bilangan Pelanggan Baru",
  the_total_order_volume_of_newly_developed_customers: "Isipadu Pesanan Pelanggan Baru",
  the_proportion_of_new_customer_orders: "Peratusan Isipadu Pesanan Pelanggan Baru",
  only_100_order_numbers_are_supported_at_a_time: "Hanya menyokong 100 nombor pesanan setiap satu siri",
  separated_by_newlines: "Dipisahkan dengan pemisah baris",
  get_label: "Dapatkan Label",
  get_success: "Pendapatan Berjaya",
  printLabel: "Cetak Label",
  dailyInventory: "Inventori Harian",
  record_date: "Tarikh Rekod",
  inventory_grounding_time: "Masa Rak Inventori",
  daily_inventory_list: "Senarai Inventori Harian",
  deliveryTime: "Masa Keluar",
  lastUpdateTime: "Masa Kemas Kini",
  completeTime: "Masa Selesai",
  settleAccountsTime: "Masa Penyetelan",
  stockId: "Gudang",
  orderType: "Jenis",
  orderId: "Nombor Pesanan",
  trackingNo: "Nombor Waybill",
  referenceNo: "Nombor Rujukan",
  skuNum: "SKU* Kuantiti",
  fileUrl: "Alamat Video",
  video_storage_address: "Alamat Penyimpanan Video",
  filePhotoUrl: "Gambaran Keluar",
  createUserId: "Kakitangan Keluar",
  starCreateTime: "Masa Mula Keluar",
  endCreateTime: "Masa Akhir Keluar",
  totalStorageSpace: "Jumlah Kapasiti Penyimpanan",
  usedStorageSpace: "Penyimpanan yang Digunakan",
  remainingStorageSpace: "Penyimpanan yang Tersisa",
  serverIP: "IP Pelayan",
  serverName: "Nama Pelayan",
  warehouseServerPort: "Pelabuhan",
  storageFilePath: "Laluan Fail Penyimpanan",
  addStorageSpaceServersWarehouse: "Tambah Penyimpanan Pelayan Dalam Gudang",
  editStorageSpaceServersWarehouse: "Sunting Penyimpanan Pelayan Dalam Gudang",
  please_select_warehouse: "Sila pilih gudang",
  please_select_serverIP: "Sila pilih IP pelayan",
  please_select_serverName: "Sila masukkan nama pelayan",
  please_select_serverPort: "Sila masukkan pelabuhan pelayan",
  video_snapshot_information: "Maklumat Rakaman Tangkapan Video",
  platformAuthorization: "Kebenaran Platform",
  authorizedStoreList: "Kedai Bertauliah",
  this_data_has_no_outbound_time: "Tiada masa penghantaran keluar direkodkan untuk kemasukan ini",
  please_choose_again: "Sila pilih semula",
  total_cloud_server_storage_video_access_path: "Jejak Akses Penyimpanan Video Pelayan Awan Keseluruhan",
  total_cloud_server_storage_image_access_path: "Jejak Akses Penyimpanan Imej Pelayan Awan Keseluruhan",
  total_cloud_server_storage_outbound_snapshot: "Jejak Akses Penyimpanan Snapshot Penghantaran Keluar Pelayan Awan Keseluruhan",
  total_cloud_server_storage_video_address: "Alamat Penyimpanan Rakaman Pelayan Awan Keseluruhan",
  unpackRegisterReturnPackage: "Daftar ke Kawasan Tuntutan",
  registerInClaimArea: "Daftar Pengembalian melalui Pembukaan Parcel",
  Please_select_the_quick_registration_type: "Sila pilih jenis pendaftaran ekspres",
  Change_storage_location: "Ubah Lokasi Penyimpanan",
  productId: "ID Produk",
  Please_select_the_product_details_first: "Sila pilih butiran produk terlebih dahulu",
  basket_listing: "Letakkan dalam Bakul Rak",
  Please_enter_the_basket_for_listing: "Sila masukkan bakul rak",
  locationId: "ID Lokasi Stok",
  automatic_return_listing: "Penyusunan Automatik Pengembalian",
  not_automatically_listed: "Jangan Susun Secara Automatik",
  shelf_return_warehouse_location: "Susun ke Lokasi Pengembalian",
  registerList: "Daftarkan dan Susun",
  Is_the_qualified_quantity_0_saved_to_the_rejection_stage: "Kuantiti layak ialah 0. Simpan ke peringkat penolakan?",
  Is_the_qualified_quantity_0_saved: "Kuantiti layak ialah 0. Simpan?",
  Please_upload_photo_of_the_package: "Sila muat naik foto bungkusan",
  The_actual_data_of_the_product_must_be_all_greater_than_0: "Semua data produk sebenar mesti melebihi 0",
  Please_enter_the_qualified_and_unqualified_quantity: "Sila masukkan jumlah kuantiti",
  Please_select_the_billing_attribute_for_the_product: "Sila pilih atribut pengebilan produk",
  Please_complete_the_selection_of_warehouse_location_number_first: "Sila lengkapkan pemilihan nombor lokasi terlebih dahulu",
  Multiple_products_please_select_multiple_SKU_types_and_location_numbers: "Untuk berbilang produk, pilih nombor lokasi jenis berbilang-SKU",
  Is_it_confirmed_that_there_is_a_difference_in_the_dimensions_of_the_three_sides_of_the_currently_inspected_product_compared_to_the_previous_inspected_product: "Dimensi tiga dimensi produk yang sedang diperiksa berbeza daripada produk yang diperiksa sebelum ini. Pengesahan?",
  Is_it_confirmed_that_there_is_a_difference_between_the_actual_weight_of_the_current_quality_inspection_product_and_the_actual_weight_of_the_previous_quality_inspection: "Berat sebenar produk yang sedang diperiksa berbeza daripada berat sebenar produk yang diperiksa sebelum ini. Pengesahan?",
  The_qualified_quantity_cannot_exceed_the_total_quantity: "Jumlah yang diluluskan tidak boleh melebihi jumlah keseluruhan",
  The_current_storage_location_is_a_single_SKU_storage_location_which_has_been_selected_by_other_products: "Lokasi semasa adalah lokasi SKU tunggal yang telah dipilih oleh item lain",
  batch_return_warehouse_relocation: "Pemindahan Lokasi Pengembalian Batch",
  automatically_print_the_inventory_transfer_list: "Cetak senarai pemindahan secara automatik",
  print_the_inventory_transfer_list: "Cetak senarai pemindahan",
  view_SKU_transaction_history: "Lihat sejarah transaksi SKU",
  Inventory_transfer_task_ID: "ID tugas pemindahan",
  print_list: "Cetak senarai",
  commodity_income: "Resit item",
  refund_fee: "Yuran pemulangan",
  shippingFee: "Perbelanjaan kargo",
  shippingIncomFee: "Hasil kargo",
  discountFee: "Jumlah diskaun",
  serviceFee: "Yuran Perkhidmatan",
  commissionFee: "Komisen",
  taxFee: "Cukai",
  advertisingFee: "Kos Pengiklanan",
  paymentFee: "Yuran Pemprosesan Pembayaran",
  warehousePackingFee: "Caj Pembungkusan Gudang",
  otherFee: "Pendapatan/Perbelanjaan Lain",
  orderIncomeFee: "Pendapatan Pesanan",
  platformName: "Nama Platform",
  FinancialRecognition: "Pengesahan Kewangan",
  Pending_warehouse_transfer: "Tunggakan Pemindahan",
  To_be_received: "Tunggakan Penerimaan",
  convertToWaitingForReception: "Tukar kepada Tunggakan Penerimaan",
  Please_enter_the_warehouse_location_number: "Sila Masukkan Nombor Lokasi",
  Please_choose_to_add_SKU: "Sila Tambah SKU",
  returnInventoryQuantity: "Jumlah Inventori Dikembalikan",
  controlTime: "Masa Kawalan",
  Transfer_of_warehouse_completed: "Dipindahkan",
  Revoked: "Dibatalkan",
  The_current_warehouse_type_is_shelf_to_return_location_Please_select_a_new_warehouse: "Jenis gudang semasa ialah 'Rak ke Lokasi Pemulangan'. Sila pilih semula gudang",
  recommended_shelf_location: "Lokasi Penyenaraian Disyorkan",
  Is_the_measurement_size_correct: "Semak Ketepatan Dimensi",
  Please_add_SKU: "Sila Tambah SKU",
  Currency_for_profit_calculation: "Mata Wang Pengiraan Keuntungan",
  Order_delivery_time: "Masa Penghantaran Pesanan",
  Last_update_time: "Masa Kemas Kini Terakhir",
  operatorUserId: "Pengguna Operasi",
  total_inventory_batch: "Jumlah Inventori Kumpulan Semasa",
  Please_select_the_recommended_storage_location_for_listing: "Sila Pilih Lokasi Penyenaraian Disyorkan",
  Please_select_the_data_that_needs_to_be_transferred_to_the_warehouse_first: "Sila Pilih Data untuk Dipindahkan Terlebih Dahulu",
  Import_inventory_list: "Import Senarai Inventori",
  Return_warehouse_location_Return_pending_review: "Lokasi Pemulangan Pemulangan Tunggak Semakan",
  Inventory_transfer_task_removal_flow: "Tugas Pemindahan Log Penyingkiran Penyenaraian",
  The_inventory_quantity_for_the_return_warehouse_relocation_cannot_be_0: "Jumlah pemindahan stok yang dikembalikan tidak boleh sifar",
  The_current_return_order_is_marked_as_abandoned_by_the_customer_and_will_be_automatically_discarded_after_saving: "Pelanggan pesanan pulangan semasa ditandakan sebagai ditinggalkan; akan dibuang secara automatik selepas disimpan",
  Final_order_placement_time: "Masa pemulihan pesanan terakhir",
  Last_updated_listing_time: "Masa kemas kini penyenaraian terakhir",
  Product_SKU: "SKU produk",
  sales_volumes: "Jumlah jualan",
  Platform_settlement_amount: "Jumlah penyelesaian platform",
  Order_product_sales_revenue: "Nilai jualan produk pesanan",
  Cost_of_goods: "Kos produk",
  merchandise_procurement_cost: "Kos perolehan produk",
  First_leg_freight: "Kos kargo awal",
  Platform_shipping_fee: "Kos kargo platform",
  Actual_shipping_cost: "Kos kargo sebenar",
  The_buyer_pays_the_shipping_fee: "Kargo dibayar pembeli",
  Platform_freight_subsidy: "Subsidi penghantaran platform",
  Revenue_from_3PL_freight_refund: "Pendapatan rebat kargo 3PL",
  Platform_fees: "Yuran platform",
  Platform_commission: "Komisen platform",
  Alliance_commission: "Komisen rakan kongsi",
  Transaction_fee: "Yuran transaksi",
  Platform_activity_expenses: "Yuran promosi platform",
  Additional_plan_service_fee: "Yuran perkhidmatan program tambahan",
  threePL_insurance_premium: "Premium insurans 3PL",
  Seller_pays_cross_border_tax: "Cukai merentas sempadan yang dibayar oleh penjual",
  Freight_service_tax_SST: "Cukai Perkhidmatan Barangan dan Perkhidmatan (SST)",
  Withholding_tax: "Cukai pendahuluan",
  Overseas_return_service_fee: "Yuran perkhidmatan pemulangan luar negara",
  Value_added_tax_VAT: "Cukai Nilai Tambah (VAT)",
  Product_and_Service_Tax: "Cukai Barangan dan Perkhidmatan",
  Coupons_Discounts: "Baucar & diskaun",
  Seller_Coupons: "Baucar penjual",
  Shopee_discount: "Diskaun Shopee",
  Shopee_coin_deduction: "Potongan Shopee Coin",
  Shopee_discount_return: "Pulang tunai diskaun Shopee",
  refund_amount: "Jumlah bayaran balik",
  Other_platform_expenses: "Yuran platform lain",
  place_an_order_time: "Masa membuat pesanan",
  createTime: "Masa membuat pesanan",
  Refund_product_amount: "Nilai item yang dikembalikan",
  updateTime: "Masa kemas kini",
  Original_price_of_the_product: "Harga asal item",
  merchandise_discount: "Diskaun item",
  Sellers_product_discount: "Diskaun item penjual",
  Shopee_Coupons: "Kupon Shopee",
  Shopee_coin_exchange: "Penebusan Shopee Coins",
  The_buyer_pays_the_transaction_fee: "Yuran transaksi pembeli",
  The_buyer_pays_the_total_amount: "Jumlah bayaran pembeli",
  Estimated_shipping_cost: "Anggaran kos penghantaran",
  The_seller_bears_the_shipping_cost: "Kos penghantaran ditanggung penjual",
  Platform_compensation_amount: "Jumlah pampasan platform",
  Service_fees_charged_for_participating_in_the_sellers_free_shipping_plan: "Yuran perkhidmatan yang dikenakan untuk penyertaan dalam Program Penghantaran Percuma Penjual",
  Order_reverse_shipping_service_tax_shipping_service_tax: "Cukai Perkhidmatan Penghantaran Balik Pesanan + Cukai Perkhidmatan Penghantaran",
  SG_Goods_and_Services_Tax_MY_LVG_Goods_Ta: "Cukai Barang dan Perkhidmatan SG / Cukai Barang Nilai Rendah MY",
  Cross_border_goods_tax_logistics_clearance_service_fees_service_tax_on_low_value_goods_imported_from_Singapore_anti_dumping_duty_on_imported_goods: "Cukai Barangan Lintas Batas + Yuran Perkhidmatan Pelepasan Kastam Penyedia Logistik + Cukai Perkhidmatan Import Barangan Nilai Rendah Singapura + Cukai Anti-Dumping Barangan Import",
  The_amount_of_fees_charged_to_the_seller_for_failure_to_deliver_the_order: "Yuran yang dikenakan ke atas Penjual untuk Penghantaran Pesanan Gagal",
  Return_order_return_shipping_fee: "Kos penghantaran balik pesanan yang dikembalikan",
  refundShippingSubsidyFee: "Pendapatan insurans penghantaran balik",
  Compensation_provided_by_the_platform_for_lost_or_damaged_packages: "Pampasan yang diberikan oleh platform untuk bungkusan yang hilang atau rosak",
  Import_of_MY_low_value_goods_subject_to_service_tax: "Cukai perkhidmatan yang dikenakan ke atas pengimportan barangan bernilai rendah MY",
  Profit_margin_Profit_Order_payment_for_product_amount_Financial_currency_exchange_rate: "Margin keuntungan = Keuntungan ÷ (Jumlah bayaran pesanan barangan × Kadar pertukaran mata wang kewangan)",
  Charges_incurred_for_packages_requiring_signature_confirmation_services: "Yuran yang ditanggung untuk bungkusan yang memerlukan perkhidmatan pengesahan tandatangan",
  Profit_Order_paid_product_amount_Actual_shipping_fee_Buyer_paid_shipping_fee_Platform_shipping_subsidy_3PL_shipping_fee_refund_income_Commission_Alliance_commission_Transaction_fee_Service_fee_Platform_activity_fee_Additional_planned_service_fee_3PL_insurance_fee_Seller_paid_cross_border_tax_Shipping_service_tax_SST_Withholding_tax_Overseas_return_service_fee_Value_added_tax_VAT_Product_service_tax_Seller_discount_coupon_Shopee_discount_Shopee_gold_coin_deduction_Shopee_discount_refund_Refund_product_amount_Return_order_return_shipping_fee_Return_shipping_insurance_income_Platform_other_fees_Order_adjustment_amount_x_Financial_currency_exchange_rate_Product_procurement_cost_First_leg_shipping_fee_Warehouse_rental_Listing_fee_Order_processing_fee: "Keuntungan = (Nilai barangan yang dipesan - Kos penghantaran sebenar + Penghantaran dibayar pembeli + Subsidi penghantaran platform + Pendapatan rebat penghantaran 3PL - Komisen - Komisen rakan niaga - Yuran transaksi - Yuran perkhidmatan - Yuran promosi platform - Yuran perkhidmatan program tambahan - Yuran insurans 3PL - Cukai rentas sempadan dibayar penjual - SST Penghantaran - Cukai pendahuluan - Yuran perkhidmatan pemulangan luar negara - Cukai Barang dan Perkhidmatan (VAT) - Cukai Perkhidmatan Produk - Baucar penjual - Diskaun Shopee - Tolakan Shopee Coins + Rebat diskaun Shopee - Jumlah produk yang dikembalikan - Kos penghantaran pesanan yang dikembalikan + Pendapatan insurans penghantaran balik - Yuran platform lain + Jumlah pelarasan pesanan) × Kadar pertukaran mata wang kewangan - (Kos perolehan produk + Kos penghantaran keluar + Sewa gudang + Yuran penyenaraian + Yuran pemprosesan pesanan)",
  Profit_Order_payment_for_product_amount_Actual_Freight_Buyer_Paid_Freight_Platform_Freight_Subsidy_3PL_Freight_Return_Revenue_Commission_Alliance_Commission_Transaction_Fee_Service_Fee_Platform_Activity_Fee_Additional_Plan_Service_Fee_3PL_Insurance_Fee_Seller_Paid_Cross_border_Tax_Freight_Service_Tax_SST_Withholding_Tax_Overseas_Return_Service_Fee_Value_Added_Tax_VAT_Product_Service_Tax_Seller_Discount_Coupon_Shopee_Discount_Shopee_Gold_Coin_Deduction_Shopee_Discount_Return_Refund_Product_Amount_Return_Order_Return_Freight_Return_Freight_Insurance_Income_Platform_Other_Fees_Financial_Currency_Exchange_Rate_Product_Procurement_Cost_First_leg_Freight_Warehouse_Rent_Listing_Fee_Order_Processing_Fee: "Keuntungan = (Jumlah Bayaran Pesanan - Kos Penghantaran Sebenar + Penghantaran Dibayar Pembeli + Subsidi Penghantaran Platform + Pendapatan Rebat Penghantaran 3PL - Komisen - Komisen Rakan Kongsi - Yuran Transaksi - Yuran Perkhidmatan - Yuran Promosi Platform - Yuran Perkhidmatan Program Tambahan - Yuran Insurans 3PL - Cukai Lintas Batas Dibayar Penjual - Cukai Perkhidmatan Penghantaran (SST) - Cukai Pemotongan - Yuran Perkhidmatan Pengembalian Luar Negara - Cukai Nilai Tambah (CGT) - Cukai Barang dan Perkhidmatan (CBP) - Baucar Penjual - Diskaun Shopee - Pengimbangan Shopee Coin + Rebat Diskaun Shopee - Jumlah Pampasan Barangan - Kos Penghantaran Pengembalian Pesanan + Pendapatan Insurans Penghantaran Pengembalian - Yuran Platform Lain) × Kadar Pertukaran Mata Wang Kewangan - (Kos Perolehan Produk + Kos Penghantaran Keluar + Sewa Gudang + Yuran Penyenaraian + Yuran Pemprosesan Pesanan)",
  Profit_Order_payment_for_product_amount_actual_shipping_cost_buyer_paid_shipping_cost_platform_shipping_subsidy_seller_bears_shipping_cost_seller_discount_coupon_gold_coin_deduction_platform_discount_subsidy_commission_product_service_tax_platform_activity_fee_installment_payment_handling_fee_advertising_fee_payment_handling_fee_platform_compensation_amount_platform_other_fees_refunded_product_amount_return_order_return_shipping_cost_Exchange_rate_product_procurement_cost_first_leg_shipping_cost_warehouse_rental_shelving_fee_order_processing_fee: "Keuntungan = (Jumlah Barang Dipesan - Kos Penghantaran Sebenar + Penghantaran Dibayar Pembeli + Subsidi Penghantaran Platform - Penghantaran Ditanggung Penjual - Baucar Penjual - Pengurangan Syiling + Subsidi Diskaun Platform - Komisen - Cukai Perkhidmatan Produk - Yuran Acara Platform - Yuran Pengendalian Ansuran - Perbelanjaan Pengiklanan - Yuran Pemprosesan Pembayaran + Jumlah Pampasan Platform + Yuran Platform Lain - Jumlah Barang Dikembalikan - Kos Penghantaran Pesanan Dikembalikan) × Kadar Pertukaran - (Kos perolehan produk + kargo awal + sewa gudang + yuran penyenaraian + yuran pemprosesan pesanan)",
  Profit_Discounted_product_subtotal_Refund_Actual_Freight_Seller_Paid_Freight_Platform_Freight_Subsidy_Exchange_Freight_Seller_Freight_Discount_TSP_Commission_Platform_Commission_Alliance_Commission_Transaction_Fees_SFP_Service_Fees_Service_Fees_Additional_Plan_Service_Fees_Logistics_Insurance_Fees_Freight_Service_Tax_SST_Value_Added_Tax_VAT_Product_Service_Tax_Seller_Coupon_Return_Order_Freight_Other_Platform_Fees_Credit_Card_Payment_Fees_Platform_Adjustment_Amount_Ecological_Donations_Commission_Exchange_Rate_Product_Purchase_Cost_First_leg_Freight_Warehouse_Rent_Listing_Fee_Order_Processing_Fee: "Keuntungan = (Jumlah sub-total item yang diberi diskaun - Pengembalian dana - Kos penghantaran sebenar + Penghantaran dibayar penjual + Subsidi penghantaran platform - Kos penghantaran pertukaran - Diskaun penghantaran penjual - Komisen TSP - Komisen platform - Komisen gabungan - Yuran transaksi - Yuran perkhidmatan SFP - Yuran perkhidmatan - Yuran perkhidmatan program tambahan - Yuran insurans logistik - Cukai perkhidmatan penghantaran (SST) - Cukai Barang dan Perkhidmatan (GST) - Cukai perkhidmatan produk - Baucar diskaun penjual - Kos penghantaran pesanan dikembalikan - Yuran platform lain - Yuran pemprosesan kad kredit + Jumlah pelarasan platform - Sumbangan ekosistem - Yuran pengendalian) * Kadar pertukaran - (Kos perolehan produk + Kos penghantaran awal + Sewa gudang + Yuran penyenaraian + Yuran pemprosesan pesanan)",
  storeCurrency: "Mata wang kedai",
  escrowCurrency: "Mata wang kewangan",
  exchangeRate: "Kadar pertukaran mata wang kewangan",
  income_expenditure_information: "Maklumat pendapatan dan perbelanjaan",
  expense_item: "Butiran perbelanjaan",
  revenue_expenditure: "Pendapatan dan perbelanjaan",
  Take_the_actual_bill_and_the_buyer_pays_the_shipping_fee: "Jumlah Invois Sebenar Kos Penghantaran Pembeli",
  percent: "Peratusan",
  Order_payment_for_product_amoun: "Jumlah Produk yang Ditempah",
  The_last_update_time_of_profit_and_expense_data_automatically_updated_when_platform_orders_change_or_settle: "Data Untung/Rugi Dikemas Kini Terakhir: Dikemas kini secara automatik apabila terdapat perubahan pesanan platform atau penyelesaian",
  Take_the_settlement_time_of_the_order_and_for_non_platform_orders_take_the_time_when_the_order_is_moved_to_the_Completed_status_When_the_settlement_time_is_empty_it_means_that_the_platform_has_not_ended_yet: "Tarikh Penyelesaian Pesanan: Untuk pesanan bukan platform, ini adalah tarikh pesanan bertukar kepada status [Disenyumkan]. Tarikh penyelesaian kosong menunjukkan platform belum memuktamadkan pemprosesan",
  Take_the_final_settlement_time_of_the_order_Payment_Period_and_for_non_platform_orders_take_the_time_when_the_order_is_moved_to_the_Completed_status_If_the_settlement_time_is_empty_it_means_the_platform_has_not_ended_yet: "Masa penyelesaian akhir (Tempoh Pembayaran) untuk pesanan. Bagi pesanan bukan platform, masa penyelesaian ialah apabila pesanan bertukar kepada status [Disenyumkan]. Ruang masa penyelesaian kosong menunjukkan platform belum memuktamadkan pesanan.",
  Take_the_final_settlement_date_of_the_order_Settlement_Date_and_for_non_platform_orders_take_the_time_when_the_order_is_moved_to_the_Completed_status_If_the_settlement_time_is_empty_it_means_the_platform_has_not_ended_yet: "Tarikh penyelesaian akhir (Tarikh Penyelesaian) untuk pesanan. Bagi pesanan bukan platform, tarikh penyelesaian ialah apabila pesanan bertukar kepada status [Disenyumkan]. Ruang tarikh penyelesaian kosong menunjukkan platform belum memuktamadkan pesanan.",
  The_system_calculates_the_estimated_settlement_amount_of_the_order_based_on_the_income_of_the_order_platform_fees_minus_the_expenditure_of_the_order_platform_fees_Please_compare_and_verify_it_with_the_settlement_amount_of_the_platform: "Sistem mengira anggaran amaun penyelesaian untuk sesuatu pesanan berdasarkan hasil yuran platform tolak perbelanjaan yuran platform. Sila sahkan ini dengan amaun penyelesaian platform.",
  Estimated_settlement_amount: "Anggaran Amaun Penyelesaian",
  The_order_payment_completion_time_the_time_when_the_funds_have_been_transferred_is_recorded_For_non_platform_orders_the_settlement_time_is_determined_by_the_moment_the_order_is_moved_to_the_Completed_status_If_the_settlement_time_is_blank_it_indicates_that_the_platform_has_not_finalized_the_order: "Masa penyempurnaan pembayaran untuk sesuatu pesanan (dana dipindahkan sepenuhnya). Untuk pesanan bukan platform, masa penyelesaian ialah apabila pesanan memasuki status [Disenyumkan]. Ruang masa penyelesaian kosong menunjukkan platform belum menyelesaikan transaksi tersebut.",
  The_time_when_the_platform_status_of_the_order_changes_to_Competed_Cancelled: "Masa apabila status platform pesanan bertukar kepada Siap/Dibatalkan.",
  Retrieve_the_system_order_outbound_time: "Masa penghantaran pesanan sistem.",
  Seller_bears_the_shipping_cost_actual_shipping_cost_buyer_pays_the_shipping_cost_platform_shipping_subsidy_3PL_shipping_cost_refund_income_not_included_in_order_profit_calculation_for_operational_analysis_reference_only: "Kos penghantaran ditanggung penjual = Kos penghantaran sebenar - Kos penghantaran dibayar pembeli - Subsidi penghantaran platform - Pendapatan rebat penghantaran 3PL (tidak dimasukkan dalam pengiraan keuntungan pesanan, hanya untuk rujukan analisis operasi).",
  time_filtering: "Penapisan masa.",
  Exchange_rate_setting_System_settings_Currency_exchange_rate_Currency_exchange_rate_list: "Konfigurasi kadar pertukaran: Tetapan Sistem → Kadar Pertukaran Mata Wang → Senarai Kadar Pertukaran Mata Wang;",
  The_system_converts_the_original_currency_of_the_store_into_the_financial_currency_for_profit_based_on_the_exchange_rate: "Sistem menukarkan mata wang asal kedai kepada mata wang kewangan keuntungan berdasarkan kadar pertukaran;",
  When_the_currency_exchange_rate_is_not_set_the_system_will_not_perform_data_synchronization_After_setting_the_data_will_be_synchronized_after_24_00_on_the_same_day: "Jika kadar pertukaran mata wang tidak dikonfigurasikan, sistem tidak akan menyegerakkan data. Setelah dikonfigurasikan, penyegerakan data akan berlaku selepas pukul 24:00 pada hari yang sama.",
  deduction_currency_value_system_settings_Currency_exchange_rate_Exchange_rates_in_the_currency_exchange_rate_list_Record_the_exchange_rate_when_obtaining_the_order_revenue_and_expenditure_for_the_first_time_and_do_not_update_the_exchange_rate_value_in_the_profit_afterwards_When_the_currency_exchange_rate_is_not_set_it_defaults_to_0_When_the_exchange_rate_value_can_be_obtained_in_subsequent_automatic_updates_it_will_be_updated: "Menukar Mata Wang Kedai kepada Mata Wang Penolakan Kewangan: Nilai diambil daripada Tetapan Sistem ➡ Kadar Pertukaran Mata Wang ➡ Kadar Pertukaran dalam Senarai Mata Wang. Kadar pertukaran direkodkan semasa pengambilan pertama pendapatan/perbelanjaan pesanan; pengiraan keuntungan seterusnya menggunakan kadar yang tidak berubah. Lalai kepada 0 jika tiada kadar ditetapkan; dikemas kini secara automatik apabila kadar pertukaran tersedia.",
  Please_set_the_conversion_exchange_rate_between_the_relevant_store_currency_and_the_financial_deduction_currency_which_will_be_used_for_calculating_order_profit_report_data: "Sila atur cara kadar penukaran mata wang kedai berkaitan kepada mata wang potongan kewangan untuk digunakan dalam pengiraan laporan keuntungan pesanan.",
  Not_involved_in_order_profit_calculation_for_operational_analysis_reference_only: "Tidak dimasukkan dalam pengiraan keuntungan pesanan; hanya untuk rujukan analisis operasi.",
  The_actual_settlement_amount_on_the_platform_is_not_included_in_the_calculation_of_order_profits_and_is_only_for_operational_analysis_reference: "Jumlah penyelesaian sebenar platform; tidak dimasukkan dalam pengiraan keuntungan pesanan; hanya untuk rujukan analisis operasi.",
  The_procedures_for_sellers_to_participate_in_the_PayLater_program_and_receive_fees: "Yuran yang dikenakan kepada penjual yang menyertai skim PayLater",
  Freight_subsidies_and_rewards_provided_by_the_platform_Freight_subsidies_provided_by_the_platform_for_sellers_to_ship_Delivery_rewards_obtained_by_sellers_signing_a_joint_sponsorship_free_delivery_plan: "Subsidi dan insentif penghantaran yang disediakan oleh platform + subsidi penghantaran platform untuk pesanan yang dipenuhi oleh penjual + insentif penghantaran yang diperoleh oleh penjual yang mendaftar untuk skim penghantaran percuma yang dibiayai bersama",
  billID: "ID Invois",
  Deduct_a_20_refund_management_fee_from_the_total_amount_of_returned_items: "Yuran pengurusan pulangan 20% yang ditolak daripada jumlah yuran barangan yang dikembalikan",
  Service_fees_charged_for_participating_in_on_site_special_programs_service_fees_charged_for_participating_in_bonus_rebates_service_fees_charged_for_using_Tiktok_Mall_servers_charged_for_participating_in_coupon_plans_service_fees_charged_for_participating_in_limited_time_rush_purchase_service_fees_charged_for_promotional_activities_service_fees_charged_for_pre_purchase_plans: "Yuran perkhidmatan untuk menyertai program istimewa langsung + yuran perkhidmatan untuk menyertai skim pulangan tunai bonus + yuran perkhidmatan untuk menggunakan Douyin Mall + yuran perkhidmatan untuk menyertai program baucar + yuran perkhidmatan untuk menyertai jualan kilat + yuran perkhidmatan untuk aktiviti promosi + yuran perkhidmatan untuk program tempahan awal",
  difference_amount: "Jumlah Perbezaan",
  bill_type: "Jenis Invois",
  recalculateTime: "Masa Pengiraan Semula Invois",
  Please_fill_in_the_task_number_first: "Sila masukkan nombor tugasan terlebih dahulu",
  Payment_time: "Tarikh Pengebilan",
  part_number: "Nombor Barangan",
  The_commission_paid_by_the_seller_to_the_creator_alliance_advertising_commission_commission_purchased_through_partner_links_eligible_advertising_order_commission: "Komisen yang dibayar oleh penjual kepada pencipta + komisen pengiklanan rakan kongsi + komisen daripada pembelian melalui pautan rakan kongsi + komisen daripada pesanan pengiklanan yang layak",
  Please_enter_SKU_line_break_or_comma_separated: "Sila masukkan SKU, dipisahkan dengan perentang baris atau koma",
  Recalculate_warehouse_rental_fees: "Kira semula yuran penyimpanan",
  Recalculate_manual_outbound_fees: "Kira semula yuran pengendalian penghantaran keluar manual",
  Recalculate_manual_warehousing_fees: "Kira semula yuran pengendalian penerimaan manual",
  Recalculate_the_return_item_listing_fee: "Kira semula yuran pengisian semula barangan dikembalikan",
  Recalculate_storage_fees: "Kira semula yuran pengendalian penerimaan",
  Recalculate_storage_order_operation_fees: "Kira Semula Yuran Pengendalian Pesanan Gudang",
  Please_select_the_delivery_time: "Sila pilih masa penghantaran",
  Copy_the_expense_settings_to_the_specified_warehouse: "Salin tetapan yuran ke gudang yang ditetapkan",
  Specify_the_customer: "Pelanggan yang Ditetapkan",
  Customers_who_need_to_be_copied: "Pelanggan yang memerlukan replikasi",
  If_you_do_not_select_it_it_means_that_all_customers_are_selected: "Jika tidak dipilih, semua pelanggan akan dipilih",
  Exclude_customers: "Pelanggan Dikecualikan",
  Excluded_customers: "Pelanggan yang dikecualikan",
  Specify_the_warehouse: "Gudang yang Ditetapkan",
  The_warehouse_that_was_copied: "Gudang yang direplikasi",
  Template_warehouse: "Gudang Templat",
  Specify_the_warehouse_from_which_the_data_originated: "Gudang yang menentukan sumber data",
  If_it_is_empty_it_is_equivalent_to_the_specified_warehouse: "Jika dibiarkan kosong, akan menggunakan gudang yang ditetapkan secara lalai",
  Template_customers: "Pelanggan Templat",
  Generate_the_header_fee_settings_according_to_the_specified_template: "Jana tetapan yuran penghantaran awal mengikut templat yang ditetapkan",
  The_type_of_expense: "Jenis Yuran",
  Order_Processing_Fees: "Yuran Pemprosesan Pesanan",
  Warehouse_rental_fee: "Yuran Sewa Gudang",
  Labelling_fee: "Yuran Pelabelan",
  Head_fee: "Yuran Penghantaran Awal",
  Packaging_material_fee: "Yuran Bahan Pembungkusan",
  Please_select_a_specified_warehouse: "Sila pilih gudang yang ditetapkan",
  Configure_at_least_one_item: "Sekurang-kurangnya satu mesti dikonfigurasikan",
  Adjust_the_price_of_the_first_leg_in_batches: "Batch Laras Harga Penghantaran Awal",
  Freight_costs: "Kos Kargo",
  OverRange_shipping_rates: "Kargo di Luar Julat",
  On_the_basis_of_the_original_treatment_the_positive_number_increases_the_price_and_the_negative_number_decreases_the_price: "Proses berdasarkan nilai asal: nombor positif meningkatkan harga, nombor negatif menurunkan harga",
  Copy_additional_service_fees: "Salin yuran perkhidmatan bernilai tambah",
  Specify_the_customer_from_which_the_data_originated: "Pelanggan sumber data yang ditetapkan",
  Please_select_a_module_type: "Sila pilih jenis modul",
  copy_approval_template: "Salin templat kelulusan",
  copy_template: "Salin templat",
  replace_approver: "Gantikan pengesah",
  Original_approver: "Pengesah asal",
  Approver: "Pengesah",
  Please_select_the_module_type_first: "Sila pilih jenis modul terlebih dahulu",
  Please_select_the_task_stage: "Sila pilih peringkat tugasan",
  Please_select_the_valueAdded_type: "Sila pilih jenis nilai tambah",
  Please_select_a_template_customer: "Sila pilih pelanggan templat",
  Please_select_a_template_warehouse: "Sila pilih gudang templat",
  modify_information: "Sunting Maklumat",
  receiving_SMS_number: "Nombor Penerimaan SMS",
  early_warning_balance: "Amaran Baki",
  whether_to_receive_SMS_messages: "Pilihan Penerimaan SMS",
  Not_less_than_zero: "Tidak boleh kurang daripada 0",
  wechat_binding_status: "Status Pengikatan WeChat",
  get_qrcode: "Dapatkan Kod QR",
  untie: "Batal Pengikatan",
  refresh_binding_status: "Segarkan Status Pengikatan",
  bound: "Telah Diikat",
  not_yet_bound: "Tidak Diikat",
  whether_to_untie: "Pilihan Batal Pengikatan",
  officialAccountPushLogs: "Senarai Log Hantar Akaun Rasmi",
  The_type_of_message: "Jenis Mesej",
  Push_status: "Status Hantar",
  Push_customers: "Dihantar Kepada",
  Push_content: "Kandungan Hantar",
  Push_time: "Masa Hantar",
  Push_the_OpenID: "OpenID Hantar",
  creator: "Pencipta",
  The_push_succeeded: "Hantar Berjaya",
  Push_failed: "Hantar Gagal",
  Please_enter_a_name_for_the_subAccount: "Sila Masukkan Nama Anak Akaun",
  Please_enter_your_mobile_phone_number: "Sila Masukkan Nombor Mudah Alih",
  Please_select_a_role: "Sila Pilih Peranan",
  Please_select_Enable_status: "Sila Pilih Status Aktif",
  role: "Peranan",
  roleGrade: "Tahap Peranan",
  Enabled_status: "Status Aktif",
  The_name_of_the_subAccount: "Nama Anak Akaun",
  Mobile_phone_number: "Nombor Mudah Alih",
  mailbox: "Alamat E-mel",
  Confirm_your_password: "Sahkan Kata Laluan",
  The_warehouse_to_which_it_belongs: "Gudang Berkaitan",
  Transit_warehouses: "Gudang Transit",
  Select_all: "Pilih Semua",
  operate: "Tindakan",
  Delete: "Padam",
  Please_enter_your_password: "Sila Masukkan Kata Laluan",
  Please_enter_your_password_correctly_first: "Sila Masukkan Kata Laluan Yang Betul Terlebih Dahulu",
  Please_enter_your_confirmation_password: "Sila Sahkan Kata Laluan",
  The_password_entered_twice_is_inconsistent: "Kata Laluan Yang Dimasukkan Tidak Sama",
  This_is_used_to_restrict_the_account_to_only_be_able_to_select_the_next_lower_role_level_when_creating_or_modifying_employee_accounts_during_operations_based_on_the_current_account_is_role_level: "Digunakan untuk mengehadkan operasi akaun semasa mencipta/memodifikasi akaun pekerja, membenarkan pemilihan hanya peranan satu peringkat di bawah tahap peranan akaun semasa",
  Modify_the_quality_inspection_quantity: "Ubah Suai Jumlah Pemeriksaan",
  When_there_is_a_labeled_quantity_prioritize_the_fee_deduction_and_the_refund_of_the_labeling_fee_to_avoid_double_deductions: "Apabila terdapat kuantiti yang telah dilabelkan terlebih dahulu, keutamaan diberikan kepada potongan yuran pemprosesan dan pemulangan yuran pelabelan untuk mengelakkan caj berganda",
  Please_enter_your_inquiry: "Sila masukkan butiran pertanyaan",
  Please_select_the_level_3_data_you_want_to_modify: "Sila pilih data peringkat ketiga untuk diubah suai",
  Select_the_data_in_the_same_task: "Sila pilih data di bawah tugasan yang sama",
  The_number_of_quality_inspections_cannot_be_greater_than_the_number_of_appointments: "Kuantiti pemeriksaan kualiti tidak boleh melebihi kuantiti yang ditempah",
  The_number_of_labels_cannot_be_greater_than_the_qualified_quantity: "Kuantiti label tidak boleh melebihi kuantiti yang layak",
  There_is_a_labeled_quantity: "Terdapat kuantiti yang telah dilabelkan terlebih dahulu",
  Whether_to_continue: "Teruskan?",
  The_operation_was_canceled: "Operasi dibatalkan",
  Please_check_the_secondary_data: "Sila pilih data peringkat kedua",
  Please_check_the_boxes_under_the_same_shipping_list: "Sila pilih kotak di bawah resit gudang yang sama",
  Please_select_the_products_in_the_same_task: "Sila pilih produk di bawah tugasan yang sama",
  Please_check_only_one_task: "Sila pilih satu tugasan sahaja",
  Please_tick_the_box: "Sila pilih",
  Please_check_only_one_inbound_order: "Sila pilih satu resit gudang sahaja",
  Please_check_the_Inbound_List_or_Inbound_List_box: "Sila pilih resit gudang atau kotak resit gudang",
  operation_cancelled: "Operasi dibatalkan",
  Complete_quality_inspection_in_batches: "Batch selesai pemeriksaan kualiti",
  The_quantity_to_be_inspected: "Kuantiti menunggu pemeriksaan",
  The_quantity_has_been_inspected: "Kuantiti diperiksa",
  sku: "SKU",
  inspected_quantity: "Kuantiti diperiksa",
  labelled_quantity: "Kuantiti dilabel",
  actual_length_cm: "Panjang sebenar (cm)",
  actual_width_cm: "Lebar sebenar (cm)",
  actual_height_cm: "Ketinggian sebenar (cm)",
  actual_weight_kg: "Berat sebenar (kg)",
  commodity_billing_attribute: "Atribut pengebilan produk",
  Confirm_quality_inspection_information: "Kesahkan butiran pemeriksaan kualiti",
  No_need_for_confirmation: "Tidak memerlukan pengesahan",
  to_be_confirmed: "Menunggu pengesahan",
  acknowledged: "Dikesahkan",
  Quality_inspection_information_status: "Status pemeriksaan kualiti",
  Confirm_the_actual_weight_length_width_height_and_whether_the_billing_attributes_of_the_goods_are_correct: "Sahkan bahawa berat sebenar, dimensi, dan atribut pengebilan produk adalah betul",
  Please_verify_the_actual_weight_dimensions_length_width_height_and_the_billing_attributes_of_the_goods_to_prevent_any_abnormal_deductions_of_fees: "Sila sahkan bahawa berat sebenar, dimensi, dan atribut pengebilan produk adalah betul untuk mengelakkan anomali pengebilan",
  Please_input_inspection_quantity: "Sila masukkan kuantiti pemeriksaan",
  please_input_unqualified_quantity: "Sila masukkan kuantiti tidak mematuhi",
  please_input_labeled_quantity: "Sila masukkan kuantiti yang dilabel",
  please_input_positive_number: "Sila masukkan nombor positif",
  please_input_qualified_quantity: "Sila masukkan kuantiti mematuhi",
  please_select_is_there_a_mark: "Sila pilih sama ada dilabel",
  please_input_actual_length: "Sila masukkan panjang sebenar",
  please_input_actual_width: "Sila masukkan lebar sebenar",
  please_input_actual_height: "Sila masukkan tinggi sebenar",
  please_input_actual_weight: "Sila masukkan berat sebenar",
  please_select_commodity_billing_attribute: "Sila pilih atribut pengebilan produk",
  please_input_quantity: "Sila masukkan kuantiti",
  appointment_quantity: "Kuantiti yang dijadualkan",
  whether_to_go_to_configure_warehouse_inbound_task_control_settings: "Mahu kami teruskan untuk mengkonfigurasi resit gudang bagi mendapatkan tetapan kawalan tugas?",
  please_check: "Sila tandakan",
  inspection_quantity_cannot_exceed_reserved_quantity: "Jumlah pemeriksaan tidak boleh melebihi jumlah tempahan",
  labeled_quantity_cannot_exceed_qualified_quantity: "Jumlah pelabelan tidak boleh melebihi jumlah yang layak",
  box_number: "Nombor kotak",
  special_commodity_confirm: "Barangan khas – sahkan?",
  box_number_error_please_reenter: "Nombor kotak tidak betul – sila masukkan semula",
  please_input_box_number: "Sila masukkan nombor kotak",
  please_input_goods_code: "Sila masukkan kod bar produk",
  current_box_number_no_goods_code: "Nombor kotak semasa tidak mengandungi kod bar produk ini",
  duplicate_sku_box_number: "Nombor kotak SKU dwi dikesan",
  operation_successful: "Operasi berjaya",
  product_entry_number: "Nombor resit",
  product: "Produk",
  has_labeled_quantity_continue: "Terdapat jumlah pelabelan sedia ada – teruskan?",
  please_input_real_length: "Sila masukkan panjang sebenar",
  please_input_real_width: "Sila masukkan lebar sebenar",
  please_input_real_height: "Sila masukkan tinggi sebenar",
  please_input_real_weight: "Sila masukkan berat sebenar",
  real_length_cm: "Panjang Sebenar (CM)",
  real_width_cm: "Lebar Sebenar (CM)",
  real_height_cm: "Tinggi Sebenar (CM)",
  real_weight_kg: "Berat Sebenar (KG)",
  commodity_chinese_name: "Nama Cina",
  commodity_english_name: "Nama Inggeris",
  labeled_quantity: "Kuantiti Label",
  this_time_labeled_quantity: "Kuantiti Pelabelan Semasa",
  There_is_an_incorrect_location_number: "ID Lokasi Penyimpanan Tidak Sah",
  Please_fill_it_out: "Sila Lengkapkan",
  shelved_quantity: "Kuantiti Letak Rak",
  recommended_storage_location_number: "Lokasi Penyimpanan Disyorkan",
  reserved_commodity_quantity: "Kuantiti Barangan Ditempah",
  Task_time: "Tempoh Tugas",
  set_priority_quality_inspection: "Tetapkan Pemeriksaan Keutamaan",
  pause_task: "Jeda Tugas",
  activate_task: "Aktifkan Tugas",
  modify_quality_inspection_num: "Ubah Kuantiti Pemeriksaan",
  to_be_generated: "Tunggak Penghasilan",
  uncompleted: "Belum Selesai",
  paused: "Jeda",
  Rebinding_task: "Tukar Pengikatan Tugas",
  Mandate_Holder: "Pelaksana Tugas",
  task_id: "ID Tugas",
  customer_id: "ID Pelanggan",
  task_executor: "Pelaksana Tugas",
  task_quality_inspection_start_time: "Masa Mula Pemeriksaan Kualiti Tugas",
  task_quality_inspection_end_time: "Masa Tamat Pemeriksaan Kualiti Tugas",
  total_reserved_quantity: "Jumlah Kuantiti Dijadualkan",
  total_qualified_quantity: "Jumlah Kuantiti Lulus",
  total_unqualified_quantity: "Jumlah Kuantiti Gagal",
  is_task_paused: "Jeda Tugas?",
  is_priority_quality_inspection: "Keutamaan Pemeriksaan Kualiti?",
  Rebinding: "Tugaskan Semula",
  is_excess_quality_inspection_task: "Tugas Pemeriksaan Berlebihan?",
  reserved_quantity: "Kuantiti Dijadualkan",
  excess_quantity: "Kuantiti Hantar Berlebihan",
  lack_send_quantity: "Kuantiti Hantar Kurang",
  breakage_quantity: "Kuantiti Rosak",
  is_wrongly_sent_sku: "SKU Tidak Betul?",
  Please_select_the_assignee: "Sila pilih pelaksana tugasan",
  original_qualified_quantity: "Kuantiti kelayakan asal",
  original_labeled_quantity: "Kuantiti label asal",
  original_lack_send_quantity: "Kuantiti kurang penghantaran asal",
  original_breakage_quantity: "Kuantiti rosak asal",
  please_select: "Sila tandakan",
  confirm_operation: "Kuatkan operasi?",
  prompt: "Prompt",
  cancel: "Batal",
  set_priority_shelves: "Tetapkan penyenaraian keutamaan",
  total_shelved_quantity: "Jumlah kuantiti yang disenaraikan",
  is_priority_shelves: "Penyenaraian keutamaan diaktifkan",
  batch_complete_shelves: "Selesaikan penyenaraian kelompok",
  shelves_layer: "Tingkat rak",
  shelves_column: "Lajur rak",
  shelves_cube: "Kapasiti",
  Mark_the_number_of_anomalies: "Tandakan kuantiti luar biasa",
  Please_enter_a_valid_number: "Sila masukkan nombor yang sah",
  Please_enter_an_integer_greater_than_0: "Sila masukkan integer yang lebih besar daripada 0",
  The_current_row_data_is_abnormal_The_qualified_quantity_cannot_be_less_than_the_quantity_that_has_been_put_on_the_shelves: "Anomali data baris semasa: Jumlah yang layak tidak boleh kurang daripada jumlah di rak",
  The_abnormal_quantity_cannot_exceed: "Jumlah anomali tidak boleh melebihi",
  Exchange_shipping_fee: "Yuran penghantaran pertukaran",
  Seller_shipping_discount: "Diskaun penghantaran penjual",
  TSP_commission: "Komisen TSP",
  Transportation_insurance_premium: "Yuran insurans pengangkutan",
  Credit_card_payment_processing_fee: "Yuran pemprosesan pembayaran kad kredit",
  SFP_service_fee: "Yuran perkhidmatan SFP",
  Ecological_donation: "Derma alam sekitar",
  Transportation_Service_Tax_SST: "Cukai perkhidmatan pengangkutan (SST)",
  Platform_adjustment_amount: "Jumlah pelarasan platform",
  TikTok_Coupons: "Baucar TikTok",
  TikTok_product_discounts: "Diskaun produk TikTok",
  Add_multiple_SKU: "Tambah SKU terlebih penghantaran",
  Add_wrongly_sent_SKU: "Tambah SKU salah penghantaran",
  preview_file: "Pratonton fail",
  all_file_number: "Jumlah fail",
  can_preview_file_number: "Fail boleh pratonton",
  can_not_preview_file_number: "Fail tidak boleh pratonton",
  current_preview_file: "Fail pratonton semasa",
  download_all: "Muat turun semua",
  download_file: "Muat turun fail",
  upload_file: "Muat naik fail",
  add_type_of_value_added_expense: "Tambah jenis yuran nilai tambah",
  type_of_value_added: "Jenis nilai tambah",
  revocation_time: "Masa pembatalan",
  can_preview: "Boleh pratonton",
  can_not_preview: "Tidak boleh pratonton",
  task_phase: "Tahap tugasan",
  customer_file: "Fail pelanggan",
  view_file: "Lihat fail",
  warehouse_file: "Fail gudang",
  a: "Barangan",
  freight: "Yuran penghantaran",
  special_expense: "Caj khas",
  revocation_operator: "Dibatalkan oleh",
  accomplish_operator: "Diselesaikan oleh",
  confirm_audit: "Sahkan ulasan",
  return_to_be_audit: "Kembalikan untuk ulasan",
  filename: "Nama Fail",
  value_added_task_id: "ID Tugas Nilai Tambah",
  whether_to_submit: "Diserahkan",
  cancelled_operation: "Dibatalkan",
  transfer_inventory_customer: "Pelanggan Pemindahan Inventori",
  whether_to_audit: "Disemak",
  whether_to_return_to_be_audit: "Dikembalikan untuk Disemak",
  only_can_upload: "Muat naik Sahaja",
  file_and_not_more_than_300_MB: "Fail tidak melebihi 300MB",
  add_expense_item: "Tambah Item Yuran",
  add_settings_of_value_added_expense: "Tambah Tetapan Yuran Nilai Tambah",
  default_expense: "Yuran Lalai",
  valueAddedServiceTask: "Tugas Perkhidmatan Nilai Tambah",
  operateValueAddedServiceTask: "Kelola Tugas Perkhidmatan Nilai Tambah",
  valueAddedServiceTaskDetail: "Butiran Tugas Perkhidmatan Nilai Tambah",
  valueAddedServiceFee: "Yuran Perkhidmatan Nilai Tambah",
  valueAddedServiceList: "Senarai Perkhidmatan Nilai Tambah",
  approverList: "Senarai Pengesah",
  approvalProcesstemplate: "Reka Bentuk Proses Kelulusan",
  Import_the_approval_process_template: "Kemasukan Reka Bentuk Proses Kelulusan",
  SKU_Inventory_Transfer: "Pemindahan Inventori SKU",
  Full_Inventory: "Semua Inventori",
  Transfer_the_entire_inventory_of_the_corresponding_SKU_in_the_system_to_the_specified_customer_in_all_warehouses_After_the_task_is_completed_the_product_barcode_and_SKU_will_have_a_suffix: "Memindahkan semua inventori SKU yang dinyatakan di semua gudang dalam sistem ke pelanggan yang ditetapkan. Setelah tugasan selesai, bar kod produk dan SKU akan disertakan dengan awalan.",
  Partial_Inventory: "Inventori Sebahagian",
  Transfer_the_specified_quantity_of_the_corresponding_SKU_in_the_system_to_the_specified_customer_Re_labeling_is_required: "Memindahkan kuantiti inventori yang dinyatakan untuk SKU yang ditetapkan dari sistem ke pelanggan yang ditetapkan. Memerlukan pelabelan semula.",
  Label_Removal: "Keluarkan Label",
  Common_scenarios_include_removing_the_specified_barcode_from_the_product_The_warehouse_will_re_price_this_task_based_on_the_difficulty_of_processing: "Senario biasa: Mengeluarkan bar kod yang dinyatakan daripada produk. Bergantung pada kerumitan, gudang mungkin menetapkan semula harga tugas ini.",
  Replace_Product_Barcode: "Gantikan Kod Bar produk",
  Replace_the_barcode_on_the_product_with_the_system_barcode_Common_scenarios_include_incorrect_barcode_content_mismatch_with_system_settings_damaged_barcode_stained_barcode_and_aged_barcode_that_cannot_be_recognized: "Gantikan kod bar produk dengan kod bar sistem. Senario biasa: kandungan kod bar yang salah, tidak sepadan dengan rekod sistem, kod bar rosak, kod bar bernoda, atau kod bar lama yang tidak dapat diimbas.",
  Replace_Other_Labels_on_Products: "Gantikan Label Lain pada Produk",
  Replace_the_labels_on_products_according_to_requirements_If_the_processing_is_complex_please_describe_it_clearly_or_provide_detailed_information_The_warehouse_will_re_price_this_task_based_on_the_difficulty_of_processing: "Proses penggantian label seperti yang diminta. Sekiranya proses ini kompleks, sila berikan penerangan yang jelas atau dokumentasi terperinci. Gudang akan menetapkan semula harga tugas ini berdasarkan kerumitan pemprosesan.",
  Processing: "Pemprosesan",
  Common_scenarios_include_processing_the_packaging_box_bubble_wrap_and_specified_products_transported_to_the_warehouse_If_it_is_complex_please_provide_a_detailed_operation_process_It_can_be_created_together_with_the_creation_of_the_inventory_receipt_or_added_as_a_value_added_service_before_the_inventory_receipt_starts_inspection: "Senario biasa: Memproses kotak pembungkusan dan bubble wrap yang dihantar ke gudang bersama produk yang ditetapkan. Untuk operasi yang kompleks, sila berikan arahan prosedur terperinci. Perkhidmatan ini boleh dibuat serentak dengan nota penerimaan barangan atau ditambah sebagai perkhidmatan nilai tambah sebelum pemeriksaan kualiti bermula.",
  Assembly: "Pemasangan",
  Common_scenarios_include_assembling_multiple_products_into_a_new_product_or_multiple_assemblies_of_products_and_adjusting_the_inventory_for_corresponding_shelf_up_and_shelf_down_operations_after_assembly_If_there_are_complex_assembly_operations_please_provide_detailed_explanations_and_example_files: "Senario biasa: Mengumpul beberapa item menjadi satu produk baharu, atau melakukan beberapa langkah pemasangan di mana tahap inventori disesuaikan dengan sewajarnya. Untuk prosedur pemasangan yang rumit, berikan penjelasan terperinci dan dokumentasi contoh.",
  transfer_customer_id: "Pindahkan ID Pelanggan",
  Transfer_inventory_to_use_current_label: "Pindahkan inventori menggunakan label semasa",
  If_selected_the_product_barcode_of_the_transferred_party_will_be_changed_to_the_current_SKU_barcode_If_not_selected_the_product_barcode_of_the_transferred_party_will_remain_unchanged: "Pilih 'Ya' untuk menukar kod bar item yang dipindahkan kepada kod bar SKU semasa selepas pemindahan. Pilih 'Tidak' untuk mengekalkan kod bar asal.",
  file: "Fail",
  select_inventory: "Pilih Inventori",
  Save_and_Submit: "Simpan dan Hantar",
  greater_than_0_number: "Nombor melebihi 0",
  batch_submit: "Hantar Berkumpulan",
  batch_return_to_be_audit: "Kembalikan Berkumpulan untuk Semakan",
  batch_revoke: "Cabut Semula Berkumpulan",
  batch_confirm: "Sahkan Berkumpulan",
  Confirm_revoke: "Sahkan Pencabutan?",
  The_remarks_are_the_same_as_the_original: "Keterangan sama seperti asal",
  task_info: "Maklumat Tugas",
  Audit_flow: "Proses Semakan",
  Joint_approval: "Lulus Bersama",
  Single_approval: "Lulus Individu",
  Process_flow: "Aliran Proses",
  Module_type: "Jenis Modul",
  processing: "Pemprosesan",
  add_flow: "Tambah Proses",
  edit_flow: "Sunting Proses",
  select_auditor: "Pilih Penilai",
  Audit_details: "Butiran Semakan",
  Approval_level: "Tahap Kelulusan",
  approver_Type: "Jenis Kelulusan",
  comfirm_delete: "Sahkan Pemadaman?",
  please_set_audit_flow: "Sila sediakan proses semakan",
  valueAddedServiceFeeDetail: "Butiran Yuran Perkhidmatan Nilai Tambah",
  addValueAddedServiceTask: "Buat Tugas Perkhidmatan Nilai Tambah",
  expense_deduction_details: "Butiran Pelarasan Yuran",
  createValueAddedServiceTask: "Buat Tugas Perkhidmatan Nilai Tambah",
  editValueAddedServiceTask: "Sunting Tugas Perkhidmatan Nilai Tambah",
  create_Task: "Buat Tugas",
  set_Audit_Flow: "Tetapkan Proses Semakan",
  return_Audit_Flow: "Batal Proses Semakan",
  batch_confirm_audit: "Sahkan Semakan Secara Berkumpulan",
  set_process_flow: "Tetapkan Aliran Kerja Pemprosesan",
  return_process_flow: "Batal Aliran Kerja Pemprosesan",
  batch_complete_task: "Lengkapkan Tugas Secara Berkumpulan",
  Edit_price: "Sunting Harga",
  Joint_audit: "Kelulusan Bersama",
  Single_audit: "Kelulusan Individu",
  add_approver: "Tambah Pengesah",
  print_task: "Cetak Tugas",
  view_audit_process: "Lihat Proses Kelulusan",
  view_process_flow: "Lihat Aliran Kerja Pemprosesan",
  confirm_complete_task: "Sahkan Penyiapan Tugas",
  billing_type: "Jenis Pengebilan",
  mark_Exception: "Tandakan sebagai Anomali",
  replenishmentTaskControl: "Kawalan Tugas Pengisian Semula",
  replenishmentList: "Senarai Tugas Pengisian Semula",
  Picking_storage_location_number: "ID Lokasi Pemungutan",
  Inventory_storage_location_number: "ID Lokasi Penyimpanan",
  Order_quantity_awaiting_replenishment: "Kuantiti Pesanan Menunggu Pengisian Semula",
  Replenishment_control_threshold_quantity: "Ambang Kuantiti Kawalan Pengisian Semula",
  Picking_items_below_the_threshold_based_on_the_current_inventory_quantity: "Tahap Stok Semasa di Bawah Ambang",
  Inventory_threshold_for_picking_warehouse_locations: "Ambang Stok untuk Lokasi Pemilihan",
  Number_of_task_varieties: "Bilangan Barangan dalam Tugas",
  No_recommended_storage_location_Default_replenishment_quantity_is_not_specified: "Kuantiti Pengisian Semula Lalai untuk Tiada Lokasi Disyorkan",
  Generate_replenishment_task: "Jana Tugas Pengisian Semula",
  Create_replenishment_task_control: "Buat Kawalan Tugas Pengisian Semula",
  Only_video_and_image_formats_are_supported_for_preview_for_other_types_of_files_please_download_them_and_view_them: "Hanya format video dan imej disokong untuk pratonton. Muat turun jenis fail lain untuk dilihat.",
  returnRemark: "Nota Pengembalian",
  The_length_of_this_note_does_not_exceed_2000_characters: "Panjang nota tidak boleh melebihi 2000 aksara",
  shopeeOnlineProductDetails: "Butiran Produk Dalam Talian Shopee",
  lazadaOnlineProductDetails: "Butiran Produk Dalam Talian Lazada",
  tiktokOnlineProductDetails: "Butiran Produk Dalam Talian TikTok",
  lazadaHostTheOnlineProductDetails: "Butiran Produk Dalam Talian Terurus Lazada",
  Shop_SKU: "SKU Kedai",
  Inventory_SKU: "SKU Inventori",
  Multi_attribute_ID: "ID Pelbagai Atribut",
  Pairing_Log: "Log Padanan",
  "Confirm_unpairing?": "Kesahkan_pencabutan?",
  Prompt: "Prompt",
  Confirm: "Kesahkan",
  Operation_successful: "Operasi Berjaya",
  Deletion_cancelled: "Pembatalan Pemadaman",
  Unpair: "Pencabutan",
  Online_SKU_Image: "Imej SKU Dalam Talian",
  Multi_attribute: "Pelbagai Atribut",
  Inventory_SKU_Image: "Imej SKU Inventori",
  Chinese_Name: "Nama Cina",
  English_Name: "Nama Inggeris",
  Store: "Kedai",
  Inventory_Sync_Time: "Masa Penyegerakan Inventori",
  Inventory_Sync_Quantity: "Kuantiti Penyegerakan Inventori",
  Online_SKU: "SKU Dalam Talian",
  Please_select_customer_first: "Sila pilih pelanggan terlebih dahulu",
  Please_check_only_one_item: "Sila tandakan satu pilihan sahaja",
  Inventory_synchronization_time: "Masa Penyegerakan Inventori",
  Inventory_synchronization_quantity: "Kuantiti Penyegerakan Inventori",
  Handover_task_order_number: "Nombor Pesanan Tugas Serahan",
  taskStatus: "Status Tugas",
  delivery_door: "Pintu Penghantaran",
  trailer_number: "Nombor Treler",
  handover_person: "Kakitangan Serahan",
  handover_start_time: "Masa Mulai Serahan",
  handover_end_time: "Masa Akhir Serahan",
  handover_attachments: "Lampiran Serahan",
  Ended: "Siap",
  handoverTime: "Masa Serahan",
  scan_the_flow_chart: "Urutan Imbasan",
  upload_attachments: "Muat naik Lampiran",
  print_handover_form: "Cetak Slip Serahan",
  scanTime: "Masa Imbasan",
  orderDetails: "Butiran Pesanan",
  handover_scanning_time: "Masa Imbasan Serahan",
  scan_people: "Pengimbas",
  create_handover_task: "Buat Tugas Serahan",
  end_handover_task: "Akhir Tugas Serahan",
  Are_you_sure_to_end_the_current_friendship_task: "Pastikan Tugas Serahan Semasa Berakhir?",
  end_handover_task_success: "Tugas Serahan Berakhir Dengan Jaya",
  created_successfully: "Penciptaan Berjaya",
  Please_enter_the_task_number: "Sila Masukkan Nombor Tugas",
  marking_can_be_posted_for_outbound_shipment: "Tandakan untuk Keluar Bermeterai",
  remove_the_label_from_the_outbound_shipment: "Keluarkan Keluar Bermeterai",
  selected_product: "Barangan Pilihan",
  can_be_posted_and_shipped_from_the_warehouse: "Gudang Keluar Bermeterai",
  batch_posting_outbound_information: "Maklumat Keluar Bermeterai Secara Batch",
  scan: "Imbas",
  batch_labeling_posting_and_outbound: "Tandakan Secara Batch untuk Keluar Bermeterai",
  batch_deletion_of_tags_stickers_and_outbound_shipments: "Padam Berkumpulan Penanda untuk Keluar Bermalakan Label",
  amount_money: "Jumlah",
  logisticsControlList: "Kawalan Serahan Logistik",
  Confirm_the_deletion_of_the_logistics_handover_processr: "Pastikan Pemadaman Serahan Logistik?",
  New_logistics_handover_added: "Tambah Serahan Logistik Baru",
  taskSchedulingList: "Senarai Jadual Tugas",
  taskLogList: "Senarai Log Tugas",
  serverList: "Senarai Pelayan",
  Task_name: "Nama Tugas",
  Task_type: "Jenis Tugas",
  Task_priority: "Keutamaan Tugas",
  Distribution_rules: "Peraturan Pengedaran",
  Port_path: "Laluan Pelabuhan",
  Minimum_running_memory: "Memori Operasi Minimum",
  Minimum_running_CPU: "CPU Operasi Minimum",
  Whether_it_is_enabled: "Aktifkan/Nyahlaktifkan",
  Asynchronous_distribution: "Pengedaran Asinkron",
  Scheduled_execution: "Pelaksanaan Dijadualkan",
  Periodical_execution: "Pelaksanaan Berkala",
  Last_run_start_time: "Masa Mulai Jalan Terakhir",
  Please_enter_a_name_for_the_task: "Sila masukkan nama tugasan",
  Please_enter_a_task_priority: "Sila masukkan keutamaan tugasan",
  Please_enter_a_distribution_rule: "Sila masukkan peraturan pengedaran",
  Please_enter_the_port_path: "Sila masukkan laluan pelabuhan",
  Please_enter_the_minimum_running_memory: "Sila masukkan RAM minimum",
  Please_enter_the_minimum_running_CPU: "Sila masukkan CPU minimum",
  Distribute_parameter_content: "Kandungan Parameter Pengedaran",
  Unusual_content: "Kandungan Pengecualian",
  Abnormal_time: "Masa Pengecualian",
  Server_status: "Status Pelayan",
  Server_name: "Nama Pelayan",
  Server_port: "Pelabuhan Pelayan",
  memory: "RAM",
  Update_the_server_information: "Kemas Kini Maklumat Pelayan",
  listWarehouseTransferTasks: "Senarai Tugasan Pemindahan Stok",
  Move_out_Of_Warehouse: "Gudang Keluar",
  Move_into_warehouse: "Gudang Masuk",
  Completion_time_warehouse_transfer: "Masa Penyempurnaan Pemindahan",
  Please_select_to_move_out_of_the_warehouse: "Sila pilih gudang keluar",
  Please_select_to_move_into_the_warehouse: "Sila pilih gudang destinasi",
  Moving_in_and_out_of_the_warehouse_is_not_allowed_to_be_repeated: "Gudang destinasi dan asal tidak boleh bertindih",
  Warehouse_transfer_task_number: "ID tugas pemindahan",
  Remove_warehouse_location_number: "Nombor ruang asal",
  Move_into_storage_location_number: "Nombor ruang destinasi",
  Create_warehouse_transfer_task: "Buat tugas pemindahan",
  addWarehouseTransferTaskBtn: "Buat tugas pemindahan",
  edit_warehouse_transfer_task: "Sunting tugas pemindahan",
  Warehouse_transfer_type: "Jenis pemindahan",
  Partial_warehouse_transfer: "Pemindahan sebahagian",
  All_positions_transferred: "Pemindahan penuh",
  Warehouse_transfer_information: "Butiran pemindahan",
  Move_out_warehouse_location: "Nombor ruang asal",
  Move_into_storage_location: "Nombor ruang destinasi",
  Please_select_the_type_of_warehouse_transfer: "Sila pilih jenis pemindahan",
  Please_select_the_storage_location_number_to_be_moved_into: "Sila pilih nombor ruang destinasi",
  Select_the_goods_that_need_to_be_transferred: "Pilih item yang akan dipindahkan",
  Quickly_plan_storage_locations: "Perancangan Ruang Pantas",
  Please_select_the_goods_that_require_rapid_planning_of_storage_locations: "Sila pilih item yang memerlukan perancangan ruang pantas",
  Only_virtual_and_temporary_storage_locations_can_be_used_at_this_location_The_virtual_and_temporary_storage_locations_of_this_warehouse_are_empty_Please_create_the_corresponding_virtual_and_temporary_storage_locations_for_the_warehouse_and_then_refresh_again: "Hanya ruang maya dan sementara boleh digunakan di sini. Ruang maya/sementara gudang ini kosong. Sila cipta ruang maya/sementara yang sepadan untuk gudang ini sebelum menyegarkan semula dan mencuba lagi",
  The_number_of_listings_cannot_exceed_the_inventory_quantity_The_current_inventory_quantity_is: "Kuantiti stok tidak boleh melebihi kuantiti inventori. Kuantiti inventori semasa ialah",
  Select_a_store: "Pilih Kedai",
  If_the_shipping_address_in_the_store_is_backend_is_not_consistent_with_the_system_warehouse_address_it_cannot_be_selected_Please_go_to_the_store_authorization_page_to_confirm: "Tidak boleh dipilih jika alamat penghantaran belakang kedai berbeza dengan alamat gudang sistem. Sila semak di halaman kebenaran kedai.",
  Shop_shipping_warehouse: "Gudang Penghantaran Kedai",
  Clear_all: "Kosongkan Semua",
  No_data_obtained: "Data tidak diperoleh",
  Selected_store: "Kedai dipilih",
  synchronousInventorySettingList: "Senarai Tetapan Inventori Disegerakkan",
  synchronousInventoryLogList: "Senarai Log Inventori Disegerakkan",
  synchronousInventoryAnomaly: "Anomali Inventori Disegerakkan",
  synchronousInventoryProductList: "Senarai Penyegerakan Inventori Produk Dalam Talian",
  store: "Kedai",
  online_sku: "SKU Dalam Talian",
  multi_attribute_id: "ID Serba-serbi",
  multi_attribute: "Serba-serbi",
  inventory_sku: "SKU Inventori",
  sync_time: "Masa Penyegerakan",
  online_sku_image: "Imej SKU Dalam Talian",
  sync_inventory_quantity: "Kuantiti Inventori Disegerakkan",
  rule_name: "Nama Peraturan",
  inventory_allot_policy: "Strategi Peruntukan Inventori",
  modifier: "Pengubah",
  create_time: "Masa Penciptaan",
  modify_time: "Masa Pengubahsuaian",
  create: "Buat",
  set_non_sync_online_products: "Konfigurasikan Pengecualian Produk Dalam Talian",
  The_creation_and_modification_rules_will_not_take_effect_immediately_Please_wait_patiently: "Penciptaan/pengubahsuaian peraturan tidak akan berkuat kuasa serta-merta; sila bersabar.",
  Only_online_products_that_have_been_paired_with_inventory_SKUs_will_be_synchronized: "Hanya produk dalam talian dengan SKU inventori yang sepadan akan disegerakkan.",
  Inventory_threshold: "Ambang Inventori",
  Sync_store_range: "Sinkronisasi Skop Kedai",
  Sync_SKU_ranges: "Sinkronisasi Skop SKU",
  Recent_run_time: "Masa Jalan Terakhir",
  Sync_specified_policy_inventory: "Sinkronisasi Inventori Strategi Terpilih",
  The_quantity_of_available_inventory_at_that_time: "Kuantiti Inventori Tersedia pada Masa",
  The_available_inventory_quantity_during_the_synchronization_process: "Kuantiti inventori tersedia pada masa pelaksanaan penyelarasan",
  Synchronized_item_ID: "ItemId Sejarah",
  synchronous_regimes: "Status Sinkronisasi",
  synchronous_messages: "Mesej Sinkronisasi",
  The_name_of_the_inventory_updateable_strategy: "Nama Strategi untuk Kemas Kini Inventori",
  Inventory_synchronization_strategy: "Strategi Sinkronisasi Inventori",
  Inventory_synchronization_strategy_value: "Nilai Strategi Sinkronisasi Inventori",
  ExportOrderTraceTaskList: "Butiran Serah Logistik",
  Are_you_sure_to_modify_the_processing_plan: "Sahkan Penyelesaian Pengendalian Pengubahsuaian",
  The_task_number_selection_is_inconsistent_please_choose_again: "Pilihan ID Tugas tidak konsisten, sila pilih semula",
  Only_products_with_inventory_quantity_greater_than_0_and_inventory_quantity_greater_than_the_occupied_inventory_quantity_can_be_selected: "Hanya pilih item dengan kuantiti stok > 0 dan kuantiti stok > kuantiti stok yang diduduki",
  There_are_not_enough_suitable_storage_locations_for_the_user_please_choose_on_your_own: "Tiada lokasi penyimpanan yang sesuai mencukupi; sila pilih secara manual",
  Import_warehouse_order: "Import pesanan gudang",
  Do_you_want_to_cancel_the_selected_warehouse_transfer_task: "Kesahihan pembatalan tugas pemindahan yang dipilih",
  Have_you_completed_the_warehouse_relocation_task: "Kesahihan penyempurnaan tugas pemindahan",
  Has_the_status_of_pending_reception_confirmed: "Kesesuaian status berubah kepada 'Menunggu Penerimaan'",
  Please_first_select_the_warehouse_transfer_task_that_needs_to_be_revoked: "Sila pilih tugas pemindahan yang akan dibatalkan terlebih dahulu",
  Are_you_sure: "Kesahkan",
  completeWarehouseRelocation: "Pemindahan Siap",
  exportTransferTask: "Eksport Tugas Pemindahan",
  transfer_task_list: "Senarai Tugas Pemindahan",
  AdjustTheWarehouseRelocationTaskLocation: "Laras Lokasi Penyimpanan Tugas Pemindahan",
  Print_the_inventory_transfer_list: "Cetak Senarai Pemindahan",
  Print_transfer_and_packing_information: "Cetak Maklumat Pembungkusan Pemindahan",
  exportWarehouseInventoryInformation: "Eksport Maklumat Inventori Gudang",
  Only_one_warehouse_transfer_task_can_be_selected: "Hanya satu tugas pemindahan boleh dipilih",
  Export_existing_inventory: "Eksport Inventori Semasa",
  Export_all_inventory: "Eksport Semua Inventori",
  Please_select_the_relocation_task: "Sila pilih tugas pemindahan",
  binning: "Pemisahan Kotak",
  Please_download_from_the_task_center_in_five_minutes: "Sila muat turun dari Pusat Tugas selepas lima minit",
  server_storage_address: "Alamat penyimpanan pelayan",
  Please_add_product_details_first: "Sila tambah butiran produk terlebih dahulu",
  Please_select_products_with_SKU_and_location_numbers_that_are_not_the_same: "Sila pilih produk dengan kod SKU dan lokasi yang berbeza",
  Profit_Order_payment_for_product_amount_Refund_Actual_Freight_Seller_Paid_Freight_Platform_Freight_Subsidy_Exchange_Freight_Seller_Freight_Discount_TSP_Commission_Platform_Commission_Alliance_Commission_Transaction_Fees_SFP_Service_Fees_Service_Fees_Additional_Plan_Service_Fees_Logistics_Insurance_Fees_Freight_Service_Tax_SST_Value_Added_Tax_VAT_Product_Service_Tax_Seller_Discount_Coupons_Return_Order_Freight_Other_Platform_Fees_Credit_Card_Payment_Fees_Platform_Adjustment_Amount_Ecological_Donations_Fees_Refund_Product_Amount_Return_Order_Return_Freight_x_Exchange_Rate_Product_Procurement_Cost_Initial_Freight_Warehouse_Rent_Listing_Fee_Order_Processing_Fee: "Keuntungan = (Jumlah produk yang dipesan - Pengembalian - Kos penghantaran sebenar + Penghantaran dibayar penjual + Biasiswa penghantaran platform - Kos penghantaran pertukaran - Diskaun penghantaran penjual - Komisen TSP - Komisen platform - Komisen gabungan - Yuran transaksi - Yuran perkhidmatan SFP - Yuran perkhidmatan - Yuran perkhidmatan pelan tambahan - Yuran insurans logistik - Cukai perkhidmatan penghantaran (SST) - Cukai Nilai Tambah (VAT) - Cukai Perkhidmatan Produk - Baucar diskaun penjual - Kos penghantaran pesanan dikembalikan - Yuran platform lain - Yuran pemprosesan kad kredit + Jumlah pelarasan platform - Sumbangan ekosistem - Yuran pengendalian - Jumlah produk dikembalikan - Pampasan balik penghantaran pesanan dikembalikan) × Kadar pertukaran - (Kos perolehan produk + kos penghantaran awal + sewa gudang + yuran penyenaraian + yuran pemprosesan pesanan)",
  The_value_added_tax_paid_by_the_platform_on_behalf_of_the_buyer_import_value_added_tax_value_added_tax_paid_by_the_platform_on_behalf_of_the_seller: "Cukai Nilai Tambah (CGT) dibayar oleh platform bagi pihak pembeli + CGT import + CGT dibayar oleh platform bagi pihak penjual",
  Return_order_return_fee: "Yuran penyimpanan semula pesanan dikembalikan",
  When_the_original_currency_conversion_profit_financial_currency_exchange_rate_of_the_store_is_not_set_the_system_will_not_perform_data_synchronization_After_setting_the_data_will_be_synchronized_after_24_00_on_the_same_day: "Apabila kadar penukaran mata wang asal kedai untuk mata wang kewangan keuntungan tidak ditetapkan, sistem tidak akan menyegerakkan data. Setelah ditetapkan, data akan disegerakkan selepas pukul 24:00 pada hari yang sama.",
  Gold_coin_deduction: "Potongan syiling emas",
  Platform_preferential_subsidies: "Bantuan subsidi promosi platform",
  Installment_payment_handling_fee: "Yuran pengendalian bayaran ansuran",
  Sellers_free_shipping_promotion_fee_refund_of_shipping_fee_to_customer_shipping_subsidy_provided_by_seller_seller_pays_for_shipping_fee: "Kos promosi penghantaran percuma penjual + kos penghantaran yang dikembalikan kepada pelanggan + subsidi penghantaran yang disediakan oleh penjual + kos penghantaran yang dibayar oleh penjual",
  The_total_amount_of_other_expenses_not_shown_such_as_FBI_project_processing_fees_buyer_review_incentives_LazFlash_additional_daily_subsidies_below_9_99_etc: "Jumlah yuran lain yang tidak dipaparkan, contohnya: yuran pemprosesan projek FBI, insentif ulasan pembeli, subsidi tambahan/harian LazFlash di bawah $9.99, dan lain-lain.",
  starting_inventory: "Inventori permulaan (≥)",
  Terminate_inventory: "Inventori akhir (<)",
  Inventory_allocation_strategy: "Strategi peruntukan inventori",
  Inventory_update_value: "Nilai kemas kini inventori",
  Fixed_value: "Nilai tetap",
  Percentage: "Peratusan",
  schema: "Mod",
  Add_the_maximum_inventory_range: "Tambah julat inventori maksimum",
  Shop_back_end: "Belakang kedai",
  Mapping_warehouse_address: "Alamat gudang yang dipetakan",
  ship_address: "Alamat penghantaran",
  Create_a_strategy: "Buat dasar",
  Manually_synchronize_the_specified_strategy: "Seragamkan secara manual dasar yang ditetapkan",
  Inventory_warning_threshold: "Ambang amaran inventori",
  resynchronization: "Seragamkan semula",
  Latest_synchronization_time: "Masa seragaman terakhir",
  Synchronous_logs: "Log seragaman",
  The_shipping_address_in_the_store_is_back_end_must_be_exactly_the_same_as_the_warehouse_address_If_they_are_not_the_same_please_modify_it_in_the_store_is_back_end_and_then_click_the_Manually_Synchronize_Warehouse_button: "Alamat penghantaran di belakang kedai mesti sepadan tepat dengan alamat gudang. Jika terdapat perbezaan, sila ubah suai belakang kedai dan klik butang seragaman gudang manual",
  The_fixed_value_strategy_is_a_fixed_quantity_and_the_percentage_strategy_is_a_percentage_of_the_current_available_inventory: "Dasar nilai tetap menggunakan kuantiti tetap; dasar peratusan menggunakan peratusan inventori tersedia semasa",
  The_creation_modification_manual_synchronization_of_the_policy_will_be_completed_within_half_an_hour: "Penciptaan/Pembetulan/Penciptaan/Pembetulan/Sinkronisasi Manual dasar akan selesai dalam masa setengah jam.",
  Please_check_the_synchronization_status_in_the_synchronization_inventory_log_list: "Sila semak status sinkronisasi dalam senarai log inventori yang disinkronkan.",
  Only_the_online_products_that_have_been_matched_with_the_inventory_SKUs_will_be_synchronized: "Hanya produk dalam talian dengan SKU inventori yang sepadan akan disinkronkan.",
  The_shipping_address_in_the_store_is_backend_must_be_exactly_the_same_as_the_warehouse_address_in_the_system: "Alamat penghantaran di backend kedai mesti sepadan tepat dengan alamat gudang sistem.",
  Maximum_synchronized_inventory: "Inventori Maksimum yang Boleh Disinkronkan",
  total_inventory: "Jumlah Inventori",
  Unshipped_inventory: "Inventori Belum Dihantar",
  Warehouse_orders_include_those_that_have_been_shipped_delivered_invalidated_cancelled_and_those_that_match_the_total_quantity_of_the_corresponding_SKUs: "Pesanan gudang kecuali yang telah dihantar, dihantar keluar, dibatalkan, dibatalkan, atau kuantiti SKU yang sepadan",
  The_maximum_synchronizable_inventory_quantity_for_a_combined_SKU_is_equal_to_the_lowest_inventory_quantity_among_the_SKUs_in_the_combination: "Inventori maksimum yang boleh diselaraskan untuk SKU komposit adalah sama dengan tahap stok terendah dalam komposit tersebut",
  Select_store: "Pilih Kedai",
  Specified_SKUs: "Nyatakan SKU",
  To_prevent_over_selling_when_the_synchronized_inventory_falls_below_the_warning_threshold_the_system_will_automatically_set_the_inventory_quantity_to_0: "Untuk mengelakkan jualan berlebihan, apabila inventori yang boleh diselaraskan jatuh di bawah ambang amaran, sistem secara automatik menetapkan kuantiti yang boleh diselaraskan kepada sifar",
  Set_inventory_alert_threshold_100_Current_maximum_available_inventory_99_Below_the_inventory_alert_threshold_the_system_synchronizes_the_inventory_quantity_to_0: "Contoh: Tetapkan ambang amaran inventori: 100. Inventori maksimum tersedia semasa: 99. Di bawah ambang amaran, sistem menyegerakkan kuantiti inventori kepada 0.",
  Input_the_synchronous_inventory_range_interval_When_the_quantity_of_synchronous_inventory_falls_within_this_range_the_system_will_synchronize_based_on_the_set_synchronization_strategy_and_the_synchronous_inventory_quantity: "Masukkan julat inventori yang boleh diselaraskan. Apabila kuantiti berada dalam julat ini, sistem akan menyegerakkan berdasarkan strategi dan kuantiti yang dikonfigurasikan.",
  Add_asynchronous_online_products: "Tambah produk dalam talian yang tidak diselaraskan",
  Asynchronous_online_product_logs: "Log produk dalam talian yang tidak diselaraskan",
  This_operation_will_permanently_delete_Do_you_want_to_continue: "Tindakan ini akan memadam item ini secara kekal. Teruskan?",
  contractList: "Senarai Kontrak",
  contractDetail: "Butiran Kontrak",
  The_name_of_the_contract: "Nama Kontrak",
  Contract_number: "Nombor Kontrak",
  Type_of_contract: "Jenis Kontrak",
  Initiation_time: "Tarikh Permulaan",
  Signing_time: "Tarikh Tandatangan",
  Expiration_time: "Tarikh Luput",
  voided_ontract: "Pembatalan Kontrak",
  Rejection_contract: "Penolakan Kontrak",
  Activate_the_contract: "Pengaktifan Kontrak",
  contractSubject: "Tukar Senarai Entiti",
  Apply_for_switching_the_entity: "Minta Tukar Entiti",
  Rejection_time: "Tarikh Penolakan",
  Those_who_rejected_it: "Pihak Penolak",
  Reason_for_Rejection: "Alasan Penolakan",
  Details_of_the_Supplementary_Agreement: "Butiran Perjanjian Tambahan",
  downLoadContract: "Muat turun Kontrak",
  Please_select_the_customer_type: "Sila pilih jenis pelanggan",
  E_signature_Treasure_Authorization_Status: "Status Kebenaran eDua Tangan",
  Invalid_review: "Kaji Semula Pembatalan",
  Review_rejected: "Kaji Semula Penolakan",
  Parent_Contract_Number: "Nombor Kontrak Induk",
  Is_it_the_contracting_party: "Adakah ini pihak kontraktor?",
  Without_signing_the_contract_all_functions_will_be_prohibited: "Kontrak yang tidak ditandatangani sebelum tarikh akhir akan menyahaktifkan semua fungsi",
  protocolCode: "Kod Perjanjian",
  Has_the_contract_and_user_information_been_verified_to_be_correct_and_approved_for_review: "Adakah anda telah mengesahkan maklumat kontrak dan pengguna adalah tepat? Sahkan kelulusan?",
  Sign_expiration_date: "Tarikh Luput Tandatangan",
  Signing_link_expiration_date: "Tarikh Luput Pautan Tandatangan",
  Please_contact_your_dedicated_investment_manager_to_review_the_contract_information: "Sila hubungi pengurus akaun khusus anda untuk menyemak butiran kontrak.",
  Whether_to_automatically_renew: "Pembaharuan Automatik",
  Used_for_subsequent_billing_and_invoicing_functions_of_the_system_account: "Diperlukan untuk fungsi pengebilan dan penyediaan invois akaun sistem seterusnya",
  The_phone_number_of_the_current_contract_signatory_otherwise_the_contract_cannot_be_successfully_signed: "Nombor telefon bimbit yang didaftarkan di bawah nama penandatangan semasa; jika tidak, penandatanganan kontrak akan gagal",
  Real_QQ_WeChat_contact_with_our_company_otherwise_the_contract_cannot_be_successfully_signed: "Butiran hubungan QQ/WeChat yang sah untuk syarikat kami; jika tidak, penandatanganan kontrak akan gagal",
  addcompany: "Tambah Syarikat",
  Sign_contract_documents: "Bahan Penandatanganan Kontrak",
  qq_wehat__non_nickname: "QQ/WeChat (bukan nama samaran)",
  Company_Name: "Nama Syarikat",
  contracting_entity: "Entiti Penandatangan",
  Do_you_want_to_apply_for_switching_subjects: "Permintaan untuk Menukar Entiti?",
  Please_contact_the_investment_promotion_review_to_switch_the_subject_application: "Sila hubungi Pembangunan Perniagaan untuk semakan permohonan pertukaran entiti",
  deadline: "Tarikh Tutup",
  Is_the_selected_contract_to_be_reviewed: "Status Kelulusan",
  Whether_to_void_the_selected_contract: "Status Pembatalan",
  Note_To_ensure_the_legal_validity_of_the_contract_please_verify_the_accuracy_of_relevant_materials: "Nota: Untuk memastikan kesahihan undang-undang kontrak, sila sahkan ketepatan semua maklumat berkaitan",
  Inventory_information: "Maklumat Pesanan Stok",
  Product_Details: "Butiran Produk",
  suggest_types: "Jenis Cadangan",
  stock_up_suggestions: "Cadangan Stok",
  shortage_suggestion: "Cadangan Habis Stok",
  generate_a_backup_order: "Jana Pesanan Stok",
  Total_number_of_products_awaiting_review: "Jumlah Item Tunggakan Semakan",
  Planned_stocking_inventory: "Inventori Stok Dirancang",
  Sales_volume_7_14_30_60_90: "Jumlah Jualan (7/14/30/60/90 hari)",
  Daily_average_sales_in_the_past_30_days: "Purata Jualan Harian (30 hari terakhir)",
  Stock_quantity: "Kuantiti Stok",
  Minimum_reserve_price: "Harga Stok Minimum",
  Last_stocking_price: "Harga Stok Sebelumnya",
  Reserve_currency_type: "Mata Wang Stok",
  Stock_unit_price: "Harga Unit Stok",
  In_stock: "Dalam Penyimpanan",
  Total_stocking_price: "Jumlah Kos Penyimpanan",
  Stock_quantity_times_Stock_unit_price: "Kuantiti Penyimpanan × Harga Unit Penyimpanan",
  The_stage_of_inventory_management_is_equal_to_the_total_number_of_matching_SKUs_in_the_pending_review_and_inventory_process: "Pengurusan Pesanan Penyimpanan: Tahap sama dengan 'Menunggu Kelulusan', 'Dalam Penyimpanan', jumlah kuantiti SKU yang sepadan",
  Daily_sales_in_the_past_30_days_purchase_days_warning_inventory_total_inventory_in_transit_inventory_if_less_than_0_display_0: "Jualan Harian (30 hari lepas) × Hari Perolehan + Stok Amaran - Jumlah Stok - Stok Dalam Penghantaran; memaparkan 0 jika negatif",
  By_default_it_is_equal_to_the_currency_of_the_last_stocking_If_not_available_it_is_RMB_which_can_be_modified: "Mata wang lalai ialah mata wang pengisian semula terakhir; jika tidak, RMB. Boleh diubah.",
  By_default_it_is_equal_to_the_unit_price_of_the_last_stocking_If_not_available_it_is_the_purchase_price_of_the_product_which_can_be_modified: "Harga unit lalai ialah harga unit pengisian semula terakhir; jika tidak, harga pembelian produk. Boleh diubah.",
  Completed_the_last_completed_stocking_unit_price_for_matching_SKUs: "Siap: Harga unit pengisian semula terakhir untuk SKU yang sepadan.",
  Starting_time_of_stocking: "Tarikh Mula Pengisian Semula",
  Please_select_the_start_time_for_stocking: "Sila pilih tarikh mula pengisian semula",
  Completed_matching_the_lowest_stocking_unit_price_for_SKU: "Siap, harga unit pengisian semula terendah yang sepadan dengan SKU",
  Please_select_products_from_the_same_warehouse: "Sila pilih produk dalam stor yang sama",
  Stock_order_number: "Nombor pesanan pengisian semula",
  Stockist: "Kakitangan pengisian semula",
  LeadTime: "Masa pengisian semula",
  supplier: "Pembekal",
  Platform_order_status: "Status pesanan platform",
  Subtotals_of_pre_discount_products: "Jumlah produk sebelum diskaun",
  Subtotals_of_discount_products: "Jumlah produk selepas diskaun",
  Not_involved_in_order_profit_calculation_for_operational_analysis_reference_only_seller_discounts_product_discounts_flash_purchases_buy_more_save_more_vouchers_and_bundled_transactions: "Tidak dimasukkan dalam pengiraan keuntungan pesanan; hanya untuk rujukan analisis operasi. Diskaun penjual (diskaun produk, jualan kilat, penjimatan pukal, baucar, dan transaksi pakej)",
  The_data_at_this_stage_is_the_original_data_before_merging_the_stocking_list_for_reference_only: "Data pada peringkat ini mewakili angka mentah sebelum penggabungan pesanan dan hanya untuk rujukan.",
  When_the_financial_currency_exchange_rate_for_converting_profits_from_the_original_currency_of_the_store_is_not_set_the_system_will_not_perform_data_synchronization_After_setting_the_previous_days_data_will_be_synchronized_after_24_00_on_the_same_day_only_for_orders_that_have_been_shipped_out_Profit_data_will_continue_to_be_updated_in_the_early_morning_until_the_settlement_time_of_platform_orders_is_updated: "Apabila tiada kadar pertukaran ditetapkan untuk menukarkan keuntungan mata wang kedai ke mata wang kewangan, sistem tidak akan menyegerakkan data. Setelah ditetapkan, data dari hari sebelumnya akan disegerakkan selepas tengah malam, terhad kepada pesanan yang telah dihantar sahaja. Angka keuntungan akan dikemas kini secara berterusan sepanjang malam sehingga penyelesaian pesanan platform mencetuskan kemas kini.",
  When_the_financial_currency_exchange_rate_for_converting_profits_from_the_original_currency_of_the_store_is_not_set_the_system_will_not_perform_data_synchronization_After_setting_it_the_previous_days_data_will_be_synchronized_after_24_00_on_the_same_day_Only_orders_that_have_been_issued_and_bills_have_been_generated_will_be_synchronized_Profit_data_will_be_updated_in_the_early_morning_when_bills_are_generated_and_the_settlement_time_will_be_based_on_the_last_time_bills_are_generated: "Apabila kadar pertukaran untuk menukar keuntungan dalam mata wang asal kedai ke mata wang kewangan tidak dikonfigurasikan, sistem tidak akan menyegerakkan data. Setelah dikonfigurasikan, data dari hari sebelumnya akan disegerakkan selepas pukul 24:00 pada hari semasa. Hanya pesanan yang telah dihantar dan telah dijana invois akan disegerakkan. Data keuntungan akan dikemas kini pada awal pagi apabila invois dijana, dengan masa penyelesaian adalah masa invois terakhir dijana.",
  Exchange_rate_setting: "Konfigurasi Kadar Pertukaran",
  Total_quantity_of_stocked_goods: "Jumlah Kuantiti Barangan Perolehan",
  Total_number_of_stocked_goods: "Jumlah Jenis Barangan Perolehan",
  Total_price_of_the_purchase_order: "Jumlah Nilai Pesanan Perolehan",
  Total_cubic_meter_of_inventory_M_three: "Jumlah Isipadu Perolehan (m³)",
  Total_weight_of_stock_KG: "Jumlah Berat Perolehan (kg)",
  Ending_time_of_stocking: "Masa Penyiapan Perolehan",
  Real_payment_amount: "Jumlah Bayaran Sebenar",
  Stocking_remarks: "Nota Perolehan",
  Total_cubic_meters_of_goods_M_three: "Jumlah Meter Padu Barangan (m³)",
  Total_weight_of_the_product_KG: "Jumlah Berat Barangan (kg)",
  Merge_backup_documents: "Gabungkan Pesanan Penimbunan",
  Are_you_sure_to_merge_the_selected_backup_orders: "Sahkan Gabungan Pesanan Penimbunan Pilihan",
  Change_to_void_status: "Ubah Status kepada Dibatalkan",
  Change_the_status_to_abnormal: "Ubah Status kepada Tidak Normal",
  Change_status_to_return: "Ubah Status kepada Dikembalikan",
  Submit_to_stocking: "Hantar ke Barisan Penimbunan",
  Have_you_submitted_it_to_the_inventory: "Hantar ke Barisan Penimbunan",
  Submit_to_Completed: "Hantar ke Siap",
  SKUs_that_have_not_been_stocked_will_not_be_displayed_on_this_page: "SKU yang belum diterima ke dalam stok tidak akan muncul di halaman ini",
  Please_select_a_backup_order_to_print: "Sila pilih pesanan penimbunan untuk dicetak",
  Inventory_quantity_if_there_is_real_length_width_and_height_it_is_real_length_real_width_real_height_if_there_is_no_real_length_width_and_height_it_is_length_width_height_100000_if_less_than_0_001_it_is_equal_to_0_001: "Jumlah Stok * (Jika panjang/lebar/tinggi sebenar wujud: Panjang Sebenar × Lebar Sebenar × Tinggi Sebenar; jika tidak: Panjang × Lebar × Tinggi) / 1,000,000. Jika kurang daripada 0.001, dianggap 0.001",
  If_there_is_a_true_weight_the_stock_quantity_multiplied_by_the_true_weight_If_not_available_stock_quantity_weight: "Jika berat sebenar wujud: Jumlah Stok × Berat Sebenar. Jika tidak: Jumlah Stok × Berat",
  Append_contract: "Tambah Kontrak",
  AppendContract: "Tambah Kontrak",
  Add_supplementary_agreement: "Tambah Perjanjian Tambahan",
  Add_an_ancillary_agreement_template: "Tambah Templat Perjanjian Tambahan",
  Addendum_to_the_subcontract: "Tambah Sub-Kontrak",
  Please_select_the_addendum_contract: "Sila pilih kontrak tambahan",
  contract: "Kontrak",
  To_be_signed: "Menunggu Tandatangan",
  To_be_signed_contract: "Kontrak Menunggu Tandatangan",
  Go_to_sign: "Teruskan untuk Menandatangani",
  You_have_contracts_to_sign: "Anda mempunyai kontrak yang menunggu tandatangan. Mahu diteruskan?",
  Add_contract_template: "Tambah Templat Kontrak",
  Edit_contract_template: "Sunting Templat Kontrak",
  Template_chinese_name: "Nama Templat (Cina)",
  Template_english_name: "Nama Templat (Inggeris)",
  Audit_contract: "Kaji Semula Kontrak",
  Credit_limit: "Had Kredit",
  Online_product_status: "Status Produk Dalam Talian",
  The_store_product_data_status_for_synchronizing_inventory_will_be_automatically_synchronized_at_least_once_a_day_and_other_unconfigured_items_need_to_be_manually_synchronized: "Konfigurasikan inventori diselaraskan untuk data produk kedai. Kemas kini status diselaraskan secara automatik sekurang-kurangnya sekali sehari. Item yang tidak dikonfigurasikan memerlukan pengambilan semula secara manual.",
  Online_product_matching: "Pairing Produk Dalam Talian",
  Batch_Online_product_matching: "Batch Pairing Produk Dalam Talian",
  receiveWarehousePermissions: "Kebenaran Gudang Penerimaan",
  Choose_zones_and_shelves_for_quick_planning: "Pilih Zon Perancangan Pantas dan Rak",
  If_a_partition_or_shelf_is_selected_only_unused_shelves_under_that_partition_or_shelf_will_be_recommended_If_partitioning_or_shelving_is_not_selected_it_will_be_recommended_that_the_corresponding_customer_s_receiving_warehouse_has_unused_storage_locations_near_the_inventory_shelves_If_there_is_no_inventory_it_will_not_be_recommended: "Jika zon atau rak dipilih, hanya rak yang tidak digunakan dalam zon/rak tersebut akan dicadangkan. Jika tiada zon/rak dipilih, lokasi penyimpanan yang tidak digunakan berhampiran rak yang berbarangan di gudang penerimaan pelanggan yang sepadan akan dicadangkan. Tiada cadangan akan dibuat jika tiada stok wujud.",
  Pair_product_images: "Pairing Imej Produk",
  Paired_product_barcode: "Barcode Produk Padanan",
  Matching_product_SKU: "SKU Produk Padanan",
  Paired_product_Chinese_name: "Nama Cina Produk Padanan",
  Paired_product_English_name: "Nama Inggeris Produk Padanan",
  online_SKU: "SKU Dalam Talian",
  Actual_amount: "Jumlah Sebenar",
  Please_select_orders_from_the_same_platform: "Sila pilih pesanan dari platform yang sama",
  The_old_password_matches_the_new_password_please_re_enter: "Kata laluan lama dan kata laluan baru sepadan. Sila masukkan semula",
  generate_a_contract: "Jana Kontrak",
  Deposit_Bank: "Bank Pembukaan Akaun Bank",
  Deposit_Bank_No: "Nombor Pembukaan Akaun Bank",
  ID_card_address: "Alamat ID",
  ID_card_name: "Nama",
  Please_enter_your_name: "Sila masukkan nama",
  Please_enter_the_name_of_the_legal_representative: "Sila masukkan nama wakil undang-undang",
  Please_enter_the_company: "Sila masukkan syarikat",
  Please_enter_the_legal_representative_company: "Sila masukkan syarikat wakil undang-undang",
  Please_select_the_company: "Sila pilih syarikat",
  Please_enter_the_business_license_code: "Sila masukkan nombor lesen perniagaan",
  contractTemplateManagemen: "Reka Bentuk Kontrak",
  Contract_Template_Id: "ID Reka Bentuk Kontrak",
  Contract_signing_expiration_date: "Hari Luput Penandatanganan Kontrak",
  file_path: "Laluan Fail",
  Please_select_the_contract_type: "Sila pilih jenis kontrak",
  Please_select_the_contract_template: "Sila pilih reka bentuk kontrak",
  Please_upload_the_file: "Sila muat naik fail",
  Signing_effective_time: "Tempoh Kesahihan Penandatanganan",
  Validity_period_of_ID_card: "Tempoh Kesahihan Kad Pengenalan",
  Please_enter_the_validity_period_of_your_ID_card: "Sila masukkan tempoh kesahihan kad pengenalan",
  Validity_period_of_legal_person_s_ID_card: "Tempoh Kesahihan Kad Pengenalan Wakil Sah",
  Please_enter_the_validity_period_of_the_legal_person_s_ID_card: "Sila masukkan tarikh luput kad pengenalan wakil sah",
  Date_of_Birth: "Tarikh Kelahiran",
  Please_enter_your_date_of_birth: "Sila masukkan tarikh lahir",
  Business_license_address: "Alamat Lesen Perniagaan",
  Validity_period_of_business_license: "Tempoh Sah Lesen Perniagaan",
  Please_enter_the_validity_period_of_the_business_license: "Sila masukkan tempoh sah lesen perniagaan",
  Please_enter_your_ID_address: "Sila masukkan alamat kad pengenalan",
  Please_enter_the_address_on_your_business_license: "Sila masukkan alamat lesen perniagaan",
  When_uploading_the_ID_card_file_the_first_one_is_the_front_of_the_ID_card_and_the_second_one_is_the_back_of_the_ID_card: "Apabila memuat naik dokumen kad pengenalan: imej pertama mesti bahagian hadapan kad pengenalan, imej kedua mesti bahagian belakang kad pengenalan",
  Please_select_data_from_the_same_warehouse: "Sila pilih data dari gudang yang sama",
  Batch_modify_storage_location_types_and_store_SKU_types: "Pengubahsuaian pukal jenis lokasi penyimpanan, jenis penyimpanan SKU",
  Single_page_signature_page: "Halaman tandatangan satu muka",
  Please_enter_the_single_page_signature_page: "Sila masukkan halaman tandatangan satu muka",
  Signature_page_number_of_saddle_seal: "Nombor halaman tandatangan rentas-segel",
  Please_enter_the_page_number_for_signing_the_saddle_seal: "Sila masukkan nombor halaman tandatangan rentas-segel",
  Total_number_of_pages_in_the_contract: "Jumlah keseluruhan muka kontrak",
  If_the_total_number_of_pages_in_the_contract_is_2_fill_in_1_2_The_total_number_of_pages_in_the_contract_is_3_please_fill_in_1: "Jika jumlah keseluruhan muka kontrak adalah 2, masukkan 1-2. Jika jumlah keseluruhan muka kontrak adalah 3, masukkan 1-3",
  Online_product_information: "Maklumat produk dalam talian",
  Online_variant_ID: "ID varian dalam talian",
  Import_warehouse_transfer_task: "Tugas pemindahan gudang import",
  Export_warehouse_inventory_information: "Eksport maklumat stok gudang",
  Adjust_the_storage_location: "Laraskan lokasi penyimpanan",
  The_selected_stock_quantity_cannot_be_0_please_enter_the_stock_quantity: "Kuantiti stok yang dipilih tidak boleh sifar. Sila masukkan kuantiti stok",
  Order_status: "Status pesanan",
  Rule_1: "Peraturan 1",
  Rule_2: "Peraturan 2",
  Channel_number: "Nombor saluran",
  Area_code: "Kod zon",
  Shelf_number: "Nombor rak",
  Shelf_position: "Nombor kedudukan rak",
  Represent_with_1_2_letters_numbers_to_distinguish_different_functional_areas_for_example: "Gunakan 1-2 aksara alfanumerik untuk menunjukkan zon fungsi yang berbeza, contohnya:",
  R_Receiving_Area: "R: Zon Penerimaan",
  S_Storage_Area: "S: Zon Penyimpanan",
  P_Picking_Area: "P: Zon Pemilihan",
  D_Delivery_Area: "D: Zon Penghantaran",
  Or_use_SA_to_distinguish_different_areas_of_different_functional_zones_heavy_shelves_light_shelves_ground_push: "Sebagai alternatif, gunakan SA untuk membezakan sub-zon dalam kawasan fungsi (contohnya, rak tugas berat, rak tugas ringan, paparan lantai)",
  Represented_by_1_2_digits_numbered_in_sequence_such_as_01_02__99_combined_with_the_area_number_such_as_S_01_for_storage_area: "Ditunjukkan oleh 1-2 digit numerik, bernombor secara bersiri (contohnya 01, 02…99), digabungkan dengan kod zon (contohnya S-01 menunjukkan Zon Penyimpanan)",
  Represent_with_1_2_digits_numbered_in_sequence_such_as_01_02_99_combined_with_the_area_channel_number_such_as_S_01_01_representing_the_first_shelf_of_the_first_channel_in_the_storage_area: "Ditunjukkan oleh 1-2 digit numerik, bernombor secara bersiri (contohnya 01, 02…99), digabungkan dengan kod lorong zon (contohnya S-01-01 menunjukkan unit rak pertama di lorong pertama Zon Penyimpanan).",
  Represent_with_1_2_digits_numbered_from_bottom_to_top_such_as_01_02_03_combined_with_the_area_channel_and_shelf_number_such_as_S_01_01_01_representing_the_first_layer_of_the_first_shelf_in_the_first_channel_of_the_storage_area: "Dilambangkan oleh 1-2 digit, bernombor dari bawah ke atas (contohnya 01, 02, 03…), digabungkan dengan penomboran zon, lorong, dan rak (contohnya S-01-01-01 menunjukkan rak pertama pada lapisan pertama lorong pertama dalam zon penyimpanan).",
  Represented_by_1_2_digits_the_same_layer_is_numbered_from_left_to_right_such_as_01_02_combined_with_the_area_channel_shelf_and_layer_numbers_such_as_S_01_01_01_01_representing_the_first_channel_first_shelf_first_layer_first_digit_grid_of_the_storage_area: "Menggunakan nombor 1-2 digit, bernombor dari kiri ke kanan dalam lapisan yang sama (contohnya 01, 02…), digabungkan dengan nombor kawasan, lorong, rak, dan lapisan (contohnya S-01-01-01-01 menunjukkan kedudukan pertama (bay) pada lapisan pertama rak pertama dalam lorong pertama kawasan penyimpanan).",
  Complete_coding_example_S_02_05_03_04: "Contoh pengekodan lengkap: S-02-05-03-04",
  if_03_is_03_rd_floor_04_is_04_th_storage_location_S_Storage_area_02_Second_aisle_05_Fifth_shelf: "03 Barisan Ketiga 04 Pelabuhan Penyimpanan Keempat Zon Simpanan S 02 Saluran Kedua 05 Rak Kelima",
  Please_enter_the_area_code: "Sila masukkan kod zon",
  Please_enter_the_channel_number: "Sila masukkan nombor lorong",
  Please_enter_the_shelf_position: "Sila masukkan nombor kedudukan rak",
  Online_product_images: "Imej produk dalam talian",
  increase_storage_locations: "Tambah kedudukan penyimpanan",
  articleList: "Senarai Artikel",
  article_Name: "Tajuk Artikel",
  whether_to_turn_it_on: "Aktif/Lumpuhkan",
  create_Article: "Buat Artikel",
  edit_Article: "Sunting Artikel",
  article_Details: "Butiran Artikel",
  Open: "Aktif",
  Shut_down: "Lumpuhkan",
  articleDetail: "Butiran Artikel",
  External_ERP_Help_Documentation: "Dokumentasi Bantuan ERP Luaran",
  help_document: "Dokumentasi Bantuan",
  help_center: "Pusat Bantuan",
  Please_enter_the_article_name: "Sila masukkan nama artikel",
  Please_select_the_status: "Sila pilih status",
  Please_select_the_menu: "Sila pilih menu",
  helpDocument: "Dokumentasi Bantuan",
  shopeeGlobalOnlineProducts: "Produk Dalam Talian Shopee Global",
  global_item_id: "itemId Global",
  global_multi_attribute_id: "ID Multi-Atribut Global",
  global_online_sku: "SKU Dalam Talian Global",
  is_mapped: "Status Pemetaan",
  product_status: "Status Produk",
  pull_product_task: "Tugas Tarik Produk",
  pull_log: "Log Tarik",
  delete_shelves_by_layer: "Padam Rak mengikut Tahap",
  The_lowest_purchase_unit_price_in_the_completed_stage_of_inventory_management: "Pengurusan Pesanan Penyediaan Stok: Harga Unit Pembelian Terendah dalam Tahap Selesai",
  The_most_recent_purchase_unit_price_in_the_completed_stage_of_inventory_management: "Pengurusan Pesanan Penyediaan Stok: Harga Unit Pembelian Terkini dalam Tahap Selesai",
  Default_last_purchase_currency_initially_CNY: "Mata Wang Lalai Pembelian Terakhir, Dilaraskan sebagai CNY",
  The_default_is_the_last_purchase_unit_price_which_is_initially_the_purchase_price_of_the_product: "Lalai kepada Harga Unit Pembelian Terakhir, Dilaraskan sebagai Harga Pembelian Produk.",
  Daily_sales_in_the_past_30_days_multiplied_by_purchase_days_warning_inventory_total_inventory_in_transit_inventory_and_planned_stock_quantity: "Jumlah jualan harian dalam 30 hari terakhir * hari perolehan + paras amaran - jumlah inventori - stok dalam perjalanan - kuantiti pengisian semula yang dirancang",
  Do_not_display_items_less_than_or_equal_to_0: "Nilai ≤ 0 tidak dipaparkan",
  Daily_sales_in_the_past_30_days_multiplied_by_purchase_days_warning_inventory_total_inventory_in_transit_inventory_planned_stock_quantity_and_out_of_stock_quantity: "Jumlah jualan harian dalam 30 hari terakhir * hari perolehan + paras amaran - jumlah inventori - stok dalam perjalanan - kuantiti pengisian semula yang dirancang + kuantiti stok habis",
  Suggested_stocking_quantity_multiplied_by_purchase_unit_price: "Jumlah pengisian semula yang disyorkan * harga unit pembelian",
  Completing_the_purchase_order_will_not_change_the_purchase_unit_price_of_the_goods: "Menyelesaikan pesanan pengisian semula tidak mengubah harga unit pembelian produk",
  The_number_of_layers_cannot_be_0: "Tahap lapisan tidak boleh 0",
  Mandatory_deduction_of_fees: "Potongan wajib",
  Do_you_confirm_the_mandatory_deduction_of_fees: "Kesahkan potongan wajib",
  Unrestricted_balance_can_be_deducted_as_negative: "Tanpa had; baki boleh dikurangkan kepada nilai negatif",
  Inventory_management_pending_review_sum_of_stage_quantities_in_inventory_preparation: "Pengurusan Pesanan Pengisian Semula: Jumlah kuantiti dalam peringkat Tertunggak Kelulusan + Dalam Pengisian Semula",
  The_quantity_of_inventory_pending_review_reviewed_received_in_transit_warehouse_in_transit_in_the_final_stage_of_receiving_received_in_the_final_stage_under_quality_inspection_and_not_yet_listed_in_the_quality_inspection_stage: "Pesanan Penerimaan Menunggu Kelulusan, Diluluskan, Diterima di Gudang Transit, Dalam Penghantaran, Menerima Peringkat Akhir, Peringkat Akhir Diterima, Di Bawah Pemeriksaan, Pemeriksaan Siap Kuantiti belum disusun di setiap peringkat",
  Please_enter_1_2_characters: "Sila masukkan 1-2 aksara",
  Please_enter_1_2_digits: "Sila masukkan 1-2 digit",
  Please_enter_a_number: "Sila masukkan satu nombor",
  Is_it_an_available_storage_location: "Adakah ini lokasi penyimpanan yang tersedia?",
  deduction_item: "Item Pengurangan",
  Sales_Trend_Chart: "Grafik Tren Jualan",
  total_occupancy_quantity: "Jumlah Kuantiti Terisi",
  Occupied_inventory_volume: "Jumlah Inventori Terisi",
  Total_occupancy_quantity_order_occupancy_quantity_manual_outbound_occupancy_quantity_warehouse_transfer_occupancy_quantity: "Jumlah Kuantiti Terpegang (Kuantiti Terpegang Pesanan / Kuantiti Terpegang Keluar Manual / Kuantiti Terpegang Pemindahan)",
  Sales_time_filtering: "Penapis Masa Jualan",
  Order_occupancy_quantity: "Kuantiti Terpegang Pesanan",
  Quantity_occupied_by_manual_outbound: "Kuantiti Terpegang Keluar Manual",
  Number_of_occupied_warehouses_for_relocation: "Kuantiti Terpegang Pemindahan",
  Please_select_the_item_that_needs_to_be_deducted: "Sila pilih item potongan yang diperlukan",
  Please_select_the_storage_type: "Sila pilih jenis penyimpanan",
  Please_select_the_type_of_storage_location: "Sila pilih jenis lokasi",
  Transfer_according_to_batches_If_the_transfer_quantity_is_less_than_or_equal_to_the_available_inventory_of_a_single_batch_transfer_the_available_inventory_first_If_the_available_inventory_of_the_batch_is_less_than_the_total_inventory_of_the_batch_it_cannot_be_transferred: "Pindahan mengikut kumpulan. Jika kuantiti pindahan <= inventori tersedia setiap kumpulan, pindahkan stok tersedia terlebih dahulu. Jika inventori tersedia > jumlah inventori kumpulan, pindahan tidak dapat diteruskan",
  If_batch_occupancy_quantity_priority_should_be_given_to_transferring_occupied_inventory_followed_by_transferring_available_inventory: "Jika >= kuantiti terisi kumpulan, pindahkan inventori terisi terlebih dahulu, kemudian pindahkan inventori tersedia",
  After_transferring_a_batch_of_inventory_if_there_are_still_remaining_quantities_that_have_not_been_transferred_transfer_the_remaining_quantities_from_other_batches: "Selepas memindahkan inventori satu kumpulan, sebarang baki kuantiti akan dipindahkan daripada kumpulan lain",
  When_the_financial_currency_exchange_rate_for_converting_profits_from_the_original_currency_of_the_store_is_not_set_the_system_will_not_perform_data_synchronization_After_setting_it_the_previous_day_s_data_will_be_synchronized_after_24_00_on_the_same_day_Only_orders_that_have_been_issued_and_bills_have_been_generated_will_be_synchronized_Profit_data_will_be_updated_in_the_early_morning_when_bills_are_generated_and_the_settlement_time_will_be_based_on_the_last_time_bills_are_generated_Note_The_billing_of_platform_orders_may_be_generated_at_multiple_time_points_If_some_of_the_billing_points_are_generated_before_the_currency_exchange_rate_is_set_these_bills_will_not_be_pulled_resulting_in_incomplete_order_report_fees: "Apabila kadar pertukaran untuk menukar keuntungan mata wang asal kedai kepada mata wang kewangan tidak dikonfigurasikan, sistem tidak akan menjalankan penyelarasan data. Setelah dikonfigurasikan, ia akan menyelararas data hari sebelumnya selepas pukul 24:00 pada hari yang sama. Hanya pesanan dengan penghantaran keluar yang telah diselesaikan dan invois yang telah dijana akan diselararas. Data keuntungan akan dikemas kini pada tengah malam apabila invois dijana, dengan masa penyelesaian adalah masa penjanaan invois yang paling lewat. Nota: Invois pesanan platform boleh dijana pada pelbagai masa. Jika beberapa invois dijana sebelum kadar pertukaran mata wang ditetapkan, invois ini tidak akan diambil, yang berpotensi menyebabkan yuran laporan pesanan tidak lengkap.",
  Currency_for_warehouse_fee_settlement: "Mata wang penyelesaian yuran gudang",
  Original_currency_of_the_order: "Mata wang asal pesanan",
  BatchAddStorageLocations: "Tambah lokasi stor secara pukal",
  Please_fill_in_the_scope_in_order: "Sila isi julat mengikut urutan",
  The_initial_value_cannot_be_greater_than_or_equal_to_the_end_value: "Nilai awal tidak boleh lebih besar atau sama dengan nilai akhir",
  The_initial_value_must_be_greater_than_0: "Nilai awal mesti lebih besar daripada 0",
  The_interval_between_initial_and_final_values_should_not_exceed_20: "Jarak antara nilai awal dan akhir tidak boleh melebihi 20",
  Position_grid_number: "ID Lokasi",
  Fetching: "Mencari",
  Refresh_delivery_exception: "Segarkan anomali penghantaran",
  Activate_Contract: "Aktifkan kontrak",
  First_leg_order_log: "Log pesanan masuk",
  Initial_billing_log: "Log pengebilan masuk",
  Create_template: "Buat templat",
  Set_custom_calculation: "Tetap kan pengiraan tersuai",
  Custom_calculation_log: "Log pengiraan tersuai",
  Daily_sales_in_the_past_30_days: "Jumlah jualan harian untuk 30 hari lepas",
  Planned_stocking_quantity: "Kuantiti pengisian semula yang dirancang",
  No_goods_found: "Produk tidak ditemui",
  Stock_up_suggestions_Product_information: "Barang pengisian semula yang disyorkan",
  Out_of_stock_suggested_product_information: "Alternatif yang disyorkan untuk barang yang kehabisan stok",
  Address_Business_License_Address: "Alamat/Alamat lesen perniagaan",
  Customer_type: "Jenis Pelanggan",
  Customer_authorization_status: "Status Kebenaran Pelanggan",
  Authorization_effective_time: "Tarikh Berkuatkuasa Kebenaran",
  Authorization_expiration_time: "Tarikh Luput Kebenaran",
  Go_to_authorization: "Teruskan ke Kebenaran",
  logistics_information: "Maklumat Logistik",
  Logistics_update_time: "Masa Kemas Kini Logistik",
  Current_inventory_batch_quantity: "Jumlah Batch Inventori Semasa",
  Unqualified_quantity_shortage_damage: "Jumlah Tidak Pematuhan (Kekurangan/Barangan Rosak)",
  Positive_numbers_are_required_to_refund_fees_while_negative_numbers_are_required_to_deduct_customer_balances: "Nilai positif menunjukkan bayaran balik yang terhutang; nilai negatif menunjukkan potongan daripada baki pelanggan",
  ReturnedForGeneration: "Pendaftaran Pemulangan Tertunggak",
  Our_Information: "Maklumat Kami",
  the_other_party_s_information: "Maklumat Penerima",
  Identity_witness_portrait: "Bahagian potret kad pengenalan",
  National_emblem_on_ID_card: "Bahagian logo negara kad pengenalan",
  Please_enter_QQ_WeChat: "Sila masukkan QQ/WeChat",
  generated_person: "Penjana",
  generation_time: "Masa penjanaan",
  The_automatic_addition_of_packaging_materials_will_only_be_triggered_when_it_is_submitted_for_shipment_or_when_the_waybill_number_is_obtained: "Penambahan pembungkusan automatik hanya diaktifkan apabila dihantar ke 'Tunggakan Penghantaran' atau 'Pencarian Nombor Waybill'",
  preview: "Rangka tontonan",
  Packaging_material_combination: "Gabungan Pembungkusan",
  Inventory_quantity_is_below: "Kuantiti stok di bawah",
  Sales_in_the_last_30_days_greater_than: "Jualan melebihi 30 hari terakhir",
  Sales_in_the_last_30_days_greater: "Jualan 30 hari terakhir",
  Please_select_the_affiliated_warehouse: "Sila pilih gudang",
  The_calculated_suggested_stocking_quantity_will_be_sorted_in_descending_order: "Jumlah stok yang dicadangkan akan disusun dari yang tertinggi ke yang terendah",
  Custom_calculation_settings: "Tetapan pengiraan tersuai",
  Suggested_stocking_quantity: "Jumlah stok yang dicadangkan",
  Calculate_based_on_custom_calculation_formula: "Dikira berdasarkan formula tersuai",
  Calculate_the_recommended_stocking_quantity_based_on_the_formula_in_your_custom_calculation_settings_located_in_the_top_right_corner: "Jumlah stok yang dicadangkan dikira menggunakan formula anda dalam Tetapan Pengiraan Tersuai (bahagian atas kanan)",
  When_the_available_inventory_cannot_meet_your_pending_shipment_quantity_a_shortage_recommendation_will_be_triggered_recommending_as_much_as_is_needed: "Apabila stok yang ada tidak dapat memenuhi penghantaran yang tertunggak, cadangan penghabisan stok akan dicetuskan, mencadangkan jumlah kekurangan yang tepat",
  The_total_quantity_of_goods_required_for_orders_in_the_pending_processing_and_review_stages_of_the_order_list: "Jumlah kuantiti barangan yang diperlukan untuk pesanan dalam peringkat 'Tertunggak Pemprosesan' + 'Tertunggak Kelulusan'",
  Calculate_the_recommended_stocking_quantity_based_on_a_custom_calculation_formula: "Kira paras stok yang disyorkan berdasarkan formula tersuai",
  Inventory_in_return_processing: "Stok Pemprosesan Pemulangan",
  Average_daily_sales_in_the_past_30_days_multiplied_by_purchase_days_plus_warning_inventory_at_least_one_must_be_activated: "(Jualan harian purata sepanjang 30 hari terakhir × masa perolehan) + paras stok amaran (sekurang-kurangnya satu mesti diaktifkan)",
  Total_inventory_available_inventory_Total_number_of_goods_awaiting_review_Inventory_in_return_processing_In_transit_inventory_Planned_stocking_quantity_at_least_one_must_be_activated: "(Jumlah inventori / inventori tersedia) - jumlah barangan menunggu semakan - inventori dalam pemprosesan pemulangan - inventori dalam penghantaran - kuantiti pengisian semula stok yang dirancang (sekurang-kurangnya satu mesti diaktifkan)",
  warehouse_type: "Jenis Gudang",
  Please_enter_the_name_of_the_person_in_charge: "Sila masukkan nama orang yang bertanggungjawab",
  Only_process_orders_that_have_been_pending_review_and_entered_the_system_within_the_current_15_day_period: "Proses hanya pesanan tertunggak yang dimasukkan dalam tempoh 15 hari terakhir dari masa sistem semasa",
  The_order_will_be_automatically_triggered_when_it_is_submitted_for_shipment_or_when_the_waybill_number_is_obtained: "Diaktifkan secara automatik apabila pesanan mencapai status 'Menunggu Penghantaran' atau 'Pendaftaran Nombor Pengesanan'",
  Return_Order: "Pulang",
  Pending_Review_Pending_Listing_In_Listing_Process_Number_of_Qualified_Items_Not_Yet_Completed_for_Listing: "Menunggu semakan, menunggu penyimpanan semula, penyimpanan semula sedang dijalankan, kuantiti penyimpanan semula yang layak tetapi tidak lengkap",
  canChangeSku: "SKU boleh diganti",
  abnormalSKUPendingProcessing: "SKU tidak normal menunggu pemprosesan",
  batch_change_sku: "Penggantian SKU secara pukal",
  change_sku: "Gantikan SKU",
  please_select_the_sku_to_be_replaced: "Sila pilih SKU yang memerlukan penggantian",
  please_select_new_sku: "Sila pilih SKU baru",
  please_select_orders_from_the_same_warehouse: "Sila tandakan pesanan dalam gudang yang sama",
  The_old_and_new_sku_cannot_be_the_same: "SKU lama dan baru tidak boleh sama",
  Mark_replaceable_SKU: "Tandakan SKU yang boleh diganti",
  Month_of_cost_recalculation: "Bulan untuk pengiraan semula yuran",
  Order_adjustment_amount: "Jumlah pelarasan pesanan",
  If_there_is_a_token_error_prompt_please_check_if_the_token_is_copied_correctly_or_if_the_authorized_Lazada_service_marketplace_site_corresponds_to_the_system_repository_country: "Sekiranya mesej ralat token muncul, sahkan bahawa token telah disalin dengan betul atau semak sama ada laman Marketplace Perkhidmatan Lazada yang dibenarkan sepadan dengan negara gudang sistem",
  channel_name: "Nama Saluran",
  Service_Type: "Jenis Perkhidmatan",
  Billing_Plan: "Pelan Pengebilan",
  Delivery_countr: "Negara Penghantaran",
  Delivery_area: "Wilayah Penghantaran",
  Logistics_provider_name: "Nama Pengangkut",
  Quality_inspection_has_started: "Pemeriksaan Kualiti Dimulakan",
  Completed_quality_inspection: "Pemeriksaan Kualiti Selesai",
  Number_of_items_awaiting_quality_inspection: "Barangan Menunggu Pemeriksaan",
  The_number_of_quality_inspection_items_that_have_started: "Pemeriksaan Barangan Dimulakan",
  Number_of_completed_quality_inspections: "Pemeriksaan Barangan Selesai",
  Product_in_transit_details: "Butiran Barang dalam Penghantaran",
  Quick_Region_Selection: "Pilihan Wilayah Pantas",
  Connection_error_please_check_if_the_video_plugin_is_open_and_try_again: "Ralat sambungan. Sila semak sama ada pemalam video telah diaktifkan dan cuba semula.",
  Failed_to_save_the_currently_recorded_video: "Rakaman video semasa gagal disimpan.",
  Please_enter_the_name_of_the_logistics_provider: "Sila masukkan nama penghantar.",
  Please_enter_the_channel_name: "Sila masukkan nama saluran.",
  Please_select_the_delivery_country: "Sila pilih negara penghantaran.",
  Import_logistics_channel_management_data: "Import Data Pengurusan Saluran Logistik",
  Export_Logistics_Channel_Management_Data: "Eksport Data Pengurusan Saluran Logistik",
  Edit_channel: "Sunting Saluran",
  Confirm_the_logistics_provider: "Kesahkan penghantar",
  Recording_local_address: "Rekod alamat tempatan",
  Confirm_Clearing_Order_Packaging: "Kesahkan bahan pembungkusan pesanan pelupusan kastam",
  Operation_Successful: "Operasi berjaya",
  Please_Select_The_Data: "Sila tandakan data",
  Please_Select_Data_From_The_Same_Platform: "Sila pilih data dari platform yang sama",
  Confirm_Transfer_To_Pending: "Kesahkan pemindahan ke pemprosesan tertangguh",
  Confirm_Excluding_All_Rules: "Kesahkan pengecualian semua peraturan",
  Confirm_Canceling_Exclusion_Of_All_Rules: "Kesahkan pembatalan pengecualian semua peraturan",
  Confirm_Excluding_Automatic_Packaging_Rules: "Kesahkan pengecualian peraturan pembungkusan automatik",
  Confirm_Canceling_Exclusion_Of_Automatic_Packaging_Rules: "Kesahkan pembatalan pengecualian peraturan pembungkusan automatik",
  Confirm_Excluding_Submission_Rules: "Kesahkan pengecualian peraturan penghantaran",
  Confirm_Canceling_Exclusion_Of_Submission_Rules: "Kesahkan pembatalan pengecualian peraturan penghantaran",
  Yes: "Ya",
  No: "Tidak",
  Currently_Selected_Orders_Have_No_Shipping_Exceptions_No_Action_Required: "Tiada anomali penghantaran dikesan dalam pesanan yang dipilih semasa; tiada tindakan diperlukan",
  Orders_Will_Be_Marked_As_Out_Of_Stock_If_Warehouse_Has_No_Inventory_After_Submission: "Selepas tindakan dihantar, pesanan tanpa barangan di gudang akan ditandakan sebagai kehabisan stok",
  Out_Of_Stock_Orders: "Pesanan kehabisan stok",
  Selected_Orders_Contain_Orders_Without_Tracking_Numbers_Cannot_Preview_Shipping_Labels: "Pesanan terpilih mengandungi penghantaran dengan nombor waybill kosong; pratonton waybill tidak tersedia",
  Preview_PDF: "Pratonton PDF",
  Sum_Of_Created_Within_Last_Seven_Days_Pending_Review_Tracking_Number_Acquisition_In_Progress_And_Shipping_Exceptions: "Jumlah anomali penghantaran dalam tujuh hari terakhir: menunggu semakan, pemerolehan nombor waybill, anomali penghantaran",
  Shipping_Exceptions_In_Last_Seven_Days: "Anomali penghantaran dalam tujuh hari terakhir",
  Basic_Query: "Carian Asas",
  Expired_Stores: "Toko Luput",
  Order_Number: "Nombor Pesanan",
  Tracking_Number: "Nombor Waybill",
  Creation_Time: "Tarikh Cipta",
  Transaction_Number: "ID Transaksi",
  Platform: "Platform",
  Order_Source: "Sumber Pesanan",
  API_Order: "Pesanan API",
  Push_Order: "Pesanan Diteruskan",
  Manual_Order: "Pesanan Manual",
  Cargo_Query: "Carian Barangan",
  Warehouse: "Gudang",
  Logistics_Channel: "Saluran Logistik",
  Country: "Negara",
  Chinese_Product_Name: "Nama Produk Cina",
  English_Product_Name: "Nama Produk Inggeris",
  Order_Status_Query: "Carian Status Pesanan",
  Logistics_Status: "Status Logistik",
  Priority_Delivery: "Penghantaran Keutamaan",
  Delivery_Method: "Kaedah Penghantaran",
  WMS_Status: "Status WMS",
  Platform_Status: "Status Platform",
  Time_Query: "Carian Masa",
  Confirmation_Time: "Masa Pengesahan",
  Outbound_Time: "Masa Keluar",
  Batch_Query: "Carian Batch",
  Add_Quick_Query: "Tambah Carian Pantas",
  Create_Order: "Cipta Pesanan",
  Transfer_To_Tracking_Number_Acquisition_In_Progress_Or_Awaiting_Shipment: "Pemindahan Perolehan Nombor Waybill / Menunggu Penghantaran",
  Orders_With_Tracking_Numbers_Will_Automatically_Transfer_To_Stage_Awaiting_Shipment_Orders_Without_Tracking_Numbers_Will_Automatically_Transfer_To_Stage_Tracking_Number_Acquisition_In_Progress: "Pesanan dengan nombor waybill akan secara automatik bertukar kepada: Menunggu Penghantaran. Pesanan tanpa nombor waybill akan secara automatik bertukar kepada: Perolehan Nombor Waybill.",
  Transfer_To_Pending: "Pindahkan ke Menunggu Pemprosesan",
  Fetch_Orders: "Dapatkan Pesanan",
  Set_Order_Packaging: "Konfigurasikan Bahan Pembungkusan Pesanan",
  Clear_Order_Packaging: "Sapu Bahan Pembungkusan Pesanan",
  Void_Orders: "Batal Pesanan",
  Delete_Orders: "Padam Pesanan",
  Only_Supports_Operating_API_Orders_Within_12_Hours_Of_Delivery_Deadline_And_Push_Orders_Created_More_Than_12_Hours_Ago: "Hanya menyokong pesanan API dalam tempoh 12 jam sebelum tarikh akhir penghantaran dan pesanan push yang dibuat lebih 12 jam lalu",
  Return_To_Pending_Review: "Kembali ke Tunggak Semakan",
  Activate: "Aktifkan",
  Refresh_Platform_Status: "Segarkan Status Platform",
  Online_Product_Matching: "Padankan Produk Dalam Talian",
  Resubmit_For_Shipping: "Serahkan Semula untuk Penghantaran",
  More_Operations: "Tindakan Lain",
  Import: "Import",
  Export: "Eksport",
  Tracking_Number_Acquisition_Successful_Will_Automatically_Transfer_To_Awaiting_Shipment: "Secara automatik dipindahkan ke Tunggak Penghantaran setelah berjaya memperoleh nombor penjejakan",
  Shipping_Label_Operations: "Operasi Waybill",
  Upload_Shipping_Label: "Muat naik Waybill",
  System_Printing_Requires_Downloading_A_Print_Plugin: "Untuk menggunakan sistem cetakan, anda mesti memuat turun pemalam cetakan.",
  Click_To_Download: "Klik untuk memuat turun",
  Print_Shipping_Label: "Cetak label penghantaran",
  Download_Shipping_Label: "Muat turun label penghantaran",
  Preview_Shipping_Label: "Praperiksa label penghantaran",
  Order_Batch_Processing: "Pemprosesan pukal pesanan",
  Replace_SKU: "Gantikan SKU",
  Delete_SKU: "Padam SKU",
  Add_SKU: "Tambah SKU",
  Modify_SKU_Quantity: "Ubah kuantiti SKU",
  Modify_Warehouse: "Sunting Gudang",
  Edit_Notes: "Sunting Nota",
  Rule_Processing: "Pemprosesan Peraturan",
  Exclude_Submission_Rules: "Kecualikan Peraturan Penghantaran",
  Cancel_Excluding_Submission_Rules: "Batal Pengecualian Peraturan Penghantaran",
  Exclude_Automatic_Packaging_Rules: "Kecualikan Peraturan Pembungkusan Automatik",
  Cancel_Excluding_Automatic_Packaging_Rules: "Batal Pengecualian Peraturan Pembungkusan Automatik",
  Exclude_All_Rules: "Kecualikan Semua Peraturan",
  Cancel_Excluding_All_Rules: "Batal Pengecualian Semua Peraturan",
  Exception: "Anomali",
  Order_Amount: "Jumlah Pesanan",
  Tracking_Number_Acquisition_In_Progress: "Mencari Nombor Waybill...",
  Push: "Tolak",
  Manual: "Tangan",
  Platform_Set_Priority_Delivery: "Tetapan penghantaran keutamaan platform",
  Priority: "Cemerlang",
  Manual_Set_Priority_Delivery: "Atur penghantaran keutamaan secara manual",
  Pre_Sale_Orders: "Pesanan Pra-jualan",
  Pre_Sale: "Pra",
  Out_Of_Stock: "kekurangan",
  Split_Orders: "Pesanan Terbahagi",
  Split: "Bongkar",
  Product_Category: "Kategori produk",
  Product_Quantity: "Kuantiti produk",
  Operation: "Operasi",
  Edit: "Sunting",
  Do_Not_Leave_Blanks_For_Line_Breaks: "Tiada baris kosong",
  Warehouse_Order_List: "Senarai Pesanan Gudang",
  All: "Semua",
  Today: "Hari Ini",
  Yesterday: "Semalam",
  Day_Before_Yesterday: "Tua Semalam",
  Last_Three_Days: "Tiga Hari Terakhir",
  Last_Week: "Minggu Lalu",
  Last_Month: "Bulan Lalu",
  Non_Out_Of_Stock_Orders: "Pesanan Tidak Habis Stok",
  With_Tracking_Number: "Dengan Nombor Waybill",
  Without_Tracking_Number: "Tanpa Nombor Waybill",
  Notes: "Nota",
  With_Notes: "Dengan Nota",
  Without_Notes: "Tanpa Nota",
  With_Platform_Notes: "Dengan Nota Platform",
  Without_Platform_Notes: "Tanpa Nota Platform",
  Platform_Notes: "Nota Platform",
  Non_Split_Orders: "Pesanan Tidak Dibahagi",
  Non_Pre_Sale_Orders: "Pesanan Pra-Jualan",
  Paired_Orders: "Pesanan Sepadan",
  Already_Paired_Orders: "Pesanan Sejodoh",
  Not_Paired_Orders: "Pesanan Tidak Sejodoh",
  Shipping_Exceptions: "Anomali Penghantaran",
  Priority_Delivery_Orders: "Pesanan Penghantaran Keutamaan",
  Non_Priority_Delivery_Orders: "Pesanan Penghantaran Bukan Keutamaan",
  With_Shipping_Exceptions: "Dengan Anomali Penghantaran",
  Without_Shipping_Exceptions: "Tanpa Anomali Penghantaran",
  Task: "Tugas",
  All_Tasks: "Semua Tugas",
  Today_Tasks: "Tugas Hari Ini",
  Yesterday_Tasks: "Tugas Semalam",
  Submitted_Order_Tasks: "Tugas Pesanan Dihantar",
  Today_000000_180000_Submitted_Order_Tasks: "Tugas pesanan dihantar antara 00:00:00 dan 18:00:00 hari ini",
  Yesterday_000000_235959_Submitted_Order_Tasks: "Tugas pesanan dihantar antara 00:00:00 dan 23:59:59 semalam",
  Not_Excluding_Submission_Rules: "Peraturan penghantaran tidak dikecualikan",
  Excluded_Submission_Rules: "Peraturan penghantaran dikecualikan",
  Not_Excluding_Automatic_Packaging_Rules: "Peraturan pembungkusan automatik tidak dikecualikan",
  Excluded_Automatic_Packaging_Rules: "Peraturan pembungkusan automatik dikecualikan",
  Shipping_Label: "Waybill",
  With_Shipping_Label: "Waybill ada",
  Without_Shipping_Label: "Waybill tiada",
  Online_Product_Image: "Imej Produk Dalam Talian",
  No_Online_Product_Details_Available: "Tiada butiran produk dalam talian tersedia",
  Online_Product_Details: "Butiran Produk Dalam Talian",
  Product_Image: "Imej Produk",
  System_Product_Details: "Butiran Produk Sistem",
  Quantity: "Kuantiti",
  Out_Of_Stock_Status: "Status Habis Stok",
  Out: "Habis Stok",
  Total_Inventory: "Jumlah Inventori",
  Total_Available_Inventory: "Jumlah Inventori Tersedia",
  Total_Occupied_Inventory: "Jumlah Inventori Ditala",
  Total_Unavailable_Inventory: "Jumlah Inventori Tidak Tersedia",
  Total_In_Transit_Inventory: "Jumlah Inventori Dalam Penghantaran",
  This_Operation_Will_Permanently_Delete_The_Query_Condition_Proceed: "Tindakan ini akan memadamkan syarat pertanyaan ini secara kekal. Teruskan?",
  Currently_Only_Single_Order_Upload_Is_Supported: "Pada masa ini hanya menyokong muat naik satu pesanan",
  Current_Order_Cannot_Upload_Shipping_Label_Only_Orders_With_Order_Status_As_Pending_Review_Or_Awaiting_Shipment_And_WMS_Status_As_Picking_Exception_Sorting_Exception_Shipping_Exception_Or_Cancellation_Exception_Can_Upload_Shipping_Label: "Pesanan semasa tidak boleh memuat naik label penghantaran. Hanya pesanan dengan status 'Menunggu Kelulusan' atau 'Menunggu Penghantaran', dan status WMS 'Anomali Pemilihan', 'Anomali Penyusunan', 'Anomali Penghantaran', atau 'Anomali Pembatalan' boleh memuat naik label penghantaran.",
  Shipping_Label_Address_Is_Empty: "Alamat label penghantaran kosong",
  Printing_In_Progress: "Sedang dicetak...",
  Network_Response_Failed: "Tindak balas rangkaian gagal",
  Download_Failed_Please_Try_Again_Later: "Muat turun gagal, sila cuba lagi kemudian",
  Select_The_SKU_To_Add_And_Enter_The_Quantity_To_Add: "Pilih SKU untuk ditambah dan masukkan kuantiti",
  Product_Barcode: "Barang Kod Produk",
  Only_One_Can_Be_Selected: "Hanya satu pilihan boleh dipilih",
  Please_Enter_The_Quantity: "Sila masukkan kuantiti",
  Please_Enter_Notes: "Sila masukkan ulasan",
  Select_The_SKU_To_Delete: "Pilih SKU untuk dipadam",
  Please_Select_The_SKU: "Sila pilih SKU",
  Order_Fetching_Time: "Masa Pengambilan Pesanan",
  Please_Enter_Separated_By_Commas_Or_Line_Breaks: "Sila masukkan, dipisahkan oleh koma atau peralihan baris",
  Please_Select_Store: "Sila pilih kedai",
  Transaction_Number_And_Order_Fetching_Time_Cannot_Be_Empty_Simultaneously: "ID Transaksi dan masa perolehan pesanan tidak boleh kedua-duanya kosong",
  Fetch_Logistics_Tracking: "Dapatkan penjejakan logistik",
  Logistics_Tracking: "Penjejakan logistik",
  Latest_Update: "Kemas kini terkini",
  Logistics_Information_Is_Being_Fetched: "Memuat maklumat logistik",
  Select_The_SKU_To_Modify_And_Enter_The_New_SKU_Quantity: "Sila pilih SKU yang hendak diubah suai dan masukkan kuantiti yang hendak diubah suai",
  Select_Product: "Pilih produk",
  Please_Select_Warehouse: "Sila pilih gudang",
  Pair: "Padanan",
  Paired_Product_Image: "Imej produk padanan",
  Paired_Product_Barcode: "Barcode produk padanan",
  Paired_Product_SKU: "SKU produk padanan",
  Paired_Product_Chinese_Name: "Nama Cina produk padanan",
  Paired_Product_English_Name: "Menyandarkan Nama Produk",
  Statistics_Time_Range: "Julat Masa Statistik",
  Number_Of_People: "Bilangan Orang",
  Human_Efficiency: "Kecekapan Kakitangan",
  Packing_Lead_Time: "Ketepatan Pembungkusan",
  Starting_Hour: "Jam Bermula",
  Corresponding_Hour_For_Calculation_Day: "Jam sepadan pada hari pengiraan",
  Ending_Hour: "Jam Berhenti",
  Corresponding_Hour_For_Calculation_Day_Plus_One_Day: "Jam sepadan pada hari pengiraan ditambah satu hari",
  Changes_Take_Effect_From_The_Next_Hour: "Perubahan berkuat kuasa mulai jam seterusnya",
  Add: "Tambah",
  Operation_Log: "Log Operasi",
  Type: "Jenis",
  Calculation_Day: "Hari Pengiraan",
  Calculation_Day_Starting_Hour: "Jam Bermula Hari Pengiraan",
  Next_Day_Ending_Hour: "Jam Berhenti Hari Seterusnya",
  Calculation_Time_Field: "Medan Masa Pengiraan",
  List_Row_Background_Color: "Warna Latar Belakang Baris Senarai",
  Please_Enter_Starting_Hour: "Sila masukkan jam bermula",
  Please_Enter_A_Number_Between_0_And_23: "Sila masukkan nombor antara 0 dan 23",
  Starting_Hour_Cannot_Be_Greater_Than_Ending_Hour: "Jam mula tidak boleh melebihi jam tamat",
  Please_Enter_Ending_Hour: "Sila masukkan jam tamat",
  Ending_Hour_Cannot_Be_Less_Than_Starting_Hour: "Jam tamat tidak boleh lebih awal daripada jam mula",
  Please_Enter_Type: "Sila pilih jenis",
  Type_Cannot_Be_Duplicated: "Jenis tidak boleh diulang",
  Please_Select_Background_Color: "Sila pilih warna latar belakang",
  Background_Color_Cannot_Be_Duplicated: "Warna latar belakang tidak boleh diulang",
  Please_Select_Calculation_Day: "Sila pilih hari pengiraan",
  Please_Select_Calculation_Time_Field: "Sila pilih medan masa pengiraan",
  Auto_Update_Time: "Masa kemas kini automatik",
  Next_Auto_Update_Time: "Masa kemas kini automatik seterusnya",
  Set_Statistical_Time_Range: "Tetapkan julat masa statistik",
  Orders_Not_Completed_For_Delivery_Before_Statistical_Time_Range: "Pesanan Belum Dihantar Sebelum Julat Masa Statistik",
  Warehouse_Orders: "Pesanan Gudang",
  Total_Orders_Awaiting_Shipment_Picking_In_Progress_And_Shipping_In_Progress_For_The_Corresponding_Warehouse: "Jumlah Pesanan Menunggu Penghantaran, Pemilihan, atau Penghantaran di Gudang Berkaitan",
  Total_Orders_Shipped_And_Dispatched_For_The_Corresponding_Warehouse: "Jumlah Pesanan Dihantar atau Diserahkan di Gudang Berkaitan",
  Total_Orders: "Jumlah Pesanan",
  Total_Not_Shipped: "Jumlah Pesanan Belum Dihantar",
  Total_Shipped: "Jumlah Pesanan Dihantar",
  Please_Select_Time: "Sila Pilih Masa",
  Hour: "Jam",
  Minute: "Minit",
  Second: "Saat",
  Statistical_Time_Range: "Julat Masa Statistik",
  Corresponding_Start_Time_Of_Execution_At_That_Time_End_Time: "Masa mula dan tamat yang sepadan untuk pelaksanaan semasa",
  Corresponding_Field_For_Statistical_Data: "Medan yang sepadan untuk data statistik",
  Unread_Notification: "Notifikasi Belum Dibaca",
  noticeList: "Senarai Notifikasi",
  Receive_customer: "Pelanggan Penerima",
  Receive_staff: "Kakitangan Penerima",
  Receive_warehouse: "Gudang Penerima",
  Receive_department: "Jabatan Penerima",
  Receive_country: "Negara Penerima",
  Add_Notification: "Tambah Notifikasi",
  Edit_Notification: "Sunting Notifikasi",
  Recipient: "Penerima",
  Please_enter_a_title: "Sila masukkan tajuk",
  Please_enter_content: "Sila masukkan kandungan",
  Please_select_the_recipient: "Sila pilih penerima",
  The_title_must_be_1_to_50_characters: "Tajuk mesti antara 1-50 aksara",
  Please_choose_a_logistics_provider: "Sila pilih penyedia logistik",
  Platform_And_Shop: "Platform/Kedai",
  Export_inventory_historical_inventory_information: "Eksport inventori + maklumat inventori bersejarah",
  Appointment_for_warehouse_entry_and_storage_time: "Masa Kemasukan Gudang yang Dijadualkan",
  To_be_confirmed: "Tungguh Pengesahan",
  Number_of_packaging_cycles: "Pusingan Pembungkusan",
  Please_select_the_scheduled_time_for_warehouse_entry_and_storage: "Sila pilih masa kemasukan gudang yang dijadualkan",
  storage_phase: "Tahap Kemasukan",
  quantity_in_transit: "Jumlah dalam Penghantaran",
  Daily_scheduled_inbound_time: "Masa Kemasukan Harian yang Dijadualkan",
  Select_time_range: "Pilih Julat Masa",
  Maximum_number_of_reserved_storage_parties: "Parti Kemasukan yang Dijadualkan Maksimum",
  Total_number_of_reserved_storage_units: "Jumlah Parti Kemasukan yang Dijadualkan",
  Available_for_appointment: "Boleh ditempah",
  Fully_booked: "Penuh",
  The_available_appointment_dates_are_green_and_the_remaining_number_of_available_appointments_per_day_is_displayed_below_the_dates_If_the_number_of_reserved_parties_is_full_it_will_be_marked_in_red_indicating_that_the_reservation_is_full: "Tarikh yang tersedia dipaparkan dalam warna hijau, dengan slot harian yang tinggal dipaparkan di bawah. Tarikh yang penuh dipaparkan dalam warna merah dengan Penuh dinyatakan.",
  Monday: "Isnin",
  Tuesday: "Selasa",
  Wednesday: "Rabu",
  Thursday: "Khamis",
  Friday: "Jumaat",
  Saturday: "Sabtu",
  Sunday: "Ahad",
  Pre_order_storage_for_the_next_seven_days: "Tempahan kemasukan gudang 7 hari akan datang",
  //2026.7.17
  Headhaul_bills_may_be_charged_by_both_systems_when_one_side_updates_the_settlement_stage_synchronize_to_that_side_is_bill_stage: "Bil kepala perjalanan pertama akan dicaj kepada pelanggan oleh sistem kedua- dua pihak, dan setelah peringkat penyelesaian mana - mana pihak dikemas kini, ia akan diselaraskan ke peringkat bil pihak tersebut",//头程账单由双方系统向客户收费，哪方的结算阶段更新后，就同步成哪方的账单阶段
  Customer_IDs_cannot_be_the_same: "ID pelanggan tidak boleh sama",//客户ID不能相同
  Please_enter_the_SKU_product_barcode_Chinese_name_and_English_name_of_the_product_separated_by_commas_or_line_breaks_in_English: "Sila masukkan SKU, kod bar produk, nama produk dalam bahasa Cina, nama produk dalam bahasa Inggeris, dipisahkan dengan koma Inggeris atau baris baru",//请输入SKU、商品条码、中文品名、英文品名，用英文逗号或者换行隔开
  Videos_are_not_allowed_to_be_uploaded_on_the_non_Lazada_platform: "Platform bukan Lazada dilarang memuat naik video",//非 Lazada 平台禁止上传视频
  Arrange_in_descending_order_by_value: "Susun mengikut nilai dari besar ke kecil",//按数值从大到小排列
  Please_enter_the_reason_for_rejection: "Sila masukkan sebab penolakan",//请输入拒绝原因
  There_already_exists_an_identical_export_task_Do_you_want_to_download_it_directly: "Tugasan eksport yang sama sudah wujud, adakah hendak muat turun terus ? ",//已经存在完全相同的导出任务，是否直接下载
  Our_warehouse_ID: "ID gudang pihak kami",//我方仓库ID
  Customer_Warehouse_Business_Type: "Jenis perniagaan gudang pelanggan",//客户仓库业务类型
  Packaging_material_data: "Data bahan pembungkusan",//包材数据
  Please_upload_chat_evidence: "Sila muat naik bukti perbualan",//请上传聊天凭证
  Rejected: "Telah ditolak",//已拒绝
  Operable_quantity: "Kuantiti boleh dikendalikan",//可操作数量
  Third_party_warehouse: "Gudang pihak ketiga",//第三方仓库
  Sales_status: "Status jualan",//销售状态
  First_Mile_Cost: "Kos perjalanan pertama: ",//头程费用：
  About_to_expire: "Akan tamat tempoh",//即将过期
  Enter_API_account: "Sila masukkan akaun API",//请输入API账号
  Generation_task_completed_successfully: "Tugasan berjaya dihasilkan",//生成任务成功
  Sorting: "Dalam proses penyusunan",//分拣中
  platformCommissionSettings: "Tetapan komisen platform",//平台佣金设置
  Please_carefully_verify_whether_the_warehouse_address_is_consistent_with_the_system: "Sila semak dengan teliti sama ada alamat gudang sepadan dengan sistem",//请仔细检查仓库地址是否则跟系统一致
  confirm_delete_category: "Sahkan pemadaman kategori",//确认删除类目
  The_picture_is_mandatory_while_the_video_is_optional: "Gambar wajib diisi, video adalah pilihan",//图片为必填，视频为选填
  Customer_defined_input_amount: "Jumlah wang yang dimasukkan secara tersuai oleh pelanggan",//客户自定义输入金额
  Returned_but_not_yet_signed: "Telah dikembalikan tetapi belum diterima",//已退回未签收
  When_the_warehouse_customer_provided_packaging_materials_are_self_supplied_packaging_materials: "Apabila bahan pembungkusan disediakan oleh gudang / pelanggan, ia dianggap sebagai bahan pembungkusan sendiri",//仓库/客户自备包材为自备包材时
  Warehouse_business_types: "Jenis perniagaan gudang",//仓库业务类型
  Select_third_party_warehouse_first: "Sila pilih gudang pihak ketiga terlebih dahulu",//请先选择第三方仓库
  The_sales_volume_of_the_goods_in_this_country_during_the_selected_time_period: "Dalam tempoh penapisan, kuantiti jualan produk bagi negara tersebut",//筛选时间内，该国家的商品销售数量
  Reject_Invoice: "Tolak invois",//驳回发票
  Only_registration: "Pendaftaran sahaja",//仅登记
  Cost_of_generating_multiple_warehouses: "Jana kos pelbagai gudang",//生成多仓费用
  First_Mile_Logistics: "Logistik perjalanan pertama",//头程物流
  start_number_cannot_be_greater_than_end_number: "Nombor permulaan tidak boleh lebih besar atau sama dengan nombor penamat",//开始编号不能大于等于截止编号
  rechargeApplication: "Permohonan tambah nilai",//充值申请
  Third_party_transit_warehouse_EN_name: "Nama Inggeris gudang transit pihak ketiga",//第三方中转仓英文名称
  Confirm_Information_Is_Correct_And_Submit_To_Invoiced_This_Action_Is_Irreversible: "Sahkan sama ada maklumat betul untuk diserahkan ke status telah diinvois, tindakan ini tidak boleh dibatalkan",//是否确认信息正确提交至已开票，此操作不可撤销。
  Please_select_city: "Sila pilih bandar",//请选择城市
  Our_warehouse: "Gudang pihak kami",//我方仓库
  value_added_task_number: "Nombor tugasan nilai tambah",//增值任务单号
  temuGoodsOnline: "Produk dalam talian Temu",//Temu在线商品
  orderPlacementReport: "Laporan kuantiti pesanan",//下单量报表
  signTheList: "Senarai tandatangan",//签署名单
  Mark_the_contract_as_invalid: "Tandakan kontrak sebagai tidak sah",//标记合同失效
  batchCreation: "Cipta secara pukal",//批量创建
  Enter_API_endpoint: "Sila masukkan API antara muka",//请输入API接口
  Confirm_Revocation: "Sahkan pembatalan ? ",//是否确认撤销？
  view_progress: "Lihat kemajuan",//查看进度
  Receiving_date: "Tarikh penerimaan",//收货日期
  Invoice_Export: "Eksport invois",//开票导出
  Please_enter_SkcId_separated_by_commas_or_newlines: "Sila masukkan SkcId, dipisahkan dengan koma atau baris baru",//请输入SkcId，用逗号或换行隔开
  Overdue_putaway_order_quantity: "Kuantiti pesanan masuk yang melebihi masa untuk disusun",//上架超时入库单量
  Third_party_transit_warehouse: "Gudang transit pihak ketiga",//第三方中转仓
  Please_select_the_synchronous_SKU_range: "Sila pilih skop SKU untuk diselaraskan",//请选择同步SKU范围
  Revoke: "Batal",//撤销
  Picking_Completed: "Telah selesai penyusunan barang",//已完成配货
  Template_ID: "ID templat",//模版ID
  Reject_to_return_the_item: "Tolak pemulangan",//拒绝退货
  File_request_failed: "Permintaan fail gagal",//文件请求失败
  If_So_Subsequently_Registered_Customer_IDs_Will_Start_From_This_Customer_ID_And_Increment_By_1: "Jika lebih besar, ID pelanggan yang berdaftar seterusnya akan meningkat secara automatik + 1 daripada ID pelanggan ini",//如果大于，则后续注册的客户ID将从此客户ID开始自增+1。
  And_attach_pictures_for_illustration: "Serta muat naik gambar sebagai keterangan",//并上传图片以作说明
  Upload_failed: "Muat naik gagal",//上传失败
  Please_click_the_Pull_Specified_Product_button_select_the_corresponding_store_and_enter_the_product_link_SkcId: "Sila klik butang 'Tarik produk yang ditentukan' untuk memilih kedai yang sepadan dan masukkan pautan produk SkcId",//请点击“拉取指定商品”按钮选择对应店铺输入商品链接SkcId
  invoiceDetail: "Butiran invois",//发票详情
  warehouseOrderPlacementReport: "Laporan kuantiti pesanan gudang",//仓库下单量报表
  Our_company: "Syarikat pihak kami",//我方公司
  Warehouse_packaging_materials: "Bahan pembungkusan gudang",//仓库包材
  Enter_token: "Sila masukkan Token",//请输入Token
  Modify_platform_commission: "Ubah suai komisen platform",//修改平台佣金
  File_format_error: "Format fail salah",//文件格式错误
  Standard_default_standard_for_all_customer_warehouses: "Biasa(semua gudang pelanggan lalai kepada biasa)",//常规（所有客户仓库默认常规）
  Please_Select_The_Specification_Type: "Sila pilih jenis yang ditentukan",//请选择指定类型
  loadingFee: "Kos pemuatan kontena",//装柜费
  No_blank_space: "Tidak meninggalkan ruang kosong",//不留白
  The_handling_fee_shall_not_be_greater_than_or_equal_to_the_recharge_amount: "Yuran perkhidmatan tidak boleh melebihi atau sama dengan jumlah tambah nilai",//手续费不得大于等于充值金额
  Hello_welcome_to_use_YTB_OMS: "Selamat datang, sila gunakan Yangtuo OMS",//您好，欢迎使用洋驼帮OMS
  Bind_transit_warehouse: "Ikat gudang transit",//绑定中转仓
  Up_To_500_Records_Are_Supported: "Sokongan maksimum 500 data",//最多支持500条数据
  Default_category: "Kategori lalai",//默认类目
  Return_waybill_number: "Nombor resit pemulangan",//退货运单号
  Single_product_quantity: "Satu item, kuantiti berganda",//单品多量
  in_service: "Dalam perkhidmatan",//服务中
  Inventory_Lack: "Gudang kehabisan stok",//仓库缺货
  Please_Select_Data_For_The_Same_Document_Type: "Sila pilih data invois dengan jenis dokumen yang sama",//请选择相同单据类型的开票数据
  The_migration_of_the_store_cannot_be_consistent_with_the_selection_of_the_store_name_Please_reselect: "Nama kedai yang dipindahkan tidak boleh sama dengan nama kedai yang dipilih, sila pilih semula",//迁移店铺不能与选择店铺名称一致，请重新选择
  Only_contracts_with_valid_status_can_be_marked: "Hanya kontrak dengan status sah boleh ditandakan",//只能标记状态有效合同
  Is_Below_The_Warning_Quantity: "Adakah di bawah kuantiti amaran ? ",//是否低于预警数量
  Packaging_name_cannot_be_the_same: "Nama bahan pembungkusan tidak boleh sama",//包材名称不能相同
  Picking_in_Progress: "Dalam proses penyusunan pesanan",//配货中
  review: "Semak",//审核
  Customer_Cancel: "Pelanggan memulakan pembatalan",//客户发起取消
  Adjust_quantity: "Laraskan kuantiti",//调整数量
  This_operation_will_permanently_delete_continue: "Tindakan ini akan memadamkan secara kekal, teruskan ? ",//此操作将永久删除, 是否继续?
  Please_select_Issue_Status: "Sila pilih status penghantaran",//请选择下发状态
  The_current_contract_is_the_last_valid_one_for_this_customer_After_manually_marking_it_as_invalid_if_the_customer_needs_to_continue_using_the_system_please_promptly_connect_and_complete_the_signing_of_a_new_contract: "Ini adalah kontrak sah terakhir bagi pelanggan ini, selepas ditandakan tidak sah secara manual, jika pelanggan masih perlu menggunakan sistem, sila hubungi untuk menandatangani kontrak baru",//当前为该客户最后一份有效合同，手动标记失效后，若客户需继续使用系统，请及时对接完成新合同签署
  Large_Scale_Exports_Must_Include_A_Time_Condition_And_The_Maximum_Time_Span_Cannot_Exceed_One_Calendar_Month: "Eksport pukal mesti mempunyai sekurang - kurangnya satu syarat masa, dan julat masa maksimum tidak boleh melebihi 1 bulan kalendar",//大批量导出必须存在一个时间条件，且时间跨度最大不能超过1个自然月。
  seaFreight: "Kos pengangkutan laut",//海运费
  importTemplateFileManagement: "Pengurusan fail templat import ",//导入模版文件管理
  No_return_logistics: "Tiada logistik pemulangan",//无退回物流
  must_be_between_0_and_100: "Mesti berada antara 0 - 100",//必须在0-100之间
  Domestic: "Domestik",//国内
  Modify_custom_fees: "Ubah suai kos tersuai",//修改自定义费用
  The_logistics_company_does_not_exist_or_has_been_deactivated_Please_check: "Syarikat logistik semasa tidak wujud atau tidak diaktifkan, sila semak",//当前物流公司不存在或未启用，请检查
  Is_The_Sum_Of_All_Costs_Excluding_First_Mile_Cost_And_Top_Ups: "Ini adalah jumlah semua kos kecuali kos perjalanan pertama dan tambah nilai",//就是除头程费用、充值外的所有费用总和。
  Used_for_non_standard_charges: "Digunakan untuk caj bukan standard",//用于非标准收费
  No_third_party_transit_warehouse_data_sync_first_then_bind: "Tiada data gudang transit pihak ketiga buat masa ini, sila selaraskan terlebih dahulu sebelum memilih untuk diikat",//当前暂无第三方中转仓数据，请先同步后再选绑定
  The_warehouse_receipt_is_submitted_for_review_and_the_stocking_process_enters_the_completion_stage_If_there_are_different_purchase_prices_the_latest_purchase_price_of_the_goods_will_be_automatically_updated: "Pesanan masuk diserahkan untuk semakan, dan penyediaan stok memasuki peringkat selesai, jika terdapat harga pembelian yang berbeza, harga pembelian terkini produk akan dikemas kini secara automatik",//入库单提交至待审核，备货进入完成阶段，如果存在不同的采购价都会自动更新商品最新采购价
  True_Length: "Panjang sebenar(CM)",//真实长(CM)
  client_region: "Kawasan pelanggan",//客户地区
  Ongoing_disputed_orders: "Pesanan dalam pertikaian yang sedang berjalan",//进行中的争议订单
  Disputed: "Telah mengemukakan pertikaian",//已提出争议
  Has_the_inventory_been_checked: "Adakah inventori telah dilaksanakan ? ",//是否已执行盘点
  Please_enter_the_rule_name: "Sila masukkan nama peraturan",//请输入规则名称
  Rejected_or_Cancelled: "Telah ditolak / dibatalkan",//已拒绝/取消
  only_revoke_orders_with_WMS_status_of: "Hanya batal jika status WMS pesanan adalah",//仅撤销订单WMS状态为
  system_order_status: "Status pesanan sistem",//系统订单状态
  Copy_Order: "Salin pesanan",//复制订单
  Transit_warehouse_already_selected: "Gudang transit ini telah dipilih oleh gudang pihak ketiga lain",//该中转仓库已被其他第三方仓库选择
  Quantity_Per_Carton: "Kuantiti sekotak",//单箱数量
  Please_enter_the_refund_amount: "Sila masukkan jumlah bayaran balik",//请输入退款金额
  Please_select_order_source: "Sila pilih sumber pesanan",//请选择订单来源
  Gross_Weight_Per_Carton: "Berat kasar sekotak",//单箱毛重
  Please_select_the_scope_of_the_synchronized_store: "Sila pilih skop kedai untuk diselaraskan",//请选择同步店铺范围
  categoryManagement: "Pengurusan kategori",//类目管理
  No_logistics_tracking_available: "Tiada jejak logistik buat masa ini",//暂无物流轨迹
  If_not: "Jika tiada",//如果没有
  The_contract_has_not_been_generated_yet: "Kontrak belum dihasilkan buat masa ini",//暂未生成合同
  Dock_handling_document_fees_storage_fees_etc: "Caj seperti pemunggahan di jeti, yuran dokumen, yuran penyimpanan, dll",//码头装卸、文件费、堆存费等
  This_platform_currently_only_supports_uploading_images_Please_select_another_image_file: "Platform semasa hanya menyokong muat naik gambar, sila pilih fail gambar semula",//当前平台仅支持上传图片，请重新选择图片文件
  Receiving: "Terima barang",//收货
  No_Invoice_Available: "Tiada invois buat masa ini",//暂无发票
  Custom_fees: "Kos tersuai",//自定义费用
  Failed_to_get_logistics_company_ID: "ID syarikat logistik tidak diperoleh",//未获取到物流公司ID
  Seller_operation_deadline: "Tarikh tamat operasi penjual",//卖家操作截止时间
  pleaseEnterCustomerID: "Sila pilih pelanggan",//请选择客户
  Confirm_unbind_transit_warehouse: "Sahkan untuk membuka ikatan gudang transit ini ? ",//确认解绑该中转仓吗？
  Please_click_the_Pull_Specified_Product_button_select_the_corresponding_store_and_enter_the_product_link_ID: "Sila klik butang 'Tarik produk yang ditentukan' untuk memilih kedai yang sepadan dan masukkan ID pautan produk",//请点击“拉取指定商品”按钮选择对应店铺输入商品链接id
  The_bar_code_cannot_start_or_end_with_spaces_or_contain_newlines: "Kod bar tidak boleh bermula atau berakhir dengan ruang kosong, dan tidak boleh mengandungi baris baru",//条形码不能以空格开头或结尾，也不能包含换行符
  Apply_For_Invoicing: "Memohon invois",//申请开票
  Warehouse_out_of_stock_cancellation: "Pembatalan akibat gudang kehabisan stok",//仓库缺货取消
  Item: "Satu item",//单品
  Self_provided_packaging_materia: "Bahan pembungkusan sendiri",//自备包材
  This_operation_will_permanently_deleteDo_you_want_to_continue: "Tindakan ini akan memadamkan secara kekal, teruskan ? ",//该操作将会永久删除，是否继续
  companyInformation: "Maklumat syarikat",//公司信息
  Returned_and_signed: "Telah dikembalikan dan diterima",//已退回已签收
  Are_you_sure_to_confirm_the_current_scanned_waybill_number: "Sahkan nombor resit penghantaran yang sedang diimbas ? ",//是否确认当前扫描运单号
  Please_Select_Data_For_The_Same_Invoicing_Entity: "Sila pilih data dengan subjek invois yang sama",//请选择同一开票主体数据
  Buyer_return_goods_deadline: "Tarikh tamat untuk pembeli memulangkan barang",//买家退回商品截止
  Insufficient_disk_space_automatic_cleaning: "Ruang cakera tidak mencukupi, pembersihan automatik dijalankan",//磁盘空间不足自动清理
  Please_Enter_Rejection_Reason: "Sila masukkan sebab penolakan",//请输入驳回原因
  Sorting_has_not_begun: "Belum memulakan penyusunan",//未开始分拣
  The_third_party_printing_has_failed_at_present: "Percetakan pihak ketiga semasa gagal",//当前第三方打印失败
  Please_select_category_name: "Sila pilih nama kategori",//请选择类目名称
  Select_data_first: "Sila tandakan data terlebih dahulu",//请先勾选数据
  Document_Type: "Jenis dokumen",//单据类型
  Please_upload_at_least_one_picture_video_is_optional: "Sila muat naik sekurang - kurangnya satu gambar(video adalah pilihan)",//请至少上传一张图片（视频为选填）
  Inventory_adjustment_of_packaging_materials: "Pelarasan stok bahan pembungkusan",//包材库存调整
  Migration_of_online_goods: "Pindahkan produk dalam talian",//迁移在线商品
  Please_Check_If_The_Invoice_Is_Correct: "Sila semak sama ada invois adalah betul",//请检查发票是否正确
  Once_Lazada_makes_a_decision: "Menunggu keputusan Lazada",//待Lazada决定
  Outer_Carton_Length: "Panjang kotak luar",//外箱长度
  Invoice_Status: "Status invois",//发票状态
  sell_out: "Habis dijual",//售罄
  Export_import_customs_clearance_service_fee_global: "Yuran perkhidmatan kastam eksport /import, berkenaan secara global",//出口/进口清关服务费，全球通用
  Paper: "Kertas",//纸质
  Agree_to_return_the_item: "Setuju pemulangan",//同意退货
  Non_API_Orders_Exist_Operation_Not_Allowed: "Wujud pesanan bukan API, tidak boleh beroperasi!",//存在非API订单，不可操作！
  Please_input_transfer_stock_fee: "Sila masukkan kos(meter padu / KG)",//请输入费用（立方/KG）
  Not_published_on_the_website: "Belum diterbitkan ke laman",//未发布到站点
  no_warehouse: "Tiada gudang",//无仓库
  No_More_Than_5_Files: "Tidak melebihi 5 keping",//不超过5张
  Warehouse_IDs_cannot_be_the_same: "ID gudang tidak boleh sama",//仓库ID不能相同
  Inventory_entry_and_exit_process_id: "ID aliran masuk / keluar stok",//出入库流水ID
  Waiting_for_TikTok_Buyer_processing: "Menunggu TikTok / pembeli memproses",//等待TikTok/买家处理
  Return_pickup_method: "Kaedah pengambilan barang pulangan",//退货取件方式
  Refunded: "Telah dibayar balik",//已退款
  third_party_logistics_service_provider: "Syarikat logistik pihak ketiga",//第三方物流公司
  The_priority_must_be_a_positive_number: "Keutamaan mestilah nombor positif",//优先级必须是正数
  issueInvoiceConfiguration: "Konfigurasi invois",//开票配置
  No_Orders_Exist_For_The_Currently_Selected_Task: "Tugasan yang dipilih tiada pesanan",//当前勾选任务不存在订单
  Reject_to_refund: "Tolak bayaran balik",//拒绝退款
  Evidence_upload_status: "Status muat naik bukti",//证据上传状态
  Establish_a_store: "Cipta kedai",//创建店铺
  Create_invoice_application: "Cipta permohonan invois",//创建开票申请
  Joining_orders: "Gabungkan pesanan",//合单
  Please_enter_the_number_of_warning_days: "Sila masukkan bilangan hari amaran",//请输入预警天数
  countryOrderPlacementReport: "Laporan kuantiti pesanan mengikut negara",//国家下单量报表
  Outer_Carton_Height: "Ketinggian kotak luar",//外箱高度
  Return_images_and_videos: "Gambar dan video pulangan",//退货图片视频
  Real_time_on_the_day: "Masa sebenar hari tersebut",//当天实时
  tagName: "Nama label",//标签名
  is_total_order_volume_click_on_the_detailed_data_to_view_the_storage_order_list: "Jumlah kuantiti pesanan, klik data terperinci untuk melihat senarai pesanan gudang",//的总下单量,点击详细数据可查看仓储订单列表
  portCharges: "Caj pelabuhan",//港杂费
  Daily_upload_time_of_pictures_videos_to_the_warehouse_server: "Masa muat naik gambar / video ke pelayan gudang setiap hari",//每天上传图片/视频到仓库服务器时间
  Multiple_Invoice_Records_Exist_Please_Upload_Individually: "Terdapat pelbagai data invois, sila muat naik secara berasingan",//存在多条开票数据，请单独上传
  Do_you_want_to_synchronize_and_update_the_current_online_product_images_to_the_paired_sku_main_image: "Adakah hendak mengemas kini gambar produk dalam talian semasa ke gambar utama SKU yang dipadankan secara serentak ? ",//是否将当前在线商品图片同步更新至配对SKU主图
  Next_Page: "Halaman seterusnya",//下一页
  Obtain_a_third_party_designated_return_order: "Dapatkan resit pulangan yang ditentukan oleh pihak ketiga",//获取第三方指定退货单
  Priority_Of_Listing_Scanning: "Keutamaan imbasan penyusunan",//上架扫描优先级
  System: "Sistem",//系统
  Sorting_in_Progress: "Dalam proses penyusunan",//分拣中
  Compensation_seller_status: "Status pampasan penjual",//赔偿卖家状态
  Invoicing: "Invois",//开票
  plugin: "Plugin",//插件
  True_Width: "Lebar sebenar(CM)",//真实宽(CM)
  take_effect: "Berkuat kuasa",//生效
  Batch_import_and_claim_data: "Import data tuntutan secara pukal",//批量导入认领数据
  Upload_the_paper_contract: "Muat naik kontrak kertas",//上传纸质合同
  Equivalent_to_regular_return_receipt: "Sama dengan penerimaan barang pulangan biasa",//等于普通的退件收货
  Update_the_first_leg_status_which_must_be_the_dispatched_status: "Kemas kini status perjalanan pertama, mestilah status penghantaran",//更新头程状态，需是下发状态
  color: "Warna",//颜色
  Product_Secondary_Image: "Gambar sekunder produk",//商品次图
  File_name: "Nama fail",//文件名
  Batch_enable: "Aktifkan secara pukal",//批量启用
  It_shows_overtime: "Maka akan menunjukkan masa tamat",//则显示超时
  Final_inventory_execution_time: "Masa pelaksanaan inventori akhir",//最终执行盘点时间
  Please_select_packaging: "Sila pilih sama",//请选择相同
  Invoice_Serial_Number: "Nombor aliran invois",//发票流水号
  ThirdPartyWarehouseAuthorization: "Kebenaran gudang pihak ketiga",//第三方仓授权
  Sync_warehouses: "Selaraskan gudang",//同步仓库
  Please_Go_To_The_Print_Label_Page_To_Obtain_The_Label: "Sila pergi ke halaman cetakan label untuk mendapatkan label",//请前往打印标签页获取标签
  Custom_classification: "Klasifikasi tersuai",//自定义分类
  Attachments: "Lampiran",//附件
  Initial_cost_sharing: "Kos pro - rata perjalanan pertama",//头程分摊费
  Total_occupancy_quantity_order_occupancy_quantity_manual_outbound_occupancy_quantity_warehouse_transfer_occupancy_quantity_Remove_occupied_quantity: "Jumlah kuantiti yang diduduki(kuantiti diduduki pesanan / kuantiti diduduki pengeluaran manual / kuantiti diduduki pemindahan stok / kuantiti diduduki pemindahan keluar)",//总占用数量（订单占用数量/手工出库占用数量/移仓占用数量/移出迁出占用数量）
  Download_Invoice: "Muat turun invois",//下载发票
  Seller_is_email_address: "E - mel penjual",//卖家邮箱
  Refund_request_has_been_initiated: "Telah memulakan bayaran balik",//已发起退款
  Please_add_the_category: "Sila tambah kategori",//请添加类目
  Edit_recharge_application: "Edit permohonan tambah nilai",//编辑充值申请
  portChargesCost: "Kos caj pelabuhan",//港杂费成本
  only_support_sku_and_goodsCode_and_createTime_and_select_export: "Hanya sokongan SKU, kod bar produk, masa penciptaan, dan eksport berdasarkan pilihan",//仅支持SKU、商品条码、创建时间、勾选导出
  appeal: "Rayuan",//申诉
  freightCost: "Kos pengangkutan",//运费成本
  Calculation_field_for_first_leg_shared_cost: "Medan pengiraan kos pro - rata perjalanan pertama",//头程分摊费计算字段
  Arbitration_status: "Status timbang tara",//仲裁状态
  Please_select_the_designated_store: "Sila pilih kedai yang ditentukan",//请选择指定店铺
  Insufficient_space_storage_days_warning: "Amaran storan tidak mencukupi berdasarkan hari",//空间不足存储天数预警
  File_formats_that_are_not_supported_for_previewing: "Format fail tidak disokong untuk pratonton",//不支持预览的文件格式
  orderolume: "Kuantiti pesanan",//下单量
  Is_it_a_default_contract: "Adakah kontrak lalai ? ",//是否为默认合同
  Our_warehouse_code: "Kod gudang pihak kami",//我方仓库编码
  Third_party_transit_warehouse_ID: "ID gudang transit pihak ketiga",//第三方中转仓ID
  Third_party_log_list: "Senarai log pihak ketiga",//第三方日志列表
  Claim_area: "Zon tuntutan",//认领区
  Returned_but_not_yet_warehoused: "Telah dikembalikan tetapi belum dimasukkan ke gudang",//已退回未入库
  Outer_Carton_Width: "Lebar kotak luar",//外箱宽度
  Logistics_company_name: "Nama syarikat logistik",//物流公司名称
  Explosive_delivery: "Penghantaran produk popular",//爆款发货
  Enter_API_address: "Sila masukkan alamat API",//请输入API地址
  Third_party_warehouse_code: "Kod gudang pihak ketiga",//第三方仓库编码
  Please_enter_your_email_address: "Sila masukkan alamat e - mel",//请输入邮箱地址
  Multi_class: "Pelbagai item",//多品
  batch_download: "Muat turun secara pukal",//批量下载
  pleaseSelectCountry: "Sila pilih negara",//请选择国家
  Hong_Kong_Ang_Macau: "Hong Kong, Macau, Taiwan",//港澳台
  Please_check_the_list_data_first: "Sila tandakan data dalam senarai terlebih dahulu",//请先勾选列表数据
  Contract_medium_type: "Jenis medium kontrak",//合同介质类型
  Automatically_read_the_location_type_corresponding_to_the_selected_location: "Secara automatik membaca jenis lokasi yang sepadan dengan lokasi yang dipilih",//自动读取选择的库位对应的库位类型
  Please_input_demurrage_start_day: "Sila masukkan hari amaran untuk tempoh tertahan",//请输入滞留起收天数
  Missing_the_upload_of_target_data: "Tiada data sasaran untuk muat naik",//缺少上传目标数据
  One_star: "Satu bintang",//一星
  When_the_signing_validity_period_is_not_filled_in_or_equal_to_0_the_validity_period_is_equal_to_unlimited: "Jika tempoh sah tandatangan tidak diisi atau sama dengan 0, tempoh sah adalah selama - lamanya",//签署有效时间未填写或者等于0的时候，有效时间等于无限期
  Add_recharge_application: "Tambah permohonan tambah nilai baharu",//新增充值申请
  Please_upload_the_picture_as_evidence: "Sila muat naik gambar sebagai bukti",//请上传图片作为凭证
  You_have_expired_stores_that_need_to_be_handled: "Anda mempunyai kedai yang akan tamat tempoh untuk diproses",//您有即将过期店铺待处理
  Reason_for_Refund: "Sebab bayaran balik",//退款原因
  Please_upload_pictures_and_videos_as_evidence: "Sila muat naik gambar dan video sebagai bukti",//请上传图片和视频作为凭证
  cut_off_time: "Tarikh tamat",//截止时间
  Synchronized_packaging_materials: "Selaraskan bahan pembungkusan",//同步包材
  The_sales_volume_of_this_SKU_in_this_warehouse_during_the_selected_time_period: "Dalam tempoh penapisan, kuantiti jualan SKU ini di gudang tersebut",//筛选时间内，该SKU在该仓库的销售数量
  Lost_package_in_logistics: "Kehilangan pakej logistik",//物流丢包
  all_product_quantity_equals_defective_quantity_this_return_order_will_turn_to_reject_stage: "Kuantiti produk adalah sama dengan kuantiti tidak memuaskan, resit pulangan ini akan dipindahkan ke peringkat penolakan",//商品数量均等于不合格数量，此退货单将会转入驳回阶段
  task_center_export_excel_task_view_progress: "Pusat tugas[Tugas Eksport Excel]",//任务中心【导出Excel任务】
  Transferred: "Transit",//转运
  There_are_stores_whose_authorization_has_expired_and_are_about_to_expire_that_need_to_be_handled: "Anda mempunyai kedai yang kebenaran telah tamat tempoh dan akan tamat tempoh untuk diproses",//您有授权过期和即将过期店铺待处理
  Printing_Shipping_Labels: "Dalam proses mencetak label",//打印面单中
  Pending_receipt: "Menunggu penerimaan barang",//待收货
  Current_time: "Masa semasa",//当前时间
  Commodity_diversion_number: "Nombor pengalihan produk",//商品分流编号
  Please_select_the_inventory_allocation_strategy: "Sila pilih strategi peruntukan stok",//请选择库存分配策略
  Final_inventory_executor: "Pelaksana inventori akhir",//最终执行盘点人
  The_sales_volume_of_the_goods_in_this_store_during_the_selected_time_period: "Dalam tempoh penapisan, kuantiti jualan produk di kedai tersebut",//筛选时间内，该店铺的商品销售数量
  Once_the_seller_makes_a_decision: "Menunggu keputusan penjual",//待卖家决定
  pleaseSelectChannelType: "Sila pilih jenis saluran",//请选择渠道类型
  Changing_The_Customer_ID_Will_Automatically_Clear_The_Corresponding_Return_Product_Details_Please_Proceed_With_Caution: "Menukar ID pelanggan akan membersihkan butiran produk pulangan yang sepadan secara automatik, sila berhati - hati",//更换客户ID，将自动清除对应退件商品明细，请谨慎作。
  Our_transit_warehouse: "Gudang transit pihak kami",//我方中转仓
  viewRechargeDetail: "Lihat butiran tambah nilai",//查看充值详情
  system_return_phase: "Tahap pulangan sistem",//系统退货阶段
  temuOnlineProductDetails: "Butiran produk dalam talian Temu",//Temu在线商品明细
  Synchronize_third_party_product_information: "Selaraskan maklumat produk pihak ketiga",//同步第三方商品信息
  Switch_repositories: "Tukar gudang",//切换仓库
  Only_Files_In_Png_Jpg_Jpeg_Or_Webp_Format_Can_Be_Uploaded: "Hanya boleh muat naik fail format png, jpg, jpeg, webp",//只能上传png、jpg、jpeg、webp格式文件
  Please_Select_The_Parent_Data: "Sila tandakan data peringkat atas",//请勾选上级数据
  Please_verify_the_goods_before_approving_the_refund: "Sila sahkan produk sebelum meluluskan bayaran balik",//请验证商品后方可批准退款
  Packing_dimensions: "Dimensi pemuatan kontena",//装柜尺寸
  Please_enter_the_category_name: "Sila masukkan nama kategori",//请输入类目名称
  Return_logistics_status: "Status logistik pulangan",//退回物流状态
  Pulling_in_progress: "Sedang menarik data",//正在拉取中
  Batch_Add_category: "Tambah kategori secara pukal",//批量添加类目
  firstPassCostFCL: "Kos perjalanan pertama - kontena penuh",//头程费-整柜
  issueAnInvoice: "Menerbitkan invois",//开具发票
  Applied: "Telah memohon",//已申请
  Purchase_unit_price: "Harga belian seunit",//采购单价
  The_following_orders_products_have_been_refused_for_return_Please_provide_the_reasons_for_the_rejection: "Pesanan / produk berikut ditolak untuk pemulangan Sila berikan sebab penolakan",//下列订单/商品被拒绝退货。请提供拒绝理由
  Clear: "Kosongkan",//清空
  add_Category: "Tambah kategori",//添加类目
  Data_With_Empty_Invoice_Address_Exists_Cannot_Submit: "Terdapat data dengan alamat invois kosong, tidak boleh dihantar",//存在发票地址为空的数据，不可提交
  Please_enter_a_running_rule: "Sila masukkan peraturan larian",//请输入运行规则
  After_return_automatically_put_away_to_return_storage_location: "Selepas pemulangan, automatik naik ke rak di lokasi pulangan",//退件后自动上架到退货库位
  Seller_compensation_deadline: "Tarikh akhir penjual memohon pampasan",//卖家申请赔偿截止
  Specified_Condition_Data: "Data mengikut syarat yang ditentukan",//指定条件数据
  Unable_to_access_camera_please_reconnect_and_refresh_page: "Tidak dapat mengakses kamera, sila sambung semula dan muat semula halaman",//无法访问摄像头,请重新连接后刷新页面
  Remove_occupied_quantity: "Kuantiti diduduki untuk pemindahan keluar",//移出迁出占用数量
  API_address: "Alamat API",//API地址
  Upload_Invoice: "Muat naik invois",//上传发票
  Full_refund: "Bayaran balik penuh",//全额退款
  Rejection_Reason: "Sebab penolakan",//驳回原因
  Platform_return_status: "Status pemulangan platform",//平台退货状态
  Select_status: "Sila pilih status pengaktifan",//请选择启用状态
  Details_of_the_first_leg_bill_full_container: "Butiran bil perjalanan pertama(kontena penuh)",//头程账单详情（整柜）
  Our_company_is_collection_of_payments: "Penerimaan bayaran syarikat pihak kami",//我方公司收款
  Minimum_purchase_price: "Harga belian minimum seunit",//最低采购单价
  Distribution_or_Shipping_Classification: "Klasifikasi penghantaran / pembungkusan",//配/发货分类
  Template_file: "Fail templat",//模版文件
  Our_warehouse_name: "Nama gudang pihak kami",//我方仓库名称
  Select_transit_warehouse: "Sila pilih gudang transit",//请选择中转仓库
  Import_return_inventory_list: "Import senarai stok pulangan",//导入退货库存列表
  Edit_packaging_material: "Ubah suai bahan pembungkusan",//修改包材
  Default_first_leg_cost_sharing_for_products: "Kos pro - rata perjalanan pertama lalai produk",//商品默认头程分摊费
  The_synchronized_inventory_quantity_must_be_greater_than_0: "Kuantiti stok yang diselaraskan mestilah lebih besar daripada 0",//同步库存数量必须大于0
  The_priority_must_be_a_positive_integer: "Keutamaan mestilah integer positif",//优先级必须为正整数
  Platform_Under_Review: "Dalam proses semakan platform",//平台审核中
  airportHandlingFeeCost: "Kos operasi lapangan terbang",//机场操作费成本
  API_account: "Akaun API",//API账号
  Apply_For_Customer_ID: "Memohon ID pelanggan",//申请客户ID
  Cancel_type: "Jenis pembatalan",//取消类型
  Cron_string: "Peraturan larian",//运行规则
  Currently_selected_data_cannot_be_operated_on: "Data yang dipilih semasa tidak boleh dikendalikan",//当前选中数据不能操作
  pleaseSelectEnableStatus: "Sila pilih status pengaktifan",//请选择启用状态
  Our_transit_warehouse_ID: "ID gudang transit pihak kami",//我方中转仓ID
  This_warehouse_has_been_selected_by_other_third_party_warehouses: "Gudang ini telah dipilih oleh gudang pihak ketiga lain",//该仓库已被其他第三方仓库选择
  The_Amount_Of_Data_To_Be_Exported_Is_Very_Large_It_Needs_To_Be_Queued_For_Processing_Please_Wait_Patiently: "Jumlah data yang dieksport sangat banyak, perlu beratur untuk berjalan, sila tunggu dengan sabar",//导出的数据量非常多，需要排队运行，请耐心等待。
  costConfiguration: "Konfigurasi kos",//成本配置
  Issued_By: "Penginvois",//开票人
  Receivables_of_both_companies: "Penerimaan bayaran kedua - dua syarikat",//双方公司收款
  No_data: "Tiada data",//无数据
  Transit_warehouse: "Gudang transit",//中转仓库
  Return_creation_time: "Masa penciptaan pulangan",//退货创建时间
  Outing_of_stock: "Dalam proses pengeluaran",//出库中
  Supported_previewable_file_formats: "Format fail yang disokong untuk pratonton",//支持预览的文件格式
  Product_differences: "Perbezaan produk",//商品差异
  This_operation_is_irreversible_please_proceed_with_caution: "Tindakan ini tidak boleh dipulihkan, sila berhati - hati",//此操作不可恢复，请谨慎操作
  Sync_online_product_images_to_SKU: "Selaraskan gambar produk dalam talian ke SKU",//同步在线商品图片至SKU
  Customer_Identification_Failed: "Pengenalpastian pelanggan gagal",//识别客户失败
  Are_you_sure_to_delete_this_shelf: "Sahkan pemadaman rak ini ? ",//确认删除该货架吗
  Current_inventory_information: "Maklumat stok sedia ada",//现有库存信息
  Issue_warehouse_receipt: "Penghantaran masuk ke gudang",//下发入库
  Is_API_Push_Enabled: "Adakah penghantaran API ? ",//是否API推送
  Import_attribute_managemen: "Import pengurusan atribut",//导入属性管理
  end_slice_number: "Nombor penamat",//截止编号
  Can_the_actual_product_data_be_modified_during_inbound_quality_inspection_or_return_quality_inspection: "Semasa menjalankan pemeriksaan kualiti masuk dan pemeriksaan kualiti pulangan, bolehkah data sebenar produk diubah ? ",//在进行入库质检、退货质检时，能否修改产品真实数据
  Has_the_settlement_been_completed: "Adakah penyelesaian selesai ? ",//是否完成结算
  stock_information: "Maklumat stok",//库存信息
  end_number_cannot_be_less_than_start_number: "Nombor penamat tidak boleh lebih kecil atau sama dengan nombor permulaan",//截止编号不能小于等于开始编号
  New_location_type: "Jenis lokasi baharu",//新库位类型
  Initiate_dispute: "Memulakan pertikaian",//发起争议
  Applied_Invoice_Amount: "Jumlah permohonan invois",//申请开票金额
  Additional_Deduction_Fee: "Caj tambahan",//补扣费
  or_mp4_video: "Atau video mp4",//或 mp4 视频
  rechargeManagement: "Pengurusan tambah nilai",//充值管理
  Bind_the_warehouse: "Ikat gudang",//绑定仓库
  PDF_Download_Failed: "Muat turun PDF gagal",//下载PDF失败
  Please_select_the_packaging_operation_first: "Sila pilih operasi pembungkusan terlebih dahulu",//请先选择包装操作
  Video: "Video",//视频
  special_needs: "Keperluan khas",//特需
  contract_file: "Fail kontrak",//合同文件
  dispute: "Pertikaian",//争议
  Please_enter_search_keywords: "Sila masukkan kata kunci carian",//请输入搜索关键词
  Return_and_refund: "Pemulangan dan bayaran balik",//退货退款
  file_and_not_more_than: "Fail, dan tidak melebihi",//文件，且不超过
  Each_picture_is_10MB_in_size_or_each_video_is_30MB_in_length_1_minute: "Setiap gambar 10MB atau setiap video 1 minit(30MB)",//每张图片10MB或每支影片1分钟(30MB)
  Invoicing_Month: "Bulan invois",//开票月份
  batch_modify_quantity: "Ubah suai kuantiti secara pukal",//批量修改数量
  Name_of_the_third_party_repository: "Nama gudang pihak ketiga",//第三方仓库名称
  The_quantity_that_has_not_been_put_on_the_shelves_will_be_regarded_as_all_unqualified: "Kuantiti yang belum melalui penyusunan akan dianggap sebagai tidak memuaskan sepenuhnya",//未经过上架的数量将视为全部不合格
  Transfer_stock_fee: "Kos pemindahan gudang(M³/ringgit)",// 移仓费用（M³/元）
  Complete_warehouse_pairing: "Sila lengkapkan padanan gudang",//请完成仓库配对
  Platform_or_Merchant_intervention: "Platform / penjual campur tangan",//平台/商家介入
  Please_Select_Data_For_The_Same_Invoice_Header: "Sila pilih data dengan kepala invois yang sama",//请选择同一发票抬头数据
  Please_select_the_mode: "Sila pilih mod",//请选择模式
  Entry_and_exit_slip_type: "Jenis masuk / keluar",//出入库类型
  Pay_special_attention_to: "Perhatian utama",//重点关注
  Place_an_order: "Hantar pesanan",//下发订单
  Commodity_purchase_price: "Harga pembelian produk",//商品采购价
  If_The_Number_Of_Exported_Rows_Exceeds_100000_It_Will_Automatically_Convert_To_A_Bulk_Export: "Jika kuantiti eksport melebihi 100,000 baris, ia akan ditukar secara automatik kepada eksport pukal besar",//如果导出数量超过10万行，将自动转换成大批量导出。
  Please_Upload_Invoice: "Sila muat naik invois",//请上传发票
  The_quantity_must_be_greater_than_1: "Kuantiti mestilah lebih besar daripada 1",//数量必须大于1
  Batch_binding_of_warehouses: "Ikat gudang secara pukal",//批量绑定仓库
  trailerFee: "Kos trak",//拖车费
  Re_Upload_Invoice: "Muat naik semula invois",//重新上传发票
  otherHandlingFee: "Kos operasi lain",//其他操作费
  customTags: "Label tersuai",//自定义标签
  Import_relocation_location: "Import pemindahan lokasi",//导入移库位
  Chat_Record: "Bukti perbualan",//聊天凭证
  All_inventory_information: "Semua maklumat stok",//所有库存信息
  Our_transit_warehouse_EN_name: "Nama Inggeris gudang transit pihak kami",//我方中转仓英文名称
  only_orders_with_WMS_status_of: "Hanya sokongan status WMS pesanan sebagai",//仅支持订单WMS状态为
  Number_of_automatically_generated_tasks: "Bilangan tugas dijana secara automatik",//自动生成任务数量
  Invoice_Details: "Butiran invois",//发票详情
  Download_failed: "Muat turun gagal",//下载失败
  Packaging_operation: "Operasi bahan pembungkusan",//包材操作
  Select_payment_mode: "Sila pilih mod penerimaan bayaran",//请选择收款模式
  Invoice_Line_Items: "Butiran invois",//发票明细
  Only_Jpg_Or_Png_Files_Can_Be_Uploaded_And_Up_To_5_Files: "Hanya boleh muat naik fail jpg atau png, dan tidak melebihi 5 keping",//只能上传jpg或png文件，且不超过5张
  Total_waybill_quantity: "Jumlah bil penghantaran",//总运单量
  Function_Name: "Nama fungsi",//功能名称
  Are_you_sure_to_delete_this_partition: "Sahkan pemadaman zon ini ? ",//确认删除该分区吗
  surface_area: "Luas permukaan",//表面积
  The_time_effect_formula_is: "Formula keberkesanan masa ialah",//时效公式为
  Sipment_in_Progress: "Dalam penghantaran",//发货中
  infinite: "Tanpa had",//无限
  The_customer_password_will_be_reset_to_customer_ID: "Kata laluan pelanggan akan ditetapkan semula kepada: ID pelanggan",//将会把客户密码重置为：客户ID
  Cross_border_customs_inspection_transfer_fees: "Kos kastam, pemeriksaan, dan transit semasa lintasan sempadan",//跨境时的通关、查验、中转费用
  Transit_warehouse_relation: "Hubungan gudang transit",//中转仓关系
  The_number_of_differences: "Kuantiti perbezaan",//差异数量
  Waiting_to_run: "Menunggu untuk berjalan",//等待运行中
  on_sale: "Dalam jualan",//在售
  Resolved: "Telah diselesaikan",//已解决
  Logistics_transit_warehouse: "Gudang transit logistik",//物流中转仓
  Electronic_contract: "Kontrak elektronik",//电子合同
  Up_To_5000_Records_Are_Supported: "Sokongan maksimum 5000 data",//最多支持5000条数据
  Destroyed: "Musnahkan",//销毁
  Initial_first_leg_sharing_fee: "Kos pro - rata perjalanan pertama awal",//初始头程分摊费
  logistics_warehouse: "Gudang logistik",//物流仓库
  Please_confirm_if_you_agree_to_the_refund: "Sila sahkan sama ada bersetuju untuk bayaran balik",//请确认是否同意退款
  loading_method: "Kaedah pemuatan kontena",//装柜方式
  The_Current_Export_Limit_Is_100000_Rows_Excluding_Child_Data: "Had eksport semasa ialah 100,000 baris(tidak termasuk data sub - level)",//当前限制导出条数为10万条（不包含子级数据）。
  InvoiceTotalAmount: "Jumlah invois",//开票总额
  loadingFeeCost: "Kos pemuatan kontena",//装柜费成本
  The_distribution_basket_has_not_been_scanned: "Bakul penyusunan belum diimbas sepenuhnya",//未完全扫描配货篮子
  True_Weight: "Berat sebenar",//真实重量
  closed: "Telah ditutup",//已关闭
  Start_execute_time: "Masa mula pelaksanaan",//执行开始时间
  Cost_allocation: "Konfigurasi kos",//费用配置
  Please_Upload_PDF_Format_File: "Sila muat naik fail format pdf",//请上传pdf格式的文件
  Return_logistics_information: "Maklumat logistik pulangan",//退回物流信息
  No_Invoicing_Application_Data_Exists: "Tiada data permohonan invois wujud",//不存在开票申请数据
  Please_input_detention_stock_fee: "Sila masukkan caj sewa gudang tertahan(M³/ringgit)",// 请输入滞留仓租费（M³/元）
  Four_star: "Empat bintang",//四星
  Sea_container_loading_service: "Perkhidmatan pemuatan kontena laut",//海运集装箱装箱服务
  Please_select_the_same_customer_order: "Sila tandakan pesanan pelanggan yang sama",//请勾选同一客户订单
  Save_and_generate_multiple_warehouse_fees: "Simpan dan jana kos pelbagai gudang",//保存并生成多仓费用
  The_third_party_printing_failed_Please_check_the_third_party_authorization_information: "Percetakan pihak ketiga gagal, sila semak maklumat kebenaran pihak ketiga!",//第三方打印失败，请检查第三方授权信息！
  Invoice_Download: "Muat turun invois",//发票下载
  Compensation_seller_amount: "Jumlah pampasan penjual",//赔偿卖家金额
  remove_from_shelves: "Turunkan dari rak",//下架
  Delivery_completed: "Penghantaran selesai",//发货完成
  Return_and_Collection_Method: "Kaedah pengambilan barang pulangan",//退件取件方式
  The_following_orders_products_require_the_buyer_to_return_the_goods_first: "Pesanan / produk berikut perlu dipulangkan oleh pembeli terlebih dahulu",//下列订单/商品需先由买家寄回
  attachment: "Lampiran",//附件
  Please_enter_the_inventory_synchronization_strategy_value: "Sila masukkan nilai strategi penyelarasan stok",//请输入库存同步策略值
  print_and_video_plugin: "Plugin cetakan + rakaman video",//打印+录像插件
  Currently_there_is_no_data_from_the_third_party_Please_synchronize_the_product_first: "Tiada data pihak ketiga buat masa ini, sila selaraskan produk terlebih dahulu",//当前没有第三方数据，请先同步商品
  Move_to_the_return_storage_location: "Naikkan ke rak di lokasi pulangan",//上架至退货库位
  Five_star: "Lima bintang",//五星
  in_dispute: "Dalam pertikaian",//争议中
  customsDeclarationFeeCost: "Kos pengisytiharan kastam",//报关费成本
  Commission_percentage: "Peratusan komisen",//佣金百分比
  third_party_distribution_log: "Log penghantaran pihak ketiga",//第三方下发日志
  Maximum_file_upload_size: "Saiz muat naik fail maksimum",//最大文件上传大小
  appointment_time: "Masa temu janji",//预约时间
  If_shelving_time_exceeds: "Jika masa penyusunan melebihi",//如果上架时间超过
  Ground_transportation_from_the_factory_or_warehouse_to_the_port_or_airport_or_distribution_center: "Pengangkutan darat dari kilang / gudang ke pelabuhan / lapangan terbang / pusat pengumpulan",//从工厂/仓库到港口/机场/集散中心的地面运输
  The_current_request_to_the_third_party_interface_is_abnormal_Please_check_the_authorization_of_the_third_party_logistics_company: "Permintaan antara muka pihak ketiga semasa tidak normal, sila semak kebenaran syarikat logistik pihak ketiga!",//当前第三方接口请求异常，请检查第三方物流公司授权！
  To_be_submitted: "Menunggu untuk dihantar",//待提交
  Total_Invoice_Amount: "Jumlah invois",//发票总额
  Please_set_up_the_return_storage_location_first: "Sila tetapkan lokasi pulangan terlebih dahulu",//请先设置好退件库位
  Please_enter_the_synchronized_inventory_quantity: "Sila masukkan kuantiti stok yang diselaraskan",//请输入同步库存数量
  Partial_refund: "Bayaran balik separa",//部分退款
  Main_transportation_costs: "Kos pengangkutan utama",//主要运输成本
  The_default_first_leg_sharing_fee_for_the_corresponding_country_based_on_the_product_settings: "Berasal daripada kos pro - rata perjalanan pertama lalai negara yang ditetapkan oleh produk",//来源于商品设置的对应国家的默认头程分摊费
  Last_purchase_unit_price: "Harga belian seunit terakhir",//上次采购单价
  Establish_headhaul_logistics_authorization: "Cipta kebenaran logistik perjalanan pertama",//创建头程物流授权
  Carton_Dimensions: "Dimensi sekotak",//单箱尺寸
  import_labelling_charges: "Import caj pelabelan",//导入贴标费
  managementOfFirstLegwarehouse: "Pengurusan gudang transit logistik perjalanan pertama",//头程物流中转仓管理
  off_the_shelf: "Telah diturunkan dari rak",//已下架
  Invoice_Medium: "Medium invois",//发票介质
  Confirm_The_Marking_Can_Be_Modified_For_The_SKU: "Sahkan tanda boleh mengubah suai SKU ? ",//确认标记可修改sku？
  camera: "Kamera",//摄像头
  Switch_Invoicing_Entity: "Tukar subjek invois",//切换开票主体
  Appealed_or_Disputed: "Telah merayu / dalam pertikaian",//已上诉/有争议
  category: "Kategori",//类目
  countdown: "Kira detik",//进行倒计时
  Additional_Charging_Information: "Maklumat pengebilan",//计费信息
  Only_allow_upload: "Hanya dibenarkan memuat naik",//只允许上传
  Inventory_Transfer_To_Unavailable_Inventory: "Pemindahan stok tidak boleh digunakan",//不可用库存移库
  Please_enter_remarks: "Sila masukkan nota",//请输入备注
  Application_Month: "Bulan permohonan",//申请月份
  Invoice_TotalAmount_Detail: "Butiran jumlah invois",//开票金额详情
  Are_you_sure_you_want_to_unbind_this_warehouse: "Sahkan untuk membuka ikatan gudang ini ? ",//确定要解绑该仓库吗？
  Warehouse_customer_provided_packaging_materials: "Bahan pembungkusan disediakan oleh gudang / pelanggan",//仓库/客户自备包材
  Refers_To_The_First_Mile_In_Custom_Cost_Item_Integration_Not_Just_The_Cost_Type_Equal_To_First_Mile: "Merujuk kepada perjalanan pertama dalam integrasi caj tersuai, bukan hanya jenis kos yang sama dengan perjalanan pertama",//指的是自定义费用项整合中的头程，不只是费用类型等于头程。
  Pending_Picking: "Menunggu penyusunan barang",//待配货
  Photo_or_Video: "Gambar / video",//照片/视频
  Edit_Category: "Edit kategori",//编辑类目
  Scanned_waybill_number: "Nombor resit penghantaran telah diimbas",//已扫描运单号
  The_synchronized_inventory_quantity_cannot_be_a_negative_number: "Kuantiti stok yang diselaraskan tidak boleh negatif",//同步库存数量不能为负数
  Modify_the_product_barcode_import_template_20250917: "Templat import ubah suai kod bar produk 20250917",//修改商品条码导入模板20250917
  Total_contracting_material_cost: "Jumlah kos bahan pembungkusan",//总包材费
  Damaged_goods: "Kerosakan produk",//商品损坏
  Details_of_the_first_leg_bill_open_counter: "Butiran bil perjalanan pertama(kontena longgar)",//头程账单详情（散柜）
  Third_party_logistics_company: "Syarikat logistik pihak ketiga",//第三方物流公司
  All_Overseas_Warehousing_Business_Related_Costs_Incurred_In_The_System: "Semua kos yang dihasilkan dalam sistem berkaitan perniagaan pergudangan luar negara",//在系统中产生的所有关于海外仓储业务的费用
  This_document_is_used_as_a_reference_for_the_process_in_the_warehouse: "Fail ini digunakan sebagai rujukan proses untuk gudang",//此文件用于给仓库做流程参考
  platformOrderPlacementReport: "Laporan kuantiti pesanan platform",//平台下单量报表
  Dispute_description: "Keterangan pertikaian",//争议描述
  contract_file_type: "Jenis fail kontrak",//合同文件类型
  editFullContainerFirstPassCost: "Edit kos perjalanan pertama kontena penuh",//编辑整柜头程费
  Electronic: "Elektronik",//电子
  Total_amount_of_inflow_outflow: "Jumlah masuk / keluar",//总出/入金额
  Invalid_Effective: "Tidak sah / berkuat kuasa",//失效/生效
  account_prefix: "Awalan akaun",//账号前缀
  Unbind_the_warehouse: "Buka ikatan gudang",//解绑仓库
  issueInvoice: "Invois",//开票
  Up_to_5_vouchers_can_be_uploaded: "Maksimum 5 keping bukti untuk dimuat naik",//凭证最多上传5张
  Three_star: "Tiga bintang",//三星
  Dispatch_the_first_leg: "Hantar perjalanan pertama",//下发头程
  copyOrder: "Salin pesanan",//复制订单
  Top_up_voucher: "Bukti tambah nilai",//充值凭证
  Total_number_of_files: "Jumlah fail",//文件总数量
  Confirm_attribute_deletion: "Sahkan pemadaman atribut ? ",//确认删除属性?
  Loading_Shipping_Labels: "Memuatkan label",//加载面单中
  please_enter_end_number: "Sila masukkan nombor penamat",//请输入截止编号
  Please_enter_the_link_ID_Item_ID_separated_by_commas_or_line_breaks: "Sila masukkan ID pautan / ID produk, dipisahkan dengan koma atau baris baru",//请输入链接ID/商品ID，用逗号或换行分隔
  customsDeclarationFee: "Kos pengisytiharan kastam",//报关费
  Please_select_the_designated_SKU: "Sila pilih SKU yang ditentukan",//请选择指定SKU
  The_calculation_formula_for_the_on_shelf_timeliness_rate_is: "Formula kadar ketepatan masa penyusunan ialah",//上架及时率的计算公式为
  Trading_Hours: "Masa transaksi",//交易时间
  How_to_obtain_the_itemID_from_the_link: "Cara mendapatkan itemID dalam pautan",//如何在链接中获取itemID
  Each_file_should_be_no_larger_than_2MB_and_a_maximum_of_10_files_are_allowed: "Setiap fail tidak melebihi 2MB, maksimum 10 fail",//单个文件不超过 2MB，最多 10 个文件
  If_a_warehouse_is_selected_only_the_goods_that_have_been_stocked_on_the_shelves_in_that_warehouse_will_be_displayed: "Jika gudang dipilih, hanya produk yang telah disusun stok akan dipaparkan",//如果选择了仓库，那么仅展示有上架过库存的商品。
  Note_The_generation_of_bills_for_platform_orders_may_occur_at_multiple_time_points_For_instance_if_a_portion_of_the_bills_are_generated_before_the_setting_of_currency_exchange_rates_then_these_bills_will_not_be_retrieved_to_generate_the_order_report_resulting_in_the_issue_of_incomplete_fees: "Nota: Bil pesanan platform mungkin dihasilkan pada pelbagai titik masa, jika sebahagian bil dihasilkan sebelum kadar pertukaran mata wang ditetapkan, bahagian bil tersebut tidak akan ditarik, menyebabkan laporan kos pesanan tidak lengkap",//注：平台订单的账单产生可能在多个时间点，如一部分账单产生时间点在设置币种汇率之前，则这部分账单不会被拉取产生订单报表费用不全的问题
  Headhaul_bills_are_settled_by_the_third_party_logistics_system_synchronize_third_party_headhaul_bill_settlement_status_and_follow_the_third_party_system: "Bil perjalanan pertama diselesaikan oleh sistem logistik pihak ketiga, menyelaraskan status penyelesaian bil perjalanan pertama pihak ketiga, dengan sistem logistik pihak ketiga sebagai rujukan utama",//头程账单由第三方物流系统结算，同步第三方头程账单结算状态，以第三方物流系统为准
  Package_Sent: "Pakej telah dihantar",//包裹已寄出
  distribute_goods: "Hantar produk",//下发商品
  The_picture_is_a_mandatory_field: "Gambar wajib diisi",//图片为必填
  Please_Select_Floor_Or_Zone: "Sila pilih tingkat atau zon",//请选择楼层或分区
  Buyer_description_return_reason: "Pembeli menerangkan sebab pemulangan",//买家描述退货原因
  Distribution_Shipping_Classification: "Klasifikasi penghantaran / pembungkusan",//配/发货分类
  Application_Time: "Masa permohonan",//申请时间
  Switching_The_Invoicing_Entity_Takes_Effect_At_Dawn_Of_The_Next_Day_Only_The_Last_Entity_Switched_Each_Day_Is_Valid_All_Invoiced_Amounts_For_The_Corresponding_Business_Type_Thereafter_Will_Belong_To_This_Entity: "Menukar subjek invois berkuat kuasa pada awal pagi hari berikutnya, hanya subjek terakhir yang ditukar setiap hari yang sah, selepas itu jumlah invois untuk jenis perniagaan yang sepadan akan di bawah subjek ini",//切换开票主体，次日凌晨生效，仅每日切换的最后一个主体有效，在此之后对应业务类型的开票金额将归属于此主体。
  Latest_update_The_logistics_information_is_currently_being_retrieved: "Kemas kini terkini: Maklumat logistik sedang ditarik",//最新更新：物流信息正在拉取中
  When_Couriers_Mistakenly_Deliver_Returned_Items_To_A_Non_Corresponding_Return_Warehouse_And_They_Need_To_Be_Transferred_To_The_Correct_Warehouse_Return_Orders_Involving_Such_Operations_Will_Enter_This_Stage: "Apabila penghantar tersilap hantar pulangan ke gudang pulangan yang tidak sepadan dan perlu dipindahkan ke gudang yang betul; resit pulangan yang melibatkan operasi ini akan memasuki peringkat ini",//因快递员将退件误送到非对应退货仓库，需中转至正确仓库时；涉及此类操作的退货单将进入此阶段。
  processed: "Telah diproses",//已处理
  Customer_Tier: "Tahap pelanggan",//客户等级
  Description_of_return_reason: "Keterangan sebab pemulangan",//退货原因描述
  refundAndReturnTheProduct: "Pemulangan / bayaran balik",//退货/退款
  The_goods_are_being_returned_to_the_warehouse: "Barang dipulangkan ke gudang",//货物退回仓库
  pleaseSelectStuffingSize: "Sila pilih dimensi pemuatan kontena",//请选择装柜尺寸
  Approval_time: "Masa kelulusan",//审核通过时间
  Register_and_put_away: "Daftar dan naikkan ke rak",//登记并上架
  Edit_third_party_warehouse_authorization: "Edit kebenaran gudang pihak ketiga",//编辑第三方仓授权
  Verification_time: "Masa pengesahan",//校验时间
  If_a_warehouse_needs_to_be_selected_within_the_page: "Jika perlu memilih gudang dalam halaman",//若页面内需选择仓库
  Third_party_repository_ID: "ID gudang pihak ketiga",//第三方仓库ID
  When_not_yet_completed_and_put_on_the_shelf: "Apabila penyusunan belum selesai",//未完成上架时
  Pictures_videos: "Gambar / video",//图片/视频
  Do_not_download_reexport_instead: "Jangan muat turun, eksport semula",//不下载重新导出
  Top_Up_Amount_Cannot_Be_Invoiced_Directly_It_Must_Be_Consumed_And_Settled_Before_Invoicing: "Jumlah tambah nilai tidak boleh terus diinvois, mesti diselesaikan selepas penggunaan barulah boleh diinvois",//充值金额不能直接开票，必须消费后结算才能开票。
  Sync_the_initial_shipping_status: "Selaraskan status perjalanan pertama",//同步头程状态
  Please_enter_the_customer_id: "Sila masukkan ID pelanggan",//请输入客户ID
  When_the_original_currency_conversion_profit_financial_currency_exchange_rate_for_the_store_is_not_set_the_system_will_not_perform_data_synchronization_After_the_setting_is_completed_the_data_from_the_previous_day_will_be_synchronized_after_24_00_of_the_current_day_Only_orders_that_have_been_dispatched_and_bills_have_been_generated_will_be_synchronized_The_profit_data_will_be_updated_at_the_beginning_of_the_next_day_when_the_bill_is_generated_The_settlement_time_will_be_the_time_when_the_bill_was_last_generated: "Apabila kadar pertukaran mata wang kewangan untuk menukar keuntungan daripada mata wang asal kedai tidak ditetapkan, sistem tidak akan melaksanakan penyelarasan data Selepas ditetapkan, data hari sebelumnya akan diselaraskan selepas jam 24:00 pada hari tersebut, hanya menyelaraskan pesanan yang telah dikeluarkan dan bil telah dihasilkan Data keuntungan akan dikemas kini pada awal pagi apabila bil dihasilkan, dan masa penyelesaian akan menggunakan masa bil terakhir dihasilkan",//当未设置店铺原始币种换算利润财务币种汇率时，系统将不执行数据同步，设置后会在当天24点后同步前一天数据，只同步已出库且账单已产生订单，利润数据将在凌晨且账单产生时更新，账单产生时将会以最后产生账单的时间作为结算时间。
  The_sales_volume_of_the_goods_on_this_platform_during_the_selected_time_period: "Dalam tempoh penapisan, kuantiti jualan produk di platform tersebut",//筛选时间内，该平台的商品销售数量
  The_quantity_of_goods_cannot_exceed_the_operable_quantity: "Kuantiti produk tidak boleh melebihi kuantiti boleh dikendalikan",//商品数量不能超过可操作数量
  Please_add_the_attribute: "Sila tambah atribut",//请添加属性
  Security_inspection_storage_sorting_fuel_surcharge_etc: "Caj keselamatan, storan, penyusunan, caj tambahan bahan api, dll",//安检、仓储、分拣、燃油附加费等
  The_sales_volume_of_this_SKU_in_this_store_during_the_selected_time_period: "Dalam tempoh penapisan, kuantiti jualan SKU ini di kedai tersebut",//筛选时间内，该SKU在该店铺的销售数量
  Both_paper_and_electronic_contracts_exist_please_choose_again: "Kontrak kertas dan kontrak elektronik wujud serentak, sila pilih semula",//同时存在纸质合同和电子合同，请重新选择
  Update_the_order_status: "Kemas kini status pesanan",//更新订单状态
  Seller_Buyer_Cancel: "Penjual / pembeli membatalkan",//卖/买家取消
  Application_status: "Status permohonan",//申请状态
  Please_select_product: "Sila pilih produk",//请选择商品
  Delete_shelves: "Padam rak",//删除货架
  total_three_sides: "Jumlah tiga sisi panjang",//总三边长
  Batch_Upload_Invoice: "Muat naik invois secara pukal",//批量上传发票
  Receiving_payment_from_a_third_party_logistics_company: "Penerimaan bayaran syarikat logistik pihak ketiga",//第三方物流公司收款
  Not_yet_shipped: "Belum dihantar",//未发货
  is_total_orders_click_on_the_detailed_data_to_view_the_list_of_order_quantities: "Jumlah penghantaran, klik data terperinci untuk melihat senarai kuantiti pesanan",//的总出单量,点击详细数据可查看下单量列表
  borderCrossingFeeCost: "Kos transit sempadan",//边境过境费成本
  Headhaul_bills_are_settled_by_our_system_do_not_sync_third_party_headhaul_bill_settlement_status: "Bil perjalanan pertama diselesaikan oleh sistem pihak kami, tidak menyelaraskan status penyelesaian bil perjalanan pertama pihak ketiga",//头程账单由我方系统结算，不同步第三方头程账单结算状态
  import_manualEntryAndExit: "Import masuk / keluar manual",//导入手工出入库
  Detailed_Quality_Inspection_Status: "Status terperinci pemeriksaan kualiti",//质检详细状态
  tip_365_days_per_year_730_days_per_year_1095_days_per_year: "365 hari untuk satu tahun, 730 untuk dua tahun, 1095 untuk tiga tahun",//一年365天，二年730，三年1095
  minimumValueIsZero: "Nilai minimum ialah 0",//最小值为0
  After_the_creation_is_successful_please_click_to_synchronize_the_transfer_warehouse_for_the_synchronization_process: "Selepas penciptaan berjaya, sila klik 'Selaraskan gudang transit' untuk menyelaraskan",//创建成功后请点击同步中转仓进行同步
  Import_full_container_for_the_initial_shipment: "Import kos perjalanan pertama kontena penuh",//导入整柜头程费
  Enter_creator: "Sila masukkan nama pencipta",//请输入创建人
  Shelving_in_progress: "Dalam proses penyusunan",//上架中
  Multiple_warehouses_need_to_be_selected: "Perlu memilih pelbagai gudang",//需要选择多个仓库
  When_The_Employee_Type_Is_Picker_And_A_Single_Warehouse_Is_Selected_The_Priority_Picking_Floor_And_Priority_Picking_Zone_Are_Required_Fields_Select_At_Least_One: "Apabila jenis pekerja adalah penyusun barang dan memilih satu gudang, lantai keutamaan dan zon keutamaan adalah wajib diisi(pilih salah satu)",//当员工类型为配货员且选择单个仓库时，优先配货楼层与优先配货分区为必填项（二选一）
  airportHandlingFee: "Kos operasi lapangan terbang",//机场操作费
  Allocation_completed: "Penyusunan selesai",//配货完成
  Confirm_that_the_settings_are_not_synchronized_for_online_products: "Sahkan tetapan tidak menyelaraskan produk dalam talian",//确认设置不同步在线商品
  Payment_mode: "Mod penerimaan bayaran",//收款模式
  Cost_Calculation_Fields_for_Merchandise: "Medan pengiraan kos produk",//商品成本计算字段
  enterprise_individual: "Syarikat / individu",//企业/个人
  The_Platform_Order_Status_Is_Completed_If_You_Still_Need_To_Ship_The_Order_Please_Create_A_Manual_Order: "Status pesanan platform telah selesai, jika anda masih perlu menghantar, sila cipta pesanan manual",//平台订单状态已完结，如果您还需要发货请创建手工单。
  Only_PDF_Files_Under_10MB_Are_Accepted: "Hanya boleh muat naik fail pdf, dan tidak melebihi 10MB",//只能上传pdf文件，且不超过10MB
  Video_plugin_Connection_error_please_check_if_the_video_plugin_is_open_After_reopening_the_video_plugin_the_page_needs_to_be_refreshed: "Ralat sambungan plugin video, sila semak sama ada plugin video dibuka, selepas dibuka semula, sila muat semula halaman",//视频插件连接错误，请检查是否打开视频插件,视频插件重新打开后需要刷新页面
  Available_Inventory_Transfer: "Pemindahan stok boleh digunakan",//可用库存移库
  submitter: "Penghantar",//提交人
  Enter_logistics_company_name: "Sila masukkan nama syarikat logistik",//请输入物流公司名称
  Third_party_transit_warehouse_CN_name: "Nama Cina gudang transit pihak ketiga",//第三方中转仓中文名称
  Dispute_arbitration: "Timbang tara pertikaian",//争议仲裁
  Warehouse_in_Warehouse: "Gudang dalam gudang",//仓中仓
  create_setting: "Cipta tetapan",//创建设置
  Sales_volume_7_14_30_45_60_90: "Jualan(7 / 14 / 30 / 45 / 60 / 90)",//销量(7/14/30/45/60/90)
  Please_fill_in_the_complete_fee_information_first: "Sila lengkapkan maklumat kos terlebih dahulu",//请先填写完整费用信息
  orderProcessingFeeReport: "Laporan yuran pemprosesan pesanan",//订单处理费报表
  total_weight: "Jumlah berat",//总重量
  Connection_successful: "Sambungan berjaya",//连接成功
  Overseas: "Luar negara",//海外
  Please_enter_the_inventory_threshold: "Sila masukkan ambang stok",//请输入库存阈值
  Confirm_synchronization_of_the_specified_strategy_inventory: "Sahkan penyelarasan stok strategi yang ditentukan",//确认同步指定策略库存
  cancelOrderReport: "Laporan pesanan dibatalkan",//取消订单报表
  storeOrderPlacementReport: "Laporan kuantiti pesanan kedai",//店铺下单量报表
  It_will_overwrite_the_current_packaging_information_if_there_are_any_adjustments_to_the_quotation_please_update_it_yourself: "Akan menimpa maklumat bahan pembungkusan semasa, jika terdapat pelarasan harga, sila kemas kini sendiri",//会覆盖当前包材信息，如有调整报价，请自行更新。
  Suspected_deletion: "Disyaki dipadam",//疑似删除
  otherHandlingFeeCost: "Kos operasi lain",//其他操作费成本
  Logistics_company_authorization_information: "Maklumat kebenaran syarikat logistik",//物流公司授权信息
  Import_category_management: "Import pengurusan kategori",//导入类目管理
  Issue_Status: "Status penghantaran",//下发状态
  After_marking_as_abnormal_the_original_state_cannot_be_restored_Once_activated_it_will_enter_the_final_receiving_process_clearing_all_receiving_and_quality_inspection_information_Are_you_sure_you_want_to_adjust_it_to_the_abnormal_stage: "Selepas ditandakan sebagai tidak normal, status tidak dapat dipulihkan Selepas diaktifkan, ia akan memasuki penerimaan penghantaran terakhir, membersihkan semua maklumat penerimaan dan pemeriksaan kualiti Sahkan sama ada ingin melaraskan ke peringkat tidak normal",//标记异常后无法恢复原来的状态，激活后会进入尾程收货中，清除掉所有的收货与质检信息，确认是否要调整至异常阶段
  The_adjustment_quantity_must_be_greater_than_0: "Kuantiti pelarasan mestilah lebih besar daripada 0",//调整数量必须大于0
  The_following_orders_products_have_been_selected_for_direct_refund_without_the_need_for_return: "Pesanan / produk berikut telah dipilih untuk bayaran balik terus tanpa pemulangan",//以下订单/商品已被选定为无需退货直接退款
  Upload_contract: "Muat naik kontrak",//上传合同
  derived_from_the_initial_allocation_fee_filled_in_by_the_completed_inventory_that_has_been_put_on_the_shelves_and_distributed_at_a_unit_price_based_on_the_volume_of_the_goods: "Berasal daripada kos pro - rata perjalanan pertama yang diisi untuk pesanan masuk yang telah selesai penyusunan, harga seunit berdasarkan volum produk",//来源于已完成上架的入库填写的头程分摊费，按照商品的体积平摊出的单价
  The_refund_application_has_been_closed: "Permohonan bayaran balik sahaja telah ditutup",//仅退款申请已关闭
  Purchase_currency: "Mata wang pembelian",//采购币种
  Packaging_material_product_information: "Maklumat produk bahan pembungkusan",//包材商品信息
  True_Height: "Tinggi sebenar(CM)",//真实高(CM)
  Incorrect_File_Name_Format: "Format nama fail salah",//文件名格式错误
  Rejection_Reason_Too_Long_Supports_up_to_255_characters: "Sebab penolakan terlalu panjang, maksimum 255 aksara",//驳回原因过长，最多支持255个字符
  Packaging_manage: "Operasi pembungkusan",//包装操作
  Dispute_type: "Jenis pertikaian",//争议类型
  Pending_Sorting: "Menunggu penyusunan",//待分拣
  pleaseSelectDestinationWarehouse: "Sila pilih gudang destinasi",//请选择目的仓库
  Returning: "Dalam proses pemulangan",//退货中
  Edit_headhaul_logistics_authorization: "Edit kebenaran logistik perjalanan pertama",//编辑头程物流授权
  Agree_to_refund: "Setuju bayaran balik",//同意退款
  File_upload: "Muat naik fail",//文件上传
  Return_type: "Jenis pemulangan",//退货类型
  The_buyer_initiates_a_return: "Pembeli memulakan pemulangan",//买家发起退货
  Currently_there_is_no_data_from_the_third_party_warehouse_Please_synchronize_first_and_then_select_to_bind: "Tiada data gudang pihak ketiga buat masa ini, sila selaraskan terlebih dahulu sebelum memilih untuk diikat",//当前暂无三方仓库数据，请先同步后再选绑定
  return_number: "Nombor resit pemulangan",//退货单号
  Overseas_warehouse: "Pergudangan luar negara",//海外仓储
  Actual_Length_Width_Height_Dimensions: "Dimensi tiga sisi sebenar",//实际三边尺寸
  Our_transit_warehouse_CN_name: "Nama Cina gudang transit pihak kami",//我方中转仓中文名称
  Total_stocking_amount: "Jumlah nilai persediaan stok",//备货总金额
  hot_selling_product: "Produk popular",//爆品
  The_selection_of_goods_can_only_be_made_after_choosing_a_warehouse: "Pemilihan produk hanya boleh dilakukan selepas memilih gudang",//选择仓库后才能进行商品选择
  headlineogisticsAuthorization: "Kebenaran logistik perjalanan pertama",//头程物流授权
  The_Customer_ID_And_Invoice_Header_Will_Be_Extracted_From_The_File_Name_For_Data_Matching_Please_Ensure_The_File_Name_Is_Correct: "Akan mengekstrak ID pelanggan dan kepala invois daripada nama fail untuk padanan data, sila pastikan nama fail betul",//将提取文件名中的客户ID和开票抬头进行数据匹配，请确保文件名正确。
  Synchronous_transfer_warehouse: "Selaraskan gudang transit",//同步中转仓
  todayTask19: "Tugasan hari ini 19",//今日任务19
  Please_select_warehouse_type: "Sila pilih jenis gudang",//请选择仓库类型
  Platform_return_process_stage: "Tahap pemulangan platform",//平台退货阶段
  Batch_bind_transit_warehouse: "Ikat gudang transit secara pukal",//批量绑定中转仓
  Issue_Invoice: "Menerbitkan invois",//开具发票
  API_endpoint: "Antara muka API",//API接口
  independent_warehouse: "Gudang bebas",//独立仓
  Brand_Name: "Nama jenama",//品牌名称
  trailerFeeCost: "Kos trak",//拖车费成本
  The_current_waybill_number_is_duplicated: "Nombor resit penghantaran semasa berulang",//当前运单号重复
  start_number: "Nombor permulaan",//开始编号
  Self_provided_packaging_materials_only_support_adjustment_for_removal_with_a_maximum_removal_quantity_of_inventory_quantity_occupied_quantity: "Data yang dipilih mempunyai bahan pembungkusan sendiri, bahan pembungkusan sendiri hanya menyokong pelarasan penurunan dari rak, kuantiti maksimum penurunan ialah: kuantiti stok - kuantiti diduduki",//选择数据存在自备包材，自备包材只支持调整下架，最大下架数量为：库存数量-占用数量
  URL_must_start_with_http_or_https: "URL mestilah bermula dengan http atau https",//URL 必须以 http 或 https 开头
  Is_consolidated_backup_order: "Adakah pesanan persediaan stok gabungan ? ",//是否为合并备货单
  File_Size_Cannot_Exceed_10MB: "Saiz fail tidak boleh melebihi 10MB",//文件大小不能超过10MB
  Derived_from_the_purchase_price_of_the_product_and_the_latest_purchase_price: "Berasal daripada harga pembelian produk dan harga pembelian terkini",//来源于商品的采购价与最新采购价
  Work_Order_Details: "Butiran tiket kerja",//工单详情
  firstPassCostDrawercabinet: "Kos perjalanan pertama - kontena longgar",//头程费-散柜
  Business_termination_time: "Tarikh tamat perniagaan",//终止业务时间
  Two_star: "Dua bintang",//二星
  Detention_stock_fee: "Caj sewa gudang tertahan(M³/ringgit)",// 滞留仓租费（M³/元）
  Personnel_from_the_investment_promotion_department_and_contract_documents_cannot_be_selected_simultaneously: "Kakitangan jabatan pelaburan dan fail kontrak tidak boleh dipilih serentak",//招商部人员和合同文件不能同时选择
  Old_location_type: "Jenis lokasi lama",//旧库位类型
  Export_warehouse_rent: "Eksport sewa gudang",//导出仓租
  Note_The_gift_amount_is_not_a_database_field_in_the_customer_table_There_is_a_separate_field_for_the_gift_amount_stored_in_the_bill_details: "Nota: Jumlah hadiah bukanlah medan pangkalan data jadual pelanggan Butiran bil mempunyai medan jumlah hadiah yang disimpan secara berasingan",//注意：赠送金额不是客户表的数据库字段。账单明细中有单独存储的赠送金额字段
  InvoiceRemark: "Nota invois",//开票备注
  If_The_Number_Of_Exported_Rows_Exceeds_100000_The_Export_Will_Fail_Please_Export_Within_The_Specified_Limit: "Jika bilangan baris yang dieksport melebihi 100,000, eksport akan gagal, sila eksport dalam had yang ditetapkan",//若导出条数超过10万条，将导出失败，请在规定范围内进行导出。
  After_the_creation_is_successful_please_click_Synchronize_Repository_to_perform_the_synchronization: "Selepas penciptaan berjaya, sila klik 'Selaraskan gudang' untuk menyelaraskan",//创建成功后请点击同步仓库进行同步
  Granting_authorization_for_establishing_a_third_party_warehouse: "Cipta kebenaran gudang pihak ketiga",//创建第三方仓授权
  upAndDownListingProcess: "Adakah aliran masuk / keluar konsisten ? ",//上下架流水是否一致
  After_registering_the_returned_items_and_selecting_the_storage_location_proceed_with_putaway: "Daftar pulangan dan pilih nombor lokasi sebelum naik ke rak",//退件登记并选择库位号后上架
  viewAuthorizationDetails: "Lihat butiran kebenaran",//查看授权详情
  Invoice_Header: "Kepala invois",//发票抬头
  level: "Tahap",//级别
  Finish_execute_time: "Masa selesai pelaksanaan",//执行完成时间
  Category_Name: "Nama kategori",//类目名称
  Specified_Condition: "Syarat yang ditentukan",//指定条件
  Refund_only: "Bayaran balik sahaja",//仅退款
  Please_Check_Whether_The_Currently_Set_Customer_ID_Is_Greater_Than_The_Largest_Customer_ID_In_The_Current_System: "Sila semak sama ada ID pelanggan yang ditetapkan semasa lebih besar daripada ID pelanggan maksimum dalam sistem semasa",//请检查当前设置的客户ID是否大于目前系统中最大的客户ID。
  please_enter_start_number: "Sila masukkan nombor permulaan",//请输入开始编号
  Unbind_transit_warehouse: "Buka ikatan gudang transit",//解绑中转仓
  The_current_waybill_number_exceeds_the_limit_length_of_30_characters: "Nombor resit penghantaran semasa melebihi had panjang 30 aksara",//当前运单号超过限制长度30个字符
  Paper_contract: "Kontrak kertas",//纸质合同
  Latest_Purchase_Price: "Harga pembelian terkini",//最新采购价
  Return_to_the_merchant: "Pulangkan kepada penjual",//退回商家
  The_current_customer_s_configured_usable_currency_defaults_to_the_first_currency: "Mata wang yang boleh digunakan yang dikonfigurasikan oleh pelanggan semasa, mata wang pertama adalah lalai",//当前客户配置的可使用币种，默认第一个币种
  Please_Contact_The_Customer_To_Provide_The_Shipping_Label: "Sila hubungi pelanggan untuk menyediakan label penghantaran",//请联系客户提供面单
  Business_type: "Jenis perniagaan",//业务类型
  Preview_Invoice: "Pratonton invois",//预览发票
  You_can_select_one_or_more_warehouses_and_the_system_will_only_display_the_data_of_the_warehouses_you_have_chosen: "Anda boleh memilih satu atau lebih gudang, sistem akan memaparkan data hanya untuk gudang yang anda pilih",//您可以选择一个或多个仓库，系统将只展示您选择的仓库的数据
  Return_tracking_number: "Nombor resit pulangan",//退回运单号
  batch_create_account: "Cipta akaun secara pukal",//批量创建账号
  Overseas_Warehouse_Cost: "Kos gudang luar negara: ",//海外仓费用：
  pleaseSelectTransitWarehouse: "Sila pilih gudang transit",//请选择中转仓库
  Previous_Page: "Halaman sebelumnya",//上一页
  Pending: "Menunggu pemprosesan",//待处理
  The_current_barcode_has_been_scanned: "Kod bar semasa telah diimbas berjaya",//当前条码已扫描成功
  Operation_id: "ID operasi",//操作ID
  When_the_type_of_warehouse_operation_is_outbound_after_selecting_the_storage_location_the_available_inventory_on_this_location_will_be_displayed_The_quantity_filled_in_must_not_exceed_the_operable_inventory: "Apabila jenis masuk / keluar adalah keluar, selepas memilih lokasi, stok boleh guna di lokasi tersebut akan dipaparkan, kuantiti yang diisi tidak boleh melebihi stok boleh dikendalikan",//当出入库类型为出库时，选择库位后会显示此库位上可用库存，填写数量不可大于可操作库存
  Confirm_receipt: "Sahkan penerimaan barang",//确认收货
  Due_To_The_Large_Export_Volume_Please_Wait_Patiently: "Oleh kerana kuantiti eksport terlalu besar, sila tunggu dengan sabar",//由于导出数量过大，请耐心等待。
  The_current_status_does_not_allow_for_repeated_operation_dispatch: "Status semasa tidak boleh mengulangi operasi penghantaran",//当前状态不可重复操作下发
  Seller_evidence_deadline: "Tarikh akhir penjual menyerahkan bukti",//卖家提交证据截止
  Demurrage_start_day: "Hari permulaan caj tertahan",//滞留起收天数
  The_inventory_synchronization_strategy_value_cannot_be_a_negative_number: "Nilai strategi penyelarasan stok tidak boleh negatif",//库存同步策略值不能为负数
  The_inventory_synchronization_strategy_value_must_be_greater_than_0: "Nilai strategi penyelarasan stok mestilah lebih besar daripada 0",//库存同步策略值必须大于 0
  Unable_To_Access: "Tidak dapat diakses",//无法访问
  attributeManagement: "Pengurusan atribut",//属性管理
  edit_setting: "Edit tetapan",//编辑设置
  borderCrossingFee: "Kos transit sempadan",//边境过境费
  Sorting_completed: "Telah selesai penyusunan",//已完成分拣
  Batch_disable: "Lumpuhkan secara pukal",//批量禁用
  Region_type: "Jenis kawasan",//地区类型
  It_shows_normal: "Maka akan menunjukkan normal",//则显示正常
  All_Costs_Incurred_In_The_System_Related_To_First_Mile_Logistics_Business: "Semua kos yang dihasilkan dalam sistem berkaitan perniagaan logistik perjalanan pertama",//系统中产生的所有关于头程物流业务的费用
  If_you_need_to_pull_a_specific_product: "Untuk menarik produk yang ditentukan",//如需拉取指定商品
  Please_enter_and_then_click_the_Query_button_on_the_right: "Sila masukkan dan klik carian di sebelah kanan",//请输入后点击右侧查询
  Including_Overseas_Warehousing_Business_Related_Costs_From_The_Deduction_Or_Supplement_Cost_Type: "Termasuk kos perniagaan pergudangan luar negara dalam jenis caj tambahan",//包含补扣费用类型中的关于海外仓储业务费用
  Please_Select_Invoice_Date: "Sila pilih tarikh invois",//请选择开票日期
  Default_Packing_Information: "Maklumat pemuatan kontena lalai",//默认装箱信息
  Return_reason: "Sebab pemulangan",//退货原因
  Merchant_pending_processing: "Penjual menunggu pemprosesan",//商家待处理
  Please_select_the_type_of_customer: "Sila pilih jenis pelanggan",//请选择客户类型
  Invoice_Date: "Tarikh invois",//开票日期
  Invoicing_Entity: "Subjek invois",//开票主体
  Your_selection_will_be_remembered_and_will_still_be_valid_the_next_time_you_log_in: "Pilihan anda akan diingati dan akan terus berkuat kuasa pada log masuk seterusnya",//您的选择将被记住，并在您下次登录时继续生效
  View: "Lihat",//查看
  modify: "Ubah suai",//修改
  Currently_previewing: "Pratonton semasa",//当前预览
  The_sales_volume_of_the_goods_in_this_warehouse_during_the_selected_time_period: "Dalam tempoh penapisan, kuantiti jualan produk di gudang tersebut",//筛选时间内，该仓库的商品销售数量
  Contract_review_time: "Masa semakan kontrak",//审核合同时间
  Sticking_order_Out_of_stock: "Penghantaran dengan label",//贴单出库
  The_warehouse_rental_type_does_not_currently_support_selecting_export: "Jenis sewa gudang buat masa ini tidak menyokong pemilihan untuk eksport",//仓租类型暂不支持选择导出
  if_you_need_to_check_progress_please_go_to: "Untuk mengetahui kemajuan, sila pergi ke",//如需了解进度，请到
  The_total_inventory_on_the_old_storage_location_and_the_proportion_of_total_inventory_to_usage: "Jumlah stok pada lokasi lama, jumlah penggunaan stok",//旧库位上的库存总量，库存总占用量
  Order_item_ID: "ID produk pesanan",//订单商品ID
  Third_party_warehouse_authorization_company: "Syarikat kebenaran gudang pihak ketiga",//第三方仓授权公司
  Total_Length_Width_Height: "Jumlah tiga sisi panjang",//三边总长
  Category_names_must_be_unique_Please_check_and_resubmit: "Nama kategori tidak boleh sama, sila semak sebelum menghantar",//类目名称不得相同，请检查后再提交
  Inventory_batch_id: "ID kumpulan stok",//库存批次ID
  Including_First_Mile_Business_Related_Costs_From_The_Deduction_Or_Supplement_Cost_Type: "Termasuk kos perniagaan perjalanan pertama dalam jenis caj tambahan",//包含补扣费用类型中的关于头程业务费用
  Switching_The_Signing_Entity_Takes_Effect_After_Approval_All_Invoiced_Amounts_Thereafter_Will_Belong_To_This_Entity: "Menukar subjek kontrak, berkuat kuasa selepas kelulusan, selepas itu jumlah invois akan di bawah subjek ini",//切换签约主体，审核通过后生效，在此之后的开票金额将归属于此主体。
  Parent_category: "Kategori peringkat atas",//上级类目


}